webpackJsonp([1,2],Array(190).concat([
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(32);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(1491);

var _vuex2 = _interopRequireDefault(_vuex);

var _global = __webpack_require__(612);

var _global2 = _interopRequireDefault(_global);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

exports.default = new _vuex2.default.Store({
  modules: {
    global: _global2.default
  }
});

/***/ }),
/* 191 */,
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _elementUi = __webpack_require__(281);

exports.default = {
  openMessage: function openMessage(text) {
    _elementUi.MessageBox.alert(text, '关于', {
      confirmButtonText: '确定',
      dangerouslyUseHTMLString: true
    });
  },
  errorMessage: function errorMessage(text) {
    _elementUi.MessageBox.alert(text, '错误信息', {
      type: 'error',
      confirmButtonText: '确定'
    });
  },
  successMessage: function successMessage(text, callback) {
    _elementUi.MessageBox.alert(text, '成功信息', {
      type: 'success',
      confirmButtonText: '确定'
    }).then(function () {
      callback();
    }).catch(function () {});
  },
  confirmMessage: function confirmMessage(text, callback) {
    _elementUi.MessageBox.confirm(text, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
      dangerouslyUseHTMLString: true
    }).then(function () {
      callback();
    }).catch(function () {});
  },
  loading: function loading() {
    var loadingInstance = _elementUi.Loading.service({
      body: true,
      text: '拼命加载中'
    });
    return loadingInstance;
  },
  successNotify: function successNotify(text) {
    _elementUi.Notification.success({
      title: '成功',
      message: text,
      duration: 3000,
      type: 'success'
    });
  },
  customMessage: function customMessage(type, text) {
    (0, _elementUi.Message)({
      type: type,
      message: text,
      showClose: true
    });
  }
};

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(38);

var _promise2 = _interopRequireDefault(_promise);

var _axios = __webpack_require__(591);

var _axios2 = _interopRequireDefault(_axios);

var _message = __webpack_require__(192);

var _message2 = _interopRequireDefault(_message);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var showError = false;
_axios2.default.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

exports.default = {
  get: function get(url, data) {
    return this.request(url, data, 'GET');
  },
  post: function post(url, data) {
    return this.request(url, data, 'POST');
  },
  put: function put(url, data) {
    return this.request(url, data, 'PUT');
  },
  delete: function _delete(url, data) {
    return this.request(url, data, 'DELETE');
  },
  buildErrorHandler: function buildErrorHandler(msg, callback) {
    if (!showError) {
      _message2.default.errorMessage(msg);
      showError = false;
    }
    if (callback) {
      callback();
    }
  },
  request: function request(url, dataObj, methodType) {
    return new _promise2.default(function (resolve, reject) {
      var config = {
        url: url,
        method: methodType,
        cache: false
      };

      switch (methodType) {
        case 'GET':
        case 'DELETE':
          config.params = dataObj;
          break;
        case 'POST':
        case 'PUT':
          var formData = new URLSearchParams(dataObj);
          config.data = formData;
          break;
        default:
          config.data = dataObj;
          break;
      }
      _axios2.default.request(config).then(function (response) {
        if (response.data.status === 0) {
          showError = false;
          resolve(response.data.obj);
        } else if (response.data.status === 1) {
          if (response.data.message.indexOf('认证失败') > -1) {
            showError = false;
            resolve(response.data);
          } else {
            _message2.default.errorMessage(response.data.message);
            showError = true;
            reject();
          }
        } else if (response.data.status === 2) {
          top.location.href = response.data.obj;
        } else {
          _message2.default.errorMessage(response.data.message);
          showError = true;
          reject();
        }
      }).catch(function (err) {
        var status = err.response.status;
        if (err.response.headers.headerstatus) {
          status = parseInt(err.response.headers.headerstatus, 0);
        }
        switch (status) {
          case 600:
            if (top.location.hash !== '/login') {
              top.location.hash = '/login';
            }
            break;
          case 606:
          default:
            showError = false;
            reject(err);
            break;
        }
      });
    });
  }
};

/***/ }),
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var apiMapperlist = [{ name: 'executor_dump', url: '/console/namespaces/{domainName}/executors/{executorName}/dump', replace: true }];

exports.default = {
  PushItem: function PushItem(name, value, replace) {
    var items = apiMapperlist.filter(function (x) {
      return x.name === name;
    });
    if (items.length > 0) {
      items.forEach(function (each) {
        if (apiMapperlist.indexOf(each) > -1) {
          apiMapperlist.splice(apiMapperlist.indexOf(each), 1);
        }
      });
    }
    apiMapperlist.push({ name: name, url: value, replace: replace });
  },
  GetUrl: function GetUrl(name, dataObj) {
    var items = apiMapperlist.filter(function (x) {
      return x.name === name;
    });
    if (items && items.length > 0) {
      if (items[0].replace) {
        return this.GetUrlReplaced(items[0].url, dataObj);
      }
      return items[0].url;
    }
    throw new Error('can not find url path for ' + name);
  },
  GetUrlReplaced: function GetUrlReplaced(url, dataObj) {
    var regexp = /\{[a-zA-Z0-9_]*\}+/g;
    var urlReplace = url.match(regexp);
    var target = url;
    if (urlReplace && urlReplace.length) {
      urlReplace.forEach(function (value) {
        var param = value.slice(1, value.length - 1);
        target = target.replace(value, param in dataObj ? dataObj[param] : '');
      });
    } else {
      throw new Error('replace is true, but can not find urlReplace ');
    }
    return target;
  }
};

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var routermapperlist = [{ name: 'login', path: '/login' }, { name: 'jobManage', path: '/job_manage' }, { name: 'jobList', path: '/job_list/:domain' }, { name: 'jobOverview', path: '/job_list/:domain/job_overview' }, { name: 'executorOverview', path: '/job_list/:domain/executor_overview' }, { name: 'namespaceAlarmCenter', path: '/job_list/:domain/namespace_alarm_center' }, { name: 'namespaceAbnormalJobs', path: '/job_list/:domain/namespace_alarm_center/namespace_abnormal_jobs' }, { name: 'namespaceTimeoutJobs', path: '/job_list/:domain/namespace_alarm_center/namespace_timeout_jobs' }, { name: 'namespaceFailoverJobs', path: '/job_list/:domain/namespace_alarm_center/namespace_failover_jobs' }, { name: 'namespaceAbnormalContainers', path: '/job_list/:domain/namespace_alarm_center/namespace_abnormal_containers' }, { name: 'jobDetail', path: '/job_detail/:domain/:jobName' }, { name: 'jobSetting', path: '/job_detail/:domain/:jobName/job_setting' }, { name: 'jobSharding', path: '/job_detail/:domain/:jobName/job_sharding' }, { name: 'jobExecution', path: '/job_detail/:domain/:jobName/job_execution' }, { name: 'jobAlarm', path: '/job_detail/:domain/:jobName/job_alarm' }, { name: 'jobHistory', path: '/job_detail/:domain/:jobName/job_history' }, { name: 'jobMessageHistory', path: '/job_detail/:domain/:jobName/job_message_history' }, { name: 'dashboardManage', path: '/dashboard_manage' }, { name: 'dashboardDetail', path: '/dashboard_detail' }, { name: 'domainStatistic', path: '/dashboard_detail/domain_statistic' }, { name: 'executorStatistic', path: '/dashboard_detail/executor_statistic' }, { name: 'jobStatistic', path: '/dashboard_detail/job_statistic' }, { name: 'alarmManage', path: '/alarm_manage' }, { name: 'alarmAbnormalJobs', path: '/alarm_manage/alarm_abnormal_jobs' }, { name: 'alarmTimeoutJobs', path: '/alarm_manage/alarm_timeout_jobs' }, { name: 'unableFailoverJobs', path: '/alarm_manage/unable_failover_jobs' }, { name: 'alarmAbnormalContainers', path: '/alarm_manage/alarm_abnormal_containers' }, { name: 'registryManage', path: '/registry_manage' }, { name: 'namespaceManage', path: '/registry_manage/namespace_manage' }, { name: 'clustersManage', path: '/registry_manage/clusters_manage' }, { name: 'systemConfigManage', path: '/system_config_manage' }, { name: 'consoleConfig', path: '/system_config_manage/console_config' }, { name: 'oauthClientConfig', path: '/system_config_manage/oauth_client_config' }, { name: 'authorityManage', path: '/authority_manage' }, { name: 'userManage', path: '/user_manage' }];

exports.default = {
  GetPath: function GetPath(name) {
    var items = routermapperlist.filter(function (x) {
      return x.name === name;
    });
    if (items.length > 0) {
      return items[0].path;
    }
    throw new Error('can not find route path ');
  }
};

/***/ }),
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1456)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(620),
  /* template */
  __webpack_require__(1385),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(32);

var _vue2 = _interopRequireDefault(_vue);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.filter('formatDate', function (time) {
  var formatTime = void 0;
  if (time !== null) {
    var date = new Date(time);
    formatTime = (0, _moment2.default)(date).format('YYYY-MM-DD HH:mm:ss');
  } else {
    formatTime = '-';
  }
  return formatTime;
});
_vue2.default.filter('formatOnlyDate', function (time) {
  var date = new Date(time);
  return (0, _moment2.default)(date).format('MM-DD');
});
_vue2.default.filter('formatOnlyTime', function (time) {
  var date = new Date(time);
  return (0, _moment2.default)(date).format('HH:mm:ss');
});
_vue2.default.filter('duringTime', function (time) {
  var date = (0, _moment2.default)(new Date(time));
  var s = (0, _moment2.default)().diff(date, 'seconds');
  var hours = parseInt(s % (60 * 60 * 24) / (60 * 60), 10);
  var minutes = parseInt(s % (60 * 60) / 60, 10);
  var seconds = parseInt(s % 60, 10);
  return hours + '\u65F6' + minutes + '\u5206' + seconds + '\u79D2';
});

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(32);

var _vue2 = _interopRequireDefault(_vue);

var _container = __webpack_require__(1308);

var _container2 = _interopRequireDefault(_container);

var _header = __webpack_require__(1320);

var _header2 = _interopRequireDefault(_header);

var _top_bar = __webpack_require__(1327);

var _top_bar2 = _interopRequireDefault(_top_bar);

var _breadcrumb = __webpack_require__(1301);

var _breadcrumb2 = _interopRequireDefault(_breadcrumb);

var _aside = __webpack_require__(1300);

var _aside2 = _interopRequireDefault(_aside);

var _timeline = __webpack_require__(1324);

var _timeline2 = _interopRequireDefault(_timeline);

var _timeline_item = __webpack_require__(1325);

var _timeline_item2 = _interopRequireDefault(_timeline_item);

var _chart_container = __webpack_require__(1303);

var _chart_container2 = _interopRequireDefault(_chart_container);

var _pie = __webpack_require__(1306);

var _pie2 = _interopRequireDefault(_pie);

var _line = __webpack_require__(1305);

var _line2 = _interopRequireDefault(_line);

var _column = __webpack_require__(1304);

var _column2 = _interopRequireDefault(_column);

var _relate = __webpack_require__(1307);

var _relate2 = _interopRequireDefault(_relate);

var _panel = __webpack_require__(1323);

var _panel2 = _interopRequireDefault(_panel);

var _cardPanel = __webpack_require__(1302);

var _cardPanel2 = _interopRequireDefault(_cardPanel);

var _filterPageList = __webpack_require__(1319);

var _filterPageList2 = _interopRequireDefault(_filterPageList);

var _importFileDialog = __webpack_require__(1321);

var _importFileDialog2 = _interopRequireDefault(_importFileDialog);

var _viewContentDialog = __webpack_require__(1329);

var _viewContentDialog2 = _interopRequireDefault(_viewContentDialog);

var _abnormalJobs = __webpack_require__(1299);

var _abnormalJobs2 = _interopRequireDefault(_abnormalJobs);

var _timeoutJobs = __webpack_require__(1326);

var _timeoutJobs2 = _interopRequireDefault(_timeoutJobs);

var _unableFailoverJobs = __webpack_require__(1328);

var _unableFailoverJobs2 = _interopRequireDefault(_unableFailoverJobs);

var _abnormalContainers = __webpack_require__(1298);

var _abnormalContainers2 = _interopRequireDefault(_abnormalContainers);

var _cronPredictDialog = __webpack_require__(1309);

var _cronPredictDialog2 = _interopRequireDefault(_cronPredictDialog);

var _inputTags = __webpack_require__(1322);

var _inputTags2 = _interopRequireDefault(_inputTags);

var _batch_migrate_dialog = __webpack_require__(1312);

var _batch_migrate_dialog2 = _interopRequireDefault(_batch_migrate_dialog);

var _migrate_status_dialog = __webpack_require__(1316);

var _migrate_status_dialog2 = _interopRequireDefault(_migrate_status_dialog);

var _add_config_dialog = __webpack_require__(1310);

var _add_config_dialog2 = _interopRequireDefault(_add_config_dialog);

var _job_info_dialog = __webpack_require__(1315);

var _job_info_dialog2 = _interopRequireDefault(_job_info_dialog);

var _batch_priority_dialog = __webpack_require__(1313);

var _batch_priority_dialog2 = _interopRequireDefault(_batch_priority_dialog);

var _import_result_dialog = __webpack_require__(1314);

var _import_result_dialog2 = _interopRequireDefault(_import_result_dialog);

var _arrange_layout_dialog = __webpack_require__(1311);

var _arrange_layout_dialog2 = _interopRequireDefault(_arrange_layout_dialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('Container', _container2.default);
_vue2.default.component('VHeader', _header2.default);
_vue2.default.component('Top-bar', _top_bar2.default);
_vue2.default.component('Breadcrumb', _breadcrumb2.default);
_vue2.default.component('VAside', _aside2.default);
_vue2.default.component('Timeline', _timeline2.default);
_vue2.default.component('Timeline-item', _timeline_item2.default);
_vue2.default.component('Chart-container', _chart_container2.default);
_vue2.default.component('Pie', _pie2.default);
_vue2.default.component('Column', _column2.default);
_vue2.default.component('MyLine', _line2.default);
_vue2.default.component('Relate', _relate2.default);
_vue2.default.component('Panel', _panel2.default);
_vue2.default.component('CardPanel', _cardPanel2.default);
_vue2.default.component('FilterPageList', _filterPageList2.default);
_vue2.default.component('ImportFileDialog', _importFileDialog2.default);
_vue2.default.component('ViewContentDialog', _viewContentDialog2.default);
_vue2.default.component('AbnormalJobs', _abnormalJobs2.default);
_vue2.default.component('TimeoutJobs', _timeoutJobs2.default);
_vue2.default.component('UnableFailoverJobs', _unableFailoverJobs2.default);
_vue2.default.component('AbnormalContainers', _abnormalContainers2.default);
_vue2.default.component('CronPredictDialog', _cronPredictDialog2.default);
_vue2.default.component('InputTags', _inputTags2.default);
_vue2.default.component('batch-migrate-dialog', _batch_migrate_dialog2.default);
_vue2.default.component('migrate-status-dialog', _migrate_status_dialog2.default);
_vue2.default.component('add-config-dialog', _add_config_dialog2.default);
_vue2.default.component('job-info-dialog', _job_info_dialog2.default);
_vue2.default.component('batch-priority-dialog', _batch_priority_dialog2.default);
_vue2.default.component('import-result-dialog', _import_result_dialog2.default);
_vue2.default.component('arrange-layout-dialog', _arrange_layout_dialog2.default);

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(32);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(1446);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _router_mapper = __webpack_require__(289);

var _router_mapper2 = _interopRequireDefault(_router_mapper);

var _Login = __webpack_require__(534);

var _Login2 = _interopRequireDefault(_Login);

var _job_manage = __webpack_require__(1359);

var _job_manage2 = _interopRequireDefault(_job_manage);

var _job_list = __webpack_require__(1356);

var _job_list2 = _interopRequireDefault(_job_list);

var _job_overview = __webpack_require__(1357);

var _job_overview2 = _interopRequireDefault(_job_overview);

var _executor_overview = __webpack_require__(1355);

var _executor_overview2 = _interopRequireDefault(_executor_overview);

var _namespace_alarm_center = __webpack_require__(1351);

var _namespace_alarm_center2 = _interopRequireDefault(_namespace_alarm_center);

var _namespace_abnormal_jobs = __webpack_require__(1350);

var _namespace_abnormal_jobs2 = _interopRequireDefault(_namespace_abnormal_jobs);

var _namespace_timeout_jobs = __webpack_require__(1353);

var _namespace_timeout_jobs2 = _interopRequireDefault(_namespace_timeout_jobs);

var _namespace_failover_jobs = __webpack_require__(1352);

var _namespace_failover_jobs2 = _interopRequireDefault(_namespace_failover_jobs);

var _namespace_abnormal_containers = __webpack_require__(1349);

var _namespace_abnormal_containers2 = _interopRequireDefault(_namespace_abnormal_containers);

var _job_detail = __webpack_require__(1343);

var _job_detail2 = _interopRequireDefault(_job_detail);

var _job_setting = __webpack_require__(1347);

var _job_setting2 = _interopRequireDefault(_job_setting);

var _job_sharding = __webpack_require__(1348);

var _job_sharding2 = _interopRequireDefault(_job_sharding);

var _job_execution = __webpack_require__(1344);

var _job_execution2 = _interopRequireDefault(_job_execution);

var _job_alarm = __webpack_require__(1342);

var _job_alarm2 = _interopRequireDefault(_job_alarm);

var _job_history = __webpack_require__(1345);

var _job_history2 = _interopRequireDefault(_job_history);

var _job_message_history = __webpack_require__(1346);

var _job_message_history2 = _interopRequireDefault(_job_message_history);

var _dashboard_manage = __webpack_require__(1338);

var _dashboard_manage2 = _interopRequireDefault(_dashboard_manage);

var _dashboard_detail = __webpack_require__(1337);

var _dashboard_detail2 = _interopRequireDefault(_dashboard_detail);

var _domain_statistic = __webpack_require__(1339);

var _domain_statistic2 = _interopRequireDefault(_domain_statistic);

var _executor_statistic = __webpack_require__(1340);

var _executor_statistic2 = _interopRequireDefault(_executor_statistic);

var _job_statistic = __webpack_require__(1341);

var _job_statistic2 = _interopRequireDefault(_job_statistic);

var _registry_manage = __webpack_require__(1364);

var _registry_manage2 = _interopRequireDefault(_registry_manage);

var _clusters_manage = __webpack_require__(1361);

var _clusters_manage2 = _interopRequireDefault(_clusters_manage);

var _namespace_manage = __webpack_require__(1363);

var _namespace_manage2 = _interopRequireDefault(_namespace_manage);

var _alarm_manage = __webpack_require__(1332);

var _alarm_manage2 = _interopRequireDefault(_alarm_manage);

var _alarm_abnormal_jobs = __webpack_require__(1331);

var _alarm_abnormal_jobs2 = _interopRequireDefault(_alarm_abnormal_jobs);

var _alarm_timeout_jobs = __webpack_require__(1333);

var _alarm_timeout_jobs2 = _interopRequireDefault(_alarm_timeout_jobs);

var _unable_failover_jobs = __webpack_require__(1334);

var _unable_failover_jobs2 = _interopRequireDefault(_unable_failover_jobs);

var _alarm_abnormal_containers = __webpack_require__(1330);

var _alarm_abnormal_containers2 = _interopRequireDefault(_alarm_abnormal_containers);

var _system_config_manage = __webpack_require__(1369);

var _system_config_manage2 = _interopRequireDefault(_system_config_manage);

var _console_config = __webpack_require__(1366);

var _console_config2 = _interopRequireDefault(_console_config);

var _oauth_client_config = __webpack_require__(1367);

var _oauth_client_config2 = _interopRequireDefault(_oauth_client_config);

var _authority_manage = __webpack_require__(1335);

var _authority_manage2 = _interopRequireDefault(_authority_manage);

var _user_manage = __webpack_require__(1370);

var _user_manage2 = _interopRequireDefault(_user_manage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);

exports.default = new _vueRouter2.default({
  routes: [{
    path: _router_mapper2.default.GetPath('jobManage'),
    name: 'job_manage',
    component: _job_manage2.default
  }, {
    path: '/',
    redirect: 'job_manage'
  }, {
    path: _router_mapper2.default.GetPath('login'),
    name: 'login',
    component: _Login2.default
  }, {
    path: _router_mapper2.default.GetPath('jobList'),
    component: _job_list2.default,
    children: [{ path: '', redirect: 'job_overview' }, { name: 'job_overview', path: _router_mapper2.default.GetPath('jobOverview'), component: _job_overview2.default }, { name: 'executor_overview', path: _router_mapper2.default.GetPath('executorOverview'), component: _executor_overview2.default }, {
      path: _router_mapper2.default.GetPath('namespaceAlarmCenter'),
      component: _namespace_alarm_center2.default,
      name: 'namespace_alarm_center',
      children: [{ path: _router_mapper2.default.GetPath('namespaceAlarmCenter'), redirect: 'namespace_abnormal_jobs' }, { name: 'namespace_abnormal_jobs', path: _router_mapper2.default.GetPath('namespaceAbnormalJobs'), component: _namespace_abnormal_jobs2.default }, { name: 'namespace_timeout_jobs', path: _router_mapper2.default.GetPath('namespaceTimeoutJobs'), component: _namespace_timeout_jobs2.default }, { name: 'namespace_failover_jobs', path: _router_mapper2.default.GetPath('namespaceFailoverJobs'), component: _namespace_failover_jobs2.default }, { name: 'namespace_abnormal_containers', path: _router_mapper2.default.GetPath('namespaceAbnormalContainers'), component: _namespace_abnormal_containers2.default }]
    }]
  }, {
    path: _router_mapper2.default.GetPath('jobDetail'),
    component: _job_detail2.default,
    children: [{ path: '', redirect: 'job_setting' }, { name: 'job_setting', path: _router_mapper2.default.GetPath('jobSetting'), component: _job_setting2.default }, { name: 'job_sharding', path: _router_mapper2.default.GetPath('jobSharding'), component: _job_sharding2.default }, { name: 'job_execution', path: _router_mapper2.default.GetPath('jobExecution'), component: _job_execution2.default }, { name: 'job_alarm', path: _router_mapper2.default.GetPath('jobAlarm'), component: _job_alarm2.default }, { name: 'job_history', path: _router_mapper2.default.GetPath('jobHistory'), component: _job_history2.default }, { name: 'job_message_history', path: _router_mapper2.default.GetPath('jobMessageHistory'), component: _job_message_history2.default }]
  }, {
    path: _router_mapper2.default.GetPath('dashboardManage'),
    name: 'dashboard_manage',
    component: _dashboard_manage2.default
  }, {
    path: _router_mapper2.default.GetPath('dashboardDetail'),
    component: _dashboard_detail2.default,
    children: [{ path: '', redirect: 'domain_statistic' }, { name: 'domain_statistic', path: _router_mapper2.default.GetPath('domainStatistic'), component: _domain_statistic2.default }, { name: 'executor_statistic', path: _router_mapper2.default.GetPath('executorStatistic'), component: _executor_statistic2.default }, { name: 'job_statistic', path: _router_mapper2.default.GetPath('jobStatistic'), component: _job_statistic2.default }]
  }, {
    path: _router_mapper2.default.GetPath('registryManage'),
    component: _registry_manage2.default,
    children: [{ path: '', redirect: 'namespace_manage' }, { name: 'namespace_manage', path: _router_mapper2.default.GetPath('namespaceManage'), component: _namespace_manage2.default }, { name: 'clusters_manage', path: _router_mapper2.default.GetPath('clustersManage'), component: _clusters_manage2.default }]
  }, {
    path: _router_mapper2.default.GetPath('alarmManage'),
    component: _alarm_manage2.default,
    children: [{ path: '', redirect: 'alarm_abnormal_jobs' }, { name: 'alarm_abnormal_jobs', path: _router_mapper2.default.GetPath('alarmAbnormalJobs'), component: _alarm_abnormal_jobs2.default }, { name: 'alarm_timeout_jobs', path: _router_mapper2.default.GetPath('alarmTimeoutJobs'), component: _alarm_timeout_jobs2.default }, { name: 'unable_failover_jobs', path: _router_mapper2.default.GetPath('unableFailoverJobs'), component: _unable_failover_jobs2.default }, { name: 'alarm_abnormal_containers', path: _router_mapper2.default.GetPath('alarmAbnormalContainers'), component: _alarm_abnormal_containers2.default }]
  }, {
    path: _router_mapper2.default.GetPath('systemConfigManage'),
    component: _system_config_manage2.default,
    children: [{ path: '', redirect: 'console_config' }, { name: 'console_config', path: _router_mapper2.default.GetPath('consoleConfig'), component: _console_config2.default }, { name: 'oauth_client_config', path: _router_mapper2.default.GetPath('oauthClientConfig'), component: _oauth_client_config2.default }]
  }, {
    path: _router_mapper2.default.GetPath('authorityManage'),
    name: 'authority_manage',
    component: _authority_manage2.default
  }, {
    path: _router_mapper2.default.GetPath('userManage'),
    name: 'user_manage',
    component: _user_manage2.default
  }]
});

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _array = __webpack_require__(614);

var _array2 = _interopRequireDefault(_array);

var _request = __webpack_require__(193);

var _request2 = _interopRequireDefault(_request);

var _message = __webpack_require__(192);

var _message2 = _interopRequireDefault(_message);

var _validate = __webpack_require__(618);

var _validate2 = _interopRequireDefault(_validate);

var _router_mapper = __webpack_require__(289);

var _router_mapper2 = _interopRequireDefault(_router_mapper);

var _map = __webpack_require__(616);

var _map2 = _interopRequireDefault(_map);

var _option = __webpack_require__(617);

var _option2 = _interopRequireDefault(_option);

var _common = __webpack_require__(615);

var _common2 = _interopRequireDefault(_common);

var _apiMapper = __webpack_require__(288);

var _apiMapper2 = _interopRequireDefault(_apiMapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Utils = {
  array: _array2.default,
  http: _request2.default,
  message: _message2.default,
  validate: _validate2.default,
  routerMapper: _router_mapper2.default,
  map: _map2.default,
  option: _option2.default,
  common: _common2.default,
  apiMapper: _apiMapper2.default
};

Utils.install = function (Vue) {
  Vue.prototype.$array = _array2.default;
  Vue.prototype.$http = _request2.default;
  Vue.prototype.$message = _message2.default;
  Vue.prototype.$validate = _validate2.default;
  Vue.prototype.$routermapper = _router_mapper2.default;
  Vue.prototype.$map = _map2.default;
  Vue.prototype.$option = _option2.default;
  Vue.prototype.$common = _common2.default;
  Vue.prototype.$apiMapper = _apiMapper2.default;
};
exports.default = Utils;

/***/ }),
/* 562 */,
/* 563 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 564 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 565 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(964);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(1295)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./main.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./main.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 567 */,
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(619),
  /* template */
  __webpack_require__(1422),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(291);

var _assign2 = _interopRequireDefault(_assign);

var _values = __webpack_require__(697);

var _values2 = _interopRequireDefault(_values);

var _typeof2 = __webpack_require__(124);

var _typeof3 = _interopRequireDefault(_typeof2);

var _stringify = __webpack_require__(44);

var _stringify2 = _interopRequireDefault(_stringify);

var _main = __webpack_require__(1318);

var _main2 = _interopRequireDefault(_main);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_main2.default.install = function install(Vue, options) {
  var _ref = options || {},
      _ref$key = _ref.key,
      key = _ref$key === undefined ? 'oaName' : _ref$key,
      _ref$storage = _ref.storage,
      storage = _ref$storage === undefined ? localStorage : _ref$storage;

  Vue.directive('favorites', {
    bind: function bind(el, binding, vnode) {
      function handler() {
        var path = location.hash.substring(1);
        var title = path.split('?')[0].substring(1);
        var group = '';
        var map = JSON.parse(storage.getItem(key) || '{}');
        var parent = vnode.context;
        var self = vnode.componentInstance;
        if (binding.modifiers.del) {
          var item = map[binding.value];
          delete map[binding.value];
          storage.setItem(key, (0, _stringify2.default)(map));
          self.$emit('favorites-del', true, 'del', item);
        } else if (binding.modifiers.add) {
          if (!Object.prototype.hasOwnProperty.call(map, path)) {
            if (typeof binding.value === 'string') {
              title = binding.value;
            } else if ((0, _typeof3.default)(binding.value) === 'object') {
              if (binding.value.title) {
                title = binding.value.title;
              }
              if (binding.value.path) {
                path = binding.value.path;
              }
              if (binding.value.group) {
                group = binding.value.group;
              }
            }
            map[path] = { title: title, path: path, group: group, date: new Date() };
            storage.setItem(key, (0, _stringify2.default)(map));
            self.$emit('favorites-add', true, 'add', map[path]);
          } else {
            self.$emit('favorites-add', false, 'add', map[path]);
          }
        }
        parent.$set(parent, binding.arg || 'favorites', (0, _values2.default)(map));
        self.$emit('favorites-show', true, 'show', (0, _values2.default)(map));
      }
      if (el.addEventListener) {
        el.addEventListener('click', handler, false);
      } else if (el.attachEvent) {
        el.attachEvent('onclick', handler);
      } else {
        el.onclick = handler;
      }
    }
  });
  Vue.prototype.$favorites = function favorites(path, title, group) {
    var map = JSON.parse(storage.getItem(key) || '{}');
    if (title) {
      var index = path || location.hash.substring(1);
      (0, _assign2.default)(map[index], { title: title, group: group });
      storage.setItem(key, (0, _stringify2.default)(map));
      return map[index];
    } else if (path) {
      return map[path];
    }
    return (0, _values2.default)(map);
  };
  Vue.component(_main2.default.name, _main2.default);
};

exports.default = _main2.default;

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(44);

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var config = {};
function History(route) {
  var paths = JSON.parse(localStorage.getItem(config.key) || '[]');
  if (route && route.path && route.name === 'job_overview') {
    if (paths.length === config.max) {
      paths.pop();
    }
    var index = paths.findIndex(function (item) {
      return item.path === route.path;
    });
    if (index > -1) {
      paths.splice(index, 1);
    }
    paths.unshift({
      path: route.path,
      name: route.name,
      params: route.params
    });
    localStorage.setItem(config.key, (0, _stringify2.default)(paths));
  } else {
    return paths;
  }
}

History.install = function install(Vue, _ref) {
  var _ref$key = _ref.key,
      key = _ref$key === undefined ? 'history' : _ref$key,
      _ref$max = _ref.max,
      max = _ref$max === undefined ? 11 : _ref$max;

  config.key = key;
  config.max = max;
  Vue.mixin({
    beforeRouteEnter: function beforeRouteEnter(to, from, next) {
      next(function () {
        History(to);
      });
    },
    beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
      History(to);
      next();
    }
  });
  Vue.history = History;
  Vue.prototype.$history = History;
};
exports.default = History;

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(196);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(123);

var _extends3 = _interopRequireDefault(_extends2);

var _mutations, _actions;

var _types = __webpack_require__(613);

var types = _interopRequireWildcard(_types);

var _request = __webpack_require__(193);

var _request2 = _interopRequireDefault(_request);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  state: {
    allDomains: [],
    domainInfo: {
      nameAndNamespace: '',
      sysAdmin: '',
      techAdmin: ''
    },
    jobInfo: {},
    jobListInfo: {
      jobList: [],
      totalNumber: 0,
      enabledNumber: 0,
      abnormalNumber: 0,
      total: 0
    },
    userAuthority: {
      username: '',
      authority: []
    },
    isUseAuth: true
  },

  getters: {
    allDomains: function allDomains(state) {
      return state.allDomains;
    },
    domainInfo: function domainInfo(state) {
      return state.domainInfo;
    },
    jobInfo: function jobInfo(state) {
      return state.jobInfo;
    },
    jobListInfo: function jobListInfo(state) {
      return state.jobListInfo;
    },
    userAuthority: function userAuthority(state) {
      return state.userAuthority;
    },
    isUseAuth: function isUseAuth(state) {
      return state.isUseAuth;
    }
  },

  mutations: (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.SET_ALL_DOMAINS, function (state, item) {
    state.allDomains = item;
  }), (0, _defineProperty3.default)(_mutations, types.SET_DOMAIN_INFO, function (state, item) {
    state.domainInfo = (0, _extends3.default)({}, state.domainInfo, {
      nameAndNamespace: item.nameAndNamespace,
      sysAdmin: item.sysAdmin,
      techAdmin: item.techAdmin
    });
  }), (0, _defineProperty3.default)(_mutations, types.SET_JOB_INFO, function (state, item) {
    state.jobInfo = (0, _extends3.default)({}, item);
  }), (0, _defineProperty3.default)(_mutations, types.SET_JOB_LIST_INFO, function (state, item) {
    state.jobListInfo = (0, _extends3.default)({}, state.jobListInfo, {
      jobList: item.jobList,
      totalNumber: item.totalNumber,
      enabledNumber: item.enabledNumber,
      abnormalNumber: item.abnormalNumber,
      total: item.total
    });
    console.log(state.jobListInfo);
  }), (0, _defineProperty3.default)(_mutations, types.SET_USER_AUTHORITY, function (state, item) {
    state.userAuthority = (0, _extends3.default)({}, state.userAuthority, {
      username: item.username,
      authority: item.authority
    });
    console.log(state.userAuthority);
  }), (0, _defineProperty3.default)(_mutations, types.SET_IS_USE_AUTH, function (state, item) {
    state.isUseAuth = item;
  }), _mutations),

  actions: (_actions = {}, (0, _defineProperty3.default)(_actions, types.SET_ALL_DOMAINS, function (_ref, allDomains) {
    var commit = _ref.commit;

    commit(types.SET_ALL_DOMAINS, allDomains);
  }), (0, _defineProperty3.default)(_actions, types.SET_DOMAIN_INFO, function (_ref2, domainInfo) {
    var commit = _ref2.commit;

    commit(types.SET_DOMAIN_INFO, domainInfo);
  }), (0, _defineProperty3.default)(_actions, types.SET_JOB_INFO, function (_ref3, jobInfoParams) {
    var commit = _ref3.commit;

    return _request2.default.get('/console/namespaces/' + jobInfoParams.domainName + '/jobs/' + jobInfoParams.jobName + '/config').then(function (data) {
      commit(types.SET_JOB_INFO, data);
      return data;
    });
  }), (0, _defineProperty3.default)(_actions, types.SET_JOB_LIST_INFO, function (_ref4, jobListInfoParams) {
    var commit = _ref4.commit;

    return _request2.default.get('/console/namespaces/' + jobListInfoParams.domainName + '/jobs').then(function (data) {
      var dataResult = {
        jobList: data.jobs,
        totalNumber: data.totalNumber,
        enabledNumber: data.enabledNumber,
        abnormalNumber: data.abnormalNumber,
        total: data.jobs.length
      };
      commit(types.SET_JOB_LIST_INFO, dataResult);
      return data;
    });
  }), (0, _defineProperty3.default)(_actions, types.SET_USER_AUTHORITY, function (_ref5) {
    var commit = _ref5.commit;

    return _request2.default.get('/console/authorization/loginUser').then(function (data) {
      var storeUserAuthority = {
        username: data.userName,
        authority: []
      };
      if (data.userRoles.length > 0) {
        data.userRoles.forEach(function (ele) {
          var permission = {
            namespace: ele.namespace,
            isRelatingToNamespace: ele.role.isRelatingToNamespace,
            permissionList: []
          };
          ele.role.rolePermissions.forEach(function (ele2) {
            permission.permissionList.push(ele2.permissionKey);
          });
          storeUserAuthority.authority.push(permission);
        });
      }
      commit(types.SET_USER_AUTHORITY, storeUserAuthority);
      return data;
    });
  }), (0, _defineProperty3.default)(_actions, types.SET_IS_USE_AUTH, function (_ref6, isUseAuth) {
    var commit = _ref6.commit;

    commit(types.SET_IS_USE_AUTH, isUseAuth);
  }), _actions)
};

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SET_ALL_DOMAINS = exports.SET_ALL_DOMAINS = 'setAllDomains';

var SET_DOMAIN_INFO = exports.SET_DOMAIN_INFO = 'setDomainInfo';

var SET_JOB_INFO = exports.SET_JOB_INFO = 'setJobInfo';

var SET_JOB_LIST_INFO = exports.SET_JOB_LIST_INFO = 'setJobListInfo';

var SET_USER_AUTHORITY = exports.SET_USER_AUTHORITY = 'setUserAuthority';

var SET_IS_USE_AUTH = exports.SET_IS_USE_AUTH = 'setIsUseAuth';

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(696);

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  removeByValue: function removeByValue(arr, val) {
    (0, _keys2.default)(arr).forEach(function (element, index) {
      if (arr[index] === val) {
        arr.splice(index, 1);
      }
    });
  },
  isContainValue: function isContainValue(arr, val) {
    var flag = false;
    if (arr.length > 0) {
      flag = arr.some(function (element) {
        if (element === val) {
          return true;
        }
        return false;
      });
    }
    return flag;
  },
  strToArray: function strToArray(str) {
    if (str !== '') {
      if (str.indexOf(',') > 0) {
        var arr = str.split(',');
        return arr;
      }
      return [str];
    }
    return [];
  }
};

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _set = __webpack_require__(292);

var _set2 = _interopRequireDefault(_set);

var _from = __webpack_require__(194);

var _from2 = _interopRequireDefault(_from);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

var _store = __webpack_require__(190);

var _store2 = _interopRequireDefault(_store);

var _request = __webpack_require__(193);

var _request2 = _interopRequireDefault(_request);

var _message = __webpack_require__(192);

var _message2 = _interopRequireDefault(_message);

var _apiMapper = __webpack_require__(288);

var _apiMapper2 = _interopRequireDefault(_apiMapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  hasPerm: function hasPerm(permission, namespace) {
    var flag = false;
    var isUseAuth = _store2.default.getters.isUseAuth;
    var myPermissions = _store2.default.getters.userAuthority;
    if (isUseAuth) {
      if (myPermissions.authority) {
        var isAllNamespace = myPermissions.authority.some(function (ele) {
          if (!ele.isRelatingToNamespace) {
            return true;
          }
          return false;
        });
        if (isAllNamespace) {
          var allPermission = this.getAllPermisson(myPermissions.authority);
          if (allPermission) {
            flag = allPermission.indexOf(permission) > -1;
          }
        } else {
          var permissionArr = this.getNamepacePermisson(myPermissions.authority, namespace);
          if (permissionArr) {
            flag = permissionArr.indexOf(permission) > -1;
          }
        }
      }
    } else {
      flag = true;
    }
    return flag;
  },
  getAllPermisson: function getAllPermisson(authorityArray) {
    var allPermissionsArray = [];
    authorityArray.forEach(function (ele) {
      if (!ele.isRelatingToNamespace) {
        ele.permissionList.forEach(function (ele1) {
          allPermissionsArray.push(ele1);
        });
      }
    });
    return (0, _from2.default)(new _set2.default(allPermissionsArray));
  },
  getNamepacePermisson: function getNamepacePermisson(authorityArray, namespace) {
    var allPermissionsArray = [];
    authorityArray.forEach(function (ele) {
      if (ele.namespace === namespace) {
        ele.permissionList.forEach(function (ele2) {
          allPermissionsArray.push(ele2);
        });
      }
    });
    return (0, _from2.default)(new _set2.default(allPermissionsArray));
  },
  isContainDomain: function isContainDomain(value, arr) {
    return arr.some(function (ele) {
      if (ele.value === value) {
        return true;
      }
      return false;
    });
  },
  formatDate: function formatDate(time, format) {
    var date = new Date(time);
    var formatTime = (0, _moment2.default)(date).format(format);
    return formatTime;
  },
  handleDump: function handleDump(row, domainName, dumpNext) {
    _message2.default.confirmMessage('\u786E\u5B9Adump ' + row.executorName + ' \u5417?', function () {
      _request2.default.post(_apiMapper2.default.GetUrl('executor_dump', { domainName: domainName, executorName: row.executorName }), '').then(function () {
        dumpNext();
      }).catch(function () {
        _request2.default.buildErrorHandler('一键DUMP请求失败！');
      });
    });
  }
};

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  degreeMap: {
    '': '没有定义',
    0: '没有定义',
    1: '非线上业务',
    2: '简单业务',
    3: '一般业务',
    4: '重要业务',
    5: '核心业务'
  },
  causeMap: {
    NOT_RUN: '过时未跑',
    NO_SHARDS: '没有分片',
    EXECUTORS_NOT_READY: '没有executor能运行该作业'
  },
  jobTypeMap: {
    JAVA_JOB: 'JAVA定时',
    SHELL_JOB: 'SHELL定时',
    PASSIVE_JAVA_JOB: 'JAVA被动',
    PASSIVE_SHELL_JOB: 'SHELL被动'
  },
  jobStatusMap: {
    READY: '已就绪',
    RUNNING: '运行中',
    STOPPING: '停止中',
    STOPPED: '已停止'
  }
};

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  jobTypes: [{
    value: 'JAVA_JOB',
    label: 'Java定时作业'
  }, {
    value: 'SHELL_JOB',
    label: 'Shell定时作业'
  }, {
    value: 'PASSIVE_JAVA_JOB',
    label: 'Java被动作业'
  }, {
    value: 'PASSIVE_SHELL_JOB',
    label: 'Shell被动作业'
  }],
  isJava: function isJava(jobType) {
    return jobType === this.jobTypes[0].value || jobType === this.jobTypes[2].value || jobType === 'MSG_JOB';
  },
  isShell: function isShell(jobType) {
    return jobType === this.jobTypes[1].value || jobType === this.jobTypes[3].value || jobType === 'VSHELL';
  },
  isCron: function isCron(jobType) {
    return jobType === this.jobTypes[0].value || jobType === this.jobTypes[1].value;
  },
  isPassive: function isPassive(jobType) {
    return jobType === this.jobTypes[2].value || jobType === this.jobTypes[3].value;
  },
  isMsg: function isMsg(jobType) {
    return jobType === 'MSG_JOB' || jobType === 'VSHELL';
  },

  jobStatusTypes: [{
    value: 0,
    label: '已停止'
  }, {
    value: 1,
    label: '已就绪'
  }, {
    value: 2,
    label: '运行中'
  }, {
    value: 3,
    label: '停止中'
  }]
};

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _from = __webpack_require__(194);

var _from2 = _interopRequireDefault(_from);

var _parseInt = __webpack_require__(290);

var _parseInt2 = _interopRequireDefault(_parseInt);

var _store = __webpack_require__(190);

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isIPv4 = function isIPv4(ip) {
  var re = /^(\d+)\.(\d+)\.(\d+)\.(\d+)$/;
  if (re.test(ip)) {
    if (RegExp.$1 <= 255 && RegExp.$1 >= 0 && RegExp.$2 <= 255 && RegExp.$2 >= 0 && RegExp.$3 <= 255 && RegExp.$3 >= 0 && RegExp.$4 <= 255 && RegExp.$4 >= 0) {
      return true;
    }
    return false;
  }
  return false;
};

var isPort = function isPort(str) {
  var parten = /^(\d)+$/g;
  if (parten.test(str) && (0, _parseInt2.default)(str, 10) <= 65535 && (0, _parseInt2.default)(str, 10) >= 0) {
    return true;
  }
  return false;
};

var isCharacterAndNumber = function isCharacterAndNumber(str, symbolArr) {
  var flag = true;
  var parten = /[^a-zA-Z0-9-_.]/g;
  if (!symbolArr) {
    if (parten.test(str)) {
      flag = false;
    }
  } else {
    var isError = symbolArr.some(function (element) {
      if (parten.test(str) || str.indexOf(element) >= 0) {
        return true;
      }
      return false;
    });
    if (isError) {
      flag = false;
    }
  }
  return flag;
};

var isIpAndPort = function isIpAndPort(str) {
  var num = 0;
  if (str) {
    if (str.indexOf(':') <= 0) {
      num = 1;
    } else {
      var arr = str.split(':');
      if (!isIPv4(arr[0])) {
        num = 2;
      }
      if (!isPort(arr[1])) {
        num = 3;
      }
    }
  }
  return num;
};

var isContainEnglishCapital = function isContainEnglishCapital(str) {
  var arr = (0, _from2.default)(str);
  return arr.some(function (ele) {
    if (ele.charCodeAt(0) >= 65 && ele.charCodeAt(0) <= 90) {
      return true;
    }
    return false;
  });
};

exports.default = {
  validateIp: function validateIp(rule, value, callback) {
    if (value === '') {
      callback(new Error('请输入ip地址'));
    } else {
      if (!isIPv4(value)) {
        callback(new Error('请输入正确的ip'));
      }
      callback();
    }
  },
  validatePort: function validatePort(rule, value, callback) {
    if (value === '') {
      callback(new Error('请输入端口号'));
    } else {
      if (!isPort(value)) {
        callback(new Error('请输入正确的端口号'));
      }
      callback();
    }
  },
  validateIpPort: function validateIpPort(rule, value, callback) {
    if (!value) {
      callback(new Error('请输入ip及端口号'));
    } else {
      if (value.indexOf(':') <= 0) {
        callback(new Error('请输入正确的ip端口号，以:连接'));
      } else {
        var arr = value.split(':');
        if (!isIPv4(arr[0])) {
          callback(new Error('请输入正确的ip'));
        }
        if (!isPort(arr[1])) {
          callback(new Error('请输入正确的端口号'));
        }
      }
      callback();
    }
  },
  validateMultipleIpPort: function validateMultipleIpPort(rule, value, callback) {
    if (!value) {
      callback(new Error('请输入ip及端口号'));
    } else {
      if (value.indexOf(',') <= 0) {
        if (isIpAndPort(value) !== 0) {
          callback(new Error('请输入正确的ip端口号，以:连接'));
        }
        callback();
      } else {
        var arr2 = value.split(',');
        var isError = arr2.some(function (element) {
          if (isIpAndPort(element) !== 0) {
            return true;
          }
          return false;
        });
        if (isError) {
          callback(new Error('请输入正确的ip端口号，以:连接'));
        }
      }
      callback();
    }
  },
  validateCharacterAndNumber: function validateCharacterAndNumber(rule, value, callback) {
    if (value === '') {
      callback(new Error('该内容不能为空'));
    } else {
      if (!isCharacterAndNumber(value)) {
        callback(new Error('不允许中文和特殊字符'));
      }
      callback();
    }
  },
  validateCharacterAndNumberIsExcludePointAndBar: function validateCharacterAndNumberIsExcludePointAndBar(rule, value, callback) {
    if (value === '') {
      callback(new Error('该内容不能为空'));
    } else {
      var arr = ['.', '-'];
      if (!isCharacterAndNumber(value, arr)) {
        callback(new Error('不允许输入中文和特殊字符'));
      }
      if (isContainEnglishCapital(value)) {
        callback(new Error('不允许输入英文大写'));
      }
      callback();
    }
  },
  validateArray: function validateArray(rule, value, callback) {
    if (Array.isArray(value)) {
      if (value.length === 0) {
        callback(new Error('内容为空，请选择'));
      }
      callback();
    }
  },
  validateContainDomain: function validateContainDomain(rule, value, callback) {
    if (!value) {
      callback(new Error('请选择域名'));
    } else {
      var flag = _store2.default.getters.allDomains.some(function (ele) {
        return ele.value === value;
      });
      if (!flag) {
        callback(new Error('该域不存在，请重新选择！'));
      }
      callback();
    }
  }
};

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(38);

var _promise2 = _interopRequireDefault(_promise);

var _vue = __webpack_require__(32);

var _vue2 = _interopRequireDefault(_vue);

var _Login = __webpack_require__(534);

var _Login2 = _interopRequireDefault(_Login);

var _favorites = __webpack_require__(610);

var _favorites2 = _interopRequireDefault(_favorites);

var _history = __webpack_require__(611);

var _history2 = _interopRequireDefault(_history);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      loading: false,
      initialized: false
    };
  },

  methods: {
    loginSuccess: function loginSuccess() {
      this.init();
    },
    loadAllDomains: function loadAllDomains() {
      var _this = this;

      return this.$http.get('/console/namespaces').then(function (data) {
        var allNamespaces = data.map(function (obj) {
          var rObj = {};
          rObj.value = obj;
          return rObj;
        });
        _this.$store.dispatch('setAllDomains', allNamespaces);
      }).catch(function () {
        _this.$http.buildErrorHandler('获取namespaces失败！');
      });
    },
    getUseAuth: function getUseAuth() {
      var _this2 = this;

      return this.$http.get('/console/authorization/isAuthorizationEnabled').then(function (data) {
        _this2.$store.dispatch('setIsUseAuth', data);
      }).catch(function () {
        _this2.$http.buildErrorHandler('获取权限开关请求失败！');
      });
    },
    getLoginUser: function getLoginUser() {
      var _this3 = this;

      return this.$store.dispatch('setUserAuthority').then(function (resp) {
        _vue2.default.use(_favorites2.default, { key: resp.userName });
        _vue2.default.use(_history2.default, { key: 'history_' + resp.userName });
      }).catch(function () {
        return _this3.$http.buildErrorHandler('获取用户请求失败！');
      });
    },
    init: function init() {
      var _this4 = this;

      this.loading = true;
      _promise2.default.all([this.getLoginUser(), this.getUseAuth(), this.loadAllDomains()]).then(function () {
        _this4.loading = false;
        _this4.initialized = true;
      });
    }
  },
  computed: {
    initComponent: function initComponent() {
      var resultComponent = '';
      if (this.$route.path === '/login') {
        resultComponent = 'Login';
      } else {
        resultComponent = 'Container';
      }
      return resultComponent;
    }
  },
  created: function created() {
    this.init();
  },

  components: {
    Login: _Login2.default
  }
};

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      loading: false,
      loginInfo: {
        username: '',
        password: '',
        authentication: ''
      },
      loginErrorMsg: ''
    };
  },

  methods: {
    login: function login() {
      var _this = this;

      this.loading = true;
      this.$http.post('/console/authentication/login', this.loginInfo).then(function (data) {
        if (data.status === 1) {
          _this.loginErrorMsg = data.message;
        } else {
          _this.$router.push({ path: '/' });
          _this.$emit('login-success');
        }
      }).catch(function (ret) {
        _this.$http.buildErrorHandler(ret.response.data.message);
      }).finally(function () {
        _this.loading = false;
      });
    }
  },
  created: function created() {}
};

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: ['abnormalContainersList'],
  data: function data() {
    return {
      filters: {
        taskId: { value: '' }
      },
      orderBy: 'taskId',
      total: this.abnormalContainersList.length
    };
  },

  methods: {
    refreshList: function refreshList() {
      this.$emit('refresh-list');
    }
  }
};

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: ['abnormalJobsList'],
  data: function data() {
    return {
      filters: {
        jobName: { value: '' }
      },
      orderBy: 'jobName',
      total: this.abnormalJobsList.length
    };
  },

  methods: {
    refreshList: function refreshList() {
      this.$emit('refresh-list');
    },
    handleRead: function handleRead(row) {
      var params = {
        uuid: row.uuid,
        domainName: row.domainName
      };
      this.$emit('no-alarm', params);
    }
  }
};

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: ['sidebarMenus', 'headerHeight'],
  data: function data() {
    var activeMenu = this.getActiveMenu();
    return {
      collapse: false,
      activeMenu: activeMenu,
      sidebarHeight: {
        height: document.documentElement.clientHeight - this.headerHeight
      }
    };
  },

  methods: {
    collapseChange: function collapseChange() {
      this.collapse = !this.collapse;
    },
    init: function init() {
      this.activeMenu = this.getActiveMenu();
    },
    getActiveMenu: function getActiveMenu() {
      var pathArr = this.$route.path.split('/');
      if (pathArr[1] === 'job_list') {
        return pathArr[3];
      } else if (pathArr[1] === 'job_detail') {
        return pathArr[4];
      }
      return this.$route.name;
    }
  },
  watch: {
    $route: 'init'
  },
  computed: {
    styleObject: function styleObject() {
      return {
        paddingLeft: this.collapse ? '15px' : '30px'
      };
    },
    siderWidth: function siderWidth() {
      var w = void 0;
      if (this.collapse) {
        w = '50px';
      } else {
        w = '190px';
      }
      return w;
    }
  },
  mounted: function mounted() {
    this.sidebarHeight = { height: document.documentElement.clientHeight - this.headerHeight };
    var that = this;
    window.onresize = function temp() {
      that.sidebarHeight = { height: document.documentElement.clientHeight - that.headerHeight };
    };
  }
};

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: ['items']
};

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(196);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ['type', 'title', 'icon', 'num', 'toUrl', 'urlQuery'],
  data: function data() {
    return {};
  },

  methods: {
    viewDetail: function viewDetail() {
      this.$router.push({ name: this.toUrl, query: { zkCluster: this.urlQuery } });
    }
  },
  computed: {
    panelType: function panelType() {
      var obj = (0, _defineProperty3.default)({}, 'card-panel-' + this.type, true);
      return obj;
    }
  }
};

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: ['title', 'type'],
  data: function data() {
    return {
      isExpand: true
    };
  },

  computed: {
    chartIcon: function chartIcon() {
      return 'fa fa-' + this.type + '-chart';
    }
  },
  methods: {
    togglePanel: function togglePanel() {
      this.isExpand = !this.isExpand;
    }
  }
};

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _echarts = __webpack_require__(171);

var _echarts2 = _interopRequireDefault(_echarts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(349);

exports.default = {
  props: ['id', 'optionInfo'],
  data: function data() {
    return {
      myChart: {},
      option: {
        color: ['#7CB5EC'],
        tooltip: {},
        grid: {
          top: '40',
          left: '3%',
          right: '3%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [{
          type: 'category',
          data: [],
          axisLabel: {
            show: true,
            interval: 0,
            rotate: '20',
            formatter: function formatter(value) {
              var str = value.length < 15 ? value : value.substr(0, 13) + '...';
              return str;
            }
          }
        }],
        yAxis: [{
          type: 'value',
          name: ''
        }],
        series: [{
          type: 'bar',
          barWidth: '40%',
          itemStyle: {
            normal: {
              label: {
                show: true,
                position: 'top',
                textStyle: {
                  fontWeight: 'bold',
                  color: 'gray',
                  fontSize: 11
                }
              }
            }
          },
          data: []
        }]
      }
    };
  },

  watch: {
    optionInfo: {
      handler: function handler() {
        this.drawLine();
      },

      deep: true
    }
  },
  methods: {
    resize: function resize() {
      var _this = this;

      window.addEventListener('resize', function () {
        _this.myChart.resize();
      });
    },
    handleClick: function handleClick() {
      var _this2 = this;

      this.myChart.on('click', function (handler) {
        if (handler.data.columnType === 'domain') {
          _this2.$router.push({ name: 'job_overview', params: { domain: handler.data.domainName } });
        } else if (handler.data.columnType === 'job') {
          _this2.$router.push({ name: 'job_setting', params: { domain: handler.data.domainName, jobName: handler.data.jobName } });
        }
      });
    },
    drawLine: function drawLine() {
      this.option.xAxis[0].data = this.optionInfo.xCategories;
      this.option.yAxis[0].name = this.optionInfo.yTitle;
      this.option.tooltip = this.optionInfo.tooltip;
      this.option.series[0].data = this.optionInfo.seriesData;
      this.myChart = _echarts2.default.init(document.getElementById(this.id));
      this.myChart.setOption(this.option);
      this.resize();
      this.handleClick();
    }
  },
  mounted: function mounted() {
    this.drawLine();
  }
};

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(123);

var _extends3 = _interopRequireDefault(_extends2);

var _echarts = __webpack_require__(171);

var _echarts2 = _interopRequireDefault(_echarts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(360);

exports.default = {
  props: ['id', 'optionInfo'],
  data: function data() {
    return {
      myChart: {},
      option: {
        title: {
          text: null
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {},
        grid: {
          top: '40',
          left: '3%',
          right: '3%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: []
        },
        yAxis: {
          type: 'value',
          name: ''
        },
        series: []
      }
    };
  },

  watch: {
    optionInfo: {
      handler: function handler() {
        this.drawLine();
      },

      deep: true
    }
  },
  methods: {
    resize: function resize() {
      var _this = this;

      window.addEventListener('resize', function () {
        _this.myChart.resize();
      });
    },
    drawLine: function drawLine() {
      var _this2 = this;

      var seriesArray = this.optionInfo.seriesData.map(function (obj) {
        var rObj = (0, _extends3.default)({}, obj);
        var itemStyle = {
          normal: {
            label: {
              show: true,
              position: 'top',
              textStyle: {
                fontWeight: 'bold',
                color: 'gray',
                fontSize: 11
              }
            }
          }
        };
        _this2.$set(rObj, 'type', 'line');
        _this2.$set(rObj, 'itemStyle', itemStyle);
        return rObj;
      });
      this.option.xAxis.data = this.optionInfo.xAxis;
      this.option.yAxis.name = this.optionInfo.yAxisName;
      this.option.series = seriesArray;
      this.myChart = _echarts2.default.init(document.getElementById(this.id));
      this.myChart.setOption(this.option);
      this.resize();
    }
  },
  mounted: function mounted() {}
};

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _echarts = __webpack_require__(171);

var _echarts2 = _interopRequireDefault(_echarts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(364);

exports.default = {
  props: ['id', 'optionInfo'],
  data: function data() {
    return {
      myChart: {},
      option: {
        title: {
          show: false,
          text: ''
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        legend: {
          orient: 'vertical',
          left: 'left'
        },
        series: []
      }
    };
  },

  watch: {
    optionInfo: {
      handler: function handler() {
        this.drawLine();
      },

      deep: true
    }
  },
  methods: {
    resize: function resize() {
      var _this = this;

      window.addEventListener('resize', function () {
        _this.myChart.resize();
      });
    },
    drawLine: function drawLine() {
      this.option.series = this.optionInfo.seriesData;
      this.myChart = _echarts2.default.init(document.getElementById(this.id));
      this.myChart.setOption(this.option);
      this.resize();
    }
  },
  mounted: function mounted() {}
};

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _echarts = __webpack_require__(171);

var _echarts2 = _interopRequireDefault(_echarts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(352);

exports.default = {
  props: ['id', 'optionInfo'],
  data: function data() {
    return {
      myChart: {},
      option: {
        symbolSize: 45,
        tooltip: {
          show: true,
          formatter: function formatter(params) {
            return params.dataType === 'node' ? params.data.description : params.name;
          }
        },
        legend: {
          show: true
        },
        animationDurationUpdate: 1500,
        animationEasingUpdate: 'quinticInOut',
        series: [{
          type: 'graph',
          layout: 'none',
          focusNodeAdjacency: true,
          circular: {
            rotateLabel: true
          },
          animation: true,
          symbolSize: 45,
          roam: true,
          draggable: false,
          label: {
            normal: {
              show: true }
          },
          edgeSymbol: ['circle', 'arrow'],
          edgeSymbolSize: [4, 10],
          edgeLabel: {
            normal: {
              textStyle: {
                fontSize: 10
              }
            }
          },
          data: [],
          links: [],
          categories: [],
          lineStyle: {
            normal: {
              opacity: 0.9,
              width: 2,
              curveness: 0
            }
          }
        }]
      }
    };
  },

  watch: {
    optionInfo: {
      handler: function handler() {
        this.drawLine();
      },

      deep: true
    }
  },
  methods: {
    initInvisibleGraphic: function initInvisibleGraphic() {
      var _this = this;

      this.myChart.setOption({
        graphic: _echarts2.default.util.map(this.option.series[0].data, function (item, dataIndex) {
          var tmpPos = _this.myChart.convertToPixel({ seriesIndex: 0 }, [item.x, item.y]);
          return {
            type: 'circle',
            id: dataIndex,
            position: tmpPos,
            shape: {
              cx: 0,
              cy: 0,
              r: 20
            },
            invisible: true,
            draggable: true,
            ondrag: _echarts2.default.util.curry(_this.onPointDragging(), dataIndex),
            z: 100
          };
        })
      });
      window.addEventListener('resize', this.updatePosition);
      this.myChart.on('dataZoom', this.updatePosition);
    },
    updatePosition: function updatePosition() {
      var _this2 = this;

      this.myChart.setOption({
        graphic: _echarts2.default.util.map(this.option.series[0].data, function (item) {
          var tmpPos = _this2.myChart.convertToPixel({ seriesIndex: 0 }, [item.x, item.y]);
          return {
            position: tmpPos
          };
        })
      });
    },
    onPointDragging: function onPointDragging() {
      var self = this;
      return function getXY(dataIndex) {
        var tmpPos = self.myChart.convertFromPixel({ seriesIndex: 0 }, this.position);
        self.option.series[0].data[dataIndex].x = tmpPos[0];
        self.option.series[0].data[dataIndex].y = tmpPos[1];
        self.myChart.setOption(self.option);
        self.updatePosition();
      };
    },
    resize: function resize() {
      var _this3 = this;

      window.addEventListener('resize', function () {
        _this3.myChart.resize();
      });
    },
    handleClick: function handleClick() {
      var _this4 = this;

      this.myChart.on('click', function (handler) {
        if (handler.dataType === 'node') {
          _this4.$emit('job-redirect', handler.data.name);
        }
      });
    },
    drawLine: function drawLine() {
      if (this.optionInfo) {
        this.option.series[0].data = this.optionInfo.data;
        this.option.series[0].links = this.optionInfo.links;
        this.option.series[0].categories = this.optionInfo.categories;
        this.myChart = _echarts2.default.init(document.getElementById(this.id));
        this.myChart.setOption(this.option);
        this.resize();
        this.handleClick();
      }
    }
  },
  mounted: function mounted() {
    this.drawLine();
  }
};

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: ['cronPredictParams'],
  data: function data() {
    return {
      isVisible: true,
      cronPredictInfo: {},
      result: '失败'
    };
  },

  methods: {
    closeDialog: function closeDialog() {
      this.$emit('close-dialog');
    },
    checkAndForecastCron: function checkAndForecastCron() {
      var _this = this;

      this.$http.post('/console/utils/checkAndForecastCron', this.cronPredictParams).then(function (data) {
        _this.cronPredictInfo = data;
        _this.result = '成功';
      }).catch(function () {
        _this.$http.buildErrorHandler('预测请求失败！');
      });
    }
  },
  created: function created() {
    this.checkAndForecastCron();
  }
};

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: ['type'],
  data: function data() {
    return {
      isVisible: true,
      loading: false,
      configInfo: {
        key: '',
        value: ''
      },
      rules: {
        key: [{ required: true, message: '请输入key', trigger: 'blur' }],
        value: [{ required: true, message: '请输入value', trigger: 'blur' }]
      }
    };
  },

  methods: {
    handleSubmit: function handleSubmit() {
      var _this = this;

      this.$refs.configInfo.validate(function (valid) {
        if (valid) {
          var url = _this.type === 'console' ? '/console/configs/' + _this.type + '/create' : '/console/configs/' + _this.type;
          _this.$http.post(url, _this.configInfo).then(function () {
            _this.$emit('add-config-success');
          }).catch(function () {
            _this.$http.buildErrorHandler('添加系统配置请求失败！');
          });
        }
      });
    },
    closeDialog: function closeDialog() {
      this.$emit('close-dialog');
    }
  },
  computed: {}
};

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(123);

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ['arrangeLayoutInfo'],
  data: function data() {
    return {
      isVisible: true,
      loading: false,
      initX: 0,
      initY: 300
    };
  },

  methods: {
    closeDialog: function closeDialog() {
      this.$emit('close-dialog');
    },
    getRelateDataXY: function getRelateDataXY(relatesData) {
      var _this = this;

      var dataX = this.initX;
      var dataY = this.initY;
      var resultData = [];
      relatesData.forEach(function (ele) {
        dataX += 150;
        if (ele.length > 1) {
          var count = 0;
          if (ele.length % 2 === 0) {
            dataY = _this.initY - 25;
          } else {
            dataY = _this.initY;
          }
          ele.forEach(function (ele2, index2) {
            if (index2 > 0) {
              count += 1;
              if (index2 % 2 === 1) {
                dataY += count * 50;
              } else {
                dataY -= count * 50;
              }
            }
            _this.$set(ele2, 'x', dataX);
            _this.$set(ele2, 'y', dataY);
            resultData.push(ele2);
          });
        } else {
          _this.$set(ele[0], 'x', dataX);
          _this.$set(ele[0], 'y', _this.initY);
          resultData.push(ele[0]);
        }
      });
      return resultData;
    },
    jobRedirect: function jobRedirect(jobName) {
      this.$emit('job-redirect', jobName);
    },
    isLineCurve: function isLineCurve(allDatas, sourceData, targetData) {
      var flag = false;
      flag = allDatas.some(function (ele) {
        if (sourceData.y === targetData.y) {
          if (ele.y === sourceData.y && ele.x > sourceData.x && ele.x < targetData.x) {
            return true;
          }
        } else if (sourceData.x === targetData.x) {
          if (ele.x === sourceData.x && ele.y > Math.min(sourceData.y, targetData.y) && ele.y < Math.max(sourceData.y, targetData.y)) {
            return true;
          }
        } else {
          console.log('line');
          if (ele.x > Math.min(sourceData.x, targetData.x) && ele.x < Math.max(sourceData.x, targetData.x) && ele.y > Math.min(sourceData.y, targetData.y) && ele.y < Math.max(sourceData.y, targetData.y)) {
            if (Math.abs((ele.x - sourceData.x) / (ele.y - sourceData.y)) === Math.abs((targetData.x - ele.x) / (targetData.y - ele.y))) {
              return true;
            }
          }
        }
        return false;
      });
      return flag;
    }
  },
  computed: {
    optionInfo: function optionInfo() {
      var _this2 = this;

      var resultInfo = {
        links: [],
        data: [],
        categories: []
      };
      var relateDatas = [];
      this.arrangeLayoutInfo.levels.forEach(function (ele) {
        var levelItem = ele.map(function (obj) {
          var rObj = (0, _extends3.default)({}, obj);
          rObj.category = _this2.$map.jobStatusMap[obj.jobStatus];
          return rObj;
        });
        relateDatas.push(levelItem);
      });
      resultInfo.data = this.getRelateDataXY(relateDatas);
      resultInfo.links = this.arrangeLayoutInfo.paths.map(function (item) {
        var lineParams = {
          normal: {
            curveness: 0.2
          }
        };
        var rObj = {};
        rObj.source = item.source;
        rObj.target = item.target;
        var sourceData = resultInfo.data.find(function (v) {
          return v.name === item.source;
        });
        var targetData = resultInfo.data.find(function (v) {
          return v.name === item.target;
        });
        if (_this2.isLineCurve(resultInfo.data, sourceData, targetData)) {
          rObj.lineStyle = lineParams;
        }
        return rObj;
      });
      resultInfo.categories = [{
        name: this.$map.jobStatusMap.READY,
        itemStyle: { color: '#487bb0' }
      }, {
        name: this.$map.jobStatusMap.RUNNING,
        itemStyle: { color: '#23ad07' }
      }, {
        name: this.$map.jobStatusMap.STOPPING,
        itemStyle: { color: '#E6A23C' }
      }, {
        name: this.$map.jobStatusMap.STOPPED,
        itemStyle: { color: '#808080' }
      }];
      return resultInfo;
    }
  }
};

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: ['batchMigrateInfo', 'zkClusterKeys'],
  data: function data() {
    return {
      isVisible: true,
      loading: false,
      rules: {
        zkClusterKeyNew: [{ required: true, message: '请选择目标集群', trigger: 'change' }]
      }
    };
  },

  methods: {
    handleSubmit: function handleSubmit() {
      var _this = this;

      this.$refs.batchMigrateInfo.validate(function (valid) {
        if (valid) {
          _this.$message.confirmMessage('\u786E\u5B9A\u5C06\u8FD9 ' + _this.batchMigrateInfo.namespacesArray.length + ' \u4E2A\u57DF\u8FC1\u79FB\u5230 ' + _this.batchMigrateInfo.zkClusterKeyNew + ' \u5417?', function () {
            _this.migrateRequest();
          });
        }
      });
    },
    migrateRequest: function migrateRequest() {
      var _this2 = this;

      var params = {
        namespaces: this.batchMigrateInfo.namespacesArray.join(','),
        zkClusterKeyNew: this.batchMigrateInfo.zkClusterKeyNew
      };
      this.$http.post('/console/namespaces/zkCluster/migrate', params).then(function () {
        _this2.$emit('batch-migrate-complete', _this2.batchMigrateInfo.zkClusterKeyNew);
      }).catch(function () {
        _this2.$http.buildErrorHandler('批量域迁移请求失败！');
      });
    },
    closeDialog: function closeDialog() {
      this.$emit('close-dialog');
    }
  },
  computed: {
    onLineClusters: function onLineClusters() {
      var onlineArr = [];
      this.zkClusterKeys.forEach(function (element) {
        if (!element.offline) {
          onlineArr.push(element);
        }
      });
      return onlineArr;
    }
  }
};

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: ['domainName', 'jobNamesArray'],
  data: function data() {
    return {
      isVisible: true,
      loading: false,
      onlineExecutors: [],
      selectedExecutors: []
    };
  },

  methods: {
    handleSubmit: function handleSubmit() {
      var _this = this;

      this.setSelectedExecutor();
      var params = {
        jobNames: this.jobNamesArray.join(','),
        preferList: this.selectedExecutors.join(',')
      };
      this.$http.post('/console/namespaces/' + this.domainName + '/jobs/preferExecutors', params).then(function () {
        _this.$emit('batch-priority-success');
      }).catch(function () {
        _this.$http.buildErrorHandler('批量设置作业的优先Executors失败！');
      });
    },
    closeDialog: function closeDialog() {
      this.$emit('close-dialog');
    },
    setSelectedExecutor: function setSelectedExecutor() {
      var _this2 = this;

      if (this.selectedExecutors.length > 0) {
        this.selectedExecutors.forEach(function (ele, index) {
          _this2.onlineExecutors.forEach(function (ele2) {
            if (ele === ele2.value && ele2.container) {
              _this2.selectedExecutors[index] = '@' + ele;
            }
          });
        });
      }
    },
    getOnlineExecutors: function getOnlineExecutors() {
      var _this3 = this;

      this.loading = true;
      this.$http.get('/console/namespaces/' + this.domainName + '/executors').then(function (data) {
        var onlineExecutorsArray = [];
        data.forEach(function (ele) {
          if (ele.status === 'ONLINE') {
            onlineExecutorsArray.push(ele);
          }
        });
        var setOnlineExecutors = onlineExecutorsArray.map(function (obj) {
          var rObj = {};
          if (obj.container) {
            rObj.container = obj.container;
            rObj.value = obj.groupName;
          } else {
            rObj.container = obj.container;
            rObj.value = obj.executorName;
          }
          return rObj;
        });
        var hash = {};
        _this3.onlineExecutors = setOnlineExecutors.reduce(function (item, next) {
          if (!hash[next.value]) {
            hash[next.value] = true;
            item.push(next);
          }
          return item;
        }, []);
      }).catch(function () {
        _this3.$http.buildErrorHandler('获取Executors失败！');
      }).finally(function () {
        _this3.loading = false;
      });
    }
  },
  created: function created() {
    this.getOnlineExecutors();
  }
};

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: ['importResult'],
  data: function data() {
    return {
      isVisible: true,
      statusMap: {
        true: '成功',
        false: '失败'
      }
    };
  },

  methods: {
    closeDialog: function closeDialog() {
      this.$emit('close-dialog');
    }
  }
};

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(38);

var _promise2 = _interopRequireDefault(_promise);

var _stringify = __webpack_require__(44);

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ['domainName', 'jobInfo', 'jobInfoTitle', 'jobInfoOperation'],
  data: function data() {
    return {
      isVisible: true,
      isCronPredictVisible: false,
      cronPredictParams: {},
      loading: false,
      rules: {
        jobType: [{ required: true, message: '请选择作业类型', trigger: 'change' }],
        jobName: [{ required: true, message: '作业名不能为空', trigger: 'blur' }],
        jobClass: [{ required: true, message: '作业实现类不能为空', trigger: 'blur' }],
        cron: [{ required: true, message: 'cron表达式不能为空', trigger: 'blur' }],
        shardingItemParameters: [{ required: true, message: '分片序列号/参数对照表不能为空', trigger: 'blur' }],
        queueName: [{ required: true, message: 'queue不能为空', trigger: 'blur' }],
        siteId: [{ required: true, message: '站点ID不能为空', trigger: 'blur' }],
        taskId: [{ required: true, message: '任务ID不能为空', trigger: 'blur' }],
        taskCode: [{ required: true, message: '任务Code不能为空', trigger: 'blur' }],
        jobParameter: [{ required: true, message: '自定义参数不能为空', trigger: 'blur' }]
      },
      upStreamProvided: [],
      downStreamProvided: []
    };
  },

  methods: {
    checkAndForecastCron: function checkAndForecastCron() {
      var cronData = {
        timeZone: this.jobInfo.timeZone,
        cron: this.jobInfo.cron
      };
      this.cronPredictParams = JSON.parse((0, _stringify2.default)(cronData));
      this.isCronPredictVisible = true;
    },
    closeCronDialog: function closeCronDialog() {
      this.isCronPredictVisible = false;
    },
    handleSubmit: function handleSubmit() {
      var _this = this;

      this.$refs.jobInfo.validate(function (valid) {
        if (valid) {
          if (_this.validateShardingParamsNumber()) {
            if (_this.validateShardingParam()) {
              if (_this.jobInfoOperation === 'add') {
                _this.jobInfoRequest('/console/namespaces/' + _this.domainName + '/jobs/jobs');
              } else if (_this.jobInfoOperation === 'copy') {
                _this.jobInfoRequest('/console/namespaces/' + _this.domainName + '/jobs/' + _this.jobInfo.jobNameCopied + '/copy');
              }
            } else {
              _this.$message.errorMessage('请正确输入分片参数!');
            }
          } else {
            _this.$message.errorMessage('分片参数不能小于作业分片总数!');
          }
        }
      });
    },
    jobInfoRequest: function jobInfoRequest(url) {
      var _this2 = this;

      this.loading = true;
      this.$http.post(url, this.jobInfo).then(function () {
        _this2.$emit('job-info-success');
      }).catch(function () {
        _this2.$http.buildErrorHandler(url + '\u8BF7\u6C42\u5931\u8D25\uFF01');
      }).finally(function () {
        _this2.loading = false;
      });
    },
    closeDialog: function closeDialog() {
      this.$emit('close-dialog');
    },
    validateShardingParamsNumber: function validateShardingParamsNumber() {
      var flag = false;
      var arr = [];
      if (this.jobInfo.shardingItemParameters.indexOf(',') > 0) {
        arr = this.jobInfo.shardingItemParameters.split(',');
      } else {
        arr = [this.jobInfo.shardingItemParameters];
      }
      if (this.jobInfo.shardingTotalCount > arr.length) {
        flag = false;
      } else {
        flag = true;
      }
      return flag;
    },
    validateShardingParam: function validateShardingParam() {
      var flag = false;
      var arr = [];
      if (this.jobInfo.shardingItemParameters.indexOf(',') > 0) {
        arr = this.jobInfo.shardingItemParameters.split(',');
      } else {
        arr = [this.jobInfo.shardingItemParameters];
      }
      arr.forEach(function (ele) {
        if (ele.indexOf('=') > -1) {
          if (ele.split('=')[0] === '') {
            flag = false;
          } else {
            flag = true;
          }
        } else {
          flag = false;
        }
      });
      return flag;
    },
    getUpStream: function getUpStream() {
      var _this3 = this;

      return this.$http.get('/console/namespaces/' + this.domainName + '/jobs/candidateUpStream').then(function (data) {
        _this3.upStreamProvided = data;
      }).catch(function () {
        _this3.$http.buildErrorHandler('获取上游作业失败！');
      });
    },
    getDownStream: function getDownStream() {
      var _this4 = this;

      return this.$http.get('/console/namespaces/' + this.domainName + '/jobs/candidateDownStream').then(function (data) {
        _this4.downStreamProvided = data;
      }).catch(function () {
        _this4.$http.buildErrorHandler('获取下游作业失败！');
      });
    },
    getJobStream: function getJobStream() {
      var _this5 = this;

      this.loading = true;
      _promise2.default.all([this.getUpStream(), this.getDownStream()]).then(function () {
        _this5.loading = false;
      });
    }
  },
  computed: {
    isEditable: function isEditable() {
      return this.jobInfoOperation !== 'copy';
    }
  },
  watch: {
    'jobInfo.shardingTotalCount': {
      immediate: true,
      handler: function handler(newCount) {
        if (newCount) {
          var result = [];
          if (Number(newCount) > 0 && (!this.jobInfo.shardingItemParameters || /^(\d*=)(,\d*=)*$/.test(this.jobInfo.shardingItemParameters))) {
            var arr = new Array(Number(newCount)).fill(1).map(function (ele, index) {
              return index;
            });
            arr.forEach(function (ele) {
              result.push(ele + '=');
            });
            this.jobInfo.shardingItemParameters = result.join(',');
            console.info(this.jobInfo.shardingItemParameters);
          }
        }
      }
    },
    'jobInfo.jobType': {
      handler: function handler(newCount) {
        if (this.$option.isPassive(newCount)) {
          this.jobInfo.cron = '';
          this.jobInfo.jobParameter = 'siteId=' + this.jobInfo.siteId + ',taskId=' + this.jobInfo.taskId + ',taskCode=' + this.jobInfo.taskCode + ',topic=SYS_ANN,timeZone=Asia/Shanghai,jobType=' + newCount + ';jsonParam=';
          this.getJobStream();
        } else {
          this.jobInfo.jobParameter = 'siteId=' + this.jobInfo.siteId + ',taskId=' + this.jobInfo.taskId + ',taskCode=' + this.jobInfo.taskCode + ',topic=SYS_ANN,timeZone=Asia/Shanghai,cron=' + this.jobInfo.cron + ',jobType=' + newCount + ';jsonParam=';
          this.jobInfo.upStream = [];
          this.jobInfo.downStream = [];
          this.jobInfo.cron = '0/5 * * * * ?';
        }
      }
    },
    'jobInfo.siteId': {
      immediate: true,
      handler: function handler(newCount) {
        if (newCount) {
          this.jobInfo.jobParameter = 'siteId=' + newCount + ',taskId=' + this.jobInfo.taskId + ',taskCode=' + this.jobInfo.taskCode + ',topic=SYS_ANN,timeZone=Asia/Shanghai,cron=' + this.jobInfo.cron + ',jobType=' + this.jobInfo.jobType + ';jsonParam=';
        }
      }
    },
    'jobInfo.taskId': {
      immediate: true,
      handler: function handler(newCount) {
        if (newCount) {
          this.jobInfo.jobParameter = 'siteId=' + this.jobInfo.siteId + ',taskId=' + newCount + ',taskCode=' + this.jobInfo.taskCode + ',topic=SYS_ANN,timeZone=Asia/Shanghai,cron=' + this.jobInfo.cron + ',jobType=' + this.jobInfo.jobType + ';jsonParam=';
        }
      }
    },
    'jobInfo.taskCode': {
      immediate: true,
      handler: function handler(newCount) {
        if (newCount) {
          this.jobInfo.jobParameter = 'siteId=' + this.jobInfo.siteId + ',taskId=' + this.jobInfo.taskId + ',taskCode=' + newCount + ',topic=SYS_ANN,timeZone=Asia/Shanghai,cron=' + this.jobInfo.cron + ',jobType=' + this.jobInfo.jobType + ';jsonParam=';
        }
      }
    },
    'jobInfo.cron': {
      immediate: true,
      handler: function handler(newCount) {
        if (newCount) {
          this.jobInfo.jobParameter = 'siteId=' + this.jobInfo.siteId + ',taskId=' + this.jobInfo.taskId + ',taskCode=' + this.jobInfo.taskCode + ',topic=SYS_ANN,timeZone=Asia/Shanghai,cron=' + newCount + ',jobType=' + this.jobInfo.jobType + ';jsonParam=';
        }
      }
    }
  }
};

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: ['migrateStatusTitle'],
  data: function data() {
    return {
      isVisible: false,
      migrateStatusInfo: {
        failCount: 0,
        ignoreCount: 0,
        successCount: 0,
        totalCount: 0,
        unDoCount: 0,
        finished: false,
        moving: ''
      }
    };
  },

  methods: {
    closeDialog: function closeDialog() {
      this.$emit('close-dialog');
    },
    getMigrationStatus: function getMigrationStatus() {
      var _this = this;

      this.$http.get('/console/namespaces/zkCluster/migrationStatus').then(function (data) {
        _this.migrateStatusInfo = data;
        _this.isVisible = true;
        if (!data.finished) {
          _this.getMigrationStatus();
        }
      }).catch(function () {
        _this.$http.buildErrorHandler('获取迁移结果状态请求失败！');
      });
    }
  },
  created: function created() {
    this.getMigrationStatus();
  }
};

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: ['userPasswordInfo', 'userInfoTitle', 'userInfoOperate'],
  data: function data() {
    var _this = this;

    var validatePass = function validatePass(rule, value, callback) {
      if (value === '') {
        callback(new Error('请输入新密码'));
      } else {
        if (_this.userPasswordInfo.newPassword2 !== '') {
          _this.$refs.userPasswordInfo.validateField('newPassword2');
        }
        callback();
      }
    };
    var validatePass2 = function validatePass2(rule, value, callback) {
      if (value === '') {
        callback(new Error('请再次输入新的密码'));
      } else if (value !== _this.userPasswordInfo.newPassword) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      isVisible: true,
      loading: false,
      rules: {
        password: [{ required: true, message: '请输入当前的密码', trigger: 'blur' }],
        newPassword: [{ required: true, trigger: 'blur', validator: validatePass }],
        newPassword2: [{ required: true, trigger: 'blur', validator: validatePass2 }]
      }
    };
  },

  methods: {
    handleSubmit: function handleSubmit() {
      var _this2 = this;

      this.$refs.userPasswordInfo.validate(function (valid) {
        if (valid) {
          _this2.$message.confirmMessage('修改密码成功后需重新登录', function () {
            var editParams = {
              prePassword: _this2.userPasswordInfo.password,
              preNewPassword: _this2.userPasswordInfo.newPassword
            };
            _this2.userInfoRequest('/console/userManage/updateUserPassword', editParams);
          });
        }
      });
    },
    userInfoRequest: function userInfoRequest(url, params) {
      var _this3 = this;

      this.loading = true;
      this.$http.post(url, params).then(function () {
        _this3.$emit('user-info-success');
      }).catch(function () {
        _this3.$http.buildErrorHandler(url + '\u8BF7\u6C42\u5931\u8D25\uFF01');
      }).finally(function () {
        _this3.loading = false;
      });
    },
    closeDialog: function closeDialog() {
      this.$emit('close-dialog');
    }
  },
  computed: {}
};

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _set = __webpack_require__(292);

var _set2 = _interopRequireDefault(_set);

var _from = __webpack_require__(194);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Favorites',
  props: ['unit'],
  data: function data() {
    return {
      show: false,
      visible: false,
      favorites: this.$favorites(),
      editPath: '',
      form: {
        title: '',
        group: ''
      }
    };
  },

  watch: {
    $route: function init() {
      this.favorites = this.$favorites();
    }
  },
  computed: {
    isFav: function isFav() {
      return this.favorites.some(function (item) {
        return item.path === location.hash.substring(1);
      });
    },
    hasFav: function hasFav() {
      return this.favorites.length;
    },
    groupsList: function groupsList() {
      var resultArr = [];
      var groupArrays = [];
      this.favorites.forEach(function (ele) {
        groupArrays.push(ele.group);
      });
      var groupArr = (0, _from2.default)(new _set2.default(groupArrays));
      groupArr.forEach(function (ele2) {
        if (ele2) {
          var param = {
            text: ele2,
            value: ele2
          };
          resultArr.push(param);
        }
      });
      return resultArr;
    }
  },
  methods: {
    filterGroup: function filterGroup(value, row) {
      return row.group === value;
    },
    resetFields: function resetFields() {
      var _this = this;

      this.form.title = '';
      this.form.group = '';
      this.favorites = this.$favorites();
      this.visible = false;
      this.$nextTick(function () {
        _this.editPath = '';
      });
    },
    submitForm: function submitForm(path) {
      this.$favorites(path, this.form.title, this.form.group);
      this.favorites = this.$favorites();
      this.resetFields();
      this.editPath = '';
    },
    edit: function edit(data, editPath) {
      this.form.title = data.title;
      this.form.group = data.group;
      this.editPath = editPath;
    },
    showMessage: function showMessage(status, op, data) {
      if (op === 'add') {
        this.edit(data);
        var messageText = status ? '该资源收藏成功！' : '该资源已收藏！';
        var messageType = status ? 'success' : 'error';
        this.$message.customMessage(messageType, messageText);
      } else if (op === 'del') {
        this.$message.customMessage('success', '该收藏资源已移除成功!');
      }
    }
  }
};

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(44);

var _stringify2 = _interopRequireDefault(_stringify);

var _is = __webpack_require__(695);

var _is2 = _interopRequireDefault(_is);

var _entries = __webpack_require__(195);

var _entries2 = _interopRequireDefault(_entries);

var _create = __webpack_require__(693);

var _create2 = _interopRequireDefault(_create);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ['getData', 'data', 'total', 'orderBy', 'filters'],
  data: function data() {
    return {
      pageSize: 25,
      currentPage: 1,
      orderby: this.orderBy,
      orderKey: undefined,
      order: undefined,
      pageData: [],
      filtered: []
    };
  },

  computed: {
    offset: function offset() {
      return (this.currentPage - 1) * this.pageSize;
    },
    params: function params() {
      var paramsResult = (0, _create2.default)(null);
      paramsResult.size = this.pageSize;
      paramsResult.page = this.currentPage;
      paramsResult.orderKey = this.orderKey;
      paramsResult.order = this.order;
      if (this.filters) {
        (0, _entries2.default)(this.filters).forEach(function (item) {
          if (item[1].value !== '' && item[1].value !== undefined) {
            paramsResult[item[0]] = item[1].value;
          }
        });
      }
      return paramsResult;
    },
    totalRecords: function totalRecords() {
      if (this.data) {
        return this.filtered.length;
      }
      return this.total;
    }
  },
  watch: {
    $route: 'getDataByParams',
    data: 'buildCurrentPage'
  },
  created: function created() {
    this.getDataByParams();
  },

  methods: {
    search: function search() {
      this.getDataByParams();
    },
    getDataByParams: function getDataByParams() {
      if (this.data) {
        this.buildCurrentPage();
      } else if (this.getData) {
        this.getData(this.params);
      }
    },
    buildCurrentPage: function buildCurrentPage() {
      var _this = this;

      if (this.data) {
        var filtered = this.data.slice();
        if (this.filters) {
          (0, _entries2.default)(this.filters).forEach(function (item) {
            var key = item[0];
            var precise = item[1].precise || false;
            var value = item[1].value;
            if (value || typeof value === 'boolean') {
              filtered = filtered.filter(function (e) {
                if (typeof e[key] === 'string') {
                  if (!precise) {
                    return e[key].toLowerCase().indexOf(value.toLowerCase().trim()) > -1;
                  }
                  return (0, _is2.default)(e[key], value);
                }
                return (0, _is2.default)(e[key], value);
              });
            }
          });
        }
        if (this.orderby) {
          var key = this.orderby.replace(/^-/, '');
          var order = 1;
          if (this.orderby[0] === '-') {
            order = -1;
          }
          filtered.sort(function (a, b) {
            if (a[key] === b[key]) {
              return 0;
            } else if (a[key] > b[key]) {
              return order;
            }
            return -order;
          });
        }
        this.filtered = filtered;
        if (filtered.length > this.pageSize) {
          filtered = filtered.filter(function (e, index) {
            return index < _this.offset + _this.pageSize && index >= _this.offset;
          });
        }
        this.pageData = filtered;
      }
    },
    onSortChange: function onSortChange(sort) {
      if (sort.order === null) {
        this.orderby = this.orderBy;
      } else if (sort.order === 'descending') {
        this.orderby = '-' + sort.prop;
      } else {
        this.orderby = '' + sort.prop;
      }

      this.order = sort.order;
      this.getDataByParams();
    },
    onCurrentChange: function onCurrentChange(page) {
      this.currentPage = page;
      this.getDataByParams();
    },
    onPageSize: function onPageSize(pageSize) {
      if ((0, _stringify2.default)(pageSize) === 'null') {
        this.pageSize = this.totalRecords;
      } else {
        this.pageSize = pageSize;
      }
      this.getDataByParams();
    }
  }
};

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(44);

var _stringify2 = _interopRequireDefault(_stringify);

var _editPwdDialog = __webpack_require__(1317);

var _editPwdDialog2 = _interopRequireDefault(_editPwdDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      domains: this.$store.getters.allDomains,
      isEditUserPassVisible: false,
      userPasswordInfo: {},
      userInfoTitle: '',
      userInfoOperate: '',
      domainName: '',
      serviceList: [{ index: '/job', title: '作业管理', icon: 'fa fa-list-alt', path: this.$routermapper.GetPath('jobManage'), isSuper: true }, { index: '/dashboard', title: 'Dashboard', icon: 'fa fa-pie-chart', path: this.$routermapper.GetPath('dashboardManage'), isSuper: true }, { index: '/alarm', title: '告警中心', icon: 'fa fa-bell', path: this.$routermapper.GetPath('alarmManage'), isSuper: true }, { index: '/registry', title: '注册中心', icon: 'fa fa-server', path: this.$routermapper.GetPath('registryManage'), isSuper: true }, { index: '/system', title: '系统配置', icon: 'fa fa-cog', path: this.$routermapper.GetPath('systemConfigManage'), isSuper: this.$common.hasPerm('systemConfig') }, { index: '/authority', title: '权限管理', icon: 'fa fa-check-square-o', path: this.$routermapper.GetPath('authorityManage'), isSuper: this.$common.hasPerm('authorizationManage') }, { index: '/user', title: '用户管理', icon: 'fa fa-user', path: this.$routermapper.GetPath('userManage'), isSuper: this.$common.hasPerm('authorizationManage') }]
    };
  },

  methods: {
    handleLogout: function handleLogout() {
      var _this = this;

      this.$http.post('/console/authentication/logout', {}).then(function () {
        _this.$router.push({ name: 'login' });
      }).catch(function () {
        _this.$http.buildErrorHandler('注销失败！');
      });
    },
    handleEditPass: function handleEditPass() {
      this.isEditUserPassVisible = true;
      this.userInfoTitle = '修改密码';
      this.userInfoOperate = 'add';
      var userEditInfo = {
        password: '',
        newPassword: '',
        newPassword2: ''
      };
      this.userPasswordInfo = JSON.parse((0, _stringify2.default)(userEditInfo));
    },
    editUserPwdSuccess: function editUserPwdSuccess() {
      this.$message.successNotify('修改密码操作成功，请重新登录！');
      this.isEditUserPassVisible = false;
      this.handleLogout();
    },
    closeUserPwdDialog: function closeUserPwdDialog() {
      this.isEditUserPassVisible = false;
    },
    querySearchAsync: function querySearchAsync(queryString, cb) {
      var domains = this.domains;
      var results = queryString ? domains.filter(this.createStateFilter(queryString)) : domains;
      cb(results);
    },
    createStateFilter: function createStateFilter(queryString) {
      return function (state) {
        return state.value.toLowerCase().indexOf(queryString.toLowerCase()) >= 0;
      };
    },
    handleSelect: function handleSelect(item) {
      this.toPage(item.value);
    },
    toPage: function toPage(domain) {
      this.domainName = '';
      this.$router.push({ name: 'job_overview', params: { domain: domain } });
    },
    handleVersion: function handleVersion() {
      var _this2 = this;

      this.$http.get('/console/utils/version').then(function (data) {
        var versionHtml = '<strong>\u7248\u672C\u53F7: ' + data + '</strong>';
        _this2.$message.openMessage(versionHtml);
      }).catch(function () {
        _this2.$http.buildErrorHandler('获取版本号请求失败！');
      });
    }
  },
  computed: {
    activeIndex: function activeIndex() {
      return this.$route.path.split('_')[0];
    },
    userInfo: function userInfo() {
      return this.$store.state.global.userAuthority;
    },
    isShowHeaderSearch: function isShowHeaderSearch() {
      var flag = false;
      var pathArr = this.$route.path.split('/');
      if (pathArr[1] === 'job_list' || pathArr[1] === 'job_detail') {
        flag = true;
      }
      return flag;
    }
  },
  components: {
    'edit-pwd-dialog': _editPwdDialog2.default
  }
};

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: ['importTitle', 'importUrl', 'importTemplateUrl', 'importData', 'importTip'],
  data: function data() {
    return {
      isVisible: true
    };
  },

  methods: {
    exportModel: function exportModel() {
      window.location.href = this.importTemplateUrl;
    },
    handleUpload: function handleUpload() {
      this.$refs.upload.clearFiles();
    },
    handleError: function handleError(err) {
      this.$message.errorMessage('\u4E0A\u4F20\u5931\u8D25: ' + err);
    },
    handleSuccess: function handleSuccess(response) {
      if (response.status === 0) {
        this.$emit('import-success', response.obj);
      } else {
        this.$message.errorMessage(response.message);
      }
    },
    handleSubmit: function handleSubmit() {
      this.$refs.upload.submit();
    },
    closeDialog: function closeDialog() {
      this.$emit('close-dialog');
      this.$refs.upload.clearFiles();
    }
  }
};

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: ['dynamicTags', 'title'],
  data: function data() {
    return {
      inputVisible: false,
      inputValue: ''
    };
  },

  methods: {
    handleClose: function handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },
    showInput: function showInput() {
      var _this = this;

      this.inputVisible = true;
      this.$nextTick(function () {
        _this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm: function handleInputConfirm() {
      var inputValue = this.inputValue;
      if (inputValue) {
        if (this.title === '日期段') {
          var dateParten = /^(0[1-9]|1[0-2])\/(0[1-9]|[1-2][0-9]|3[0-1])-(0[1-9]|1[0-2])\/(0[1-9]|[1-2][0-9]|3[0-1])$/;
          if (dateParten.test(inputValue)) {
            this.dynamicTags.push(inputValue);
          } else {
            this.$message.errorMessage('请输入正确的日期格式，例如03/10-03/20');
          }
        } else {
          var timeParten = /^(0[0-9]|1[0-9]|2[0-3]):([0-5][0-9])-(0[0-9]|1[0-9]|2[0-3]):([0-5][0-9])$/;
          if (timeParten.test(inputValue)) {
            this.dynamicTags.push(inputValue);
          } else {
            this.$message.errorMessage('请输入正确的时间格式，例如10:00-11:00');
          }
        }
      }
      this.inputVisible = false;
      this.inputValue = '';
    }
  }
};

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(196);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ['type'],
  data: function data() {
    return {};
  },

  methods: {},
  computed: {
    panelType: function panelType() {
      var obj = (0, _defineProperty3.default)({}, 'panel-' + this.type + '-info', true);
      return obj;
    }
  }
};

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: ['timeoutJobsList'],
  data: function data() {
    return {
      filters: {
        jobName: { value: '' }
      },
      orderBy: 'jobName',
      total: this.timeoutJobsList.length
    };
  },

  methods: {
    refreshList: function refreshList() {
      this.$emit('refresh-list');
    },
    handleRead: function handleRead(row) {
      var params = {
        uuid: row.uuid,
        domainName: row.domainName
      };
      this.$emit('no-alarm', params);
    }
  }
};

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(38);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ['domain', 'domainInfo'],
  data: function data() {
    return {
      jobNameSelect: '',
      loading: false,
      jobNameList: []
    };
  },

  methods: {
    querySearchAsync: function querySearchAsync(queryString, cb) {
      var jobNameList = this.jobNameList;
      var results = queryString ? jobNameList.filter(this.createStateFilter(queryString)) : jobNameList;
      cb(results);
    },
    createStateFilter: function createStateFilter(queryString) {
      return function (state) {
        return state.value.toLowerCase().indexOf(queryString.toLowerCase()) >= 0;
      };
    },
    handleSelect: function handleSelect(item) {
      this.toPage(item.value);
    },
    toPage: function toPage(jobName) {
      this.jobNameSelect = '';
      this.$router.push({ name: 'job_setting', params: { domain: this.domain, jobName: jobName } });
    },
    getJobNameList: function getJobNameList() {
      var _this = this;

      return this.$http.get('/console/namespaces/' + this.domain + '/jobs/names').then(function (data) {
        _this.jobNameList = data.map(function (obj) {
          var rObj = {};
          rObj.value = obj;
          return rObj;
        });
      }).catch(function () {
        _this.$http.buildErrorHandler('获取作业名列表失败！');
      });
    },
    init: function init() {
      var _this2 = this;

      this.loading = true;
      _promise2.default.all([this.getJobNameList()]).then(function () {
        _this2.loading = false;
      });
    }
  },
  computed: {
    isShowBarSearch: function isShowBarSearch() {
      var flag = false;
      var pathArr = this.$route.path.split('/');
      if (pathArr[1] === 'job_detail') {
        flag = true;
      }
      return flag;
    }
  },
  created: function created() {
    this.init();
  }
};

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: ['unableFailoverJobsList'],
  data: function data() {
    return {
      filters: {
        jobName: { value: '' }
      },
      orderBy: 'jobName',
      total: this.unableFailoverJobsList.length
    };
  },

  methods: {
    refreshList: function refreshList() {
      this.$emit('refresh-list');
    }
  }
};

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: ['title', 'content'],
  data: function data() {
    return {
      isVisible: true
    };
  },

  methods: {
    closeDialog: function closeDialog() {
      this.$emit('close-dialog');
    }
  }
};

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      loading: false,
      abnormalContainersList: []
    };
  },

  methods: {
    getAbnormalContainers: function getAbnormalContainers() {
      var _this = this;

      this.loading = true;
      this.$http.get('/console/alarmStatistics/abnormalContainers').then(function (data) {
        _this.abnormalContainersList = JSON.parse(data);
      }).catch(function () {
        _this.$http.buildErrorHandler('获取异常作业请求失败！');
      }).finally(function () {
        _this.loading = false;
      });
    }
  },
  created: function created() {
    this.getAbnormalContainers();
  }
};

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      loading: false,
      abnormalJobsList: []
    };
  },

  methods: {
    getAbnormalJobs: function getAbnormalJobs() {
      var _this = this;

      this.loading = true;
      this.$http.get('/console/alarmStatistics/abnormalJobs').then(function (data) {
        _this.abnormalJobsList = JSON.parse(data);
      }).catch(function () {
        _this.$http.buildErrorHandler('获取异常作业请求失败！');
      }).finally(function () {
        _this.loading = false;
      });
    },
    noAlarm: function noAlarm(params) {
      var _this2 = this;

      this.$http.post('/console/namespaces/' + params.domainName + '/setAbnormalJobMonitorStatusToRead', { uuid: params.uuid }).then(function () {
        _this2.getAbnormalJobs();
        _this2.$message.successNotify('操作成功');
      }).catch(function () {
        _this2.$http.buildErrorHandler('不再告警操作请求失败！');
      });
    }
  },
  created: function created() {
    this.getAbnormalJobs();
  }
};

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      sidebarMenus: [{ index: 'alarm_abnormal_jobs', title: '异常作业', icon: 'fa fa-list-alt', name: 'alarm_abnormal_jobs', alarmCount: 0 }, { index: 'alarm_timeout_jobs', title: '超时作业', icon: 'fa fa-clock-o', name: 'alarm_timeout_jobs', alarmCount: 0 }, { index: 'unable_failover_jobs', title: '无法高可用', icon: 'fa fa-exclamation-triangle', name: 'unable_failover_jobs', alarmCount: 0 }]
    };
  },

  methods: {
    getCountOfAlarmJobs: function getCountOfAlarmJobs() {
      var _this = this;

      this.$http.get('/console/alarmStatistics/countOfAlarmJobs').then(function (data) {
        data.forEach(function (ele) {
          if (ele.alarmJobType === 'unnormal_job') {
            _this.$set(_this.sidebarMenus[0], 'alarmCount', ele.count);
          } else if (ele.alarmJobType === 'timeout_4_alarm_job') {
            _this.$set(_this.sidebarMenus[1], 'alarmCount', ele.count);
          } else if (ele.alarmJobType === 'unable_failover_job') {
            _this.$set(_this.sidebarMenus[2], 'alarmCount', ele.count);
          }
        });
      }).catch(function () {
        _this.$http.buildErrorHandler('获取异常作业统计请求失败！');
      });
    }
  },
  created: function created() {
    this.getCountOfAlarmJobs();
  }
};

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      loading: false,
      timeoutJobsList: []
    };
  },

  methods: {
    getTimeoutJobs: function getTimeoutJobs() {
      var _this = this;

      this.loading = true;
      this.$http.get('/console/alarmStatistics/timeout4AlarmJobs').then(function (data) {
        _this.timeoutJobsList = JSON.parse(data);
      }).catch(function () {
        _this.$http.buildErrorHandler('获取异常作业请求失败！');
      }).finally(function () {
        _this.loading = false;
      });
    },
    noAlarm: function noAlarm(params) {
      var _this2 = this;

      this.$http.post('/console/namespaces/' + params.domainName + '/setTimeout4AlarmJobMonitorStatusToRead', { uuid: params.uuid }).then(function () {
        _this2.getTimeoutJobs();
        _this2.$message.successNotify('操作成功');
      }).catch(function () {
        _this2.$http.buildErrorHandler('不再告警操作请求失败！');
      });
    }
  },
  created: function created() {
    this.getTimeoutJobs();
  }
};

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      loading: false,
      unableFailoverJobsList: []
    };
  },

  methods: {
    getUnableFailoverJobs: function getUnableFailoverJobs() {
      var _this = this;

      this.loading = true;
      this.$http.get('/console/alarmStatistics/unableFailoverJobs').then(function (data) {
        _this.unableFailoverJobsList = JSON.parse(data);
      }).catch(function () {
        _this.$http.buildErrorHandler('获取异常作业请求失败！');
      }).finally(function () {
        _this.loading = false;
      });
    }
  },
  created: function created() {
    this.getUnableFailoverJobs();
  }
};

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(44);

var _stringify2 = _interopRequireDefault(_stringify);

var _user_info_dialog = __webpack_require__(1336);

var _user_info_dialog2 = _interopRequireDefault(_user_info_dialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      loading: false,
      isUserVisible: false,
      userInfo: {},
      userInfoTitle: '',
      userInfoOperate: '',
      userList: [],
      roles: [],
      rolesMaps: {},
      total: 0,
      filters: {},
      backFilter: {
        userName: null,
        roleKey: null,
        namespace: null
      },
      orderBy: '',
      domains: this.$store.getters.allDomains
    };
  },

  methods: {
    querySearchAsync: function querySearchAsync(queryString, cb) {
      var domains = this.domains;
      var results = queryString ? domains.filter(this.createStateFilter(queryString)) : domains;
      cb(results);
    },
    createStateFilter: function createStateFilter(queryString) {
      return function (state) {
        return state.value.toLowerCase().indexOf(queryString.toLowerCase()) >= 0;
      };
    },
    handleAdd: function handleAdd() {
      this.isUserVisible = true;
      this.userInfoTitle = '添加用户';
      this.userInfoOperate = 'add';
      var userAddInfo = {
        userNames: '',
        roleKey: '',
        namespaces: '',
        needApproval: false
      };
      this.userInfo = JSON.parse((0, _stringify2.default)(userAddInfo));
    },
    handleEdit: function handleEdit(row) {
      this.isUserVisible = true;
      this.userInfoTitle = '编辑用户';
      this.userInfoOperate = 'edit';
      var userEditInfo = {
        preUserName: row.userName,
        preRoleKey: row.roleKey,
        preNamespace: row.namespace,
        userName: row.userName,
        roleKey: row.roleKey,
        namespace: row.namespace,
        needApproval: row.needApproval
      };
      this.userInfo = JSON.parse((0, _stringify2.default)(userEditInfo));
    },
    userInfoSuccess: function userInfoSuccess() {
      this.isUserVisible = false;
      this.getAllUser();
      this.$message.successNotify('保存用户权限操作成功');
    },
    closeInfoDialog: function closeInfoDialog() {
      this.isUserVisible = false;
    },
    handleDelete: function handleDelete(row) {
      var _this = this;

      this.$message.confirmMessage('\u786E\u8BA4\u5220\u9664\u7528\u6237 ' + row.userName + ' \u5417?', function () {
        var params = {
          userName: row.userName,
          roleKey: row.roleKey,
          namespace: row.namespace
        };
        _this.$http.post('/console/authorizationManage/deleteUserRole', params).then(function () {
          _this.getAllUser();
          _this.$message.successNotify('删除用户操作成功');
        }).catch(function () {
          _this.$http.buildErrorHandler('删除用户请求失败！');
        });
      });
    },
    getRoles: function getRoles() {
      var _this2 = this;

      this.loading = true;
      this.$http.get('/console/authorizationManage/getRoles').then(function (data) {
        _this2.roles = data;
        data.forEach(function (ele) {
          _this2.rolesMaps[ele.roleKey] = ele.roleName;
        });
        _this2.getUserRolesReq();
      }).catch(function () {
        _this2.$http.buildErrorHandler('获取用户角色请求失败！');
      }).finally(function () {
        _this2.loading = false;
      });
    },
    getAllUser: function getAllUser() {
      if (this.backFilter.userName || this.backFilter.roleKey || this.backFilter.namespace) {
        this.getUserRolesReq();
      } else {
        this.userList = [];
      }
    },
    getUserRolesReq: function getUserRolesReq() {
      var _this3 = this;

      var params = {
        userName: this.backFilter.userName !== '' ? this.backFilter.userName : null,
        roleKey: this.backFilter.roleKey !== '' ? this.backFilter.roleKey : null,
        namespace: this.backFilter.namespace !== '' ? this.backFilter.namespace : null
      };
      this.loading = true;
      this.$http.get('/console/authorizationManage/getUserRoles', params).then(function (data) {
        _this3.userList = data;
      }).catch(function () {
        _this3.$http.buildErrorHandler('获取用户权限列表请求失败！');
      }).finally(function () {
        _this3.loading = false;
      });
    }
  },
  computed: {},
  components: {
    'user-info-dialog': _user_info_dialog2.default
  },
  created: function created() {
    this.getRoles();
  }
};

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: ['userInfo', 'userInfoTitle', 'userInfoOperate', 'roles'],
  data: function data() {
    return {
      isVisible: true,
      loading: false,
      rules: {
        userNames: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        roleKey: [{ required: true, message: '请选择用户角色', trigger: 'change' }],
        namespaces: [{ required: true, message: '请选择域名', trigger: 'change' }],
        namespace: [{ validator: this.$validate.validateContainDomain, trigger: 'blur' }]
      },
      allDomains: this.$store.getters.allDomains
    };
  },

  methods: {
    handleSubmit: function handleSubmit() {
      var _this = this;

      this.$refs.userInfo.validate(function (valid) {
        if (valid) {
          if (_this.userInfo.roleKey === 'namespace_developer') {
            _this.$set(_this.userInfo, 'needApproval', true);
          } else {
            _this.$set(_this.userInfo, 'needApproval', false);
          }
          if (_this.userInfoOperate === 'add') {
            var addParams = {
              userNames: _this.userInfo.userNames,
              roleKey: _this.userInfo.roleKey,
              namespaces: _this.isShowNamespace ? _this.userInfo.namespaces.join(',') : '',
              needApproval: _this.userInfo.needApproval
            };
            _this.userInfoRequest('/console/authorizationManage/addUserRoles', addParams);
          } else if (_this.userInfoOperate === 'edit') {
            var editParams = {
              preUserName: _this.userInfo.preUserName,
              preRoleKey: _this.userInfo.preRoleKey,
              preNamespace: _this.userInfo.preNamespace,
              userName: _this.userInfo.userName,
              roleKey: _this.userInfo.roleKey,
              namespace: _this.isShowNamespace ? _this.userInfo.namespace : '',
              needApproval: _this.userInfo.needApproval
            };
            _this.userInfoRequest('/console/authorizationManage/updateUserRole', editParams);
          }
        }
      });
    },
    userInfoRequest: function userInfoRequest(url, params) {
      var _this2 = this;

      this.loading = true;
      this.$http.post(url, params).then(function () {
        _this2.$emit('user-info-success');
      }).catch(function () {
        _this2.$http.buildErrorHandler(url + '\u8BF7\u6C42\u5931\u8D25\uFF01');
      }).finally(function () {
        _this2.loading = false;
      });
    },
    closeDialog: function closeDialog() {
      this.$emit('close-dialog');
    }
  },
  computed: {
    isEditable: function isEditable() {
      return this.userInfoOperate !== 'edit';
    },
    isShowNamespace: function isShowNamespace() {
      var _this3 = this;

      var flag = false;
      this.roles.some(function (ele) {
        if (_this3.userInfo.roleKey === ele.roleKey) {
          flag = ele.isRelatingToNamespace;
          return true;
        }
        return false;
      });
      return flag;
    }
  }
};

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      zkCluster: this.$route.query.zkCluster,
      sidebarMenus: [{ index: 'domain_statistic', title: '域统计', icon: 'fa fa-navicon', name: 'domain_statistic', query: { zkCluster: this.$route.query.zkCluster } }, { index: 'executor_statistic', title: 'Executor统计', icon: 'fa fa-server', name: 'executor_statistic', query: { zkCluster: this.$route.query.zkCluster } }, { index: 'job_statistic', title: '作业统计', icon: 'fa fa-cubes', name: 'job_statistic', query: { zkCluster: this.$route.query.zkCluster } }]
    };
  },

  methods: {},
  created: function created() {}
};

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: [],
  data: function data() {
    return {
      clusterKey: '',
      clusterKeys: [],
      domainCount: '',
      executorInDockerCount: '',
      executorNotInDockerCount: '',
      jobCount: '',
      domainCountOptionInfo: {},
      executorCountOptionInfo: {},
      jobCountOptionInfo: {}
    };
  },

  methods: {
    clusterChange: function clusterChange() {
      this.getDashboardCount();
    },
    getDashboardCount: function getDashboardCount() {
      var _this = this;

      this.$http.get('/console/dashboard/count', { zkClusterKey: this.clusterKey }).then(function (data) {
        _this.domainCount = data.domainCount;
        _this.executorInDockerCount = data.executorInDockerCount;
        _this.executorNotInDockerCount = data.executorNotInDockerCount;
        _this.jobCount = data.jobCount;
      }).catch(function () {
        _this.$http.buildErrorHandler('获取dashboard统计请求失败！');
      });
    },
    getZkClusters: function getZkClusters() {
      var _this2 = this;

      this.$http.get('/console/zkClusters').then(function (data) {
        _this2.clusterKeys = data;
      }).catch(function () {
        _this2.$http.buildErrorHandler('获取所有zk集群请求失败！');
      });
    },
    getDomainCountHistory: function getDomainCountHistory() {
      var _this3 = this;

      return this.$http.get('/console/dashboard/domainCount', { zkClusterKey: this.clusterKey }).then(function (data) {
        var optionInfo = {
          xAxis: data.xAxis,
          seriesData: [{ name: '总域数', data: data.yAxis }],
          yAxisName: '总域数'
        };
        _this3.domainCountOptionInfo = optionInfo;
      }).catch(function () {
        _this3.$http.buildErrorHandler('获取历史全域数据请求失败！');
      });
    },
    getExecutorCountHistory: function getExecutorCountHistory() {
      var _this4 = this;

      return this.$http.get('/console/dashboard/executorCount', { zkClusterKey: this.clusterKey }).then(function (data) {
        var optionInfo = {
          xAxis: data.date,
          seriesData: [{ name: '物理机', data: data.otherCount }, { name: '容器', data: data.dockerCount }, { name: '总数', data: data.totalCount }],
          yAxisName: 'executor数'
        };
        _this4.executorCountOptionInfo = optionInfo;
      }).catch(function () {
        _this4.$http.buildErrorHandler('获取Executor历史数据请求失败！');
      });
    },
    getJobCountHistory: function getJobCountHistory() {
      var _this5 = this;

      return this.$http.get('/console/dashboard/jobCount', { zkClusterKey: this.clusterKey }).then(function (data) {
        var optionInfo = {
          xAxis: data.xAxis,
          seriesData: [{ name: '作业数', data: data.yAxis }],
          yAxisName: '作业数'
        };
        _this5.jobCountOptionInfo = optionInfo;
      }).catch(function () {
        _this5.$http.buildErrorHandler('获取历史全域数据请求失败！');
      });
    },
    updateHistories: function updateHistories() {
      this.getDomainCountHistory();
      this.getExecutorCountHistory();
      this.getJobCountHistory();
    }
  },
  computed: {
    executorCount: function executorCount() {
      return this.executorNotInDockerCount + '+' + this.executorInDockerCount;
    },
    onlineClusterkeys: function onlineClusterkeys() {
      var arr = [];
      this.clusterKeys.forEach(function (ele) {
        if (!ele.offline) {
          arr.push(ele);
        }
      });
      return arr;
    }
  },
  created: function created() {
    this.getZkClusters();
    this.getDashboardCount();
    this.getDomainCountHistory();
    this.getExecutorCountHistory();
    this.getJobCountHistory();
  },

  watch: {
    clusterKey: 'updateHistories'
  }
};

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(38);

var _promise2 = _interopRequireDefault(_promise);

var _entries = __webpack_require__(195);

var _entries2 = _interopRequireDefault(_entries);

var _parseInt = __webpack_require__(290);

var _parseInt2 = _interopRequireDefault(_parseInt);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      loading: false,
      zkCluster: this.$route.query.zkCluster,
      domainProcessCountOptionInfo: {},
      domainExecutorVersionOptionInfo: {},
      top10FailDomainOptionInfo: {},
      top10UnstableDomainOptionInfo: {},
      allDomainHistoryOptionInfo: {}
    };
  },

  methods: {
    getDomainProcessCount: function getDomainProcessCount() {
      var _this = this;

      return this.$http.get('/console/dashboard/domainProcessCount', { zkClusterKey: this.zkCluster }).then(function (data) {
        var resultData = JSON.parse(data);
        var error = resultData.error;
        var count = resultData.count;
        var dataArr = [{ name: '成功次数', value: (0, _parseInt2.default)(count - error, 10) }, { name: '失败次数', value: error }];
        var seriesData = [{ name: '全域当天执行数据', type: 'pie', data: dataArr }];
        _this.$set(_this.domainProcessCountOptionInfo, 'seriesData', seriesData);
      }).catch(function () {
        _this.$http.buildErrorHandler('获取全域当天执行数据请求失败！');
      });
    },
    getTop10FailDomain: function getTop10FailDomain() {
      var _this2 = this;

      return this.$http.get('/console/dashboard/top10FailDomain', { zkClusterKey: this.zkCluster }).then(function (data) {
        var hasAuth = _this2.$common.hasPerm('dashboard:cleanAllJobAnalyse');
        var resultData = JSON.parse(data);
        var domains = [];
        var dataArr = [];
        resultData.forEach(function (ele) {
          domains.push(ele.domainName);
          _this2.$set(ele, 'value', ele.failureRateOfAllTime);
          _this2.$set(ele, 'columnType', 'domain');
          dataArr.push(ele);
        });
        var tooltip = {
          position: 'inside',
          enterable: true,
          formatter: function formatter(params) {
            var result = '';
            var tooltipStr = '<b>' + params.name + '</b><br/>\n            \u9519\u8BEF\u7387: ' + params.value + '<br/>\n            \u6267\u884C\u603B\u6570: ' + params.data.processCountOfAllTime + '<br/>\n            \u5931\u8D25\u603B\u6570: ' + params.data.errorCountOfAllTime + '<br/>';
            if (hasAuth) {
              result = tooltipStr + '<button class="chart-tooltip-btn" onclick="vm.clearZk(\'/console/dashboard/namespaces/' + params.data.domainName + '/shardingCount/clean\')">\u6E05\u9664zk</button>';
            } else {
              result = tooltipStr;
            }
            return result;
          }
        };
        var optionInfo = {
          seriesData: dataArr,
          xCategories: domains,
          yTitle: '失败率(小数)',
          tooltip: tooltip
        };
        _this2.top10FailDomainOptionInfo = optionInfo;
      }).catch(function () {
        _this2.$http.buildErrorHandler('获取失败率最高的Top10域请求失败！');
      });
    },
    getTop10UnstableDomain: function getTop10UnstableDomain() {
      var _this3 = this;

      return this.$http.get('/console/dashboard/top10UnstableDomain', { zkClusterKey: this.zkCluster }).then(function (data) {
        var hasAuth = _this3.$common.hasPerm('dashboard:cleanShardingCount');
        var resultData = JSON.parse(data);
        var domains = [];
        var dataArr = [];
        resultData.forEach(function (ele) {
          domains.push(ele.domainName);
          _this3.$set(ele, 'value', ele.shardingCount);
          _this3.$set(ele, 'columnType', 'domain');
          dataArr.push(ele);
        });
        var tooltip = {
          position: 'inside',
          enterable: true,
          formatter: function formatter(params) {
            var result = '';
            var tooltipStr = '<b>' + params.name + '</b><br/>\n            \u5206\u7247\u6B21\u6570: ' + params.value + '<br/>';
            if (hasAuth) {
              result = tooltipStr + '<button class="chart-tooltip-btn" onclick="vm.clearZk(\'/console/dashboard/namespaces/' + params.data.domainName + '/shardingCount/clean\')">\u6E05\u9664zk</button>';
            } else {
              result = tooltipStr;
            }
            return result;
          }
        };
        var optionInfo = {
          seriesData: dataArr,
          xCategories: domains,
          yTitle: '分片次数',
          tooltip: tooltip
        };
        _this3.top10UnstableDomainOptionInfo = optionInfo;
      }).catch(function () {
        _this3.$http.buildErrorHandler('获取稳定性最差的Top10域请求失败！');
      });
    },
    getDomainExecutorVersionNumber: function getDomainExecutorVersionNumber() {
      var _this4 = this;

      return this.$http.get('/console/dashboard/domainExecutorVersionNumber', { zkClusterKey: this.zkCluster }).then(function (data) {
        var arr = [];
        (0, _entries2.default)(data).forEach(function (ele) {
          if (ele[0] === '-1') {
            var a1 = { name: '未知版本', value: ele[1] };
            arr.push(a1);
          } else {
            var item = { name: ele[0], value: ele[1] };
            arr.push(item);
          }
        });
        var seriesData = [{ name: '该版本域数量', type: 'pie', data: arr }];
        _this4.$set(_this4.domainExecutorVersionOptionInfo, 'seriesData', seriesData);
      }).catch(function () {
        _this4.$http.buildErrorHandler('获取域版本分布请求失败！');
      });
    },
    getAllDomainHistory: function getAllDomainHistory() {
      var _this5 = this;

      return this.$http.get('/console/dashboard/domainOperationCount', { zkClusterKey: this.zkClusterKey }).then(function (data) {
        var optionInfo = {
          xAxis: data.xAxis,
          seriesData: [{ name: '历史记录', data: data.yAxis }],
          yAxisName: '次'
        };
        _this5.allDomainHistoryOptionInfo = optionInfo;
      }).catch(function () {
        _this5.$http.buildErrorHandler('获取历史全域数据请求失败！');
      });
    },
    init: function init() {
      var _this6 = this;

      this.loading = true;
      _promise2.default.all([this.getDomainProcessCount(), this.getTop10FailDomain(), this.getTop10UnstableDomain(), this.getDomainExecutorVersionNumber(), this.getAllDomainHistory()]).then(function () {
        _this6.loading = false;
      });
    }
  },
  created: function created() {
    this.init();
  }
};

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(38);

var _promise2 = _interopRequireDefault(_promise);

var _entries = __webpack_require__(195);

var _entries2 = _interopRequireDefault(_entries);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      loading: false,
      zkCluster: this.$route.query.zkCluster,
      top10FailExecutorOptionInfo: {},
      top10LoadExecutorOptionInfo: {},
      executorVersionNumberOptionInfo: {}
    };
  },

  methods: {
    getTop10FailExecutor: function getTop10FailExecutor() {
      var _this = this;

      return this.$http.get('/console/dashboard/top10FailExecutor', { zkClusterKey: this.zkCluster }).then(function (data) {
        var resultData = JSON.parse(data);
        var executors = [];
        var dataArr = [];
        resultData.forEach(function (ele) {
          executors.push(ele.executorName);
          _this.$set(ele, 'value', ele.failureRateOfTheDay);
          _this.$set(ele, 'columnType', 'executor');
          dataArr.push(ele);
        });
        var tooltip = {
          position: 'inside',
          enterable: true,
          formatter: function formatter(params) {
            return '<b>' + params.name + '</b><br/>\n            \u9519\u8BEF\u7387: ' + params.value + '<br/>\n            \u6267\u884C\u603B\u6570: ' + params.data.processCountOfTheDay + '<br/>\n            \u5931\u8D25\u603B\u6570: ' + params.data.failureCountOfTheDay + '<br/>';
          }
        };
        var optionInfo = {
          seriesData: dataArr,
          xCategories: executors,
          yTitle: '失败率(小数)',
          tooltip: tooltip
        };
        _this.top10FailExecutorOptionInfo = optionInfo;
      }).catch(function () {
        _this.$http.buildErrorHandler('获取失败率最高的Top10 Executor请求失败！');
      });
    },
    getTop10LoadExecutor: function getTop10LoadExecutor() {
      var _this2 = this;

      return this.$http.get('/console/dashboard/top10LoadExecutor', { zkClusterKey: this.zkCluster }).then(function (data) {
        var resultData = JSON.parse(data);
        var executors = [];
        var dataArr = [];
        resultData.forEach(function (ele) {
          executors.push(ele.executorName);
          _this2.$set(ele, 'value', ele.loadLevel);
          _this2.$set(ele, 'columnType', 'executor');
          dataArr.push(ele);
        });
        var tooltip = {
          position: 'inside',
          enterable: true,
          formatter: function formatter(params) {
            return '<b>' + params.name + '</b><br/>\n            \u6240\u5C5E\u57DF: ' + params.data.domain + '<br/>\n            \u603B\u8D1F\u8377: ' + params.data.loadLevel + '<br/>\n            \u4F5C\u4E1A\u4E0E\u5206\u7247: ' + params.data.jobAndShardings + '<br/>';
          }
        };
        var optionInfo = {
          seriesData: dataArr,
          xCategories: executors,
          yTitle: 'Executor总负荷',
          tooltip: tooltip
        };
        _this2.top10LoadExecutorOptionInfo = optionInfo;
      }).catch(function () {
        _this2.$http.buildErrorHandler('获取负荷最重的Top10 Executor请求失败！');
      });
    },
    getExecutorVersionNumber: function getExecutorVersionNumber() {
      var _this3 = this;

      return this.$http.get('/console/dashboard/executorVersionNumber', { zkClusterKey: this.zkCluster }).then(function (data) {
        var resultData = [];
        (0, _entries2.default)(data).forEach(function (ele) {
          var item = { name: ele[0], value: ele[1] };
          resultData.push(item);
        });
        var seriesData = [{ name: '该版本Executor数量', type: 'pie', data: resultData }];
        _this3.$set(_this3.executorVersionNumberOptionInfo, 'seriesData', seriesData);
      }).catch(function () {
        _this3.$http.buildErrorHandler('获取Executor版本分布请求失败！');
      });
    },
    init: function init() {
      var _this4 = this;

      this.loading = true;
      _promise2.default.all([this.getTop10FailExecutor(), this.getTop10LoadExecutor(), this.getExecutorVersionNumber()]).then(function () {
        _this4.loading = false;
      });
    }
  },
  created: function created() {
    this.init();
  }
};

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(38);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      loading: false,
      zkCluster: this.$route.query.zkCluster,
      top10FailJobOptionInfo: {},
      top10ActiveJobOptionInfo: {},
      top10LoadJobOptionInfo: {}
    };
  },

  methods: {
    getTop10FailJob: function getTop10FailJob() {
      var _this = this;

      return this.$http.get('/console/dashboard/top10FailJob', { zkClusterKey: this.zkCluster }).then(function (data) {
        var hasAuth = _this.$common.hasPerm('dashboard:cleanOneJobAnalyse');
        var resultData = JSON.parse(data);
        var jobs = [];
        var dataArr = [];
        resultData.forEach(function (ele) {
          jobs.push(ele.jobName);
          _this.$set(ele, 'value', ele.failureRateOfAllTime);
          _this.$set(ele, 'columnType', 'job');
          dataArr.push(ele);
        });
        var tooltip = {
          position: 'inside',
          enterable: true,
          formatter: function formatter(params) {
            var result = '';
            var tooltipStr = '<b>' + params.name + '</b><br/>\n            \u6240\u5C5E\u57DF: ' + params.data.domainName + '<br/>\n            \u6267\u884C\u603B\u6570: ' + params.data.processCountOfAllTime + '<br/>\n            \u5931\u8D25\u603B\u6570: ' + params.data.errorCountOfAllTime + '<br/>';
            if (hasAuth) {
              result = tooltipStr + '<button class="chart-tooltip-btn" onclick="vm.clearZk(\'/console/dashboard/namespaces/' + params.data.domainName + '/jobs/' + params.data.jobName + '/jobAnalyse/clean\')">\u6E05\u9664zk</button>';
            } else {
              result = tooltipStr;
            }
            return result;
          }
        };
        var optionInfo = {
          seriesData: dataArr,
          xCategories: jobs,
          yTitle: '失败率(小数)',
          tooltip: tooltip
        };
        _this.top10FailJobOptionInfo = optionInfo;
      }).catch(function () {
        _this.$http.buildErrorHandler('获取失败率最高的Top10作业请求失败！');
      });
    },
    getTop10ActiveJob: function getTop10ActiveJob() {
      var _this2 = this;

      return this.$http.get('/console/dashboard/top10ActiveJob', { zkClusterKey: this.zkCluster }).then(function (data) {
        var hasAuth = _this2.$common.hasPerm('dashboard:cleanOneJobExecutorCount');
        var resultData = JSON.parse(data);
        var jobs = [];
        var dataArr = [];
        resultData.forEach(function (ele) {
          jobs.push(ele.jobName);
          _this2.$set(ele, 'value', ele.processCountOfTheDay);
          _this2.$set(ele, 'columnType', 'job');
          dataArr.push(ele);
        });
        var tooltip = {
          position: 'inside',
          enterable: true,
          formatter: function formatter(params) {
            var result = '';
            var tooltipStr = '<b>' + params.name + '</b><br/>\n            \u6240\u5C5E\u57DF: ' + params.data.domainName + '<br/>\n            \u5F53\u5929\u6267\u884C\u603B\u6570: ' + params.data.processCountOfTheDay + '<br/>\n            \u5F53\u5929\u5931\u8D25\u6570: ' + params.data.failureCountOfTheDay + '<br/>';
            if (hasAuth) {
              result = tooltipStr + '<button class="chart-tooltip-btn" onclick="vm.clearZk(\'/console/dashboard/namespaces/' + params.data.domainName + '/jobs/' + params.data.jobName + '/jobExecutorCount/clean\')">\u6E05\u9664zk</button>';
            } else {
              result = tooltipStr;
            }
            return result;
          }
        };
        var optionInfo = {
          seriesData: dataArr,
          xCategories: jobs,
          yTitle: '当天执行次数',
          tooltip: tooltip
        };
        _this2.top10ActiveJobOptionInfo = optionInfo;
      }).catch(function () {
        _this2.$http.buildErrorHandler('获取最活跃的Top10作业请求失败！');
      });
    },
    getTop10LoadJob: function getTop10LoadJob() {
      var _this3 = this;

      return this.$http.get('/console/dashboard/top10LoadJob', { zkClusterKey: this.zkCluster }).then(function (data) {
        var resultData = JSON.parse(data);
        var jobs = [];
        var dataArr = [];
        resultData.forEach(function (ele) {
          jobs.push(ele.jobName);
          _this3.$set(ele, 'value', ele.totalLoadLevel);
          _this3.$set(ele, 'columnType', 'job');
          dataArr.push(ele);
        });
        var tooltip = {
          position: 'inside',
          enterable: true,
          formatter: function formatter(params) {
            return '<b>' + params.name + '</b><br/>\n            \u6240\u5C5E\u57DF: ' + params.data.domainName + '<br/>\n            \u5931\u8D25\u7387: ' + params.data.failureRateOfAllTime + '<br/>\n            \u603B\u8D1F\u8377: ' + params.data.totalLoadLevel + '<br/>';
          }
        };
        var optionInfo = {
          seriesData: dataArr,
          xCategories: jobs,
          yTitle: '作业总负荷',
          tooltip: tooltip
        };
        _this3.top10LoadJobOptionInfo = optionInfo;
      }).catch(function () {
        _this3.$http.buildErrorHandler('获取负荷最重的Top10作业请求失败！');
      });
    },
    init: function init() {
      var _this4 = this;

      this.loading = true;
      _promise2.default.all([this.getTop10FailJob(), this.getTop10ActiveJob(), this.getTop10LoadJob()]).then(function () {
        _this4.loading = false;
      });
    }
  },
  created: function created() {
    this.init();
  }
};

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(38);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      loading: false,
      abnormalJob: '',
      timeoutJob: '',
      unableFailoverJob: ''
    };
  },

  methods: {
    getAbnormal: function getAbnormal() {
      var _this = this;

      return this.$http.get('/console/namespaces/' + this.domainName + '/jobs/' + this.jobName + '/isAbnormal').then(function (data) {
        _this.abnormalJob = data;
      }).catch(function () {
        _this.$http.buildErrorHandler('获取异常作业信息请求失败！');
      });
    },
    getTimeout: function getTimeout() {
      var _this2 = this;

      return this.$http.get('/console/namespaces/' + this.domainName + '/jobs/' + this.jobName + '/isTimeout4Alarm').then(function (data) {
        _this2.timeoutJob = data;
      }).catch(function () {
        _this2.$http.buildErrorHandler('获取超时作业信息请求失败！');
      });
    },
    getUnableFailover: function getUnableFailover() {
      var _this3 = this;

      return this.$http.get('/console/namespaces/' + this.domainName + '/jobs/' + this.jobName + '/isUnableFailover').then(function (data) {
        _this3.unableFailoverJob = data;
      }).catch(function () {
        _this3.$http.buildErrorHandler('获取无法高可用作业信息请求失败！');
      });
    },
    handleAbnormalJob: function handleAbnormalJob() {
      var _this4 = this;

      this.$http.post('/console/namespaces/' + this.domainName + '/setAbnormalJobMonitorStatusToRead', { uuid: this.abnormalJob.uuid }).then(function () {
        _this4.init();
        _this4.$message.successNotify('操作成功');
      }).catch(function () {
        _this4.$http.buildErrorHandler('不再告警操作请求失败！');
      });
    },
    handleTimeoutJob: function handleTimeoutJob() {
      var _this5 = this;

      this.$http.post('/console/namespaces/' + this.domainName + '/setTimeout4AlarmJobMonitorStatusToRead', { uuid: this.timeoutJob.uuid }).then(function () {
        _this5.init();
        _this5.$message.successNotify('操作成功');
      }).catch(function () {
        _this5.$http.buildErrorHandler('不再告警操作请求失败！');
      });
    },
    init: function init() {
      var _this6 = this;

      this.loading = true;
      _promise2.default.all([this.getAbnormal(), this.getTimeout(), this.getUnableFailover()]).then(function () {
        _this6.loading = false;
      });
    }
  },
  computed: {
    domainName: function domainName() {
      return this.$route.params.domain;
    },
    jobName: function jobName() {
      return this.$route.params.jobName;
    }
  },
  watch: {
    $route: 'init'
  },
  created: function created() {
    this.init();
  }
};

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(38);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      loading: false,
      domainInfo: {},
      statusTag: {
        READY: 'primary',
        RUNNING: 'success',
        STOPPING: 'warning',
        STOPPED: ''
      },
      translateStatus: {
        READY: '已就绪',
        RUNNING: '运行中',
        STOPPING: '停止中',
        STOPPED: '已停止'
      },
      jobShardings: []
    };
  },

  methods: {
    handleOperate: function handleOperate(operation) {
      var _this = this;

      if (operation === 'stopAtOnce') {
        var textHtml = '<span style="font-size:12px;color:#E6A23C;">* \u6CE8\u610F\uFF1A\u5BF9\u4E8EJava\u4F5C\u4E1A\uFF0C\u7ACB\u5373\u7EC8\u6B62\u64CD\u4F5C\uFF08\u5373\u5F3A\u6740\uFF09\u4F1Astop\u4E1A\u52A1\u7EBF\u7A0B\uFF0C\u5982\u679C\u4F5C\u4E1A\u4EE3\u7801\u6CA1\u6709\u5B9E\u73B0postForceStop\u65B9\u6CD5\u6765\u91CA\u653E\u8D44\u6E90\uFF0C\u6709\u53EF\u80FD\u5BFC\u81F4\u8D44\u6E90\u7684\u4E0D\u91CA\u653E\uFF0C\u4F8B\u5982\u6570\u636E\u5E93\u8FDE\u63A5\u7684\u4E0D\u91CA\u653E\u3002</span><br/>\n        <span>\u786E\u8BA4\u7ACB\u5373\u7EC8\u6B62\u4F5C\u4E1A ' + this.jobName + ' \u5417?</span>';
        this.$message.confirmMessage(textHtml, function () {
          _this.operateRequest(operation);
        });
      } else {
        this.$message.confirmMessage('\u786E\u8BA4\u7ACB\u5373\u6267\u884C\u4F5C\u4E1A ' + this.jobName + ' \u5417?', function () {
          _this.operateRequest(operation);
        });
      }
    },
    operateRequest: function operateRequest(operation) {
      var _this2 = this;

      this.$http.post('/console/namespaces/' + this.domainName + '/jobs/' + this.jobName + '/config/' + operation, '').then(function () {
        _this2.$message.successNotify('操作成功');
        _this2.getJobInfo();
      }).catch(function () {
        _this2.$http.buildErrorHandler(operation + '\u8BF7\u6C42\u5931\u8D25\uFF01');
      });
    },
    handleDelete: function handleDelete() {
      var _this3 = this;

      this.$message.confirmMessage('\u786E\u8BA4\u5220\u9664\u4F5C\u4E1A ' + this.jobName + ' \u5417?', function () {
        _this3.$http.delete('/console/namespaces/' + _this3.domainName + '/jobs/' + _this3.jobName).then(function () {
          _this3.$router.push({ name: 'job_overview', params: { domain: _this3.domainName } });
          _this3.$message.successNotify('删除作业操作成功');
        }).catch(function () {
          _this3.$http.buildErrorHandler('删除作业请求失败！');
        });
      });
    },
    handleActive: function handleActive(enabled) {
      var _this4 = this;

      var operation = enabled ? '启用' : '禁用';
      var activeRequest = enabled ? 'enable' : 'disable';
      this.$message.confirmMessage('\u786E\u5B9A' + operation + '\u4F5C\u4E1A' + this.jobName + '\u5417?', function () {
        _this4.activeRequest(_this4.jobName, activeRequest);
      });
    },
    activeRequest: function activeRequest(jobName, reqUrl) {
      var _this5 = this;

      this.$http.post('/console/namespaces/' + this.domainName + '/jobs/' + jobName + '/' + reqUrl, '').then(function () {
        _this5.$message.successNotify('操作成功');
        _this5.getJobInfo();
      }).catch(function () {
        _this5.$http.buildErrorHandler(reqUrl + '\u8BF7\u6C42\u5931\u8D25\uFF01');
      });
    },
    getDomainInfo: function getDomainInfo() {
      var _this6 = this;

      return this.$http.get('/console/namespaces/' + this.domainName + '/').then(function (data) {
        _this6.domainInfo = data;
      }).catch(function () {
        _this6.$http.buildErrorHandler('获取namespace信息请求失败！');
      });
    },
    getJobInfo: function getJobInfo() {
      var _this7 = this;

      var params = {
        domainName: this.domainName,
        jobName: this.jobName
      };
      return this.$store.dispatch('setJobInfo', params).then(function (resp) {
        console.log(resp);
      }).catch(function () {
        return _this7.$http.buildErrorHandler('获取作业信息请求失败！');
      });
    },
    jobStatusJudge: function jobStatusJudge() {
      return this.jobShardings.some(function (ele) {
        if (ele.serverStatus === 'ONLINE') {
          return true;
        }
        return false;
      });
    },
    getJobStatus: function getJobStatus() {
      var _this8 = this;

      return this.$http.get('/console/namespaces/' + this.domainName + '/jobs/' + this.jobName + '/servers/status').then(function (data) {
        _this8.jobShardings = data;
      }).catch(function () {
        _this8.$http.buildErrorHandler('获取作业运行状态请求失败！');
      });
    },
    init: function init() {
      var _this9 = this;

      this.loading = true;
      _promise2.default.all([this.getDomainInfo(), this.getJobInfo(), this.getJobStatus()]).then(function () {
        _this9.loading = false;
      });
    }
  },
  computed: {
    jobInfo: function jobInfo() {
      return this.$store.state.global.jobInfo;
    },
    domainName: function domainName() {
      return this.$route.params.domain;
    },
    jobName: function jobName() {
      return this.$route.params.jobName;
    },
    sidebarMenus: function sidebarMenus() {
      var menus = [{ index: 'job_setting', title: '作业设置', icon: 'fa fa-gear', name: 'job_setting', params: { domain: this.$route.params.domain, jobName: this.$route.params.jobName } }, { index: 'job_sharding', title: '分片情况', icon: 'fa fa-server', name: 'job_sharding', params: { domain: this.$route.params.domain, jobName: this.$route.params.jobName } }, { index: 'job_execution', title: '运行状态', icon: 'fa fa-dot-circle-o', name: 'job_execution', params: { domain: this.$route.params.domain, jobName: this.$route.params.jobName } }, { index: 'job_alarm', title: '告警中心', icon: 'fa fa-bell', name: 'job_alarm', params: { domain: this.$route.params.domain, jobName: this.$route.params.jobName } }, { index: 'job_history', title: '作业执行日志', icon: 'fa fa-dot-circle-o', name: 'job_history', params: { domain: this.$route.params.domain, jobName: this.$route.params.jobName } }, { index: 'job_message_history', title: '作业消息日志', icon: 'fa fa-dot-circle-o', name: 'job_message_history', params: { domain: this.$route.params.domain, jobName: this.$route.params.jobName } }];
      return menus;
    }
  },
  watch: {
    $route: 'init'
  },
  created: function created() {
    this.init();
  }
};

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(38);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      isViewLogVisible: false,
      autoRefreshTime: '',
      refreshTimes: [{
        label: '关闭',
        value: ''
      }, {
        label: '30秒',
        value: 30000
      }, {
        label: '1分钟',
        value: 60000
      }, {
        label: '3分钟',
        value: 180000
      }, {
        label: '5分钟',
        value: 300000
      }],
      statusTag: {
        RUNNING: 'success',
        COMPLETED: 'primary',
        FAILED: 'danger',
        TIMEOUT: 'warning',
        PENDING: 'warning'
      },
      translateStatus: {
        RUNNING: '运行中',
        COMPLETED: '完成',
        FAILED: '失败',
        TIMEOUT: '超时',
        PENDING: '未知'
      },
      executions: [],
      interval: 0,
      logContent: ''
    };
  },

  methods: {
    getLog: function getLog(row) {
      var _this = this;

      var params = {
        jobItem: row.item
      };
      this.$http.get('/console/namespaces/' + this.domainName + '/jobs/' + this.jobName + '/execution/log', params).then(function (data) {
        _this.logContent = data;
        _this.isViewLogVisible = true;
      }).catch(function () {
        _this.$http.buildErrorHandler('获取日志请求失败！');
      });
    },
    closeViewLogDialog: function closeViewLogDialog() {
      this.isViewLogVisible = false;
    },
    refreshExecutions: function refreshExecutions() {
      var _this2 = this;

      if (this.autoRefreshTime) {
        this.interval = setInterval(function () {
          _this2.init();
        }, this.autoRefreshTime);
      } else {
        clearInterval(this.interval);
      }
    },
    getJobExecutors: function getJobExecutors() {
      var _this3 = this;

      return this.$http.get('/console/namespaces/' + this.domainName + '/jobs/' + this.jobName + '/execution/status').then(function (data) {
        _this3.executions = data;
      }).catch(function () {
        _this3.$http.buildErrorHandler('获取作业运行状态请求失败！');
      });
    },
    getJobInfo: function getJobInfo() {
      var _this4 = this;

      var params = {
        domainName: this.domainName,
        jobName: this.jobName
      };
      return this.$store.dispatch('setJobInfo', params).then(function () {}).catch(function () {
        return _this4.$http.buildErrorHandler('获取作业信息请求失败！');
      });
    },
    init: function init() {
      _promise2.default.all([this.getJobExecutors(), this.getJobInfo()]).then(function () {});
    }
  },
  watch: {
    $route: 'init'
  },
  computed: {
    domainName: function domainName() {
      return this.$route.params.domain;
    },
    jobName: function jobName() {
      return this.$route.params.jobName;
    }
  },
  created: function created() {
    this.init();
  },
  destroyed: function destroyed() {
    clearInterval(this.interval);
  }
};

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      loading: false,
      tableLoading: false,
      filters: {
        appKey: { value: '' },
        jobResult: { value: '', precise: true },
        jobType: { value: '' },
        siteId: { value: '' },
        topic: { value: '' }
      },
      jobTypes: [{
        value: 'Time',
        label: '定时作业'
      }, {
        value: 'www.abc.com',
        label: '立即执行作业'
      }],
      jobResults: [{
        value: true,
        label: '成功'
      }, {
        value: false,
        label: '失败'
      }],
      JobHistoryList: [],
      total: 0,
      orderBy: '',
      selectColumn: 'appKey',
      translateJobResult: {
        true: '成功',
        false: '失败'
      },
      multipleSelection: []
    };
  },

  methods: {
    selectColumnChange: function selectColumnChange() {
      this.filters.jobResult.value = '';
      this.filters.jobType.value = '';
    },
    getJobHistoryIdsArray: function getJobHistoryIdsArray(arr) {
      var jobHistoryIdsArray = [];
      arr.forEach(function (ele) {
        jobHistoryIdsArray.push(ele.id);
      });
      return jobHistoryIdsArray;
    },
    batchDelete: function batchDelete() {
      var _this = this;

      this.batchOperation('删除', function (arr) {
        var selectedJobHistoryArray = arr;
        if (selectedJobHistoryArray.length === 0) {
          _this.$message.errorMessage('没有可以删除的作业执行日志,请勾选!');
        } else {
          var confirmText = selectedJobHistoryArray.length < 10 ? '确认删除作业执行日志吗?' : '\u786E\u8BA4\u5220\u9664\u5DF2\u9009\u7684 ' + selectedJobHistoryArray.length + ' \u6761\u4F5C\u4E1A\u6267\u884C\u65E5\u5FD7\u5417?';
          _this.$message.confirmMessage(confirmText, function () {
            var params = {
              jobHistoryIds: _this.getJobHistoryIdsArray(selectedJobHistoryArray).join(',')
            };
            _this.$http.delete('/console/namespaces/' + _this.domainName + '/jobs/' + _this.jobName + '/jobHistory/batchRemoveJobHistory', params).then(function () {
              _this.refreshPage();
              _this.$message.successNotify('批量删除作业执行日志操作成功');
            }).catch(function () {
              _this.$http.buildErrorHandler('批量删除作业执行日志请求失败！');
            });
          });
        }
      });
    },
    batchOperation: function batchOperation(text, callback) {
      if (this.multipleSelection.length <= 0) {
        this.$message.errorMessage('\u8BF7\u9009\u62E9\u8981\u6279\u91CF' + text + '\u7684\u4F5C\u4E1A\u6267\u884C\u65E5\u5FD7\uFF01\uFF01\uFF01');
      } else {
        var selectedJobHistoryArray = [];
        this.multipleSelection.forEach(function (element) {
          selectedJobHistoryArray.push(element);
        });
        callback(selectedJobHistoryArray);
      }
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleDelete: function handleDelete(row) {
      var _this2 = this;

      this.$message.confirmMessage('确认删除作业执行日志吗?', function () {
        var params = {
          jobHistoryIds: row.id
        };
        _this2.$http.delete('/console/namespaces/' + _this2.domainName + '/jobs/' + _this2.jobName + '/jobHistory/batchRemoveJobHistory', params).then(function () {
          _this2.refreshPage();
          _this2.$message.successNotify('删除作业执行日志操作成功');
        }).catch(function () {
          _this2.$http.buildErrorHandler('删除作业执行日志请求失败！');
        });
      });
    },
    getJobHistory: function getJobHistory(params) {
      var _this3 = this;

      this.tableLoading = true;
      this.$http.get('/console/namespaces/' + this.domainName + '/jobs/' + this.jobName + '/jobHistory', params).then(function (data) {
        _this3.JobHistoryList = data.jobHistoryPage;
        _this3.total = data.totalCount;
      }).catch(function () {
        _this3.$http.buildErrorHandler('获取作业执行日志列表请求失败！');
      }).finally(function () {
        _this3.tableLoading = false;
      });
    },
    refreshPage: function refreshPage() {
      this.$refs.pageListRef.search();
    }
  },
  created: function created() {},

  watch: {
    $route: 'init'
  },
  computed: {
    domainName: function domainName() {
      return this.$route.params.domain;
    },
    jobName: function jobName() {
      return this.$route.params.jobName;
    },
    filterColumnPlaceholder: function filterColumnPlaceholder() {
      var str = '';
      switch (this.selectColumn) {
        case 'appKey':
          str = '请输入AppKey';
          break;
        case 'siteId':
          str = '请输入站点ID';
          break;
        case 'topic':
          str = '请输入消息主题';
          break;
        default:
          str = '';
          break;
      }
      return str;
    }
  }
};

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      loading: false,
      tableLoading: false,
      filters: {
        appKey: { value: '' },
        messageResult: { value: '', precise: true },
        siteId: { value: '' },
        topic: { value: '' }
      },
      messageResults: [{
        value: true,
        label: '成功'
      }, {
        value: false,
        label: '失败'
      }],
      JobMessageHistoryList: [],
      total: 0,
      orderBy: '',
      selectColumn: 'appKey',
      translateMessageResult: {
        true: '成功',
        false: '失败'
      },
      multipleSelection: []
    };
  },

  methods: {
    selectColumnChange: function selectColumnChange() {
      this.filters.appKey.value = '';
      this.filters.siteId.value = '';
      this.filters.topic.value = '';
    },
    resetMessageResult: function resetMessageResult() {
      this.filters.appKey.value = '';
      this.filters.siteId.value = '';
      this.filters.topic.value = '';
      this.filters.messageResult.value = '';
    },
    getJobMessageHistoryIdsArray: function getJobMessageHistoryIdsArray(arr) {
      var jobMessageHistoryIdsArray = [];
      arr.forEach(function (ele) {
        jobMessageHistoryIdsArray.push(ele.id);
      });
      return jobMessageHistoryIdsArray;
    },
    batchDelete: function batchDelete() {
      var _this = this;

      this.batchOperation('删除', function (arr) {
        var selectedJobMessageHistoryArray = arr;
        if (selectedJobMessageHistoryArray.length === 0) {
          _this.$message.errorMessage('没有可以删除的作业消息日志,请勾选!');
        } else {
          var confirmText = selectedJobMessageHistoryArray.length < 10 ? '确认删除作业消息日志吗?' : '\u786E\u8BA4\u5220\u9664\u5DF2\u9009\u7684 ' + selectedJobMessageHistoryArray.length + ' \u6761\u4F5C\u4E1A\u6D88\u606F\u65E5\u5FD7\u5417?';
          _this.$message.confirmMessage(confirmText, function () {
            var params = {
              jobMessageHistoryIds: _this.getJobMessageHistoryIdsArray(selectedJobMessageHistoryArray).join(',')
            };
            _this.$http.delete('/console/namespaces/' + _this.domainName + '/jobs/' + _this.jobName + '/jobMessageHistory/batchRemoveJobMessageHistory', params).then(function () {
              _this.refreshPage();
              _this.$message.successNotify('批量删除作业消息日志操作成功');
            }).catch(function () {
              _this.$http.buildErrorHandler('批量删除作业消息日志请求失败！');
            });
          });
        }
      });
    },
    batchOperation: function batchOperation(text, callback) {
      if (this.multipleSelection.length <= 0) {
        this.$message.errorMessage('\u8BF7\u9009\u62E9\u8981\u6279\u91CF' + text + '\u7684\u4F5C\u4E1A\u6D88\u606F\u65E5\u5FD7\uFF01\uFF01\uFF01');
      } else {
        var selectedJobMessageHistoryArray = [];
        this.multipleSelection.forEach(function (element) {
          selectedJobMessageHistoryArray.push(element);
        });
        callback(selectedJobMessageHistoryArray);
      }
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleDelete: function handleDelete(row) {
      var _this2 = this;

      this.$message.confirmMessage('确认删除作业消息日志吗?', function () {
        var params = {
          jobMessageHistoryIds: row.id
        };
        _this2.$http.delete('/console/namespaces/' + _this2.domainName + '/jobs/' + _this2.jobName + '/jobMessageHistory/batchRemoveJobMessageHistory', params).then(function () {
          _this2.refreshPage();
          _this2.$message.successNotify('删除作业消息日志操作成功');
        }).catch(function () {
          _this2.$http.buildErrorHandler('删除作业消息日志请求失败！');
        });
      });
    },
    getJobMessageHistory: function getJobMessageHistory(params) {
      var _this3 = this;

      this.tableLoading = true;
      this.$http.get('/console/namespaces/' + this.domainName + '/jobs/' + this.jobName + '/jobMessageHistory', params).then(function (data) {
        _this3.JobMessageHistoryList = data.jobMessageHistoryPage;
        _this3.total = data.totalCount;
      }).catch(function () {
        _this3.$http.buildErrorHandler('获取作业消息日志列表请求失败！');
      }).finally(function () {
        _this3.tableLoading = false;
      });
    },
    refreshPage: function refreshPage() {
      this.$refs.pageListRef.search();
    }
  },
  created: function created() {},

  watch: {
    $route: 'init'
  },
  computed: {
    domainName: function domainName() {
      return this.$route.params.domain;
    },
    jobName: function jobName() {
      return this.$route.params.jobName;
    },
    filterColumnPlaceholder: function filterColumnPlaceholder() {
      var str = '';
      switch (this.selectColumn) {
        case 'appKey':
          str = '请输入AppKey';
          break;
        case 'siteId':
          str = '请输入站点ID';
          break;
        case 'topic':
          str = '请输入消息主题';
          break;
        default:
          str = '';
          break;
      }
      return str;
    }
  }
};

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(44);

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: [],
  data: function data() {
    return {
      loading: false,
      isCronPredictVisible: false,
      activeNames: ['1'],
      cronPredictParams: {},
      rules: {
        cron: [{ required: true, message: 'cron表达式不能为空', trigger: 'blur' }],
        shardingItemParameters: [{ required: true, message: '分片序列号/参数对照表不能为空', trigger: 'blur' }],
        queueName: [{ required: true, message: 'queue不能为空', trigger: 'blur' }],
        jobParameter: [{ required: true, message: '自定义参数不能为空', trigger: 'blur' }]
      },
      preferListProvidedArray: [],
      isArrangeLayoutVisible: false,
      arrangeLayoutInfo: {}
    };
  },

  methods: {
    handleArrangeLayout: function handleArrangeLayout() {
      var _this = this;

      this.$http.get('/console/namespaces/' + this.domainName + '/jobs/arrangeLayout').then(function (data) {
        _this.arrangeLayoutInfo = data;
        if (_this.arrangeLayoutInfo.paths.length > 0) {
          _this.isArrangeLayoutVisible = true;
        } else {
          _this.$message.errorMessage('很抱歉！该作业没有依赖');
        }
      }).catch(function () {
        _this.$http.buildErrorHandler('请求失败！');
      });
    },
    jobRedirect: function jobRedirect(jobName) {
      var routeData = this.$router.resolve({ name: 'job_setting', params: { domain: this.domainName, jobName: jobName } });
      window.open(routeData.href, '_blank');
    },
    closeArrangeLayoutDialog: function closeArrangeLayoutDialog() {
      this.isArrangeLayoutVisible = false;
    },
    checkAndForecastCron: function checkAndForecastCron() {
      var cronData = {
        timeZone: this.jobSettingInfo.timeZone,
        cron: this.jobSettingInfo.cron
      };
      this.cronPredictParams = JSON.parse((0, _stringify2.default)(cronData));
      this.isCronPredictVisible = true;
    },
    closeCronDialog: function closeCronDialog() {
      this.isCronPredictVisible = false;
    },
    updateInfo: function updateInfo() {
      var _this2 = this;

      this.$refs.jobSettingInfo.validate(function (valid) {
        if (valid) {
          if (_this2.validateLocalMode()) {
            if (_this2.jobSettingInfo.localMode) {
              _this2.jobSettingInfo.shardingTotalCount = 1;
            }
            if (_this2.validateShardingParamsNumber()) {
              if (_this2.validateShardingParam()) {
                _this2.jobSettingInfoRequest();
              } else {
                _this2.$message.errorMessage('请正确输入分片参数!');
              }
            } else {
              _this2.$message.errorMessage('分片参数不能小于作业分片总数!');
            }
          } else {
            _this2.$message.errorMessage('作业分片参数有误，对于本地模式的作业，只需要输入如：*=a 即可。非本地模式请参考:0=a,1=b');
          }
        }
      });
    },
    jobSettingInfoRequest: function jobSettingInfoRequest() {
      var _this3 = this;

      if (this.jobSettingInfo.preferList.length > 0) {
        this.jobSettingInfo.preferList.forEach(function (ele1, index1) {
          _this3.jobSettingInfo.preferListProvided.forEach(function (ele2) {
            if (ele1 === ele2.executorName && ele2.type === 'DOCKER') {
              _this3.jobSettingInfo.preferList[index1] = '@' + ele1;
            }
          });
        });
      }
      this.$http.post('/console/namespaces/' + this.domainName + '/jobs/' + this.jobName + '/config', this.jobSettingInfo).then(function () {
        _this3.getJobSettingInfo();
        _this3.$message.successNotify('更新作业操作成功');
      }).catch(function () {
        _this3.$http.buildErrorHandler('更新作业请求失败！');
      });
    },
    validateLocalMode: function validateLocalMode() {
      var flag = true;
      if (this.jobSettingInfo.localMode) {
        if (!this.jobSettingInfo.shardingItemParameters.startsWith('*=')) {
          flag = false;
        }
      } else if (this.jobSettingInfo.shardingItemParameters.startsWith('*=')) {
        flag = false;
      }
      return flag;
    },
    validateShardingParamsNumber: function validateShardingParamsNumber() {
      var flag = false;
      if (!this.jobSettingInfo.localMode) {
        var arr = [];
        if (this.jobSettingInfo.shardingItemParameters.indexOf(',') > 0) {
          arr = this.jobSettingInfo.shardingItemParameters.split(',');
        } else {
          arr = [this.jobSettingInfo.shardingItemParameters];
        }
        if (this.jobSettingInfo.shardingTotalCount > arr.length) {
          flag = false;
        } else {
          flag = true;
        }
      } else {
        flag = true;
      }
      return flag;
    },
    validateShardingParam: function validateShardingParam() {
      var flag = false;
      var arr = [];
      if (this.jobSettingInfo.shardingItemParameters.indexOf(',') > 0) {
        arr = this.jobSettingInfo.shardingItemParameters.split(',');
      } else {
        arr = [this.jobSettingInfo.shardingItemParameters];
      }
      arr.forEach(function (ele) {
        if (ele.indexOf('=') > -1) {
          if (ele.split('=')[0] === '') {
            flag = false;
          } else {
            flag = true;
          }
        } else {
          flag = false;
        }
      });
      return flag;
    },
    getJobSettingInfo: function getJobSettingInfo() {
      var _this4 = this;

      var params = {
        domainName: this.domainName,
        jobName: this.jobName
      };
      this.loading = true;
      this.$store.dispatch('setJobInfo', params).then(function (resp) {
        console.log(resp);
      }).catch(function () {
        return _this4.$http.buildErrorHandler('获取作业信息请求失败！');
      }).finally(function () {
        _this4.loading = false;
      });
    }
  },
  computed: {
    jobSettingInfo: function jobSettingInfo() {
      var jobInfoData = this.$store.state.global.jobInfo;
      if (jobInfoData.preferList) {
        jobInfoData.preferList.forEach(function (ele, index) {
          if (ele.startsWith('@')) {
            jobInfoData.preferList[index] = ele.replace('@', '');
          }
        });
      }
      if (jobInfoData.preferListProvided) {
        this.preferListProvidedArray = jobInfoData.preferListProvided.map(function (obj) {
          var rObj = {};
          rObj.ip = obj.ip;
          rObj.executorName = obj.executorName;
          rObj.noTraffic = obj.noTraffic;
          rObj.type = obj.type;
          rObj.status = obj.status;
          if (rObj.type === 'PHYSICAL') {
            if (rObj.noTraffic) {
              switch (rObj.status) {
                case 'OFFLINE':
                  rObj.executorDes = rObj.executorName + '(\u79BB\u7EBF\u65E0\u6D41\u91CF)';
                  break;
                case 'ONLINE':
                  rObj.executorDes = rObj.executorName + '(\u5728\u7EBF\u65E0\u6D41\u91CF ' + rObj.ip + ')';
                  break;
                case 'DELETED':
                  rObj.executorDes = rObj.executorName + '(\u5DF2\u5220\u9664)';
                  break;
                default:
                  break;
              }
            } else {
              switch (rObj.status) {
                case 'OFFLINE':
                  rObj.executorDes = rObj.executorName + '(\u79BB\u7EBF)';
                  break;
                case 'ONLINE':
                  rObj.executorDes = rObj.executorName + '(\u5728\u7EBF ' + rObj.ip + ')';
                  break;
                case 'DELETED':
                  rObj.executorDes = rObj.executorName + '(\u5DF2\u5220\u9664)';
                  break;
                default:
                  break;
              }
            }
          } else {
            switch (rObj.status) {
              case 'DELETED':
                rObj.executorDes = rObj.executorName + '(\u5BB9\u5668\u7EC4\u5DF2\u5220\u9664)';
                break;
              default:
                rObj.executorDes = rObj.executorName + '(\u5BB9\u5668\u7EC4)';
                break;
            }
          }
          return rObj;
        });
      }
      return jobInfoData;
    },
    domainName: function domainName() {
      return this.$route.params.domain;
    },
    jobName: function jobName() {
      return this.$route.params.jobName;
    }
  },
  watch: {
    $route: 'getJobSettingInfo',
    'jobSettingInfo.shardingTotalCount': {
      immediate: true,
      handler: function handler(newCount) {
        if (newCount) {
          var result = [];
          if (Number(newCount) > 0 && (!this.jobSettingInfo.shardingItemParameters || /^(\d*=)(,\d*=)*$/.test(this.jobSettingInfo.shardingItemParameters))) {
            var arr = new Array(Number(newCount)).fill(1).map(function (ele, index) {
              return index;
            });
            arr.forEach(function (ele) {
              result.push(ele + '=');
            });
            this.jobSettingInfo.shardingItemParameters = result.join(',');
          }
        }
      }
    },
    'jobSettingInfo.localMode': {
      immediate: true,
      handler: function handler(newCount) {
        if (!newCount) {
          if (this.jobSettingInfo.enabledReport) {
            this.jobSettingInfo.failover = true;
          } else {
            this.jobSettingInfo.failover = false;
          }
        } else {
          this.jobSettingInfo.failover = false;
        }
      }
    },
    'jobSettingInfo.enabledReport': {
      immediate: true,
      handler: function handler(newCount) {
        if (newCount) {
          if (this.jobSettingInfo.localMode) {
            this.jobSettingInfo.failover = false;
          } else {
            this.jobSettingInfo.failover = true;
          }
        } else {
          this.jobSettingInfo.failover = false;
          this.jobSettingInfo.rerun = false;
        }
      }
    }
  }
};

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      jobShardings: []
    };
  },

  methods: {
    getJobSharding: function getJobSharding() {
      var _this = this;

      this.$http.get('/console/namespaces/' + this.domainName + '/jobs/' + this.jobName + '/sharding/status').then(function (data) {
        _this.jobShardings = data;
      }).catch(function () {
        _this.$http.buildErrorHandler('获取分片情况请求失败！');
      });
    }
  },
  computed: {
    haveShardJobShardings: function haveShardJobShardings() {
      var arr = [];
      this.jobShardings.forEach(function (ele) {
        if (ele.sharding !== '') {
          arr.push(ele);
        }
      });
      return arr;
    },
    domainName: function domainName() {
      return this.$route.params.domain;
    },
    jobName: function jobName() {
      return this.$route.params.jobName;
    }
  },
  created: function created() {
    this.getJobSharding();
  },

  watch: {
    $route: 'getJobSharding'
  }
};

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      loading: false,
      domainName: this.$route.params.domain,
      namespaceAbnormalContainersList: []
    };
  },

  methods: {
    getAbnormalContainers: function getAbnormalContainers() {
      var _this = this;

      this.loading = true;
      this.$http.get('/console/namespaces/' + this.domainName + '/alarmStatistics/abnormalContainers').then(function (data) {
        _this.namespaceAbnormalContainersList = JSON.parse(data);
      }).catch(function () {
        _this.$http.buildErrorHandler('获取异常作业请求失败！');
      }).finally(function () {
        _this.loading = false;
      });
    }
  },
  created: function created() {
    this.getAbnormalContainers();
  }
};

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      loading: false,
      domainName: this.$route.params.domain,
      namespaceAbnormalJobsList: []
    };
  },

  methods: {
    getAbnormalJobs: function getAbnormalJobs() {
      var _this = this;

      this.loading = true;
      this.$http.get('/console/namespaces/' + this.domainName + '/alarmStatistics/abnormalJobs').then(function (data) {
        _this.namespaceAbnormalJobsList = JSON.parse(data);
      }).catch(function () {
        _this.$http.buildErrorHandler('获取异常作业请求失败！');
      }).finally(function () {
        _this.loading = false;
      });
    },
    noAlarm: function noAlarm(params) {
      var _this2 = this;

      this.$http.post('/console/namespaces/' + params.domainName + '/setAbnormalJobMonitorStatusToRead', { uuid: params.uuid }).then(function () {
        _this2.getAbnormalJobs();
        _this2.$message.successNotify('操作成功');
      }).catch(function () {
        _this2.$http.buildErrorHandler('不再告警操作请求失败！');
      });
    }
  },
  created: function created() {
    this.getAbnormalJobs();
  }
};

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      activeName: 'namespace_abnormal_jobs',
      countOfAlarmJobs: {
        unnormal_job: 0,
        timeout_4_alarm_job: 0,
        unable_failover_job: 0
      }
    };
  },

  methods: {
    onTabClick: function onTabClick() {
      this.$router.push({
        name: this.activeName,
        params: {
          domain: this.$route.params.domain
        }
      });
    },
    getActiveName: function getActiveName() {
      var str = this.$route.name;
      if (str) {
        this.activeName = str;
      }
    },
    getCountOfAlarmJobs: function getCountOfAlarmJobs() {
      var _this = this;

      this.$http.get('/console/namespaces/' + this.domainName + '/alarmStatistics/countOfAlarmJobs').then(function (data) {
        data.forEach(function (ele) {
          if (ele.alarmJobType === 'unnormal_job') {
            _this.$set(_this.countOfAlarmJobs, 'unnormal_job', ele.count);
          } else if (ele.alarmJobType === 'timeout_4_alarm_job') {
            _this.$set(_this.countOfAlarmJobs, 'timeout_4_alarm_job', ele.count);
          } else if (ele.alarmJobType === 'unable_failover_job') {
            _this.$set(_this.countOfAlarmJobs, 'unable_failover_job', ele.count);
          }
        });
      }).catch(function () {
        _this.$http.buildErrorHandler('获取异常作业统计请求失败！');
      });
    }
  },
  created: function created() {
    this.activeName = this.$route.name;
    this.getCountOfAlarmJobs();
  },

  computed: {
    domainName: function domainName() {
      return this.$route.params.domain;
    }
  },
  watch: {
    $route: 'getActiveName'
  }
};

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      loading: false,
      domainName: this.$route.params.domain,
      namespaceUnableFailoverJobsList: []
    };
  },

  methods: {
    getUnableFailoverJobs: function getUnableFailoverJobs() {
      var _this = this;

      this.loading = true;
      this.$http.get('/console/namespaces/' + this.domainName + '/alarmStatistics/unableFailoverJobs').then(function (data) {
        _this.namespaceUnableFailoverJobsList = JSON.parse(data);
      }).catch(function () {
        _this.$http.buildErrorHandler('获取异常作业请求失败！');
      }).finally(function () {
        _this.loading = false;
      });
    }
  },
  created: function created() {
    this.getUnableFailoverJobs();
  }
};

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      domainName: this.$route.params.domain,
      loading: false,
      namespaceTimeoutJobsList: []
    };
  },

  methods: {
    getTimeoutJobs: function getTimeoutJobs() {
      var _this = this;

      this.loading = true;
      this.$http.get('/console/namespaces/' + this.domainName + '/alarmStatistics/timeout4AlarmJobs').then(function (data) {
        _this.namespaceTimeoutJobsList = JSON.parse(data);
      }).catch(function () {
        _this.$http.buildErrorHandler('获取异常作业请求失败！');
      }).finally(function () {
        _this.loading = false;
      });
    },
    noAlarm: function noAlarm(params) {
      var _this2 = this;

      this.$http.post('/console/namespaces/' + params.domainName + '/setTimeout4AlarmJobMonitorStatusToRead', { uuid: params.uuid }).then(function () {
        _this2.getTimeoutJobs();
        _this2.$message.successNotify('操作成功');
      }).catch(function () {
        _this2.$http.buildErrorHandler('不再告警操作请求失败！');
      });
    }
  },
  created: function created() {
    this.getTimeoutJobs();
  }
};

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: ['executorAllocationInfo'],
  data: function data() {
    return {
      isVisible: true
    };
  },

  methods: {
    closeDialog: function closeDialog() {
      this.$emit('close-dialog');
    }
  }
};

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isInteger = __webpack_require__(692);

var _isInteger2 = _interopRequireDefault(_isInteger);

var _stringify = __webpack_require__(44);

var _stringify2 = _interopRequireDefault(_stringify);

var _executor_allocation_dialog = __webpack_require__(1354);

var _executor_allocation_dialog2 = _interopRequireDefault(_executor_allocation_dialog);

var _running_allocation_dialog = __webpack_require__(1358);

var _running_allocation_dialog2 = _interopRequireDefault(_running_allocation_dialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      loading: false,
      executorList: [],
      filters: {
        executorName: { value: '' }
      },
      translateStatus: {
        ONLINE: '在线',
        OFFLINE: '离线'
      },
      orderBy: '-status',
      total: 0,
      multipleSelection: [],
      isExecutorAllocationVisible: false,
      isRunningAllocationVisible: false,
      executorAllocationInfo: {},
      runningAllocationInfo: {}
    };
  },

  methods: {
    getRunningAllocation: function getRunningAllocation(row) {
      var _this = this;

      this.$http.get('/console/namespaces/' + this.domainName + '/executors/' + row.executorName + '/runningInfo').then(function (data) {
        _this.runningAllocationInfo = JSON.parse((0, _stringify2.default)(data));
        _this.isRunningAllocationVisible = true;
      }).catch(function () {
        _this.$http.buildErrorHandler('获取分片分配失败！');
      });
    },
    closeRunningAllocationDialog: function closeRunningAllocationDialog() {
      this.isRunningAllocationVisible = false;
    },
    dumpNext: function dumpNext() {
      this.getExecutorList();
      this.$message.successNotify('一键DUMP操作成功');
    },
    handleRestart: function handleRestart(row) {
      var _this2 = this;

      this.$message.confirmMessage('\u786E\u5B9A\u91CD\u542F ' + row.executorName + ' \u5417?', function () {
        _this2.$http.post('/console/namespaces/' + _this2.domainName + '/executors/' + row.executorName + '/restart', '').then(function () {
          _this2.getExecutorList();
          _this2.$message.successNotify('重启操作成功');
        }).catch(function () {
          _this2.$http.buildErrorHandler('重启executor请求失败！');
        });
      });
    },
    getExecutorAllocation: function getExecutorAllocation(row) {
      var _this3 = this;

      this.$http.get('/console/namespaces/' + this.domainName + '/executors/' + row.executorName + '/allocationWithStatus').then(function (data) {
        _this3.isExecutorAllocationVisible = true;
        _this3.executorAllocationInfo = JSON.parse((0, _stringify2.default)(data));
      }).catch(function () {
        _this3.$http.buildErrorHandler('获取分片分配失败！');
      });
    },
    closeExecutorAllocationDialog: function closeExecutorAllocationDialog() {
      this.isExecutorAllocationVisible = false;
    },
    handleReArrange: function handleReArrange() {
      var _this4 = this;

      this.$message.confirmMessage('确认一键重排吗?', function () {
        _this4.$http.post('/console/namespaces/' + _this4.domainName + '/executors/shardAll', '').then(function () {
          _this4.getExecutorList();
          _this4.$message.successNotify('一键重排操作成功');
        }).catch(function () {
          _this4.$http.buildErrorHandler('一键重排请求失败！');
        });
      });
    },
    batchDelete: function batchDelete() {
      var _this5 = this;

      this.batchOperation('删除', function (arr) {
        var offlineExecutors = _this5.getOfflineExecutorArray(arr);
        if (offlineExecutors.length === 0) {
          _this5.$message.errorMessage('没有可以删除的Executor,请重新勾选!');
        } else {
          var params = {
            executorNames: _this5.getExecutorNameArray(offlineExecutors).join(',')
          };
          var confirmText = offlineExecutors.length < 10 ? '\u786E\u5B9A\u5220\u9664Executor ' + params.executorNames + ' \u5417?' : '\u786E\u8BA4\u5220\u9664\u5DF2\u9009\u7684 ' + offlineExecutors.length + ' \u6761Executor\u5417?';
          _this5.$message.confirmMessage(confirmText, function () {
            _this5.$http.delete('/console/namespaces/' + _this5.domainName + '/executors', params).then(function () {
              _this5.getExecutorList();
              _this5.$message.successNotify('批量删除Executor操作成功');
            }).catch(function () {
              _this5.$http.buildErrorHandler('批量删除Executor请求失败！');
            });
          });
        }
      });
    },
    batchOperation: function batchOperation(text, callback) {
      if (this.multipleSelection.length <= 0) {
        this.$message.errorMessage('\u8BF7\u9009\u62E9\u8981\u6279\u91CF' + text + '\u7684Executor\uFF01\uFF01\uFF01');
      } else {
        var selectedExecutorArray = [];
        this.multipleSelection.forEach(function (element) {
          selectedExecutorArray.push(element);
        });
        callback(selectedExecutorArray);
      }
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleDelete: function handleDelete(row) {
      var _this6 = this;

      this.$message.confirmMessage('\u786E\u5B9A\u5220\u9664Executor ' + row.executorName + ' \u5417?', function () {
        _this6.$http.delete('/console/namespaces/' + _this6.domainName + '/executors/' + row.executorName).then(function () {
          _this6.getExecutorList();
          _this6.$message.successNotify('删除Executor操作成功');
        }).catch(function () {
          _this6.$http.buildErrorHandler('删除Executor请求失败！');
        });
      });
    },
    handleTraffic: function handleTraffic(row, operation) {
      var _this7 = this;

      var params = {
        operation: operation
      };
      var text = '';
      if (operation === 'extract') {
        text = '摘取';
      } else {
        text = '恢复';
      }
      this.$message.confirmMessage('\u786E\u8BA4' + text + 'Executor ' + row.executorName + ' \u6D41\u91CF\u5417?', function () {
        _this7.$http.post('/console/namespaces/' + _this7.domainName + '/executors/' + row.executorName + '/traffic', params).then(function () {
          _this7.getExecutorList();
          _this7.$message.successNotify(text + '\u6D41\u91CF\u64CD\u4F5C\u6210\u529F');
        }).catch(function () {
          _this7.$http.buildErrorHandler(text + '\u6D41\u91CF\u8BF7\u6C42\u5931\u8D25\uFF01');
        });
      });
    },
    getExecutorNameArray: function getExecutorNameArray(arr) {
      var executorNameArray = [];
      arr.forEach(function (ele) {
        executorNameArray.push(ele.executorName);
      });
      return executorNameArray;
    },
    getOfflineExecutorArray: function getOfflineExecutorArray(arr) {
      var resultArr = [];
      arr.forEach(function (ele) {
        if (ele.status === 'OFFLINE') {
          resultArr.push(ele);
        }
      });
      return resultArr;
    },
    getExecutorList: function getExecutorList() {
      var _this8 = this;

      this.loading = true;
      this.$http.get('/console/namespaces/' + this.domainName + '/executors').then(function (data) {
        _this8.executorList = data;
        _this8.total = data.length;
      }).catch(function () {
        _this8.$http.buildErrorHandler('获取executors列表失败！');
      }).finally(function () {
        _this8.loading = false;
      });
    },
    isAbledDump: function isAbledDump(str) {
      var flag = false;
      if (str) {
        var first = Number(str[0]);
        if ((0, _isInteger2.default)(first)) {
          if (first >= 3) {
            flag = true;
          }
        } else {
          flag = true;
        }
      }
      return flag;
    }
  },
  computed: {
    onlineNum: function onlineNum() {
      var num = [];
      this.executorList.forEach(function (ele) {
        if (ele.status === 'ONLINE') {
          num.push(ele);
        }
      });
      return num.length;
    },
    totalNum: function totalNum() {
      return this.executorList.length;
    },
    domainName: function domainName() {
      return this.$route.params.domain;
    }
  },
  created: function created() {
    this.getExecutorList();
  },

  components: {
    'executor-allocation-dialog': _executor_allocation_dialog2.default,
    'running-allocation-dialog': _running_allocation_dialog2.default
  },
  watch: {
    $route: 'getExecutorList'
  }
};

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(38);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      loading: false,
      domainInfo: {}
    };
  },

  methods: {
    getDomainInfo: function getDomainInfo() {
      var _this = this;

      return this.$http.get('/console/namespaces/' + this.domainName + '/').then(function (data) {
        _this.domainInfo = data;
      }).catch(function () {
        _this.$http.buildErrorHandler('获取namespace信息请求失败！');
      });
    },
    init: function init() {
      var _this2 = this;

      this.loading = true;
      _promise2.default.all([this.getDomainInfo()]).then(function () {
        _this2.loading = false;
      });
    }
  },
  created: function created() {
    this.init();
  },

  computed: {
    domainName: function domainName() {
      return this.$route.params.domain;
    },
    sidebarMenus: function sidebarMenus() {
      var menus = [{ index: 'job_overview', title: '作业总览', icon: 'fa fa-bar-chart-o fa-fw', name: 'job_overview', params: { domain: this.$route.params.domain } }, { index: 'executor_overview', title: 'Executor总览', icon: 'fa fa-area-chart', name: 'executor_overview', params: { domain: this.$route.params.domain } }, { index: 'namespace_alarm_center', title: '告警中心', icon: 'fa fa-bell', name: 'namespace_abnormal_jobs', params: { domain: this.$route.params.domain } }];
      return menus;
    }
  },
  watch: {
    $route: 'init'
  }
};

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(38);

var _promise2 = _interopRequireDefault(_promise);

var _stringify = __webpack_require__(44);

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      loading: false,
      tableLoading: false,
      isJobInfoVisible: false,
      jobInfoTitle: '',
      jobInfoOperation: '',
      jobInfo: {},
      isBatchPriorityVisible: false,
      isImportVisible: false,
      importResult: [],
      isImportResultVisible: false,
      importData: {
        namespace: this.$route.params.domain
      },
      importUrl: '',
      isArrangeLayoutVisible: false,
      arrangeLayoutInfo: {},
      jobNamesArray: [],
      jobTotalInfo: {
        totalNumber: 0,
        enabledNumber: 0,
        abnormalNumber: 0
      },
      filters: {
        jobName: { value: '' },
        groups: { value: '', precise: true },
        status: { value: '', precise: true },
        description: { value: '' }
      },
      jobList: [],
      total: 0,
      orderBy: '',
      groupList: [],
      selectColumn: 'jobName',
      statusTag: {
        READY: 'primary',
        RUNNING: 'success',
        STOPPING: 'warning',
        STOPPED: ''
      },
      multipleSelection: []
    };
  },

  methods: {
    handleArrangeLayout: function handleArrangeLayout() {
      var _this = this;

      this.$http.get('/console/namespaces/' + this.domainName + '/jobs/arrangeLayout?groups=' + this.filters.groups.value).then(function (data) {
        _this.arrangeLayoutInfo = data;
        if (_this.arrangeLayoutInfo.paths.length > 0) {
          _this.isArrangeLayoutVisible = true;
        } else {
          _this.$message.errorMessage('很抱歉！该域没有作业依赖');
        }
      }).catch(function () {
        _this.$http.buildErrorHandler('请求失败！');
      });
    },
    jobRedirect: function jobRedirect(jobName) {
      var routeData = this.$router.resolve({ name: 'job_setting', params: { domain: this.domainName, jobName: jobName } });
      window.open(routeData.href, '_blank');
    },
    closeArrangeLayoutDialog: function closeArrangeLayoutDialog() {
      this.isArrangeLayoutVisible = false;
    },
    getShardings: function getShardings() {
      var _this2 = this;

      var jobNamesStr = this.getJobNameArray(this.jobList).join(',');
      this.$http.get('/console/namespaces/' + this.domainName + '/jobs/sharding/status', { jobNames: jobNamesStr }).then(function (data) {
        _this2.jobList.forEach(function (ele) {
          _this2.$set(ele, 'shardingList', data[ele.jobName]);
        });
      }).catch(function () {
        _this2.$http.buildErrorHandler('获取作业分片分配失败！');
      });
    },
    selectColumnChange: function selectColumnChange() {
      this.filters.jobName.value = '';
      this.filters.description.value = '';
    },
    toAbnormalJobPage: function toAbnormalJobPage() {
      this.$router.push({ name: 'namespace_abnormal_jobs', params: { domain: this.domainName } });
    },
    handleExport: function handleExport() {
      window.location.href = '/console/namespaces/' + this.domainName + '/jobs/export?groups=' + this.filters.groups.value;
    },
    handleImport: function handleImport() {
      this.isImportVisible = true;
      this.importUrl = '/console/namespaces/' + this.domainName + '/jobs/import';
    },
    closeImportDialog: function closeImportDialog() {
      this.isImportVisible = false;
    },
    importSuccess: function importSuccess(importResult) {
      this.isImportVisible = false;
      this.importResult = importResult;
      this.isImportResultVisible = true;
    },
    closeImportResultDialog: function closeImportResultDialog() {
      this.isImportResultVisible = false;
      this.refreshPage();
    },
    handleAdd: function handleAdd() {
      this.isJobInfoVisible = true;
      this.jobInfoTitle = '添加作业';
      this.jobInfoOperation = 'add';
      var jobAddInfo = {
        jobType: 'JAVA_JOB',
        jobName: '',
        jobClass: '',
        cron: '0/5 * * * * ?',
        shardingTotalCount: 1,
        shardingItemParameters: '',
        jobParameter: '',
        timeZone: 'Asia/Shanghai',
        preferList: [],
        queueName: '',
        description: '',
        upStream: [],
        downStream: [],
        siteId: '',
        taskId: '',
        taskCode: ''
      };
      this.jobInfo = JSON.parse((0, _stringify2.default)(jobAddInfo));
    },
    closeDialog: function closeDialog() {
      this.isJobInfoVisible = false;
    },
    jobInfoSuccess: function jobInfoSuccess() {
      this.isJobInfoVisible = false;
      this.refreshPage();
      this.$message.successNotify('保存作业操作成功');
    },
    batchEnabled: function batchEnabled() {
      var _this3 = this;

      this.batchOperation('启用', function (arr) {
        var stopedJob = _this3.getStoptedJobArray(arr);
        if (stopedJob.length === 0) {
          _this3.$message.errorMessage('没有可以启用的作业,请重新勾选!');
        } else {
          var params = {
            jobNames: _this3.getJobNameArray(stopedJob).join(',')
          };
          _this3.handleBatchActive(params, _this3.getJobNameArray(stopedJob), true);
        }
      });
    },
    batchDisabled: function batchDisabled() {
      var _this4 = this;

      this.batchOperation('禁用', function (arr) {
        var unstopedJob = _this4.getUnstoptedJobArray(arr);
        if (unstopedJob.length === 0) {
          _this4.$message.errorMessage('没有可以禁用的作业,请重新勾选!');
        } else {
          var params = {
            jobNames: _this4.getJobNameArray(unstopedJob).join(',')
          };
          _this4.handleBatchActive(params, _this4.getJobNameArray(unstopedJob), false);
        }
      });
    },
    batchDelete: function batchDelete() {
      var _this5 = this;

      this.batchOperation('删除', function (arr) {
        var stopedJob = _this5.getStoptedJobArray(arr);
        if (stopedJob.length === 0) {
          _this5.$message.errorMessage('没有可以删除的作业,请重新勾选!');
        } else {
          var params = {
            jobNames: _this5.getJobNameArray(stopedJob).join(',')
          };
          var confirmText = stopedJob.length < 10 ? '\u786E\u8BA4\u5220\u9664\u4F5C\u4E1A ' + params.jobNames + ' \u5417?' : '\u786E\u8BA4\u5220\u9664\u5DF2\u9009\u7684 ' + stopedJob.length + ' \u6761\u4F5C\u4E1A\u5417?';
          _this5.$message.confirmMessage(confirmText, function () {
            _this5.$http.delete('/console/namespaces/' + _this5.domainName + '/jobs', params).then(function () {
              _this5.refreshPage();
              _this5.$message.successNotify('批量删除作业操作成功');
            }).catch(function () {
              _this5.$http.buildErrorHandler('批量删除作业请求失败！');
            });
          });
        }
      });
    },
    batchPriority: function batchPriority() {
      var _this6 = this;

      this.batchOperation('优先Executors', function (arr) {
        var jobNames = _this6.getJobNameArray(arr);
        _this6.jobNamesArray = JSON.parse((0, _stringify2.default)(jobNames));
        _this6.isBatchPriorityVisible = true;
      });
    },
    closePriorityDialog: function closePriorityDialog() {
      this.isBatchPriorityVisible = false;
    },
    batchPrioritySuccess: function batchPrioritySuccess() {
      this.isBatchPriorityVisible = false;
      this.refreshPage();
      this.$message.successNotify('批量设置作业的优先Executors成功');
    },
    batchOperation: function batchOperation(text, callback) {
      if (this.multipleSelection.length <= 0) {
        this.$message.errorMessage('\u8BF7\u9009\u62E9\u8981\u6279\u91CF' + text + '\u7684\u4F5C\u4E1A\uFF01\uFF01\uFF01');
      } else {
        var selectedJobNameArray = [];
        this.multipleSelection.forEach(function (element) {
          selectedJobNameArray.push(element);
        });
        callback(selectedJobNameArray);
      }
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleCopy: function handleCopy(row) {
      var _this7 = this;

      this.$http.get('/console/namespaces/' + this.domainName + '/jobs/' + row.jobName + '/config').then(function (data) {
        var jobCopyInfo = {
          jobType: data.jobType,
          jobName: '',
          jobNameCopied: row.jobName,
          jobClass: data.jobClass,
          cron: data.cron,
          shardingTotalCount: data.shardingTotalCount,
          shardingItemParameters: data.shardingItemParameters,
          timeZone: data.timeZone,
          queueName: data.queueName,
          description: data.description,
          upStream: data.upStream || [],
          downStream: data.downStream || []
        };
        _this7.isJobInfoVisible = true;
        _this7.jobInfoTitle = '复制作业';
        _this7.jobInfoOperation = 'copy';
        _this7.jobInfo = JSON.parse((0, _stringify2.default)(jobCopyInfo));
      }).catch(function () {
        _this7.$http.buildErrorHandler('获取作业信息请求失败！');
      });
    },
    handleDelete: function handleDelete(row) {
      var _this8 = this;

      this.$message.confirmMessage('\u786E\u8BA4\u5220\u9664\u4F5C\u4E1A ' + row.jobName + ' \u5417?', function () {
        _this8.$http.delete('/console/namespaces/' + _this8.domainName + '/jobs/' + row.jobName).then(function () {
          _this8.refreshPage();
          _this8.$message.successNotify('删除作业操作成功');
        }).catch(function () {
          _this8.$http.buildErrorHandler('删除作业请求失败！');
        });
      });
    },
    handleBatchActive: function handleBatchActive(params, jobArray, enabled) {
      var _this9 = this;

      var operation = enabled ? '启用' : '禁用';
      var activeRequest = enabled ? 'enable' : 'disable';
      var confirmText = jobArray.length < 10 ? '\u786E\u5B9A' + operation + '\u4F5C\u4E1A' + params.jobNames + '\u5417?' : '\u786E\u8BA4' + operation + '\u5DF2\u9009\u7684 ' + jobArray.length + ' \u6761\u4F5C\u4E1A\u5417?';
      this.$message.confirmMessage(confirmText, function () {
        _this9.batchActiveRequest(params, activeRequest);
      });
    },
    handleActive: function handleActive(row, enabled) {
      var _this10 = this;

      var operation = enabled ? '启用' : '禁用';
      var activeRequest = enabled ? 'enable' : 'disable';
      this.$message.confirmMessage('\u786E\u5B9A' + operation + '\u4F5C\u4E1A' + row.jobName + '\u5417?', function () {
        _this10.activeRequest(row.jobName, activeRequest);
      });
    },
    batchActiveRequest: function batchActiveRequest(params, reqUrl) {
      var _this11 = this;

      this.$http.post('/console/namespaces/' + this.domainName + '/jobs/' + reqUrl, params).then(function () {
        _this11.$message.successNotify('操作成功');
        _this11.refreshPage();
      }).catch(function () {
        _this11.$http.buildErrorHandler(reqUrl + '\u8BF7\u6C42\u5931\u8D25\uFF01');
      });
    },
    activeRequest: function activeRequest(jobName, reqUrl) {
      var _this12 = this;

      this.$http.post('/console/namespaces/' + this.domainName + '/jobs/' + jobName + '/' + reqUrl, '').then(function () {
        _this12.$message.successNotify('操作成功');
        _this12.refreshPage();
      }).catch(function () {
        _this12.$http.buildErrorHandler(reqUrl + '\u8BF7\u6C42\u5931\u8D25\uFF01');
      });
    },
    getJobNameArray: function getJobNameArray(arr) {
      var jobNameArray = [];
      arr.forEach(function (ele) {
        jobNameArray.push(ele.jobName);
      });
      return jobNameArray;
    },
    getUnstoptedJobArray: function getUnstoptedJobArray(arr) {
      var resultArr = [];
      arr.forEach(function (ele) {
        if (ele.status !== 'STOPPED') {
          resultArr.push(ele);
        }
      });
      return resultArr;
    },
    getStoptedJobArray: function getStoptedJobArray(arr) {
      var resultArr = [];
      arr.forEach(function (ele) {
        if (ele.status === 'STOPPED') {
          resultArr.push(ele);
        }
      });
      return resultArr;
    },
    getJobTotal: function getJobTotal() {
      var _this13 = this;

      return this.$http.get('/console/namespaces/' + this.domainName + '/jobs/counts').then(function (data) {
        _this13.jobTotalInfo.totalNumber = data.totalNumber;
        _this13.jobTotalInfo.enabledNumber = data.enabledNumber;
        _this13.jobTotalInfo.abnormalNumber = data.abnormalNumber;
      }).catch(function () {
        _this13.$http.buildErrorHandler('获取作业总数失败！');
      });
    },
    getJobList: function getJobList(params) {
      var _this14 = this;

      this.tableLoading = true;
      this.$http.get('/console/namespaces/' + this.domainName + '/jobs', params).then(function (data) {
        _this14.jobList = data.jobs;
        _this14.total = data.totalNumber;
        if (_this14.jobList) {
          _this14.getShardings();
        }
      }).catch(function () {
        _this14.$http.buildErrorHandler('获取作业列表请求失败！');
      }).finally(function () {
        _this14.tableLoading = false;
      });
    },
    getGroupList: function getGroupList() {
      var _this15 = this;

      return this.$http.get('/console/namespaces/' + this.domainName + '/jobs/groups').then(function (data) {
        _this15.groupList = data;
      }).catch(function () {
        _this15.$http.buildErrorHandler('获取groups失败！');
      });
    },
    init: function init() {
      var _this16 = this;

      this.loading = true;
      _promise2.default.all([this.getJobTotal(), this.getGroupList()]).then(function () {
        _this16.loading = false;
      });
    },
    refreshPage: function refreshPage() {
      this.$refs.pageListRef.search();
      this.init();
    }
  },
  created: function created() {
    this.init();
  },

  watch: {
    $route: 'init'
  },
  computed: {
    domainName: function domainName() {
      return this.$route.params.domain;
    },
    filterColumnPlaceholder: function filterColumnPlaceholder() {
      var str = '';
      switch (this.selectColumn) {
        case 'jobName':
          str = '请输入作业名';
          break;
        case 'description':
          str = '请输入作业描述';
          break;
        default:
          str = '';
          break;
      }
      return str;
    }
  }
};

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: ['runningAllocationInfo'],
  data: function data() {
    return {
      isVisible: true
    };
  },

  methods: {
    closeDialog: function closeDialog() {
      this.$emit('close-dialog');
    }
  }
};

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      domainName: '',
      domains: this.$store.getters.allDomains
    };
  },

  methods: {
    querySearchAsync: function querySearchAsync(queryString, cb) {
      var domains = this.domains;
      var results = queryString ? domains.filter(this.createStateFilter(queryString)) : domains;
      cb(results);
    },
    createStateFilter: function createStateFilter(queryString) {
      return function (state) {
        return state.value.toLowerCase().indexOf(queryString.toLowerCase()) >= 0;
      };
    },
    handleSelect: function handleSelect(item) {
      this.toJobListPage(item.value);
    },
    toJobListPage: function toJobListPage(domain) {
      this.$router.push({ name: 'job_overview', params: { domain: domain } });
    }
  },
  computed: {
    userInfo: function userInfo() {
      return this.$store.state.global.userAuthority;
    },
    recentVisitDomains: function recentVisitDomains() {
      return JSON.parse(localStorage.getItem('history_' + this.userInfo.username));
    }
  }
};

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: ['clusterInfo', 'clusterInfoTitle', 'clusterInfoOperate'],
  data: function data() {
    return {
      isVisible: true,
      loading: false,
      rules: {
        zkClusterKey: [{ required: true, message: '请输入Zk集群', trigger: 'blur' }],
        alias: [{ required: true, message: '请输入集群名称', trigger: 'blur' }],
        connectString: [{ required: true, message: '请输入ZK连接串', trigger: 'blur' }]
      }
    };
  },

  methods: {
    handleSubmit: function handleSubmit() {
      var _this = this;

      this.$refs.clusterInfo.validate(function (valid) {
        if (valid) {
          _this.clusterInfoRequest('/console/zkClusters');
        }
      });
    },
    clusterInfoRequest: function clusterInfoRequest(url) {
      var _this2 = this;

      if (this.clusterInfoOperate === 'add') {
        this.loading = true;
        this.$http.post(url, this.clusterInfo).then(function () {
          setTimeout(function () {
            _this2.loading = false;
            _this2.$emit('cluster-info-success');
          }, 3000);
        }).catch(function () {
          _this2.loading = false;
          _this2.$http.buildErrorHandler(url + '\u8BF7\u6C42\u5931\u8D25\uFF01');
        });
      } else {
        this.loading = true;
        this.$http.put(url, this.clusterInfo).then(function () {
          setTimeout(function () {
            _this2.loading = false;
            _this2.$emit('cluster-info-success');
          }, 3000);
        }).catch(function () {
          _this2.$http.buildErrorHandler(url + '\u8BF7\u6C42\u5931\u8D25\uFF01');
          _this2.loading = false;
        });
      }
    },
    closeDialog: function closeDialog() {
      this.$emit('close-dialog');
    }
  },
  computed: {
    isEditable: function isEditable() {
      return this.clusterInfoOperate !== 'edit';
    }
  }
};

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(44);

var _stringify2 = _interopRequireDefault(_stringify);

var _cluster_info_dialog = __webpack_require__(1360);

var _cluster_info_dialog2 = _interopRequireDefault(_cluster_info_dialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      loading: false,
      isClusterVisible: false,
      zkClusterList: [],
      clusterInfo: {},
      clusterInfoTitle: '',
      clusterInfoOperate: '',
      filters: {
        zkClusterKey: { value: '' }
      },
      orderBy: 'zkClusterKey',
      total: 0,
      statusMap: {
        true: '离线',
        false: '在线'
      }
    };
  },

  methods: {
    handleAdd: function handleAdd() {
      var clusterAddInfo = {
        zkClusterKey: '',
        alias: '',
        connectString: '',
        description: ''
      };
      this.clusterInfoTitle = '添加ZK集群';
      this.clusterInfoOperate = 'add';
      this.clusterInfo = JSON.parse((0, _stringify2.default)(clusterAddInfo));
      this.isClusterVisible = true;
    },
    closeInfoDialog: function closeInfoDialog() {
      this.isClusterVisible = false;
    },
    clusterInfoSuccess: function clusterInfoSuccess() {
      this.isClusterVisible = false;
      this.getAllClusters();
      this.$message.successNotify('保存ZK集群操作成功,若列表未更新,请稍后手动刷新页面');
    },
    handleEdit: function handleEdit(row) {
      var _this = this;

      this.loading = true;
      this.$http.get('/console/zkClusters', { zkClusterKey: row.zkClusterKey }).then(function (data) {
        var clusterEditInfo = {
          zkClusterKey: data.zkClusterKey,
          alias: data.zkAlias,
          connectString: data.zkAddr,
          description: data.description
        };
        _this.clusterInfoTitle = '编辑ZK集群';
        _this.clusterInfoOperate = 'edit';
        _this.clusterInfo = JSON.parse((0, _stringify2.default)(clusterEditInfo));
        _this.isClusterVisible = true;
      }).catch(function () {
        _this.$http.buildErrorHandler('获取集群信息请求失败！');
      }).finally(function () {
        _this.loading = false;
      });
    },
    getAllClusters: function getAllClusters() {
      var _this2 = this;

      this.loading = true;
      this.$http.get('/console/zkClusters').then(function (data) {
        _this2.zkClusterList = data;
        _this2.total = _this2.zkClusterList.length;
      }).catch(function () {
        _this2.$http.buildErrorHandler('获取所有集群请求失败！');
      }).finally(function () {
        _this2.loading = false;
      });
    }
  },
  created: function created() {
    this.getAllClusters();
  },

  components: {
    'cluster-info-dialog': _cluster_info_dialog2.default
  }
};

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: ['namespaceInfo', 'zkClusterKeys'],
  data: function data() {
    return {
      isVisible: true,
      loading: false,
      rules: {
        zkClusterKey: [{ required: true, message: '请选择zk集群', trigger: 'change' }],
        namespace: [{ required: true, message: '请输入域名', trigger: 'blur' }]
      }
    };
  },

  methods: {
    handleSubmit: function handleSubmit() {
      var _this = this;

      this.$refs.namespaceInfo.validate(function (valid) {
        if (valid) {
          _this.namespaceInfoRequest('/console/namespaces');
        }
      });
    },
    namespaceInfoRequest: function namespaceInfoRequest(url) {
      var _this2 = this;

      this.$http.post(url, this.namespaceInfo).then(function () {
        _this2.loading = true;
        setTimeout(function () {
          _this2.loading = false;
          _this2.$emit('namespace-info-success');
        }, 3000);
      }).catch(function () {
        _this2.$http.buildErrorHandler(url + '\u8BF7\u6C42\u5931\u8D25\uFF01');
      });
    },
    closeDialog: function closeDialog() {
      this.$emit('close-dialog');
    }
  },
  computed: {
    onLineClusters: function onLineClusters() {
      var onlineArr = [];
      this.zkClusterKeys.forEach(function (element) {
        if (!element.offline) {
          onlineArr.push(element);
        }
      });
      return onlineArr;
    }
  }
};

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(38);

var _promise2 = _interopRequireDefault(_promise);

var _stringify = __webpack_require__(44);

var _stringify2 = _interopRequireDefault(_stringify);

var _namespace_info_dialog = __webpack_require__(1362);

var _namespace_info_dialog2 = _interopRequireDefault(_namespace_info_dialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      loading: false,
      isNamespaceVisible: false,
      isBatchMigrateVisible: false,
      isMigrateStatusVisible: false,
      migrateStatusTitle: '',
      namespaceList: [],
      namespaceInfo: {},
      zkClusterKeys: [],
      batchMigrateInfo: {},
      filters: {
        namespace: { value: '' },
        zkAlias: { value: '', precise: true }
      },
      orderBy: 'namespace',
      total: 0,
      multipleSelection: []
    };
  },

  methods: {
    handleExport: function handleExport() {
      this.batchOperation('导出', function (data) {
        window.location.href = '/console/namespaces/export?namespaceList=' + data;
      });
    },
    handleRefreshCenter: function handleRefreshCenter() {
      var _this = this;

      this.loading = true;
      this.$http.post('/console/registryCenter/refresh', '').then(function () {
        _this.$message.successNotify('刷新注册中心操作完成');
        _this.init();
      }).catch(function () {
        _this.$http.buildErrorHandler('刷新注册中心请求失败！');
      }).finally(function () {
        _this.loading = false;
      });
    },
    batchMigrate: function batchMigrate() {
      var _this2 = this;

      this.batchOperation('迁移', function (arr) {
        _this2.isBatchMigrateVisible = true;
        var batchMigrateData = {
          namespacesArray: arr,
          zkClusterKeyNew: ''
        };
        _this2.batchMigrateInfo = JSON.parse((0, _stringify2.default)(batchMigrateData));
      });
    },
    closeMigrateDialog: function closeMigrateDialog() {
      this.isBatchMigrateVisible = false;
    },
    batchMigrateComplete: function batchMigrateComplete(zkClusterKeyNew) {
      this.isBatchMigrateVisible = false;
      this.isMigrateStatusVisible = true;
      this.migrateStatusTitle = '\u72B6\u6001\uFF08\u6279\u91CF\u57DF\u8FC1\u79FB\u5230' + zkClusterKeyNew + '\uFF09';
    },
    closeMigrateStatusDialog: function closeMigrateStatusDialog() {
      this.isMigrateStatusVisible = false;
      this.init();
    },
    batchOperation: function batchOperation(text, callback) {
      if (this.multipleSelection.length <= 0) {
        this.$message.errorMessage('\u8BF7\u9009\u62E9\u8981\u6279\u91CF' + text + '\u7684\u57DF\uFF01\uFF01\uFF01');
      } else {
        var selectedNamespaceArray = [];
        this.multipleSelection.forEach(function (element) {
          selectedNamespaceArray.push(element.namespace);
        });
        callback(selectedNamespaceArray);
      }
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleAdd: function handleAdd() {
      this.isNamespaceVisible = true;
      var namespaceAddInfo = {
        zkClusterKey: '',
        namespace: ''
      };
      this.namespaceInfo = JSON.parse((0, _stringify2.default)(namespaceAddInfo));
    },
    closeInfoDialog: function closeInfoDialog() {
      this.isNamespaceVisible = false;
    },
    namespaceInfoSuccess: function namespaceInfoSuccess() {
      this.isNamespaceVisible = false;
      this.$message.successNotify('添加域操作成功,若列表未更新,请稍后手动刷新页面');
      this.init();
    },
    getAllNamespace: function getAllNamespace() {
      var _this3 = this;

      this.$http.get('/console/namespaces/detail').then(function (data) {
        _this3.namespaceList = data;
        _this3.total = _this3.namespaceList.length;
      }).catch(function () {
        _this3.$http.buildErrorHandler('获取所有域请求失败！');
      });
    },
    getAllClusters: function getAllClusters() {
      var _this4 = this;

      this.$http.get('/console/zkClusters').then(function (data) {
        _this4.zkClusterKeys = data;
      }).catch(function () {
        _this4.$http.buildErrorHandler('获取所有集群请求失败！');
      });
    },
    init: function init() {
      var _this5 = this;

      this.loading = true;
      _promise2.default.all([this.getAllNamespace(), this.getAllClusters()]).then(function () {
        _this5.loading = false;
      });
    }
  },
  created: function created() {
    this.init();
  },

  components: {
    'namespace-info-dialog': _namespace_info_dialog2.default
  }
};

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      sidebarMenus: [{ index: 'namespace_manage', title: '域管理', icon: 'fa fa-life-ring', name: 'namespace_manage' }, { index: 'clusters_manage', title: 'ZK集群管理', icon: 'fa fa-sitemap', name: 'clusters_manage' }]
    };
  },

  methods: {}
};

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: ['parameters', 'type'],
  data: function data() {
    return {};
  },

  methods: {
    handleSubmit: function handleSubmit(row) {
      var _this = this;

      var url = this.type === 'console' ? '/console/configs/' + this.type + '/update' : '/console/configs/' + this.type;
      var params = {
        key: row.key,
        value: row.value
      };
      this.$http.post(url, params).then(function () {
        _this.$emit('config-input-success');
      }).catch(function () {
        _this.$http.buildErrorHandler('更新配置请求失败！');
      });
    }
  }
};

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _config_input = __webpack_require__(1365);

var _config_input2 = _interopRequireDefault(_config_input);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: [],
  data: function data() {
    return {
      loading: false,
      addConfigVisible: false,
      activeNames: ['job', 'executor', 'zkCluster', 'console', 'other'],
      systemConfig: {}
    };
  },

  methods: {
    handleAdd: function handleAdd() {
      this.addConfigVisible = true;
    },
    closeDialog: function closeDialog() {
      this.addConfigVisible = false;
    },
    getSystemConfig: function getSystemConfig() {
      var _this = this;

      this.loading = true;
      this.$http.get('/console/configs/console').then(function (data) {
        _this.systemConfig = data;
      }).catch(function () {
        _this.$http.buildErrorHandler('获取Console配置请求失败！');
      }).finally(function () {
        _this.loading = false;
      });
    },
    addConfigSuccess: function addConfigSuccess() {
      this.addConfigVisible = false;
      this.$message.successNotify('添加Console配置成功');
      this.getSystemConfig();
    },
    configInputSuccess: function configInputSuccess() {
      this.$message.successNotify('Console配置保存成功');
      this.getSystemConfig();
    }
  },
  created: function created() {
    this.getSystemConfig();
  },

  components: {
    'config-input': _config_input2.default
  }
};

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(44);

var _stringify2 = _interopRequireDefault(_stringify);

var _oauth_client_config_dialog = __webpack_require__(1368);

var _oauth_client_config_dialog2 = _interopRequireDefault(_oauth_client_config_dialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      loading: false,
      isOauthClientVisible: false,
      oauthClientInfo: {},
      oauthClientTitle: '',
      oauthClientOperate: '',
      oauthClientConfigList: [],
      total: 0,
      filters: {},
      backFilter: {
        appKey: null,
        appId: null
      },
      orderBy: ''
    };
  },

  methods: {
    handleAdd: function handleAdd() {
      this.isOauthClientVisible = true;
      this.oauthClientTitle = '添加OauthClient配置';
      this.oauthClientOperate = 'add';
      var oauthClientAddInfo = {
        appId: '',
        appKey: '',
        adminName: '',
        adminPassword: '',
        extJson: ''
      };
      this.oauthClientInfo = JSON.parse((0, _stringify2.default)(oauthClientAddInfo));
    },
    handleEdit: function handleEdit(row) {
      this.isOauthClientVisible = true;
      this.oauthClientTitle = '编辑OauthClient配置';
      this.oauthClientOperate = 'edit';
      var oauthClientEditInfo = {
        id: row.id,
        appId: row.appId,
        appKey: row.appKey,
        adminName: row.adminName,
        adminPassword: '',
        extJson: row.extJson
      };
      this.oauthClientInfo = JSON.parse((0, _stringify2.default)(oauthClientEditInfo));
    },
    oauthClientSuccess: function oauthClientSuccess() {
      this.isOauthClientVisible = false;
      this.getOauthClientConfig();
      this.$message.successNotify('保存OauthClient配置操作成功');
    },
    closeInfoDialog: function closeInfoDialog() {
      this.isOauthClientVisible = false;
    },
    handleDelete: function handleDelete(row) {
      var _this = this;

      this.$message.confirmMessage('\u786E\u8BA4\u5220\u9664 ' + row.appId + ' \u5417?', function () {
        var params = {
          id: row.id
        };
        _this.$http.post('/console/configs/oauthClient/delete', params).then(function () {
          _this.getOauthClientConfig();
          _this.$message.successNotify('删除OauthClient配置操作成功');
        }).catch(function () {
          _this.$http.buildErrorHandler('删除OauthClient配置请求失败！');
        });
      });
    },
    getOauthClientConfig: function getOauthClientConfig() {
      var _this2 = this;

      var params = {
        appKey: this.backFilter.appKey !== '' ? this.backFilter.appKey : null,
        appId: this.backFilter.appId !== '' ? this.backFilter.appId : null
      };
      this.loading = true;
      this.$http.get('/console/configs/oauthClient', params).then(function (data) {
        _this2.oauthClientConfigList = data.oauthClientConfigPage;
        _this2.total = data.totalCount;
      }).catch(function () {
        _this2.$http.buildErrorHandler('获取OauthClient配置列表请求失败！');
      }).finally(function () {
        _this2.loading = false;
      });
    }
  },
  computed: {},
  components: {
    'oauth-client-config-dialog': _oauth_client_config_dialog2.default
  },
  created: function created() {
    this.getOauthClientConfig();
  }
};

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: ['oauthClientInfo', 'oauthClientTitle', 'oauthClientOperate'],
  data: function data() {
    return {
      isVisible: true,
      loading: false,
      rules: {
        appId: [{ required: true, message: '请输入应用Id', trigger: 'blur' }],
        appKey: [{ required: true, message: '请输入应用Key', trigger: 'blur' }],
        adminName: [{ required: true, message: '请输入管理员用户名', trigger: 'blur' }],
        adminPassword: [{ required: true, message: '请输入管理员密码', trigger: 'blur' }],
        extJson: [{ required: false, message: '请输入扩展参数', trigger: 'blur' }]
      }
    };
  },

  methods: {
    handleSubmit: function handleSubmit() {
      var _this = this;

      this.$refs.oauthClientInfo.validate(function (valid) {
        if (valid) {
          if (_this.oauthClientOperate === 'add') {
            var addParams = {
              appId: _this.oauthClientInfo.appId,
              appKey: _this.oauthClientInfo.appKey,
              adminName: _this.oauthClientInfo.adminName,
              adminPassword: _this.oauthClientInfo.adminPassword,
              extJson: _this.oauthClientInfo.extJson
            };
            _this.oauthClientRequest('/console/configs/oauthClient/insert', addParams);
          } else if (_this.oauthClientOperate === 'edit') {
            var editParams = {
              id: _this.oauthClientInfo.id,
              appId: _this.oauthClientInfo.appId,
              appKey: _this.oauthClientInfo.appKey,
              adminName: _this.oauthClientInfo.adminName,
              adminPassword: _this.oauthClientInfo.adminPassword,
              extJson: _this.oauthClientInfo.extJson
            };
            _this.oauthClientRequest('/console/configs/oauthClient/update', editParams);
          }
        }
      });
    },
    oauthClientRequest: function oauthClientRequest(url, params) {
      var _this2 = this;

      this.loading = true;
      this.$http.post(url, params).then(function () {
        _this2.$emit('oauth-client-success');
      }).catch(function () {
        _this2.$http.buildErrorHandler(url + '\u8BF7\u6C42\u5931\u8D25\uFF01');
      }).finally(function () {
        _this2.loading = false;
      });
    },
    closeDialog: function closeDialog() {
      this.$emit('close-dialog');
    }
  },
  computed: {
    isEditable: function isEditable() {
      return this.oauthClientOperate !== 'edit';
    }
  }
};

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      sidebarMenus: [{ index: 'console_config', title: 'Console配置', icon: 'fa fa-life-ring', name: 'console_config' }, { index: 'oauth_client_config', title: 'OauthClient配置', icon: 'fa fa-cog', name: 'oauth_client_config' }]
    };
  },

  methods: {}
};

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      loading: false,
      userList: [],
      total: 0,
      filters: {},
      backFilter: {
        userName: null,
        roleKey: null,
        namespace: null
      },
      orderBy: ''
    };
  },

  methods: {
    createStateFilter: function createStateFilter(queryString) {
      return function (state) {
        return state.value.toLowerCase().indexOf(queryString.toLowerCase()) >= 0;
      };
    },
    handleDelete: function handleDelete(row) {
      var _this = this;

      this.$message.confirmMessage('\u786E\u8BA4\u5220\u9664\u7528\u6237 ' + row.userName + ' \u5417?', function () {
        var params = {
          userName: row.userName
        };
        _this.$http.post('/console/userManage/deleteUser', params).then(function () {
          _this.getUsersReq();
          _this.$message.successNotify('删除用户操作成功');
        }).catch(function () {
          _this.$http.buildErrorHandler('删除用户请求失败！');
        });
      });
    },
    handleReset: function handleReset(row) {
      var _this2 = this;

      this.$message.confirmMessage('\u786E\u8BA4\u91CD\u7F6E\u7528\u6237 ' + row.userName + ' \u7684\u5BC6\u7801\u5417?', function () {
        var params = {
          userName: row.userName
        };
        _this2.$http.post('/console/userManage/resetUserPass', params).then(function () {
          _this2.getUsersReq();
          _this2.$message.successNotify('重置用户密码操作成功，重置后密码为 "123456"');
        }).catch(function () {
          _this2.$http.buildErrorHandler('重置用户密码请求失败！');
        });
      });
    },
    handleResetAuthenticationKey: function handleResetAuthenticationKey(row) {
      var _this3 = this;

      this.$message.confirmMessage('\u786E\u8BA4\u91CD\u7F6E\u7528\u6237 ' + row.userName + ' \u7684\u52A8\u6001\u79D8\u94A5\u5417?', function () {
        var params = {
          userName: row.userName
        };
        _this3.$http.post('/console/userManage/handleResetAuthenticationKey', params).then(function () {
          _this3.getUsersReq();
          _this3.$message.successNotify('重置用户动态秘钥操作成功');
        }).catch(function () {
          _this3.$http.buildErrorHandler('重置用户动态秘钥请求失败！');
        });
      });
    },
    getUsersReq: function getUsersReq() {
      var _this4 = this;

      var params = {
        userName: this.backFilter.userName !== '' ? this.backFilter.userName : null
      };
      this.loading = true;
      this.$http.get('/console/userManage/getUsers', params).then(function (data) {
        _this4.userList = data;
      }).catch(function () {
        _this4.$http.buildErrorHandler('获取用户列表请求失败！');
      }).finally(function () {
        _this4.loading = false;
      });
    }
  },
  computed: {},
  components: {},
  created: function created() {
    this.getUsersReq();
  }
};

/***/ }),
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, "body {\n  margin: 0;\n  padding: 0;\n  background: #f4f7f7;\n  font-family: Helvetica Neue,Helvetica,PingFang SC,Hiragino Sans GB,Microsoft YaHei,SimSun,sans-serif; }\n\ntable {\n  font-size: 14px; }\n\na {\n  cursor: pointer;\n  text-decoration: none;\n  color: #395e84; }\n  a .el-button {\n    color: #395e84; }\n  a:hover {\n    color: #2594da; }\n    a:hover .el-button {\n      color: #2594da; }\n  a.active {\n    color: #7954a7; }\n    a.active .el-button {\n      color: #7954a7; }\n\nsub, sup {\n  position: relative;\n  line-height: 0;\n  vertical-align: top; }\n\npre {\n  font: 14px/normal 'Monaco', 'Menlo', 'Ubuntu Mono', 'Consolas', 'source-code-pro', monospace; }\n\nform {\n  margin-bottom: 0; }\n\n.pull-left {\n  float: left !important; }\n\n.pull-right {\n  float: right !important; }\n\n[class*=\"fa fa-\"] {\n  margin-right: 5px;\n  margin-left: 0; }\n\n.iconfont {\n  font-size: inherit; }\n\n[class*=\"iconfont icon-\"] {\n  margin-right: 5px;\n  margin-left: 0; }\n\n.text-danger {\n  color: red; }\n\n.text-btn {\n  color: #487bb0; }\n\n.text-warning {\n  color: #E6A23C; }\n\n.text-right {\n  text-align: right; }\n\n.text-left {\n  text-align: left; }\n\n.margin-20 {\n  margin: 20px; }\n\n.page-container {\n  margin: 20px 0; }\n\n.page-content {\n  margin: 10px; }\n\n.table-filter {\n  height: 36px; }\n  .table-filter .el-form-item {\n    margin-bottom: 5px; }\n  .table-filter .operate-form-item {\n    display: inline; }\n\n.form-tags {\n  margin: 5px 5px 0; }\n\n.form-tooltip {\n  max-width: 230px; }\n\n.chart-tooltip-btn {\n  pointer-events: visible; }\n\n.form-annotation .el-form-item__content {\n  line-height: initial; }\n\n.form-annotation span {\n  font-size: 12px;\n  color: #a0a0a0; }\n\n.page-detail-header {\n  padding: 10px;\n  border-bottom: 1px solid #d0d0d0;\n  height: 30px; }\n  .page-detail-header .page-detail-title {\n    height: 30px;\n    line-height: 30px; }\n    .page-detail-header .page-detail-title .page-detail-span {\n      font-weight: bold;\n      font-size: 16px;\n      color: #777; }\n  .page-detail-header > * {\n    display: inline-block; }\n\n.dialog-title {\n  font-size: 16px;\n  font-weight: bold; }\n\n.menu-badge .el-badge__content.is-fixed {\n  top: 14;\n  right: 1; }\n\n/* header */\n.el-header {\n  padding: 0; }\n\n/* main */\n.el-main {\n  overflow: hidden; }\n\n/* autocomplete */\n.el-autocomplete-suggestion li.highlighted, .el-autocomplete-suggestion li:hover {\n  background-color: #e4e8f1; }\n\n/* input-group */\n.el-input-group__append button.el-button {\n  color: #606266; }\n\n.el-input-group__append .el-button, .el-input-group__append .el-select {\n  margin: -2px -20px 0; }\n\n.el-input-group__append div.el-select .el-input__inner {\n  color: #606266; }\n\n.el-input-group__append div.el-select:hover .el-input__inner {\n  color: #606266; }\n\n.el-input-group__prepend button.el-button {\n  color: #606266; }\n\n.el-input-group__prepend .el-button, .el-input-group__prepend .el-select {\n  margin: -2px -20px 0; }\n\n.el-input-group__prepend div.el-select .el-input__inner {\n  color: #606266; }\n\n.el-input-group__prepend div.el-select:hover .el-input__inner {\n  color: #606266; }\n\n/* input-number */\n.el-input-number .el-input__inner {\n  text-align: left; }\n\n/* input-textarea */\n.el-textarea__inner {\n  font-family: inherit; }\n\n/* upload */\n.el-upload-list__item-name [class^=el-icon] {\n  height: initial; }\n\n/* tab */\n.el-tabs__item {\n  color: #888; }\n\n/* collapse */\n.el-collapse-item__header {\n  font-size: 16px; }\n\n/* select */\n.el-select .el-tag {\n  background-color: #4185cd; }\n\n/* dialog */\n.el-dialog__header {\n  border-bottom: 1px solid #b7c0c9; }\n\n.el-dialog__title {\n  font-size: 16px;\n  font-weight: bold; }\n\n/* timedate */\n.el-range-editor.el-input__inner {\n  padding: 0px 10px; }\n\n.el-date-editor .el-range-input, .el-date-editor .el-range-separator {\n  height: initial; }\n\n/* message */\n.el-message-box {\n  word-wrap: break-word; }\n\n/* button */\n.el-button--default.is-plain {\n  color: #416f9e; }\n  .el-button--default.is-plain:hover {\n    color: #416f9e; }\n\n.el-button--default.is-plain.is-disabled {\n  color: #c0c4cc; }\n  .el-button--default.is-plain.is-disabled:hover {\n    color: #c0c4cc; }\n\n/* switch */\n.el-switch__core:after {\n  content: \"\";\n  position: absolute;\n  top: 1px;\n  left: 1px;\n  border-radius: 100%;\n  transition: all .3s;\n  width: 16px;\n  height: 16px;\n  background-color: #fff; }\n\n.el-switch.is-checked .el-switch__core:after {\n  left: 100%;\n  margin-left: -17px; }\n\n.el-form-item__content .el-switch {\n  padding-top: 0; }\n\n/* badge */\n.el-badge__content--warning {\n  background-color: #e6a23c; }\n\n/* menu */\n.el-menu--popup {\n  z-index: 100;\n  min-width: 110px;\n  border: none;\n  border-radius: 2px;\n  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1); }\n\n.el-menu--popup-bottom-start {\n  margin-top: 5px; }\n", ""]);

// exports


/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".alarm-center[data-v-0e0a7d00]{margin:10px 20px}", ""]);

// exports


/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".devicon-java-plain[data-v-0e99d042]:before{content:\"\\F144\"}", ""]);

// exports


/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".header{width:100%;display:table}.header .header-title{display:table-cell;background-color:#14212e;color:#98a5b4;height:50px;line-height:50px;font-weight:700;width:150px;text-align:center;padding-left:20px}.header .header-title a .el-button{height:50px}.header .header-title a .el-button .header-tip{color:#98a5b4;font-weight:700;font-size:medium}.header .header-content{display:table-cell;vertical-align:middle}.headerbase-search{display:inline-block;position:relative;padding-top:10px}.header-autocomplete{width:300px!important}.header-autocomplete .el-autocomplete-suggestion__wrap{margin-top:0;background:#14212e;box-shadow:none;border:none}.header-autocomplete .el-autocomplete-suggestion__wrap li{color:#c2d0d7}.header-autocomplete .el-autocomplete-suggestion__wrap li:hover{background:#253343}.header-autocomplete .el-autocomplete-suggestion__wrap li.highlighted{background-color:#253343}.header-autocomplete.el-popper .popper__arrow,.header-autocomplete.el-popper .popper__arrow:after{border-bottom-color:#14212e}", ""]);

// exports


/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".card-panel[data-v-22163640]{margin-bottom:20px;background-color:#fff;border:1px solid transparent;border-radius:4px;-webkit-box-shadow:0 1px 1px rgba(0,0,0,.05);box-shadow:0 1px 1px rgba(0,0,0,.05)}.card-panel-primary[data-v-22163640]{border-color:#409eff}.card-panel-primary>.card-panel-heading[data-v-22163640]{color:#fff;background-color:#409eff;border-color:#409eff}.card-panel-green[data-v-22163640]{border-color:#67c23a}.card-panel-green>.card-panel-heading[data-v-22163640]{background-color:#67c23a;border-color:#67c23a;color:#fff}.card-panel-yellow[data-v-22163640]{border-color:#f80}.card-panel-yellow>.card-panel-heading[data-v-22163640]{background-color:#f80;border-color:#f80;color:#fff}.card-panel-heading[data-v-22163640]{padding:10px 15px;border-bottom:1px solid transparent;border-top-left-radius:3px;border-top-right-radius:3px}.card-panel-footer[data-v-22163640]{height:20px;padding:10px 15px;background-color:#f5f5f5;border-top:1px solid #ddd;border-bottom-right-radius:3px;border-bottom-left-radius:3px}.fa-5x[data-v-22163640]{font-size:5em}.huge[data-v-22163640]{font-size:40px;line-height:normal}.title-size[data-v-22163640]{font-size:18px}", ""]);

// exports


/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".login-box{margin:15% auto;width:400px;border:1px solid #487bb0;border-radius:6px}.login-box .login-header{color:#487bb0;padding:10px;border-bottom:1px solid #487bb0}.login-box .login-body{padding:20px 40px}.login-box .login-body .el-row{margin-bottom:20px}.login-box .login-body .el-row:last-child{margin-bottom:0}.login-box .login-body .msg-error{position:relative;background:#ffebeb;color:#e4393c;border:1px solid #faccc6;line-height:15px;font-size:13px;padding:3px 10px;margin-bottom:10px}.login-box .login-body .msg-error i{margin-right:5px}", ""]);

// exports


/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".allocation-popper{max-width:300px}", ""]);

// exports


/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".tm-body{background:#373a3c none repeat scroll 0 0;border-radius:4px;margin-left:5px;margin-right:5px}.tm-body:after{bottom:0;content:\"\";display:block;height:65%;left:146px;position:absolute;width:3px;z-index:0}.tm-items{list-style:outside none none;margin:0;padding:0;position:relative;font-size:14px}.tm-items:before{background-color:#eee;bottom:0;content:\" \";left:127px;position:absolute;top:0;width:3px}.tm-items>li{margin:30px 0;min-height:65px;padding:0 0 0 190px;position:relative;z-index:1}.tm-items>li .tm-icon{background-color:#373a3c;border-color:#08c;border-radius:126px;color:#ccc;font-size:22px;height:25px;left:66px;line-height:25px;margin-left:50px;margin-top:-17px;padding-top:5px;position:absolute;text-align:center;top:50%;width:25px;z-index:2}.tm-items>li .tm-datetime{left:0;margin-left:3px;text-align:right}.tm-items>li .tm-datetime,.tm-items>li .tm-item{height:48px;margin-top:-17px;padding-top:5px;position:absolute;top:50%;width:100px;z-index:3}.tm-items>li .tm-item{color:#ccc;font-weight:700;left:150px;text-align:left}.tm-items>li .tm-timeline-box{left:140px;line-height:29px;margin-left:-30px;margin-top:-20px;position:absolute;text-align:center;top:50%;width:120px;z-index:2}.tm-items>li .tm-timeline-box .tm-timeline{background-color:#428bca;padding-left:2px;text-align:left}.tm-items>li .tm-ratio{line-height:29px;text-align:left}.tm-items>li .tm-box{background:#222 none repeat scroll 0 0;border:1px solid #222;border-radius:6px;margin-left:80px;margin-right:5px;min-height:65px;padding:10px 20px;position:relative}.tm-items>li .tm-box:after{border:none;border-color:transparent #222 transparent transparent;border-image:none;border-style:solid;border-width:8px;content:\" \";height:0;margin-top:-8px;pointer-events:none;position:absolute;right:100%;top:50%;width:0;z-index:2}.tm-items>li .tm-box .tm-meta{margin:20px 0 0}", ""]);

// exports


/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".param-table{margin:0 10px}.param-table .el-table th>.cell{line-height:15px}.param-table .el-table tr:hover{background-color:initial}.param-add-button{margin:5px 0}", ""]);

// exports


/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".sharding-tag[data-v-30aeaf64]{margin-right:3px}", ""]);

// exports


/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".input-tags[data-v-3f2190e2]{padding:10px;border:1px solid #b7c0c9;width:auto;min-height:100px;height:100px;overflow-y:auto}.el-tag[data-v-3f2190e2]{margin-right:5px;margin-bottom:5px}.button-new-tag[data-v-3f2190e2]{height:24px;line-height:24px;padding-top:0;padding-bottom:0}.input-new-tag[data-v-3f2190e2]{width:90px;margin-left:10px;vertical-align:bottom}", ""]);

// exports


/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".panel[data-v-412ba810]{background-color:#fff;border:1px solid transparent;border-radius:4px;-webkit-box-shadow:0 1px 1px rgba(0,0,0,.05);box-shadow:0 1px 1px rgba(0,0,0,.05)}.panel-default-info[data-v-412ba810]{background-color:#3d3d3d;padding-top:10px;padding-bottom:5px;border:1px solid #262626;opacity:.8}.panel-danger-info[data-v-412ba810]{background-color:#c00;padding-top:10px;padding-bottom:5px;text-decoration:none;opacity:.8}.panel-danger-info[data-v-412ba810]:hover{background-color:red}.panel-warning-info[data-v-412ba810]{background-color:#f80;padding-top:10px;padding-bottom:5px;text-decoration:none;opacity:.8}.panel-success-info[data-v-412ba810]{background-color:#67c23a;padding-top:10px;padding-bottom:5px;text-decoration:none;opacity:.8}.panel-content-title[data-v-412ba810]{text-align:center;color:#fff;font-size:15px}.panel-content-body[data-v-412ba810]{text-align:center;color:#fff;font-size:22px;padding-top:5px}", ""]);

// exports


/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".refresh-text[data-v-4f32c904]{font-weight:700;font-size:13px}", ""]);

// exports


/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".top-bar{padding:0 30px;height:40px;background:#38465a;font-size:15px;line-height:40px;color:#97a8be}.top-bar .top-bar-left{float:left}.top-bar .top-bar-left>span{margin-right:15px}.top-bar .top-bar-left>span a{color:#c2d0d7}.top-bar .top-bar-left>span a:hover{color:#fff}.top-bar .top-bar-right{float:right}.top-bar .top-bar-right .el-button--text .fa{font-size:16px;color:#c2d0d7}.top-bar-search{margin-right:5px}.top-bar-search .el-input__inner{border:none;background-color:#2b3846;color:#c2d0d7}.top-bar-search .el-input__prefix{color:#606f7e}.top-bar-search input::-webkit-input-placeholder{color:#606f7e}", ""]);

// exports


/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".fav-container{display:inline-block;margin:0 10px;height:40px;line-height:40px}.fav-table{max-height:350px;overflow:auto}.my-fav.el-popover{padding:8px}.my-fav .el-popover__title{margin-bottom:5px;padding:5px 0;font-weight:800;font-size:15px}.my-fav .el-table td,.my-fav .el-table th{height:30px}.my-fav .el-table__column-filter-trigger i{color:#00f;font-size:14px;font-weight:bolder}", ""]);

// exports


/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".arrange-layout-content .el-dialog__body{padding:15px}", ""]);

// exports


/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".my-sider .el-aside{overflow:visible}.page-sidebar-container .page-sidebar{width:190px;background-color:#283340}.page-sidebar-container .page-sidebar .el-menu{border-radius:0;border-bottom:none;border-right:none;padding:0;background-color:#283340}.page-sidebar-container .page-sidebar .el-menu .fa{width:20px}.page-sidebar-container .page-sidebar .el-menu .el-menu-item{border:1px solid #14212e;border-bottom:none;height:50px;line-height:50px;color:#bac4cd;text-align:left;padding-left:30px}.page-sidebar-container .page-sidebar .el-menu .el-menu-item i.fa{color:#617991;margin-right:0}.page-sidebar-container .page-sidebar .el-menu .el-menu-item:last-child{border-bottom:1px solid #14212e}.page-sidebar-container .page-sidebar .el-menu .el-menu-item.page-sidebar-toggle-btn{text-align:center}.page-sidebar-container .page-sidebar .el-menu .el-menu-item.page-sidebar-toggle-btn i.fa{font-size:30px}.page-sidebar-container .page-sidebar .el-menu .el-menu-item:hover{background-color:#334656;border-color:#14212e}.page-sidebar-container .page-sidebar .el-menu .el-menu-item:focus{background-color:#3e596c;color:#fff;border-left:2px solid #70d7b9}.page-sidebar-container .page-sidebar .el-menu .el-menu-item:focus i.fa{color:#9db9d2}.page-sidebar-container .page-sidebar .el-menu .el-menu-item.active{background-color:#3e596c;color:#fff;border-left:2px solid #70d7b9}.page-sidebar-container .page-sidebar .el-menu .el-menu-item.active i.fa{color:#9db9d2}.page-sidebar-container .page-sidebar.collapse{width:50px;z-index:2;position:relative}.page-sidebar-container .page-sidebar.collapse .el-menu-item.page-menu-item .page-menu-item-title{display:none}.page-sidebar-container .page-sidebar.collapse .el-menu-item.page-menu-item:hover{width:170px!important;padding-left:30px!important}.page-sidebar-container .page-sidebar.collapse .el-menu-item.page-menu-item:hover .page-menu-item-title{display:inline}", ""]);

// exports


/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".my-container[data-v-63998a0d]{height:100%}", ""]);

// exports


/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".view-content .el-dialog__body{padding:0}.view-content .view-content-body{height:350px;overflow-y:auto}", ""]);

// exports


/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".job-alarm-panel[data-v-7ad84592]{height:140px;animation:alarmBkg 2s infinite;-webkit-animation:alarmBkg 2s infinite;animation-timing-function:linear;-webkit-animation-timing-function:linear}@keyframes alarmBkg{0%{box-shadow:0 0 20px red}50%{box-shadow:0 0 20px #f80}to{box-shadow:0 0 20px red}}@-webkit-keyframes alarmBkg{0%{background:0 0 20px red}50%{box-shadow:0 0 20px #f80}to{box-shadow:0 0 20px red}}.job-alarm-title[data-v-7ad84592]{font-size:20px}.job-alarm-content[data-v-7ad84592]{font-size:16px;margin:10px 0}.job-alarm-content .panel-row[data-v-7ad84592]{margin:5px}.job-alarm-content .panel-btn[data-v-7ad84592]{margin:15px 10px 0}.job-alarm-empty[data-v-7ad84592]{text-align:center}.job-alarm-empty span[data-v-7ad84592]{font-size:18px}", ""]);

// exports


/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".devicon-java-plain[data-v-862f1b0c]:before{content:\"\\F144\"}", ""]);

// exports


/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".dashboard-content[data-v-a3f4240a]{margin:20px}", ""]);

// exports


/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".job-setting-content{padding:10px 15% 0}", ""]);

// exports


/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".page-home{margin:0 auto;max-width:1200px;height:92%}.page-home .page-home-container{position:relative;width:600px;margin:0 auto}.page-home .page-home-container .page-title{font-size:19px;font-weight:400;margin:0;text-align:center;color:#159e74}@media screen and (min-width:768px){.page-home .page-home-container,.page-home .recent-visit-form{top:12%}}@media screen and (min-width:992px){.page-home .page-home-container,.page-home .recent-visit-form{top:12%}}@media screen and (min-width:1200px){.page-home .page-home-container,.page-home .recent-visit-form{top:12%}}@media screen and (min-width:1920px){.page-home .page-home-container,.page-home .recent-visit-form{top:25%}}.recent-visit-form{position:relative;width:900px;margin:0 auto}.quick-access{border:none;padding:0;margin:15px 0}.quick-access .quick-access-title{font-size:18px;color:#686868;width:100%;text-align:center}.quick-access .tag-content{margin:10px 0;text-align:center}.quick-access .tag-content .status-tag{background:#e0e0e0;color:#686868;border:1px solid #b0b0b0;margin:5px 10px;font-size:13px;padding:5px 10px;height:18px;line-height:18px;border-radius:4px;cursor:pointer;display:inline-block}.quick-access .tag-content .status-tag:hover{background:#f4f7f7}", ""]);

// exports


/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".panel-container[data-v-dc2e1f6c]{border:1px solid #e5e5e5;margin-bottom:20px}.panel-container>.panel-header[data-v-dc2e1f6c]{color:#333;background-color:#e9edf1;border:1px solid #e5e5e5;height:35px;line-height:35px;padding:0 10px}.panel-container>.panel-header i[data-v-dc2e1f6c]{height:35px;line-height:35px}.panel-container>.panel-body[data-v-dc2e1f6c]{padding:15px;background-color:#fff}", ""]);

// exports


/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".job-detail-header[data-v-e471d94a]{padding:10px;border-bottom:1px solid #d0d0d0;height:30px}.job-detail-header .job-detail-title[data-v-e471d94a]{height:30px;line-height:30px}.job-detail-header .job-detail-title .status-tag[data-v-e471d94a]{font-size:12px;margin-left:5px}.job-detail-header .job-detail-title .job-span[data-v-e471d94a]{font-weight:700;font-size:16px;color:#777}.job-detail-header>[data-v-e471d94a]{display:inline-block}", ""]);

// exports


/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".devicon-java-plain[data-v-fd28a054]:before{content:\"\\F144\"}", ""]);

// exports


/***/ }),
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */,
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */,
/* 1211 */,
/* 1212 */,
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */,
/* 1226 */,
/* 1227 */,
/* 1228 */,
/* 1229 */,
/* 1230 */,
/* 1231 */,
/* 1232 */,
/* 1233 */,
/* 1234 */,
/* 1235 */,
/* 1236 */,
/* 1237 */,
/* 1238 */,
/* 1239 */,
/* 1240 */,
/* 1241 */,
/* 1242 */,
/* 1243 */,
/* 1244 */,
/* 1245 */,
/* 1246 */,
/* 1247 */,
/* 1248 */,
/* 1249 */,
/* 1250 */,
/* 1251 */,
/* 1252 */,
/* 1253 */,
/* 1254 */,
/* 1255 */,
/* 1256 */,
/* 1257 */,
/* 1258 */,
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */,
/* 1268 */,
/* 1269 */,
/* 1270 */,
/* 1271 */,
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */,
/* 1277 */,
/* 1278 */,
/* 1279 */,
/* 1280 */,
/* 1281 */,
/* 1282 */,
/* 1283 */,
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 415,
	"./af.js": 415,
	"./ar": 422,
	"./ar-dz": 416,
	"./ar-dz.js": 416,
	"./ar-kw": 417,
	"./ar-kw.js": 417,
	"./ar-ly": 418,
	"./ar-ly.js": 418,
	"./ar-ma": 419,
	"./ar-ma.js": 419,
	"./ar-sa": 420,
	"./ar-sa.js": 420,
	"./ar-tn": 421,
	"./ar-tn.js": 421,
	"./ar.js": 422,
	"./az": 423,
	"./az.js": 423,
	"./be": 424,
	"./be.js": 424,
	"./bg": 425,
	"./bg.js": 425,
	"./bm": 426,
	"./bm.js": 426,
	"./bn": 427,
	"./bn.js": 427,
	"./bo": 428,
	"./bo.js": 428,
	"./br": 429,
	"./br.js": 429,
	"./bs": 430,
	"./bs.js": 430,
	"./ca": 431,
	"./ca.js": 431,
	"./cs": 432,
	"./cs.js": 432,
	"./cv": 433,
	"./cv.js": 433,
	"./cy": 434,
	"./cy.js": 434,
	"./da": 435,
	"./da.js": 435,
	"./de": 438,
	"./de-at": 436,
	"./de-at.js": 436,
	"./de-ch": 437,
	"./de-ch.js": 437,
	"./de.js": 438,
	"./dv": 439,
	"./dv.js": 439,
	"./el": 440,
	"./el.js": 440,
	"./en-au": 441,
	"./en-au.js": 441,
	"./en-ca": 442,
	"./en-ca.js": 442,
	"./en-gb": 443,
	"./en-gb.js": 443,
	"./en-ie": 444,
	"./en-ie.js": 444,
	"./en-nz": 445,
	"./en-nz.js": 445,
	"./eo": 446,
	"./eo.js": 446,
	"./es": 449,
	"./es-do": 447,
	"./es-do.js": 447,
	"./es-us": 448,
	"./es-us.js": 448,
	"./es.js": 449,
	"./et": 450,
	"./et.js": 450,
	"./eu": 451,
	"./eu.js": 451,
	"./fa": 452,
	"./fa.js": 452,
	"./fi": 453,
	"./fi.js": 453,
	"./fo": 454,
	"./fo.js": 454,
	"./fr": 457,
	"./fr-ca": 455,
	"./fr-ca.js": 455,
	"./fr-ch": 456,
	"./fr-ch.js": 456,
	"./fr.js": 457,
	"./fy": 458,
	"./fy.js": 458,
	"./gd": 459,
	"./gd.js": 459,
	"./gl": 460,
	"./gl.js": 460,
	"./gom-latn": 461,
	"./gom-latn.js": 461,
	"./gu": 462,
	"./gu.js": 462,
	"./he": 463,
	"./he.js": 463,
	"./hi": 464,
	"./hi.js": 464,
	"./hr": 465,
	"./hr.js": 465,
	"./hu": 466,
	"./hu.js": 466,
	"./hy-am": 467,
	"./hy-am.js": 467,
	"./id": 468,
	"./id.js": 468,
	"./is": 469,
	"./is.js": 469,
	"./it": 470,
	"./it.js": 470,
	"./ja": 471,
	"./ja.js": 471,
	"./jv": 472,
	"./jv.js": 472,
	"./ka": 473,
	"./ka.js": 473,
	"./kk": 474,
	"./kk.js": 474,
	"./km": 475,
	"./km.js": 475,
	"./kn": 476,
	"./kn.js": 476,
	"./ko": 477,
	"./ko.js": 477,
	"./ky": 478,
	"./ky.js": 478,
	"./lb": 479,
	"./lb.js": 479,
	"./lo": 480,
	"./lo.js": 480,
	"./lt": 481,
	"./lt.js": 481,
	"./lv": 482,
	"./lv.js": 482,
	"./me": 483,
	"./me.js": 483,
	"./mi": 484,
	"./mi.js": 484,
	"./mk": 485,
	"./mk.js": 485,
	"./ml": 486,
	"./ml.js": 486,
	"./mr": 487,
	"./mr.js": 487,
	"./ms": 489,
	"./ms-my": 488,
	"./ms-my.js": 488,
	"./ms.js": 489,
	"./my": 490,
	"./my.js": 490,
	"./nb": 491,
	"./nb.js": 491,
	"./ne": 492,
	"./ne.js": 492,
	"./nl": 494,
	"./nl-be": 493,
	"./nl-be.js": 493,
	"./nl.js": 494,
	"./nn": 495,
	"./nn.js": 495,
	"./pa-in": 496,
	"./pa-in.js": 496,
	"./pl": 497,
	"./pl.js": 497,
	"./pt": 499,
	"./pt-br": 498,
	"./pt-br.js": 498,
	"./pt.js": 499,
	"./ro": 500,
	"./ro.js": 500,
	"./ru": 501,
	"./ru.js": 501,
	"./sd": 502,
	"./sd.js": 502,
	"./se": 503,
	"./se.js": 503,
	"./si": 504,
	"./si.js": 504,
	"./sk": 505,
	"./sk.js": 505,
	"./sl": 506,
	"./sl.js": 506,
	"./sq": 507,
	"./sq.js": 507,
	"./sr": 509,
	"./sr-cyrl": 508,
	"./sr-cyrl.js": 508,
	"./sr.js": 509,
	"./ss": 510,
	"./ss.js": 510,
	"./sv": 511,
	"./sv.js": 511,
	"./sw": 512,
	"./sw.js": 512,
	"./ta": 513,
	"./ta.js": 513,
	"./te": 514,
	"./te.js": 514,
	"./tet": 515,
	"./tet.js": 515,
	"./th": 516,
	"./th.js": 516,
	"./tl-ph": 517,
	"./tl-ph.js": 517,
	"./tlh": 518,
	"./tlh.js": 518,
	"./tr": 519,
	"./tr.js": 519,
	"./tzl": 520,
	"./tzl.js": 520,
	"./tzm": 522,
	"./tzm-latn": 521,
	"./tzm-latn.js": 521,
	"./tzm.js": 522,
	"./uk": 523,
	"./uk.js": 523,
	"./ur": 524,
	"./ur.js": 524,
	"./uz": 526,
	"./uz-latn": 525,
	"./uz-latn.js": 525,
	"./uz.js": 526,
	"./vi": 527,
	"./vi.js": 527,
	"./x-pseudo": 528,
	"./x-pseudo.js": 528,
	"./yo": 529,
	"./yo.js": 529,
	"./zh-cn": 530,
	"./zh-cn.js": 530,
	"./zh-hk": 531,
	"./zh-hk.js": 531,
	"./zh-tw": 532,
	"./zh-tw.js": 532
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1287;


/***/ }),
/* 1288 */,
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */,
/* 1295 */,
/* 1296 */,
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/saturn.fe28b39.png";

/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(621),
  /* template */
  __webpack_require__(1428),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(622),
  /* template */
  __webpack_require__(1379),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1473)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(623),
  /* template */
  __webpack_require__(1412),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1453)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(624),
  /* template */
  __webpack_require__(1380),
  /* scopeId */
  "data-v-1b2e37b2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1455)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(625),
  /* template */
  __webpack_require__(1384),
  /* scopeId */
  "data-v-22163640",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1486)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(626),
  /* template */
  __webpack_require__(1442),
  /* scopeId */
  "data-v-dc2e1f6c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1481)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(627),
  /* template */
  __webpack_require__(1436),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1448)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(628),
  /* template */
  __webpack_require__(1374),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1487)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(629),
  /* template */
  __webpack_require__(1443),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1452)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(630),
  /* template */
  __webpack_require__(1378),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1475)

var Component = __webpack_require__(4)(
  /* script */
  null,
  /* template */
  __webpack_require__(1419),
  /* scopeId */
  "data-v-63998a0d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1482)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(631),
  /* template */
  __webpack_require__(1437),
  /* scopeId */
  "data-v-bb51d7c2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(632),
  /* template */
  __webpack_require__(1404),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1472)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(633),
  /* template */
  __webpack_require__(1411),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(634),
  /* template */
  __webpack_require__(1381),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(635),
  /* template */
  __webpack_require__(1429),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(636),
  /* template */
  __webpack_require__(1373),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(637),
  /* template */
  __webpack_require__(1388),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(638),
  /* template */
  __webpack_require__(1421),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(639),
  /* template */
  __webpack_require__(1416),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1471)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(640),
  /* template */
  __webpack_require__(1410),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(641),
  /* template */
  __webpack_require__(1414),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1451)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(642),
  /* template */
  __webpack_require__(1377),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(643),
  /* template */
  __webpack_require__(1417),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1464)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(644),
  /* template */
  __webpack_require__(1400),
  /* scopeId */
  "data-v-3f2190e2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1465)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(645),
  /* template */
  __webpack_require__(1401),
  /* scopeId */
  "data-v-412ba810",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1459)

var Component = __webpack_require__(4)(
  /* script */
  null,
  /* template */
  __webpack_require__(1391),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  null,
  /* template */
  __webpack_require__(1434),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(646),
  /* template */
  __webpack_require__(1371),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1470)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(647),
  /* template */
  __webpack_require__(1408),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(648),
  /* template */
  __webpack_require__(1394),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1329 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1476)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(649),
  /* template */
  __webpack_require__(1420),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(650),
  /* template */
  __webpack_require__(1389),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(651),
  /* template */
  __webpack_require__(1425),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1477)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(652),
  /* template */
  __webpack_require__(1424),
  /* scopeId */
  "data-v-74a62b4a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(653),
  /* template */
  __webpack_require__(1397),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(654),
  /* template */
  __webpack_require__(1426),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1457)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(655),
  /* template */
  __webpack_require__(1387),
  /* scopeId */
  "data-v-2607ae1b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(656),
  /* template */
  __webpack_require__(1395),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1466)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(657),
  /* template */
  __webpack_require__(1403),
  /* scopeId */
  "data-v-48d3da32",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1480)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(658),
  /* template */
  __webpack_require__(1435),
  /* scopeId */
  "data-v-a3f4240a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1447)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(659),
  /* template */
  __webpack_require__(1372),
  /* scopeId */
  "data-v-060315a0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1463)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(660),
  /* template */
  __webpack_require__(1398),
  /* scopeId */
  "data-v-38b67aa2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1469)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(661),
  /* template */
  __webpack_require__(1407),
  /* scopeId */
  "data-v-508e0dd3",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1478)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(662),
  /* template */
  __webpack_require__(1427),
  /* scopeId */
  "data-v-7ad84592",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1488)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(663),
  /* template */
  __webpack_require__(1444),
  /* scopeId */
  "data-v-e471d94a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1468)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(664),
  /* template */
  __webpack_require__(1406),
  /* scopeId */
  "data-v-4f32c904",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1479)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(665),
  /* template */
  __webpack_require__(1431),
  /* scopeId */
  "data-v-862f1b0c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1346 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1450)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(666),
  /* template */
  __webpack_require__(1376),
  /* scopeId */
  "data-v-0e99d042",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1483)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(667),
  /* template */
  __webpack_require__(1439),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1462)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(668),
  /* template */
  __webpack_require__(1396),
  /* scopeId */
  "data-v-30aeaf64",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1349 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(669),
  /* template */
  __webpack_require__(1409),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1350 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(670),
  /* template */
  __webpack_require__(1438),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1351 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1449)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(671),
  /* template */
  __webpack_require__(1375),
  /* scopeId */
  "data-v-0e0a7d00",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1352 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(672),
  /* template */
  __webpack_require__(1423),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1353 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(673),
  /* template */
  __webpack_require__(1386),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1354 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1458)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(674),
  /* template */
  __webpack_require__(1390),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1355 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1454)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(675),
  /* template */
  __webpack_require__(1383),
  /* scopeId */
  "data-v-1f8b5a5a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1356 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1484)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(676),
  /* template */
  __webpack_require__(1440),
  /* scopeId */
  "data-v-c0077a0a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1357 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1489)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(677),
  /* template */
  __webpack_require__(1445),
  /* scopeId */
  "data-v-fd28a054",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1358 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(678),
  /* template */
  __webpack_require__(1413),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1359 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1485)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(679),
  /* template */
  __webpack_require__(1441),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1360 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(680),
  /* template */
  __webpack_require__(1402),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1361 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(681),
  /* template */
  __webpack_require__(1433),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1362 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(682),
  /* template */
  __webpack_require__(1432),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1363 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(683),
  /* template */
  __webpack_require__(1430),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1364 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(684),
  /* template */
  __webpack_require__(1399),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1365 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1461)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(685),
  /* template */
  __webpack_require__(1393),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1366 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1467)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(686),
  /* template */
  __webpack_require__(1405),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1367 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1460)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(687),
  /* template */
  __webpack_require__(1392),
  /* scopeId */
  "data-v-2a775e56",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1368 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(688),
  /* template */
  __webpack_require__(1415),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1369 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(689),
  /* template */
  __webpack_require__(1382),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1370 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1474)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(690),
  /* template */
  __webpack_require__(1418),
  /* scopeId */
  "data-v-62fcbc6f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1371 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('FilterPageList', {
    attrs: {
      "data": _vm.timeoutJobsList,
      "total": _vm.total,
      "order-by": _vm.orderBy,
      "filters": _vm.filters
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-form', {
          staticClass: "table-filter",
          attrs: {
            "inline": true
          }
        }, [_c('input', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (false),
            expression: "false"
          }],
          attrs: {
            "type": "text"
          }
        }), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": ""
          }
        }, [_c('el-input', {
          attrs: {
            "placeholder": "请输入作业名"
          },
          nativeOn: {
            "keyup": function($event) {
              if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
              scope.search($event)
            }
          },
          model: {
            value: (_vm.filters.jobName.value),
            callback: function($$v) {
              _vm.$set(_vm.filters.jobName, "value", $$v)
            },
            expression: "filters.jobName.value"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "icon": "el-icon-search"
          },
          on: {
            "click": scope.search
          }
        }, [_vm._v("查询")])], 1)], 1), _vm._v(" "), _c('div', {
          staticClass: "page-table"
        }, [_c('div', {
          staticClass: "page-table-header"
        }, [_c('div', {
          staticClass: "page-table-header-title"
        }, [_c('i', {
          staticClass: "fa fa-list"
        }), _vm._v("运行超时（告警）的作业分片\n                    "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": _vm.refreshList
          }
        }, [_c('i', {
          staticClass: "fa fa-refresh"
        })])], 1)]), _vm._v(" "), _c('el-table', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "stripe": "",
            "border": "",
            "data": scope.pageData
          },
          on: {
            "sort-change": scope.onSortChange
          }
        }, [_c('el-table-column', {
          attrs: {
            "prop": "jobName",
            "label": "作业名",
            "sortable": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('router-link', {
                attrs: {
                  "tag": "a",
                  "to": {
                    name: 'job_setting',
                    params: {
                      domain: scope.row.domainName,
                      jobName: scope.row.jobName
                    }
                  }
                }
              }, [_c('el-button', {
                attrs: {
                  "type": "text"
                }
              }, [_vm._v("\n                                " + _vm._s(scope.row.jobName) + "\n                            ")])], 1)]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "domainName",
            "label": "所属域",
            "sortable": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('router-link', {
                attrs: {
                  "tag": "a",
                  "to": {
                    name: 'job_overview',
                    params: {
                      domain: scope.row.domainName
                    }
                  }
                }
              }, [_c('el-button', {
                attrs: {
                  "type": "text"
                }
              }, [_vm._v("\n                                " + _vm._s(scope.row.domainName) + "\n                            ")])], 1)]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "degree",
            "label": "域等级",
            "width": "110px",
            "sortable": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n                        " + _vm._s(_vm.$map.degreeMap[scope.row.degree]) + "\n                    ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "jobDegree",
            "label": "作业等级",
            "width": "110px",
            "sortable": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n                        " + _vm._s(_vm.$map.degreeMap[scope.row.jobDegree]) + "\n                    ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "timeout4AlarmSeconds",
            "label": "超时秒数",
            "width": "110px"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "timeoutItems",
            "label": "超时分片"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "操作",
            "width": "100px",
            "align": "center"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(_vm.$common.hasPerm('alarmCenter:setTimeout4AlarmJobRead', scope.row.domainName)) ? _c('el-button', {
                attrs: {
                  "size": "small",
                  "type": "primary",
                  "disabled": scope.row.read
                },
                on: {
                  "click": function($event) {
                    _vm.handleRead(scope.row)
                  }
                }
              }, [_vm._v("不再告警")]) : _vm._e()]
            }
          }])
        })], 1)], 1)]
      }
    }])
  })
},staticRenderFns: []}

/***/ }),
/* 1372 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "page-detail-header"
  }, [_c('div', {
    staticClass: "pull-left page-detail-title"
  }, [_c('span', {
    staticClass: "page-detail-span"
  }, [_c('i', {
    staticClass: "fa fa-sitemap"
  }), _vm._v("\n              当前ZK集群 : " + _vm._s(_vm.zkCluster || '全部ZK集群') + "\n          ")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.init
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "page-content",
    attrs: {
      "element-loading-text": "请稍等···"
    }
  }, [_c('div', [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24,
      "lg": 24,
      "xl": 12
    }
  }, [_c('Chart-container', {
    attrs: {
      "title": "全域当天执行数据",
      "type": "pie"
    }
  }, [_c('div', {
    attrs: {
      "slot": "chart"
    },
    slot: "chart"
  }, [_c('Pie', {
    attrs: {
      "id": "domainProcessCount",
      "option-info": _vm.domainProcessCountOptionInfo
    }
  })], 1)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24,
      "lg": 24,
      "xl": 12
    }
  }, [_c('Chart-container', {
    attrs: {
      "title": "全域历史执行数据",
      "type": "line"
    }
  }, [_c('div', {
    attrs: {
      "slot": "chart"
    },
    slot: "chart"
  }, [_c('MyLine', {
    attrs: {
      "id": "domainProcessHistory",
      "option-info": _vm.allDomainHistoryOptionInfo
    }
  })], 1)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24,
      "lg": 24,
      "xl": 12
    }
  }, [_c('Chart-container', {
    attrs: {
      "title": "失败率最高的Top10域",
      "type": "bar"
    }
  }, [_c('div', {
    attrs: {
      "slot": "chart"
    },
    slot: "chart"
  }, [_c('Column', {
    attrs: {
      "id": "top10FailDomain",
      "option-info": _vm.top10FailDomainOptionInfo
    }
  })], 1)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24,
      "lg": 24,
      "xl": 12
    }
  }, [_c('Chart-container', {
    attrs: {
      "title": "稳定性最差的的Top10域",
      "type": "bar"
    }
  }, [_c('div', {
    attrs: {
      "slot": "chart"
    },
    slot: "chart"
  }, [_c('Column', {
    attrs: {
      "id": "top10UnstableDomain",
      "option-info": _vm.top10UnstableDomainOptionInfo
    }
  })], 1)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24,
      "lg": 24,
      "xl": 12
    }
  }, [_c('Chart-container', {
    attrs: {
      "title": "域版本分布",
      "type": "pie"
    }
  }, [_c('div', {
    attrs: {
      "slot": "chart"
    },
    slot: "chart"
  }, [_c('Pie', {
    attrs: {
      "id": "domainExecutorVersion",
      "option-info": _vm.domainExecutorVersionOptionInfo
    }
  })], 1)])], 1)], 1)], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1373 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "导入作业结果",
      "width": "45%",
      "visible": _vm.isVisible,
      "before-close": _vm.closeDialog,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.isVisible = $event
      }
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "border": "",
      "data": _vm.importResult
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "jobName",
      "label": "作业名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "success",
      "label": "状态",
      "width": "70px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "type": scope.row.success ? 'success' : 'danger'
          }
        }, [_vm._v(_vm._s(_vm.statusMap[scope.row.success]))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "message",
      "label": "失败详情",
      "min-width": "150px"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.closeDialog()
      }
    }
  }, [_vm._v("确认")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1374 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "300px"
    },
    attrs: {
      "id": _vm.id
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 1375 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alarm-center"
  }, [_c('el-tabs', {
    on: {
      "tab-click": _vm.onTabClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "name": "namespace_abnormal_jobs"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-list-alt"
  }), _vm._v("异常作业\n            "), (_vm.countOfAlarmJobs.unnormal_job) ? _c('el-badge', {
    attrs: {
      "type": "danger",
      "value": _vm.countOfAlarmJobs.unnormal_job
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "namespace_timeout_jobs"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v("超时作业\n            "), (_vm.countOfAlarmJobs.timeout_4_alarm_job) ? _c('el-badge', {
    attrs: {
      "type": "danger",
      "value": _vm.countOfAlarmJobs.timeout_4_alarm_job
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "namespace_failover_jobs"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v("无法高可用作业\n            "), (_vm.countOfAlarmJobs.unable_failover_job) ? _c('el-badge', {
    attrs: {
      "type": "warning",
      "value": _vm.countOfAlarmJobs.timeout_4_alarm_job
    }
  }) : _vm._e()], 1)])], 1), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 1376 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "margin-20"
  }, [_c('div', {
    staticClass: "page-container"
  }, [_c('FilterPageList', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.tableLoading),
      expression: "tableLoading"
    }],
    ref: "pageListRef",
    attrs: {
      "get-data": _vm.getJobMessageHistory,
      "total": _vm.total,
      "order-by": _vm.orderBy,
      "filters": _vm.filters,
      "element-loading-text": "请稍等···"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-form', {
          staticClass: "table-filter",
          attrs: {
            "inline": true
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": ""
          }
        }, [_c('el-select', {
          staticStyle: {
            "width": "140px"
          },
          on: {
            "change": scope.search
          },
          model: {
            value: (_vm.filters.messageResult.value),
            callback: function($$v) {
              _vm.$set(_vm.filters.messageResult, "value", $$v)
            },
            expression: "filters.messageResult.value"
          }
        }, [_c('el-option', {
          attrs: {
            "label": "全部状态",
            "value": ""
          }
        }), _vm._v(" "), _vm._l((_vm.messageResults), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        })], 2)], 1), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": ""
          }
        }, [_c('el-input', {
          attrs: {
            "placeholder": _vm.filterColumnPlaceholder
          },
          model: {
            value: (_vm.filters[_vm.selectColumn].value),
            callback: function($$v) {
              _vm.$set(_vm.filters[_vm.selectColumn], "value", (typeof $$v === 'string' ? $$v.trim() : $$v))
            },
            expression: "filters[selectColumn].value"
          }
        }, [_c('el-select', {
          staticStyle: {
            "width": "120px"
          },
          attrs: {
            "slot": "prepend"
          },
          on: {
            "change": _vm.selectColumnChange
          },
          slot: "prepend",
          model: {
            value: (_vm.selectColumn),
            callback: function($$v) {
              _vm.selectColumn = $$v
            },
            expression: "selectColumn"
          }
        }, [_c('el-option', {
          attrs: {
            "label": "AppKey",
            "value": "appKey"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": "站点ID",
            "value": "siteId"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": "主题",
            "value": "topic"
          }
        })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "icon": "el-icon-search"
          },
          on: {
            "click": scope.search
          }
        }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "icon": "fa fa-repeat"
          },
          on: {
            "click": function($event) {
              _vm.resetMessageResult();
              scope.search()
            }
          }
        }, [_vm._v("重置")])], 1)], 1), _vm._v(" "), _c('div', {
          directives: [{
            name: "loading",
            rawName: "v-loading",
            value: (_vm.loading),
            expression: "loading"
          }],
          staticClass: "page-table",
          attrs: {
            "element-loading-text": "请稍等···"
          }
        }, [_c('div', {
          staticClass: "page-table-header"
        }, [_c('div', {
          staticClass: "page-table-header-title"
        }, [_c('i', {
          staticClass: "fa fa-list"
        }), _vm._v("作业消息日志列表\n                            "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": scope.search
          }
        }, [_c('i', {
          staticClass: "fa fa-refresh"
        })])], 1), _vm._v(" "), _c('div', {
          staticClass: "page-table-header-separator"
        }), _vm._v(" "), _c('div', [(_vm.$common.hasPerm('job:batchRemove', _vm.domainName)) ? _c('el-button', {
          on: {
            "click": function($event) {
              _vm.batchDelete()
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash text-danger"
        }), _vm._v("删除")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
          staticClass: "pull-right"
        })]), _vm._v(" "), _c('el-table', {
          ref: "multipleTable",
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "stripe": "",
            "border": "",
            "data": _vm.JobMessageHistoryList
          },
          on: {
            "selection-change": _vm.handleSelectionChange,
            "sort-change": scope.onSortChange
          }
        }, [_c('el-table-column', {
          attrs: {
            "type": "selection",
            "width": "55"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "appKey",
            "label": "AppKey",
            "sortable": "custom",
            "width": "100px"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n                                " + _vm._s(scope.row.appKey) + "\n                            ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "siteId",
            "label": "站点ID",
            "width": "100px"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n                                " + _vm._s(scope.row.siteId) + "\n                            ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "topic",
            "label": "主题",
            "width": "100px"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n                                " + _vm._s(scope.row.topic) + "\n                            ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "userIds",
            "label": "接收用户",
            "width": "120px"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n                                " + _vm._s(scope.row.userIds) + "\n                            ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "userTypes",
            "label": "接收用户类型",
            "width": "120px"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n                                " + _vm._s(scope.row.userTypes) + "\n                            ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "msgBody",
            "show-overflow-tooltip": "",
            "label": "消息内容"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n                                " + _vm._s(scope.row.msgBody) + "\n                            ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "execTime",
            "label": "执行耗时 秒",
            "width": "100px"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n                                " + _vm._s(scope.row.execTime) + "\n                            ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "状态",
            "prop": "messageResult",
            "width": "90px"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('el-tag', {
                attrs: {
                  "type": scope.row.messageResult === true ? 'success' : 'warning',
                  "close-transition": ""
                }
              }, [_vm._v(_vm._s(_vm.translateMessageResult[scope.row.messageResult]))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "消息发送时间",
            "prop": "createTime",
            "width": "160px"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n                                " + _vm._s(_vm._f("formatDate")(scope.row.createTime)) + "\n                            ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "messageResultReason",
            "show-overflow-tooltip": "",
            "label": "失败原因"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v(" \n                                " + _vm._s(scope.row.messageResultReason) + "\n                            ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "操作",
            "width": "120px",
            "align": "center"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('el-tooltip', {
                attrs: {
                  "content": "删除",
                  "placement": "top"
                }
              }, [_c('el-button', {
                attrs: {
                  "type": "text",
                  "icon": "el-icon-delete text-danger"
                },
                on: {
                  "click": function($event) {
                    _vm.handleDelete(scope.row)
                  }
                }
              })], 1)]
            }
          }])
        })], 1)], 1)]
      }
    }])
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1377 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "header-title"
  }, [_c('router-link', {
    attrs: {
      "tag": "a",
      "to": {
        name: 'job_manage'
      }
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    }
  }, [_c('span', {
    staticClass: "header-tip"
  }, [_vm._v("Saturn Console")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "header-content"
  }, [_c('el-menu', {
    staticClass: "el-menu--dark el-menu--has-container",
    attrs: {
      "default-active": _vm.activeIndex,
      "mode": "horizontal",
      "router": true
    }
  }, [_vm._l((_vm.serviceList), function(item) {
    return [(item.isSuper) ? _c('el-menu-item', {
      key: item.index,
      attrs: {
        "index": item.index,
        "route": item
      }
    }, [_c('i', {
      class: item.icon
    }), _vm._v(_vm._s(item.title))]) : _vm._e()]
  }), _vm._v(" "), _c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "display": "inline-flex"
    }
  }, [(_vm.isShowHeaderSearch) ? _c('div', {
    staticClass: "headerbase-search"
  }, [_c('el-autocomplete', {
    attrs: {
      "prefix-icon": "el-icon-search",
      "fetch-suggestions": _vm.querySearchAsync,
      "placeholder": "请输入域名",
      "popper-class": "header-autocomplete"
    },
    on: {
      "select": _vm.handleSelect
    },
    model: {
      value: (_vm.domainName),
      callback: function($$v) {
        _vm.domainName = $$v
      },
      expression: "domainName"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "4",
      "popper-append-to-body": false
    }
  }, [_c('template', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(_vm._s(_vm.userInfo.username || 'null'))]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": ""
    }
  }, [_c('a', {
    staticStyle: {
      "display": "block"
    },
    on: {
      "click": _vm.handleEditPass
    }
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v("修改密码")])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": ""
    }
  }, [_c('a', {
    staticStyle: {
      "display": "block"
    },
    on: {
      "click": _vm.handleLogout
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out"
  }), _vm._v("注销")])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": ""
    }
  }, [_c('a', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "href": "https://vipshop.github.io/Saturn/#/",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle"
  }), _vm._v("帮助")])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": ""
    }
  }, [_c('a', {
    staticStyle: {
      "display": "block"
    },
    on: {
      "click": _vm.handleVersion
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle"
  }), _vm._v("关于")])])], 2)], 1)], 2)], 1), _vm._v(" "), (_vm.isEditUserPassVisible) ? _c('div', [_c('edit-pwd-dialog', {
    attrs: {
      "user-password-info": _vm.userPasswordInfo,
      "user-info-title": _vm.userInfoTitle,
      "user-info-operate": _vm.userInfoOperate
    },
    on: {
      "user-info-success": _vm.editUserPwdSuccess,
      "close-dialog": _vm.closeUserPwdDialog
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1378 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "id": _vm.id
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 1379 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('FilterPageList', {
    attrs: {
      "data": _vm.abnormalJobsList,
      "total": _vm.total,
      "order-by": _vm.orderBy,
      "filters": _vm.filters
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-form', {
          staticClass: "table-filter",
          attrs: {
            "inline": true
          }
        }, [_c('input', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (false),
            expression: "false"
          }],
          attrs: {
            "type": "text"
          }
        }), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": ""
          }
        }, [_c('el-input', {
          attrs: {
            "placeholder": "请输入作业名"
          },
          nativeOn: {
            "keyup": function($event) {
              if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
              scope.search($event)
            }
          },
          model: {
            value: (_vm.filters.jobName.value),
            callback: function($$v) {
              _vm.$set(_vm.filters.jobName, "value", $$v)
            },
            expression: "filters.jobName.value"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "icon": "el-icon-search"
          },
          on: {
            "click": scope.search
          }
        }, [_vm._v("查询")])], 1)], 1), _vm._v(" "), _c('div', {
          staticClass: "page-table"
        }, [_c('div', {
          staticClass: "page-table-header"
        }, [_c('div', {
          staticClass: "page-table-header-title"
        }, [_c('i', {
          staticClass: "fa fa-list"
        }), _vm._v("异常作业(java/shell作业)\n                    "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": _vm.refreshList
          }
        }, [_c('i', {
          staticClass: "fa fa-refresh"
        })])], 1)]), _vm._v(" "), _c('el-table', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "stripe": "",
            "border": "",
            "data": scope.pageData
          },
          on: {
            "sort-change": scope.onSortChange
          }
        }, [_c('el-table-column', {
          attrs: {
            "prop": "jobName",
            "label": "作业名",
            "sortable": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('router-link', {
                attrs: {
                  "tag": "a",
                  "to": {
                    name: 'job_setting',
                    params: {
                      domain: scope.row.domainName,
                      jobName: scope.row.jobName
                    }
                  }
                }
              }, [_c('el-button', {
                attrs: {
                  "type": "text"
                }
              }, [_vm._v("\n                                " + _vm._s(scope.row.jobName) + "\n                            ")])], 1)]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "domainName",
            "label": "所属域",
            "sortable": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('router-link', {
                attrs: {
                  "tag": "a",
                  "to": {
                    name: 'job_overview',
                    params: {
                      domain: scope.row.domainName
                    }
                  }
                }
              }, [_c('el-button', {
                attrs: {
                  "type": "text"
                }
              }, [_vm._v("\n                                " + _vm._s(scope.row.domainName) + "\n                            ")])], 1)]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "degree",
            "label": "域等级",
            "width": "110px",
            "sortable": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n                        " + _vm._s(_vm.$map.degreeMap[scope.row.degree]) + "\n                    ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "jobDegree",
            "label": "作业等级",
            "width": "110px",
            "sortable": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n                        " + _vm._s(_vm.$map.degreeMap[scope.row.jobDegree]) + "\n                    ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "nextFireTimeWithTimeZoneFormat",
            "label": "本该调度时间",
            "width": "160px"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "cause",
            "label": "异常原因",
            "width": "190px"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n                        " + _vm._s(_vm.$map.causeMap[scope.row.cause]) + "\n                    ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "操作",
            "width": "100px",
            "align": "center"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(_vm.$common.hasPerm('alarmCenter:setAbnormalJobRead', scope.row.domainName)) ? _c('el-button', {
                attrs: {
                  "size": "small",
                  "type": "primary",
                  "disabled": scope.row.read
                },
                on: {
                  "click": function($event) {
                    _vm.handleRead(scope.row)
                  }
                }
              }, [_vm._v("不再告警")]) : _vm._e()]
            }
          }])
        })], 1)], 1)]
      }
    }])
  })
},staticRenderFns: []}

/***/ }),
/* 1380 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user_breadcrum"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": "/"
    }
  }, [_vm._l((_vm.items), function(item) {
    return [_c('el-breadcrumb-item', {
      key: item.name,
      attrs: {
        "to": {
          name: item.name
        }
      }
    }, [_vm._v("\n                " + _vm._s(item.title) + "\n            ")])]
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 1381 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "title": "批量域迁移",
      "width": "45%",
      "visible": _vm.isVisible,
      "before-close": _vm.closeDialog,
      "element-loading-text": "请稍等···"
    },
    on: {
      "update:visible": function($event) {
        _vm.isVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "batchMigrateInfo",
    attrs: {
      "model": _vm.batchMigrateInfo,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "域名",
      "prop": "namespacesArray"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 18
    }
  }, _vm._l((_vm.batchMigrateInfo.namespacesArray), function(item) {
    return _c('el-tag', {
      key: item,
      staticClass: "form-tags",
      attrs: {
        "type": "success"
      }
    }, [_vm._v(_vm._s(item))])
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "目标集群",
      "prop": "zkClusterKeyNew"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "size": "small"
    },
    model: {
      value: (_vm.batchMigrateInfo.zkClusterKeyNew),
      callback: function($$v) {
        _vm.$set(_vm.batchMigrateInfo, "zkClusterKeyNew", $$v)
      },
      expression: "batchMigrateInfo.zkClusterKeyNew"
    }
  }, _vm._l((_vm.onLineClusters), function(item) {
    return _c('el-option', {
      key: item.zkClusterKey,
      attrs: {
        "label": item.zkAlias,
        "value": item.zkClusterKey
      }
    })
  }))], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.closeDialog()
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.handleSubmit()
      }
    }
  }, [_vm._v("确定")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1382 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('VAside', {
    attrs: {
      "sidebar-menus": _vm.sidebarMenus,
      "headerHeight": "50"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1383 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "margin-20"
  }, [_c('div', [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Panel', {
    attrs: {
      "type": "success"
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("在线数 / 总数")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v(_vm._s(_vm.onlineNum) + " / " + _vm._s(_vm.totalNum))])])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "page-container"
  }, [_c('FilterPageList', {
    attrs: {
      "data": _vm.executorList,
      "total": _vm.total,
      "order-by": _vm.orderBy,
      "filters": _vm.filters
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-form', {
          staticClass: "table-filter",
          attrs: {
            "inline": true
          }
        }, [_c('input', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (false),
            expression: "false"
          }],
          attrs: {
            "type": "text"
          }
        }), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": ""
          }
        }, [_c('el-input', {
          attrs: {
            "placeholder": "请输入Executor"
          },
          nativeOn: {
            "keyup": function($event) {
              if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
              scope.search($event)
            }
          },
          model: {
            value: (_vm.filters.executorName.value),
            callback: function($$v) {
              _vm.$set(_vm.filters.executorName, "value", $$v)
            },
            expression: "filters.executorName.value"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "icon": "el-icon-search"
          },
          on: {
            "click": scope.search
          }
        }, [_vm._v("查询")]), _vm._v(" "), (_vm.$common.hasPerm('executor:shardAllAtOnce', _vm.domainName)) ? _c('el-button', {
          attrs: {
            "type": "primary"
          },
          on: {
            "click": function($event) {
              _vm.handleReArrange()
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-repeat"
        }), _vm._v("一键重排")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
          directives: [{
            name: "loading",
            rawName: "v-loading",
            value: (_vm.loading),
            expression: "loading"
          }],
          staticClass: "page-table",
          attrs: {
            "element-loading-text": "请稍等···"
          }
        }, [_c('div', {
          staticClass: "page-table-header"
        }, [_c('div', {
          staticClass: "page-table-header-title"
        }, [_c('i', {
          staticClass: "fa fa-list"
        }), _vm._v("Executor列表\n                            "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": _vm.getExecutorList
          }
        }, [_c('i', {
          staticClass: "fa fa-refresh"
        })])], 1), _vm._v(" "), _c('div', {
          staticClass: "page-table-header-separator"
        }), _vm._v(" "), _c('div', [(_vm.$common.hasPerm('executor:batchRemove', _vm.domainName)) ? _c('el-button', {
          on: {
            "click": function($event) {
              _vm.batchDelete()
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash text-danger"
        }), _vm._v("删除")]) : _vm._e()], 1)]), _vm._v(" "), _c('el-table', {
          ref: "multipleTable",
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "stripe": "",
            "border": "",
            "data": scope.pageData
          },
          on: {
            "selection-change": _vm.handleSelectionChange,
            "sort-change": scope.onSortChange
          }
        }, [_c('el-table-column', {
          attrs: {
            "type": "selection",
            "width": "55"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "executorName",
            "label": "Executor",
            "min-width": "160px",
            "show-overflow-tooltip": "",
            "sortable": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.container) ? _c('i', {
                staticClass: "iconfont icon-docker"
              }) : _vm._e(), _vm._v(" "), (!scope.row.container) ? _c('i', {
                staticClass: "iconfont icon-zhuji"
              }) : _vm._e(), _vm._v("\n                                " + _vm._s(scope.row.executorName) + "\n                            ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "status",
            "label": "状态",
            "width": "80px",
            "sortable": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('el-tag', {
                attrs: {
                  "type": scope.row.status === 'ONLINE' ? 'success' : '',
                  "close-transition": ""
                }
              }, [_vm._v(_vm._s(_vm.translateStatus[scope.row.status]))]), _vm._v(" "), (scope.row.restarting) ? _c('el-tag', {
                attrs: {
                  "type": "warning"
                }
              }, [_vm._v("重启中")]) : _vm._e()]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "serverIp",
            "label": "IP",
            "width": "125px"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "groupName",
            "label": "分组",
            "show-overflow-tooltip": "",
            "sortable": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n                                " + _vm._s(scope.row.groupName || '--') + "\n                            ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "运行中分片",
            "header-align": "left",
            "width": "95px",
            "align": "center"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.status === 'OFFLINE') ? _c('span', [_vm._v("--")]) : _c('el-tooltip', {
                attrs: {
                  "content": "查看",
                  "placement": "top"
                }
              }, [_c('el-button', {
                attrs: {
                  "type": "text"
                },
                on: {
                  "click": function($event) {
                    _vm.getRunningAllocation(scope.row)
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-search-plus"
              })])], 1)]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "version",
            "label": "版本",
            "sortable": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "lastBeginTime",
            "label": "最近启动时间",
            "width": "160px"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "操作",
            "width": "150px",
            "align": "center"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(_vm.$common.hasPerm('executor:restart', _vm.domainName) && (scope.row.status === 'ONLINE' && !scope.row.restarting && _vm.isAbledDump(scope.row.version))) ? _c('el-tooltip', {
                attrs: {
                  "content": "重启",
                  "placement": "top"
                }
              }, [_c('el-button', {
                attrs: {
                  "type": "text"
                },
                on: {
                  "click": function($event) {
                    _vm.handleRestart(scope.row)
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-power-off"
              })])], 1) : _vm._e(), _vm._v(" "), (_vm.$common.hasPerm('executor:extractOrRecoverTraffic', _vm.domainName) && !scope.row.noTraffic) ? _c('el-tooltip', {
                attrs: {
                  "content": "摘取流量",
                  "placement": "top"
                }
              }, [_c('el-button', {
                attrs: {
                  "type": "text"
                },
                on: {
                  "click": function($event) {
                    _vm.handleTraffic(scope.row, 'extract')
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-stop-circle text-warning"
              })])], 1) : _vm._e(), _vm._v(" "), (_vm.$common.hasPerm('executor:extractOrRecoverTraffic', _vm.domainName) && scope.row.noTraffic) ? _c('el-tooltip', {
                attrs: {
                  "content": "恢复流量",
                  "placement": "top"
                }
              }, [_c('el-button', {
                attrs: {
                  "type": "text"
                },
                on: {
                  "click": function($event) {
                    _vm.handleTraffic(scope.row, 'recover')
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-play-circle"
              })])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 'ONLINE') ? _c('el-tooltip', {
                attrs: {
                  "content": "一键DUMP",
                  "placement": "top"
                }
              }, [_c('el-button', {
                attrs: {
                  "type": "text"
                },
                on: {
                  "click": function($event) {
                    _vm.$common.handleDump(scope.row, _vm.domainName, _vm.dumpNext.bind(this))
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-database"
              })])], 1) : _vm._e(), _vm._v(" "), (_vm.$common.hasPerm('executor:remove', _vm.domainName) && scope.row.status === 'OFFLINE') ? _c('el-tooltip', {
                attrs: {
                  "content": "删除",
                  "placement": "top"
                }
              }, [_c('el-button', {
                attrs: {
                  "type": "text",
                  "icon": "el-icon-delete text-danger"
                },
                on: {
                  "click": function($event) {
                    _vm.handleDelete(scope.row)
                  }
                }
              })], 1) : _vm._e(), _vm._v(" "), _c('el-tooltip', {
                attrs: {
                  "content": "分片分配查看",
                  "placement": "top"
                }
              }, [_c('el-button', {
                attrs: {
                  "type": "text"
                },
                on: {
                  "click": function($event) {
                    _vm.getExecutorAllocation(scope.row)
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-arrows-alt"
              })])], 1)]
            }
          }])
        })], 1)], 1)]
      }
    }])
  }), _vm._v(" "), (_vm.isExecutorAllocationVisible) ? _c('div', [_c('executor-allocation-dialog', {
    attrs: {
      "executor-allocation-info": _vm.executorAllocationInfo
    },
    on: {
      "close-dialog": _vm.closeExecutorAllocationDialog
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isRunningAllocationVisible) ? _c('div', [_c('running-allocation-dialog', {
    attrs: {
      "running-allocation-info": _vm.runningAllocationInfo
    },
    on: {
      "close-dialog": _vm.closeRunningAllocationDialog
    }
  })], 1) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 1384 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-panel",
    class: _vm.panelType
  }, [_c('div', {
    staticClass: "card-panel-heading"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('i', {
    staticClass: "fa-5x",
    class: _vm.icon
  })]), _vm._v(" "), _c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 18
    }
  }, [_c('div', {
    staticClass: "huge"
  }, [_vm._v(_vm._s(_vm.num))]), _vm._v(" "), _c('div', {
    staticClass: "title-size"
  }, [_vm._v(_vm._s(_vm.title))])])], 1)], 1), _vm._v(" "), _c('a', {
    on: {
      "click": _vm.viewDetail
    }
  }, [_vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-panel-footer"
  }, [_c('span', {
    staticClass: "pull-left"
  }, [_vm._v("查看")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right"
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-right"
  })])])
}]}

/***/ }),
/* 1385 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-box"
  }, [_c('div', {
    staticClass: "login-header"
  }, [_vm._v("\n        用户登录\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "login-body"
  }, [(_vm.loginErrorMsg) ? _c('div', {
    staticClass: "msg-error"
  }, [_c('i', {
    staticClass: "el-icon-remove"
  }), _vm._v(_vm._s(_vm.loginErrorMsg))]) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-input', {
    attrs: {
      "size": "medium",
      "required": "",
      "placeholder": "请输入帐号"
    },
    model: {
      value: (_vm.loginInfo.username),
      callback: function($$v) {
        _vm.$set(_vm.loginInfo, "username", $$v)
      },
      expression: "loginInfo.username"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "请输入密码"
    },
    model: {
      value: (_vm.loginInfo.password),
      callback: function($$v) {
        _vm.$set(_vm.loginInfo, "password", $$v)
      },
      expression: "loginInfo.password"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": "请输入动态验证码"
    },
    nativeOn: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.login($event)
      }
    },
    model: {
      value: (_vm.loginInfo.authentication),
      callback: function($$v) {
        _vm.$set(_vm.loginInfo, "authentication", $$v)
      },
      expression: "loginInfo.authentication"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.login()
      }
    }
  }, [_vm._v("登录")])], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1386 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": "请稍等···"
    }
  }, [_c('div', {
    staticClass: "page-container"
  }, [_c('TimeoutJobs', {
    attrs: {
      "timeout-jobs-list": _vm.namespaceTimeoutJobsList
    },
    on: {
      "refresh-list": _vm.getTimeoutJobs,
      "no-alarm": _vm.noAlarm
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1387 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": "请稍等···"
    }
  }, [_c('div', {
    staticClass: "margin-20"
  }, [_c('FilterPageList', {
    ref: "pageListRef",
    attrs: {
      "data": _vm.userList,
      "total": _vm.total,
      "order-by": _vm.orderBy,
      "filters": _vm.filters
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-form', {
          staticClass: "table-filter",
          attrs: {
            "inline": true
          }
        }, [_c('input', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (false),
            expression: "false"
          }],
          attrs: {
            "type": "text"
          }
        }), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": ""
          }
        }, [_c('el-select', {
          attrs: {
            "clearable": ""
          },
          model: {
            value: (_vm.backFilter.roleKey),
            callback: function($$v) {
              _vm.$set(_vm.backFilter, "roleKey", $$v)
            },
            expression: "backFilter.roleKey"
          }
        }, _vm._l((_vm.roles), function(item) {
          return _c('el-option', {
            key: item.roleKey,
            attrs: {
              "label": item.roleName,
              "value": item.roleKey
            }
          })
        }))], 1), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": ""
          }
        }, [_c('el-input', {
          attrs: {
            "placeholder": "请输入用户名"
          },
          nativeOn: {
            "keyup": function($event) {
              if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
              _vm.getUserRolesReq($event)
            }
          },
          model: {
            value: (_vm.backFilter.userName),
            callback: function($$v) {
              _vm.$set(_vm.backFilter, "userName", $$v)
            },
            expression: "backFilter.userName"
          }
        })], 1), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": ""
          }
        }, [_c('el-autocomplete', {
          attrs: {
            "fetch-suggestions": _vm.querySearchAsync,
            "placeholder": "请输入域名"
          },
          model: {
            value: (_vm.backFilter.namespace),
            callback: function($$v) {
              _vm.$set(_vm.backFilter, "namespace", $$v)
            },
            expression: "backFilter.namespace"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "icon": "el-icon-search"
          },
          on: {
            "click": _vm.getUserRolesReq
          }
        }, [_vm._v("查询")])], 1)], 1), _vm._v(" "), _c('div', {
          staticClass: "page-table"
        }, [_c('div', {
          staticClass: "page-table-header"
        }, [_c('div', {
          staticClass: "page-table-header-title"
        }, [_c('i', {
          staticClass: "fa fa-list"
        }), _vm._v("用户及其权限列表\n                            "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": _vm.getUserRolesReq
          }
        }, [_c('i', {
          staticClass: "fa fa-refresh"
        })])], 1), _vm._v(" "), _c('div', {
          staticClass: "pull-right"
        }, [_c('el-button', {
          on: {
            "click": function($event) {
              _vm.handleAdd()
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-plus-circle text-btn"
        }), _vm._v("添加权限集")])], 1)]), _vm._v(" "), _c('el-table', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "stripe": "",
            "border": "",
            "data": scope.pageData
          },
          on: {
            "sort-change": scope.onSortChange
          }
        }, [_c('el-table-column', {
          attrs: {
            "prop": "userName",
            "label": "用户名"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "roleKey",
            "label": "权限集合"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n                                " + _vm._s(_vm.rolesMaps[scope.row.roleKey] || scope.row.roleKey) + "\n                            ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "namespace",
            "label": "所属域"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n                                " + _vm._s(scope.row.namespace || '-') + "\n                            ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "lastUpdateTime",
            "label": "更新时间",
            "width": "160px"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n                                " + _vm._s(_vm._f("formatDate")(scope.row.lastUpdateTime)) + "\n                            ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "操作",
            "width": "100px",
            "align": "center"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('el-tooltip', {
                attrs: {
                  "content": "编辑",
                  "placement": "top"
                }
              }, [_c('el-button', {
                attrs: {
                  "type": "text",
                  "icon": "el-icon-edit"
                },
                on: {
                  "click": function($event) {
                    _vm.handleEdit(scope.row)
                  }
                }
              })], 1), _vm._v(" "), _c('el-tooltip', {
                attrs: {
                  "content": "删除",
                  "placement": "top"
                }
              }, [_c('el-button', {
                attrs: {
                  "type": "text",
                  "icon": "el-icon-delete text-danger"
                },
                on: {
                  "click": function($event) {
                    _vm.handleDelete(scope.row)
                  }
                }
              })], 1)]
            }
          }])
        })], 1)], 1)]
      }
    }])
  }), _vm._v(" "), (_vm.isUserVisible) ? _c('div', [_c('user-info-dialog', {
    attrs: {
      "user-info": _vm.userInfo,
      "user-info-title": _vm.userInfoTitle,
      "user-info-operate": _vm.userInfoOperate,
      "roles": _vm.roles
    },
    on: {
      "user-info-success": _vm.userInfoSuccess,
      "close-dialog": _vm.closeInfoDialog
    }
  })], 1) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 1388 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "title": _vm.jobInfoTitle,
      "visible": _vm.isVisible,
      "before-close": _vm.closeDialog,
      "element-loading-text": "请稍等···"
    },
    on: {
      "update:visible": function($event) {
        _vm.isVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "jobInfo",
    attrs: {
      "model": _vm.jobInfo,
      "rules": _vm.rules,
      "label-width": "180px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "siteId",
      "label": "站点ID"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.jobInfo.siteId),
      callback: function($$v) {
        _vm.$set(_vm.jobInfo, "siteId", $$v)
      },
      expression: "jobInfo.siteId"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "taskId",
      "label": "任务ID"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.jobInfo.taskId),
      callback: function($$v) {
        _vm.$set(_vm.jobInfo, "taskId", $$v)
      },
      expression: "jobInfo.taskId"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "taskCode",
      "label": "任务Code"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.jobInfo.taskCode),
      callback: function($$v) {
        _vm.$set(_vm.jobInfo, "taskCode", $$v)
      },
      expression: "jobInfo.taskCode"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "作业类型",
      "prop": "jobType"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": !_vm.isEditable
    },
    model: {
      value: (_vm.jobInfo.jobType),
      callback: function($$v) {
        _vm.$set(_vm.jobInfo, "jobType", $$v)
      },
      expression: "jobInfo.jobType"
    }
  }, _vm._l((_vm.$option.jobTypes), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "作业名",
      "prop": "jobName"
    }
  }, [_c('el-tooltip', {
    attrs: {
      "popper-class": "form-tooltip",
      "content": "存储后的作业名称为：站点ID_作业名  如：1_SaturnJavaJob",
      "placement": "bottom"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "如SaturnJavaJob"
    },
    model: {
      value: (_vm.jobInfo.jobName),
      callback: function($$v) {
        _vm.$set(_vm.jobInfo, "jobName", $$v)
      },
      expression: "jobInfo.jobName"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [(_vm.$option.isJava(_vm.jobInfo.jobType)) ? _c('el-form-item', {
    attrs: {
      "label": "作业实现类",
      "prop": "jobClass"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "如com.vip.saturn.job.SaturnJavaJob"
    },
    model: {
      value: (_vm.jobInfo.jobClass),
      callback: function($$v) {
        _vm.$set(_vm.jobInfo, "jobClass", $$v)
      },
      expression: "jobInfo.jobClass"
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [(_vm.$option.isCron(_vm.jobInfo.jobType)) ? _c('el-form-item', {
    attrs: {
      "label": "cron表达式",
      "prop": "cron"
    }
  }, [_c('el-tooltip', {
    attrs: {
      "popper-class": "form-tooltip",
      "content": "作业启动时间的cron表达式。如每10秒运行:*/10****?,每5分钟运行:0*/5***?",
      "placement": "bottom"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.jobInfo.cron),
      callback: function($$v) {
        _vm.$set(_vm.jobInfo, "cron", $$v)
      },
      expression: "jobInfo.cron"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append"
    },
    on: {
      "click": _vm.checkAndForecastCron
    },
    slot: "append"
  }, [_vm._v("预测")])], 1)], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [(_vm.$option.isCron(_vm.jobInfo.jobType)) ? _c('el-form-item', {
    staticClass: "form-annotation"
  }, [_c('span', [_vm._v("1. 每10秒运行一次的表达式：*/10 * * * * ?")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("2. 每分钟运行一次的表达式：0 * * * * ?")])]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "作业分片总数",
      "prop": "shardingTotalCount"
    }
  }, [(_vm.jobInfo.downStream) ? _c('el-tooltip', {
    attrs: {
      "popper-class": "form-tooltip",
      "placement": "bottom"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('span', [_vm._v(_vm._s(_vm.jobInfo.downStream.length > 0 ? '该作业有下游作业，作业分片数必须为1' : '作业分片数'))])]), _vm._v(" "), _c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.jobInfo.downStream.length > 0,
      "controls-position": "right",
      "min": 1
    },
    model: {
      value: (_vm.jobInfo.shardingTotalCount),
      callback: function($$v) {
        _vm.$set(_vm.jobInfo, "shardingTotalCount", $$v)
      },
      expression: "jobInfo.shardingTotalCount"
    }
  })], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "分片参数",
      "prop": "shardingItemParameters"
    }
  }, [_c('el-tooltip', {
    attrs: {
      "popper-class": "form-tooltip",
      "placement": "bottom"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                                分片序列号和参数用等号分隔，多个键值对用逗号分隔 。分片序列号从0开始，不可大于或等于作业分片总数。如：0=a,1=b,2=c;"), _c('br'), _vm._v("\n                                英文双引号请使用!!代替，英文等号请使用@@代替，英文逗号请使用##代替。"), _c('br'), _vm._v("\n                                如果作业所有分片无须参数，则只要保持值为0。例如有2个分片无须参数，则为“0=0,1=0”。"), _c('br'), _vm._v("\n                                对于本地模式的作业，格式为*=value\n                            ")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.jobInfo.shardingItemParameters),
      callback: function($$v) {
        _vm.$set(_vm.jobInfo, "shardingItemParameters", $$v)
      },
      expression: "jobInfo.shardingItemParameters"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "自定义参数",
      "prop": "jobParameter"
    }
  }, [_c('el-tooltip', {
    attrs: {
      "popper-class": "form-tooltip",
      "content": "配置格式: 多个配置使用逗号分隔(key1=value1, key2=value2)。在分片序列号/参数对照表中可作为alias形式引用，格式为{key1}",
      "placement": "bottom"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.jobInfo.jobParameter),
      callback: function($$v) {
        _vm.$set(_vm.jobInfo, "jobParameter", $$v)
      },
      expression: "jobInfo.jobParameter"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [(_vm.$option.isPassive(_vm.jobInfo.jobType)) ? _c('el-form-item', {
    attrs: {
      "prop": "upStream",
      "label": "上游作业"
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "bottom"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                                满足上游作业的条件"), _c('br'), _vm._v("1.只能是定时作业或被动作业"), _c('br'), _vm._v("2.分片只能为1"), _c('br'), _vm._v("3.不能是本地模式作业"), _c('br'), _vm._v("4.不能是本作业的直接或者间接下游\n                            ")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "multiple": ""
    },
    model: {
      value: (_vm.jobInfo.upStream),
      callback: function($$v) {
        _vm.$set(_vm.jobInfo, "upStream", $$v)
      },
      expression: "jobInfo.upStream"
    }
  }, _vm._l((_vm.upStreamProvided), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }))], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [(_vm.$option.isPassive(_vm.jobInfo.jobType)) ? _c('el-form-item', {
    attrs: {
      "prop": "downStream",
      "label": "下游作业"
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "bottom"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                                配置下游作业的条件"), _c('br'), _vm._v("1.只能是定时作业或被动作业"), _c('br'), _vm._v("2.分片只能为1"), _c('br'), _vm._v("3.不能是本地模式作业"), _c('br'), _c('br'), _vm._v("\n                                满足下游作业的条件"), _c('br'), _vm._v("1.只能是被动作业"), _c('br'), _vm._v("2.不能是本作业的直接或者间接上游\n                            ")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "multiple": "",
      "disabled": _vm.jobInfo.localMode || _vm.jobInfo.shardingTotalCount !== 1
    },
    model: {
      value: (_vm.jobInfo.downStream),
      callback: function($$v) {
        _vm.$set(_vm.jobInfo, "downStream", $$v)
      },
      expression: "jobInfo.downStream"
    }
  }, _vm._l((_vm.downStreamProvided), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }))], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.$option.isMsg(_vm.jobInfo.jobType)) ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Queue名",
      "prop": "queueName"
    }
  }, [_c('el-tooltip', {
    attrs: {
      "popper-class": "form-tooltip",
      "placement": "bottom"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                                消息类型job的queue名\n                            ")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.jobInfo.queueName),
      callback: function($$v) {
        _vm.$set(_vm.jobInfo, "queueName", $$v)
      },
      expression: "jobInfo.queueName"
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "描述",
      "prop": "description"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.jobInfo.description),
      callback: function($$v) {
        _vm.$set(_vm.jobInfo, "description", $$v)
      },
      expression: "jobInfo.description"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.closeDialog()
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.handleSubmit()
      }
    }
  }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), (_vm.isCronPredictVisible) ? _c('div', [_c('CronPredictDialog', {
    attrs: {
      "cron-predict-params": _vm.cronPredictParams
    },
    on: {
      "close-dialog": _vm.closeCronDialog
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1389 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": "请稍等···"
    }
  }, [_c('div', {
    staticClass: "page-container"
  }, [_c('AbnormalContainers', {
    on: {
      "abnormal-containers-list": _vm.abnormalContainersList,
      "refresh-list": _vm.getAbnormalContainers
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1390 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "分片分配详情",
      "visible": _vm.isVisible,
      "before-close": _vm.closeDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.isVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "130px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Executor"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.executorAllocationInfo.executorName))])])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "负荷"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.executorAllocationInfo.totalLoadLevel))])])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "分片分布"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [(Object.entries(_vm.executorAllocationInfo.allocationMap).length === 0) ? _c('div', [_vm._v("无")]) : _c('div', _vm._l((Object.entries(_vm.executorAllocationInfo.allocationMap)), function(item) {
    return _c('el-tag', {
      key: item[0],
      staticClass: "form-tags"
    }, [_vm._v(_vm._s(item[0]) + " : " + _vm._s(item[1]))])
  }))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.closeDialog()
      }
    }
  }, [_vm._v("取消")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1391 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tm-body"
  }, [_c('ol', {
    staticClass: "tm-items"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 1392 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": "请稍等···"
    }
  }, [_c('div', {
    staticClass: "margin-20"
  }, [_c('FilterPageList', {
    ref: "pageListRef",
    attrs: {
      "data": _vm.oauthClientConfigList,
      "total": _vm.total,
      "order-by": _vm.orderBy,
      "filters": _vm.filters
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-form', {
          staticClass: "table-filter",
          attrs: {
            "inline": true
          }
        }, [_c('input', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (false),
            expression: "false"
          }],
          attrs: {
            "type": "text"
          }
        }), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": ""
          }
        }, [_c('el-input', {
          attrs: {
            "placeholder": "请输入appKey"
          },
          model: {
            value: (_vm.backFilter.appKey),
            callback: function($$v) {
              _vm.$set(_vm.backFilter, "appKey", $$v)
            },
            expression: "backFilter.appKey"
          }
        })], 1), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": ""
          }
        }, [_c('el-input', {
          attrs: {
            "placeholder": "请输入应用Id"
          },
          model: {
            value: (_vm.backFilter.appId),
            callback: function($$v) {
              _vm.$set(_vm.backFilter, "appId", $$v)
            },
            expression: "backFilter.appId"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "icon": "el-icon-search"
          },
          on: {
            "click": _vm.getOauthClientConfig
          }
        }, [_vm._v("查询")])], 1)], 1), _vm._v(" "), _c('div', {
          staticClass: "page-table"
        }, [_c('div', {
          staticClass: "page-table-header"
        }, [_c('div', {
          staticClass: "page-table-header-title"
        }, [_c('i', {
          staticClass: "fa fa-list"
        }), _vm._v("OauthClient配置列表\n                                "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": _vm.getOauthClientConfig
          }
        }, [_c('i', {
          staticClass: "fa fa-refresh"
        })])], 1), _vm._v(" "), _c('div', {
          staticClass: "pull-right"
        }, [_c('el-button', {
          on: {
            "click": function($event) {
              _vm.handleAdd()
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-plus-circle text-btn"
        }), _vm._v("添加")])], 1)]), _vm._v(" "), _c('el-table', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "stripe": "",
            "border": "",
            "data": scope.pageData
          },
          on: {
            "sort-change": scope.onSortChange
          }
        }, [_c('el-table-column', {
          attrs: {
            "prop": "appId",
            "label": "应用Id"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n                                    " + _vm._s(scope.row.appId) + "\n                                ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "appKey",
            "label": "应用Key"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n                                    " + _vm._s(scope.row.appKey) + "\n                                ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "adminName",
            "label": "管理员用户名"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n                                    " + _vm._s(scope.row.adminName) + "\n                                ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "adminPassword",
            "label": "管理员密码"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n                                    " + _vm._s(scope.row.adminPassword) + "\n                                ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "extJson",
            "label": "扩展参数"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n                                    " + _vm._s(scope.row.extJson) + "\n                                ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "操作",
            "width": "100px",
            "align": "center"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('el-tooltip', {
                attrs: {
                  "content": "编辑",
                  "placement": "top"
                }
              }, [_c('el-button', {
                attrs: {
                  "type": "text",
                  "icon": "el-icon-edit"
                },
                on: {
                  "click": function($event) {
                    _vm.handleEdit(scope.row)
                  }
                }
              })], 1), _vm._v(" "), _c('el-tooltip', {
                attrs: {
                  "content": "删除",
                  "placement": "top"
                }
              }, [_c('el-button', {
                attrs: {
                  "type": "text",
                  "icon": "el-icon-delete text-danger"
                },
                on: {
                  "click": function($event) {
                    _vm.handleDelete(scope.row)
                  }
                }
              })], 1)]
            }
          }])
        })], 1)], 1)]
      }
    }])
  }), _vm._v(" "), (_vm.isOauthClientVisible) ? _c('div', [_c('oauth-client-config-dialog', {
    attrs: {
      "oauth-client-info": _vm.oauthClientInfo,
      "oauth-client-title": _vm.oauthClientTitle,
      "oauth-client-operate": _vm.oauthClientOperate
    },
    on: {
      "oauth-client-success": _vm.oauthClientSuccess,
      "close-dialog": _vm.closeInfoDialog
    }
  })], 1) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 1393 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "param-table"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.parameters,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "配置项",
      "header-align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          attrs: {
            "popper-class": "form-tooltip",
            "placement": "bottom"
          }
        }, [_c('div', {
          attrs: {
            "slot": "content"
          },
          slot: "content"
        }, [(scope.row.description) ? _c('span', [_vm._v(_vm._s(scope.row.description))]) : _c('span', [_vm._v("暂无描述")])]), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.key))])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "值",
      "header-align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          model: {
            value: (scope.row.value),
            callback: function($$v) {
              _vm.$set(scope.row, "value", $$v)
            },
            expression: "scope.row.value"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "header-align": "left",
      "width": "80px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              _vm.handleSubmit(scope.row)
            }
          }
        }, [_vm._v("更新")])]
      }
    }])
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1394 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('FilterPageList', {
    attrs: {
      "data": _vm.unableFailoverJobsList,
      "total": _vm.total,
      "order-by": _vm.orderBy,
      "filters": _vm.filters
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-form', {
          staticClass: "table-filter",
          attrs: {
            "inline": true
          }
        }, [_c('input', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (false),
            expression: "false"
          }],
          attrs: {
            "type": "text"
          }
        }), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": ""
          }
        }, [_c('el-input', {
          attrs: {
            "placeholder": "请输入作业名"
          },
          nativeOn: {
            "keyup": function($event) {
              if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
              scope.search($event)
            }
          },
          model: {
            value: (_vm.filters.jobName.value),
            callback: function($$v) {
              _vm.$set(_vm.filters.jobName, "value", $$v)
            },
            expression: "filters.jobName.value"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "icon": "el-icon-search"
          },
          on: {
            "click": scope.search
          }
        }, [_vm._v("查询")])], 1)], 1), _vm._v(" "), _c('div', {
          staticClass: "page-table"
        }, [_c('div', {
          staticClass: "page-table-header"
        }, [_c('div', {
          staticClass: "page-table-header-title"
        }, [_c('i', {
          staticClass: "fa fa-list"
        }), _vm._v("无法高可用的作业\n                    "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": _vm.refreshList
          }
        }, [_c('i', {
          staticClass: "fa fa-refresh"
        })])], 1)]), _vm._v(" "), _c('el-table', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "stripe": "",
            "border": "",
            "data": scope.pageData
          },
          on: {
            "sort-change": scope.onSortChange
          }
        }, [_c('el-table-column', {
          attrs: {
            "prop": "jobName",
            "label": "作业名",
            "sortable": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('router-link', {
                attrs: {
                  "tag": "a",
                  "to": {
                    name: 'job_setting',
                    params: {
                      domain: scope.row.domainName,
                      jobName: scope.row.jobName
                    }
                  }
                }
              }, [_c('el-button', {
                attrs: {
                  "type": "text"
                }
              }, [_vm._v("\n                                " + _vm._s(scope.row.jobName) + "\n                            ")])], 1)]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "domainName",
            "label": "所属域",
            "sortable": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('router-link', {
                attrs: {
                  "tag": "a",
                  "to": {
                    name: 'job_overview',
                    params: {
                      domain: scope.row.domainName
                    }
                  }
                }
              }, [_c('el-button', {
                attrs: {
                  "type": "text"
                }
              }, [_vm._v("\n                                " + _vm._s(scope.row.domainName) + "\n                            ")])], 1)]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "degree",
            "label": "域等级",
            "sortable": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n                        " + _vm._s(_vm.$map.degreeMap[scope.row.degree]) + "\n                    ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "jobDegree",
            "label": "作业等级",
            "sortable": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n                        " + _vm._s(_vm.$map.degreeMap[scope.row.jobDegree]) + "\n                    ")]
            }
          }])
        })], 1)], 1)]
      }
    }])
  })
},staticRenderFns: []}

/***/ }),
/* 1395 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "title": _vm.userInfoTitle,
      "width": "45%",
      "visible": _vm.isVisible,
      "before-close": _vm.closeDialog,
      "element-loading-text": "请稍等···"
    },
    on: {
      "update:visible": function($event) {
        _vm.isVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "userInfo",
    attrs: {
      "model": _vm.userInfo,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [(_vm.userInfoOperate === 'add') ? _c('el-form-item', {
    attrs: {
      "label": "用户名",
      "prop": "userNames"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "多个用户名请用英文','分隔",
      "disabled": !_vm.isEditable
    },
    model: {
      value: (_vm.userInfo.userNames),
      callback: function($$v) {
        _vm.$set(_vm.userInfo, "userNames", $$v)
      },
      expression: "userInfo.userNames"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.userInfoOperate === 'edit') ? _c('el-form-item', {
    attrs: {
      "label": "用户名",
      "prop": "userName"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": !_vm.isEditable
    },
    model: {
      value: (_vm.userInfo.userName),
      callback: function($$v) {
        _vm.$set(_vm.userInfo, "userName", $$v)
      },
      expression: "userInfo.userName"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "权限集合",
      "prop": "roleKey"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    model: {
      value: (_vm.userInfo.roleKey),
      callback: function($$v) {
        _vm.$set(_vm.userInfo, "roleKey", $$v)
      },
      expression: "userInfo.roleKey"
    }
  }, _vm._l((_vm.roles), function(item) {
    return _c('el-option', {
      key: item.roleKey,
      attrs: {
        "label": item.roleName,
        "value": item.roleKey
      }
    })
  }))], 1)], 1), _vm._v(" "), (_vm.isShowNamespace && _vm.userInfoOperate === 'add') ? _c('el-form-item', {
    attrs: {
      "label": "所属域",
      "prop": "namespaces",
      "required": ""
    }
  }, [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "size": "mini",
      "multiple": "",
      "filterable": "",
      "remote": "",
      "placeholder": "请选择域名"
    },
    model: {
      value: (_vm.userInfo.namespaces),
      callback: function($$v) {
        _vm.$set(_vm.userInfo, "namespaces", $$v)
      },
      expression: "userInfo.namespaces"
    }
  }, _vm._l((_vm.allDomains), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.value,
        "value": item.value
      }
    })
  }))], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isShowNamespace && _vm.userInfoOperate === 'edit') ? _c('el-form-item', {
    attrs: {
      "label": "所属域",
      "prop": "namespace",
      "required": ""
    }
  }, [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "size": "mini",
      "filterable": "",
      "remote": "",
      "placeholder": "请选择域名"
    },
    model: {
      value: (_vm.userInfo.namespace),
      callback: function($$v) {
        _vm.$set(_vm.userInfo, "namespace", $$v)
      },
      expression: "userInfo.namespace"
    }
  }, _vm._l((_vm.allDomains), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.value,
        "value": item.value
      }
    })
  }))], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.closeDialog()
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.handleSubmit()
      }
    }
  }, [_vm._v("确定")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1396 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    staticClass: "page-table"
  }, [_c('div', {
    staticClass: "page-table-header"
  }, [_c('div', {
    staticClass: "page-table-header-title"
  }, [_c('i', {
    staticClass: "fa fa-list"
  }), _vm._v("分片情况\n                "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.getJobSharding
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })])], 1)]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "border": "",
      "data": _vm.haveShardJobShardings
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "executorName",
      "label": "Executor",
      "min-width": "110px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.container) ? _c('i', {
          staticClass: "iconfont icon-docker"
        }) : _vm._e(), _vm._v(" "), (!scope.row.container) ? _c('i', {
          staticClass: "iconfont icon-zhuji"
        }) : _vm._e(), _vm._v(" "), (scope.row.leader) ? _c('el-tooltip', {
          attrs: {
            "content": "leader",
            "placement": "top"
          }
        }, [_c('i', {
          staticClass: "fa fa-flag",
          staticStyle: {
            "color": "red"
          }
        })]) : _vm._e(), _vm._v("\n                    " + _vm._s(scope.row.executorName) + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ip",
      "label": "IP",
      "width": "130px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "分片项"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((_vm.$array.strToArray(scope.row.sharding)), function(item) {
          return _c('el-tag', {
            key: item,
            staticClass: "sharding-tag",
            attrs: {
              "type": "primary"
            }
          }, [_vm._v(_vm._s(item))])
        })
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "分片总数",
      "width": "90px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                    " + _vm._s(_vm.$array.strToArray(scope.row.sharding).length) + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "最近处理数(每天)"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("成功:" + _vm._s(scope.row.processSuccessCount))]), _vm._v(" "), _c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("失败:" + _vm._s(scope.row.processFailureCount))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "version",
      "label": "Executor版本"
    }
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1397 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": "请稍等···"
    }
  }, [_c('div', {
    staticClass: "page-container"
  }, [_c('TimeoutJobs', {
    attrs: {
      "timeout-jobs-list": _vm.timeoutJobsList
    },
    on: {
      "refresh-list": _vm.getTimeoutJobs,
      "no-alarm": _vm.noAlarm
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1398 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "page-detail-header"
  }, [_c('div', {
    staticClass: "pull-left page-detail-title"
  }, [_c('span', {
    staticClass: "page-detail-span"
  }, [_c('i', {
    staticClass: "fa fa-sitemap"
  }), _vm._v("\n              当前ZK集群 : " + _vm._s(_vm.zkCluster || '全部ZK集群') + "\n          ")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.init
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "page-content",
    attrs: {
      "element-loading-text": "请稍等···"
    }
  }, [_c('div', [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24,
      "lg": 24,
      "xl": 12
    }
  }, [_c('Chart-container', {
    attrs: {
      "title": "失败率最高的Top10 Executor(当天)",
      "type": "bar"
    }
  }, [_c('div', {
    attrs: {
      "slot": "chart"
    },
    slot: "chart"
  }, [_c('Column', {
    attrs: {
      "id": "top10FailExecutor",
      "option-info": _vm.top10FailExecutorOptionInfo
    }
  })], 1)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24,
      "lg": 24,
      "xl": 12
    }
  }, [_c('Chart-container', {
    attrs: {
      "title": "负荷最重的Top10 Executor",
      "type": "bar"
    }
  }, [_c('div', {
    attrs: {
      "slot": "chart"
    },
    slot: "chart"
  }, [_c('Column', {
    attrs: {
      "id": "top10LoadExecutor",
      "option-info": _vm.top10LoadExecutorOptionInfo
    }
  })], 1)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24,
      "lg": 24,
      "xl": 12
    }
  }, [_c('Chart-container', {
    attrs: {
      "title": "Executor版本分布",
      "type": "pie"
    }
  }, [_c('div', {
    attrs: {
      "slot": "chart"
    },
    slot: "chart"
  }, [_c('Pie', {
    attrs: {
      "id": "executorVersionNumber",
      "option-info": _vm.executorVersionNumberOptionInfo
    }
  })], 1)])], 1)], 1)], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1399 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('VAside', {
    attrs: {
      "sidebar-menus": _vm.sidebarMenus,
      "headerHeight": "50"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1400 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-tags"
  }, [_vm._l((_vm.dynamicTags), function(tag) {
    return _c('el-tag', {
      key: tag,
      attrs: {
        "closable": "",
        "disable-transitions": false
      },
      on: {
        "close": function($event) {
          _vm.handleClose(tag)
        }
      }
    }, [_vm._v(_vm._s(tag))])
  }), _vm._v(" "), (_vm.inputVisible) ? _c('el-input', {
    ref: "saveTagInput",
    staticClass: "input-new-tag",
    attrs: {
      "size": "small"
    },
    on: {
      "blur": _vm.handleInputConfirm
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.handleInputConfirm($event)
      }
    },
    model: {
      value: (_vm.inputValue),
      callback: function($$v) {
        _vm.inputValue = $$v
      },
      expression: "inputValue"
    }
  }) : _c('el-button', {
    staticClass: "button-new-tag",
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.showInput
    }
  }, [_vm._v("+ " + _vm._s(_vm.title))])], 2)
},staticRenderFns: []}

/***/ }),
/* 1401 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel",
    class: _vm.panelType
  }, [_c('div', {
    staticClass: "panel-content-title"
  }, [_vm._t("title")], 2), _vm._v(" "), _c('div', {
    staticClass: "panel-content-body"
  }, [_vm._t("content")], 2)])
},staticRenderFns: []}

/***/ }),
/* 1402 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "title": _vm.clusterInfoTitle,
      "width": "35%",
      "visible": _vm.isVisible,
      "before-close": _vm.closeDialog,
      "element-loading-text": "请稍等···"
    },
    on: {
      "update:visible": function($event) {
        _vm.isVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "clusterInfo",
    attrs: {
      "model": _vm.clusterInfo,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "集群ID",
      "prop": "zkClusterKey"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": !_vm.isEditable
    },
    model: {
      value: (_vm.clusterInfo.zkClusterKey),
      callback: function($$v) {
        _vm.$set(_vm.clusterInfo, "zkClusterKey", $$v)
      },
      expression: "clusterInfo.zkClusterKey"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "集群名称",
      "prop": "alias"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": !_vm.isEditable
    },
    model: {
      value: (_vm.clusterInfo.alias),
      callback: function($$v) {
        _vm.$set(_vm.clusterInfo, "alias", $$v)
      },
      expression: "clusterInfo.alias"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "集群描述",
      "prop": "description"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "请输入机房信息"
    },
    model: {
      value: (_vm.clusterInfo.description),
      callback: function($$v) {
        _vm.$set(_vm.clusterInfo, "description", $$v)
      },
      expression: "clusterInfo.description"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "连接串",
      "prop": "connectString"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "连接串用','分隔"
    },
    model: {
      value: (_vm.clusterInfo.connectString),
      callback: function($$v) {
        _vm.$set(_vm.clusterInfo, "connectString", $$v)
      },
      expression: "clusterInfo.connectString"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-annotation"
  }, [_c('span', [_vm._v("格式: 例如192.168.0.1:2181,192.168.0.2:2181")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.closeDialog()
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.handleSubmit()
      }
    }
  }, [_vm._v("确定")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1403 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('VAside', {
    attrs: {
      "sidebar-menus": _vm.sidebarMenus,
      "headerHeight": "50"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1404 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "title": "添加配置",
      "width": "35%",
      "visible": _vm.isVisible,
      "before-close": _vm.closeDialog,
      "element-loading-text": "请稍等···"
    },
    on: {
      "update:visible": function($event) {
        _vm.isVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "configInfo",
    attrs: {
      "model": _vm.configInfo,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "KEY",
      "prop": "key"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.configInfo.key),
      callback: function($$v) {
        _vm.$set(_vm.configInfo, "key", $$v)
      },
      expression: "configInfo.key"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "VALUE",
      "prop": "value"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.configInfo.value),
      callback: function($$v) {
        _vm.$set(_vm.configInfo, "value", $$v)
      },
      expression: "configInfo.value"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.closeDialog()
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.handleSubmit()
      }
    }
  }, [_vm._v("确定")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1405 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "margin-20",
    attrs: {
      "element-loading-text": "请稍等···"
    }
  }, [_c('div', [_c('el-button', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("添加配置")])], 1), _vm._v(" "), _c('el-collapse', {
    model: {
      value: (_vm.activeNames),
      callback: function($$v) {
        _vm.activeNames = $$v
      },
      expression: "activeNames"
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "name": "job"
    }
  }, [_c('template', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('i', {
    staticClass: "fa fa-list-alt"
  }), _vm._v("作业配置")]), _vm._v(" "), _c('div', [_c('config-input', {
    attrs: {
      "type": "console",
      "parameters": _vm.systemConfig.job_configs
    },
    on: {
      "config-input-success": _vm.configInputSuccess
    }
  })], 1)], 2), _vm._v(" "), _c('el-collapse-item', {
    attrs: {
      "name": "executor"
    }
  }, [_c('template', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('i', {
    staticClass: "fa fa-area-chart"
  }), _vm._v("Executor配置")]), _vm._v(" "), _c('div', [_c('config-input', {
    attrs: {
      "type": "console",
      "parameters": _vm.systemConfig.executor_configs
    },
    on: {
      "config-input-success": _vm.configInputSuccess
    }
  })], 1)], 2), _vm._v(" "), _c('el-collapse-item', {
    attrs: {
      "name": "zkCluster"
    }
  }, [_c('template', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('i', {
    staticClass: "fa fa-sitemap"
  }), _vm._v("ZK集群配置")]), _vm._v(" "), _c('div', [_c('config-input', {
    attrs: {
      "type": "console",
      "parameters": _vm.systemConfig.cluster_configs
    },
    on: {
      "config-input-success": _vm.configInputSuccess
    }
  })], 1)], 2), _vm._v(" "), _c('el-collapse-item', {
    attrs: {
      "name": "console"
    }
  }, [_c('template', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('i', {
    staticClass: "fa fa-cog"
  }), _vm._v("Console配置")]), _vm._v(" "), _c('div', [_c('config-input', {
    attrs: {
      "type": "console",
      "parameters": _vm.systemConfig.console_configs
    },
    on: {
      "config-input-success": _vm.configInputSuccess
    }
  })], 1)], 2), _vm._v(" "), _c('el-collapse-item', {
    attrs: {
      "name": "other"
    }
  }, [_c('template', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('i', {
    staticClass: "fa fa-cogs"
  }), _vm._v("其他配置")]), _vm._v(" "), _c('div', [_c('config-input', {
    attrs: {
      "type": "console",
      "parameters": _vm.systemConfig.other_configs
    },
    on: {
      "config-input-success": _vm.configInputSuccess
    }
  })], 1)], 2)], 1), _vm._v(" "), (_vm.addConfigVisible) ? _c('div', [_c('add-config-dialog', {
    attrs: {
      "type": "console"
    },
    on: {
      "close-dialog": _vm.closeDialog,
      "add-config-success": _vm.addConfigSuccess
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1406 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    staticClass: "page-table"
  }, [_c('div', {
    staticClass: "page-table-header"
  }, [_c('div', {
    staticClass: "page-table-header-title"
  }, [_c('i', {
    staticClass: "fa fa-list"
  }), _vm._v("运行状态\n                "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.getJobExecutors()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "page-table-header-separator"
  }), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "refresh-text"
  }, [_vm._v("自动刷新：")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "placeholder": "请选择",
      "size": "mini"
    },
    on: {
      "change": _vm.refreshExecutions
    },
    model: {
      value: (_vm.autoRefreshTime),
      callback: function($$v) {
        _vm.autoRefreshTime = $$v
      },
      expression: "autoRefreshTime"
    }
  }, _vm._l((_vm.refreshTimes), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.label
      }
    })
  }))], 1)]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "border": "",
      "data": _vm.executions
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "item",
      "label": "分片项",
      "width": "80px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "min-width": "60px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "type": _vm.statusTag[scope.row.status]
          }
        }, [_vm._v(_vm._s(_vm.translateStatus[scope.row.status]))]), _vm._v(" "), (scope.row.failover) ? _c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("failover")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "jobMsg",
      "label": "分片返回信息"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(" \n                    " + _vm._s(scope.row.jobMsg) + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "executorName",
      "label": "Executor"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "最近执行时间",
      "width": "180px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_vm._v("起:" + _vm._s(scope.row.lastBeginTime || ' ——'))]), _vm._v(" "), _c('div', [_vm._v("止:" + _vm._s(scope.row.lastCompleteTime || ' ——'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "lastTimeConsumedInSec",
      "label": "执行时长(秒)",
      "width": "110px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.lastTimeConsumedInSec === 0) ? _c('div', [_vm._v("——")]) : _c('div', [_vm._v(_vm._s(scope.row.lastTimeConsumedInSec))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "nextFireTime",
      "label": "下次开始时间",
      "width": "180px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "日志",
      "width": "50px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          attrs: {
            "content": "查看日志",
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.getLog(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-file-text-o"
        })])], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), (_vm.isViewLogVisible) ? _c('div', [_c('ViewContentDialog', {
    attrs: {
      "title": "查看日志",
      "content": _vm.logContent
    },
    on: {
      "close-dialog": _vm.closeViewLogDialog
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1407 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "page-detail-header"
  }, [_c('div', {
    staticClass: "pull-left page-detail-title"
  }, [_c('span', {
    staticClass: "page-detail-span"
  }, [_c('i', {
    staticClass: "fa fa-sitemap"
  }), _vm._v("\n              当前ZK集群 : " + _vm._s(_vm.zkCluster || '全部ZK集群') + "\n          ")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.init
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "page-content",
    attrs: {
      "element-loading-text": "请稍等···"
    }
  }, [_c('div', [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24,
      "lg": 24,
      "xl": 12
    }
  }, [_c('Chart-container', {
    attrs: {
      "title": "失败率最高的Top10作业",
      "type": "bar"
    }
  }, [_c('div', {
    attrs: {
      "slot": "chart"
    },
    slot: "chart"
  }, [_c('Column', {
    attrs: {
      "id": "top10FailJob",
      "option-info": _vm.top10FailJobOptionInfo
    }
  })], 1)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24,
      "lg": 24,
      "xl": 12
    }
  }, [_c('Chart-container', {
    attrs: {
      "title": "最活跃的Top10作业(当天执行次数最多的作业)",
      "type": "bar"
    }
  }, [_c('div', {
    attrs: {
      "slot": "chart"
    },
    slot: "chart"
  }, [_c('Column', {
    attrs: {
      "id": "top10ActiveJob",
      "option-info": _vm.top10ActiveJobOptionInfo
    }
  })], 1)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24,
      "lg": 24,
      "xl": 12
    }
  }, [_c('Chart-container', {
    attrs: {
      "title": "负荷最重的Top10作业",
      "type": "bar"
    }
  }, [_c('div', {
    attrs: {
      "slot": "chart"
    },
    slot: "chart"
  }, [_c('Column', {
    attrs: {
      "id": "top10LoadJob",
      "option-info": _vm.top10LoadJobOptionInfo
    }
  })], 1)])], 1)], 1)], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1408 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "fullscreen": true
      }
    }],
    attrs: {
      "element-loading-text": "请稍等···"
    }
  }, [_c('div', {
    staticClass: "top-bar"
  }, [_c('div', {
    staticClass: "top-bar-left"
  }, [_c('i', {
    staticClass: "fa fa-home"
  }), _vm._v(" "), _c('span', [_vm._v("当前域: \n                "), _c('router-link', {
    attrs: {
      "tag": "a",
      "to": {
        name: 'job_overview',
        params: {
          domain: _vm.domain
        }
      }
    }
  }, [_vm._v(_vm._s(this.domain))])], 1), _vm._v(" "), _c('span', [_vm._v("所属集群: "), _c('router-link', {
    attrs: {
      "tag": "a",
      "to": {
        name: 'clusters_manage'
      }
    }
  }, [_vm._v(_vm._s(_vm.domainInfo.zkAlias))])], 1), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "placement": "right"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                    运维负责人："), _c('span', [_vm._v(_vm._s(_vm.domainInfo.sysAdmin || '空'))]), _c('br'), _vm._v("\n                    开发负责人："), _c('span', [_vm._v(_vm._s(_vm.domainInfo.techAdmin || '空'))])]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-warning"
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "top-bar-right"
  }, [(_vm.isShowBarSearch) ? _c('el-autocomplete', {
    staticClass: "top-bar-search",
    attrs: {
      "prefix-icon": "el-icon-search",
      "fetch-suggestions": _vm.querySearchAsync,
      "placeholder": "切换作业",
      "popper-class": "header-autocomplete"
    },
    on: {
      "select": _vm.handleSelect
    },
    model: {
      value: (_vm.jobNameSelect),
      callback: function($$v) {
        _vm.jobNameSelect = $$v
      },
      expression: "jobNameSelect"
    }
  }) : _vm._e(), _vm._v(" "), _c('Favorites')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1409 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": "请稍等···"
    }
  }, [_c('div', {
    staticClass: "page-container"
  }, [_c('AbnormalContainers', {
    attrs: {
      "abnormal-containers-list": _vm.namespaceAbnormalContainersList
    },
    on: {
      "refresh-list": _vm.getAbnormalContainers
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1410 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fav-container"
  }, [_c('el-popover', {
    ref: "popover",
    attrs: {
      "trigger": "click",
      "title": "我的收藏",
      "popper-class": "my-fav",
      "placement": "bottom",
      "width": "400"
    },
    on: {
      "show": function($event) {
        _vm.show = true
      },
      "hide": function($event) {
        _vm.show = false
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.form
    }
  }, [(_vm.show) ? _c('el-table', {
    staticClass: "fav-table",
    attrs: {
      "data": _vm.favorites,
      "show-header": true
    }
  }, [_c('el-table-column', {
    attrs: {
      "property": "title",
      "label": "名称",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.path === _vm.editPath) ? _c('el-form-item', {
          staticStyle: {
            "margin-bottom": "0"
          }
        }, [_c('el-input', {
          attrs: {
            "placeholder": scope.row.title
          },
          model: {
            value: (_vm.form.title),
            callback: function($$v) {
              _vm.$set(_vm.form, "title", $$v)
            },
            expression: "form.title"
          }
        })], 1) : _c('router-link', {
          attrs: {
            "to": {
              path: scope.row.path
            }
          }
        }, [_vm._v("\r\n              " + _vm._s(scope.row.title) + "\r\n            ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "group",
      "label": "分组",
      "show-overflow-tooltip": "",
      "filters": _vm.groupsList,
      "filter-method": _vm.filterGroup,
      "filter-placement": "bottom-end"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.path === _vm.editPath) ? _c('el-form-item', {
          staticStyle: {
            "margin-bottom": "0"
          }
        }, [_c('el-select', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "allow-create": "",
            "filterable": "",
            "size": "small"
          },
          model: {
            value: (_vm.form.group),
            callback: function($$v) {
              _vm.$set(_vm.form, "group", $$v)
            },
            expression: "form.group"
          }
        }, _vm._l((_vm.groupsList), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.text,
              "value": item.value
            }
          })
        }))], 1) : _c('span', [_vm._v(_vm._s(scope.row.group || '暂无分组'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "80px",
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.path === _vm.editPath) ? _c('div', [_c('el-tooltip', {
          key: "floppy",
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "保存",
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.submitForm(scope.row.path)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-floppy-o",
          attrs: {
            "aria-hidden": "true"
          }
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          key: "undo",
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "取消",
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.resetFields($event)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-undo",
          attrs: {
            "aria-hidden": "true"
          }
        })])], 1)], 1) : _c('div', [_c('el-tooltip', {
          key: "edit",
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "修改",
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text",
            "icon": "el-icon-edit"
          },
          on: {
            "click": function($event) {
              _vm.edit(scope.row, scope.row.path)
            }
          }
        })], 1), _vm._v(" "), _c('el-tooltip', {
          key: "delete",
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "删除",
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "favorites",
            rawName: "v-favorites:favorites.del",
            value: (scope.row.path),
            expression: "scope.row.path",
            arg: "favorites",
            modifiers: {
              "del": true
            }
          }],
          key: scope.row.path,
          attrs: {
            "type": "text",
            "icon": "el-icon-delete text-danger"
          },
          on: {
            "favorites-del": _vm.showMessage
          }
        })], 1)], 1)]
      }
    }])
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-popover', {
    ref: "popover1",
    attrs: {
      "trigger": "click",
      "title": "添加收藏",
      "placement": "bottom",
      "popper-class": "my-fav",
      "width": "350"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.form
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin": "9px 0"
    },
    attrs: {
      "label": "名称",
      "label-width": "40px"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "auto-complete": "off",
      "placeholder": "输入名称"
    },
    model: {
      value: (_vm.form.title),
      callback: function($$v) {
        _vm.$set(_vm.form, "title", $$v)
      },
      expression: "form.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "9px"
    },
    attrs: {
      "label": "分组",
      "label-width": "40px"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "allow-create": "",
      "filterable": "",
      "size": "small"
    },
    model: {
      value: (_vm.form.group),
      callback: function($$v) {
        _vm.$set(_vm.form, "group", $$v)
      },
      expression: "form.group"
    }
  }, _vm._l((_vm.groupsList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right",
      "margin": "0"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini",
      "type": "default"
    },
    on: {
      "click": _vm.resetFields
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        _vm.submitForm()
      }
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1), _vm._v(" "), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "添加收藏",
      "placement": "top-start"
    }
  }, [_c('el-button', {
    directives: [{
      name: "popover",
      rawName: "v-popover:popover1",
      arg: "popover1"
    }, {
      name: "favorites",
      rawName: "v-favorites:favorites.add",
      value: (_vm.unit),
      expression: "unit",
      arg: "favorites",
      modifiers: {
        "add": true
      }
    }],
    attrs: {
      "type": "text"
    },
    on: {
      "favorites-add": _vm.showMessage
    }
  }, [_c('i', {
    class: ['fa', _vm.isFav ? 'fa-heart' : 'fa-heart-o'],
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1), _vm._v(" "), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "查看收藏",
      "placement": "top-start"
    }
  }, [_c('el-button', {
    directives: [{
      name: "popover",
      rawName: "v-popover:popover",
      arg: "popover"
    }, {
      name: "favorites",
      rawName: "v-favorites:favorites",
      arg: "favorites"
    }],
    attrs: {
      "type": "text"
    }
  }, [_c('i', {
    class: ['fa', _vm.hasFav ? 'fa-star' : 'fa-star-o'],
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1411 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "title": "作业依赖图",
      "width": "70%",
      "custom-class": "arrange-layout-content",
      "visible": _vm.isVisible,
      "before-close": _vm.closeDialog,
      "element-loading-text": "请稍等···"
    },
    on: {
      "update:visible": function($event) {
        _vm.isVisible = $event
      }
    }
  }, [_c('div', [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', [_c('Relate', {
    attrs: {
      "id": "arrangeLayout",
      "option-info": _vm.optionInfo
    },
    on: {
      "job-redirect": _vm.jobRedirect
    }
  })], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.closeDialog()
      }
    }
  }, [_vm._v("取消")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1412 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "my-sider"
  }, [_c('el-container', [_c('el-aside', {
    staticStyle: {
      "background-color": "#283340"
    },
    attrs: {
      "width": _vm.siderWidth
    }
  }, [_c('div', {
    staticClass: "page-sidebar-container"
  }, [_c('div', {
    staticClass: "page-sidebar",
    class: {
      collapse: _vm.collapse
    },
    style: (_vm.sidebarHeight)
  }, [_c('el-menu', {
    attrs: {
      "mode": "vertical",
      "default-active": "1",
      "router": true
    }
  }, [_c('li', {
    staticClass: "el-menu-item page-sidebar-toggle-btn",
    style: (_vm.styleObject),
    on: {
      "click": function($event) {
        _vm.collapseChange()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left",
    class: {
      'fa-angle-left': !_vm.collapse, 'fa-angle-right': _vm.collapse
    }
  })]), _vm._v(" "), _vm._l((_vm.sidebarMenus), function(menu) {
    return _c('el-menu-item', {
      key: menu.index,
      staticClass: "page-menu-item",
      class: {
        active: _vm.activeMenu === menu.index
      },
      style: (_vm.styleObject),
      attrs: {
        "index": menu.index,
        "route": menu
      }
    }, [_c('i', {
      class: menu.icon
    }), _vm._v(" "), _c('span', {
      staticClass: "page-menu-item-title"
    }, [_vm._v("\n                            " + _vm._s(menu.title) + "\n                        ")]), _vm._v(" "), (menu.alarmCount && !_vm.collapse) ? _c('el-badge', {
      attrs: {
        "value": menu.alarmCount,
        "type": menu.name === 'unable_failover_jobs' ? 'warning' : 'danger'
      }
    }) : _vm._e()], 1)
  })], 2)], 1)])]), _vm._v(" "), _c('el-main', [_vm._t("default")], 2)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1413 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "运行中作业分片查看",
      "visible": _vm.isVisible,
      "before-close": _vm.closeDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.isVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "190px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Executor"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.runningAllocationInfo.executorName))])])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "运行中作业分片"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [(Object.entries(_vm.runningAllocationInfo.runningJobItems).length === 0) ? _c('div', [_vm._v("无")]) : _c('div', _vm._l((Object.entries(_vm.runningAllocationInfo.runningJobItems)), function(item) {
    return _c('el-tag', {
      key: item[0],
      staticClass: "form-tags",
      attrs: {
        "type": "success"
      }
    }, [_vm._v(_vm._s(item[0]) + " : " + _vm._s(item[1]))])
  }))])], 1), _vm._v(" "), _c('el-form-item', [_c('div', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('span', [_vm._v("可能运行中的作业分片")]), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "placement": "top",
      "content": "作业状态未上报，无法获知运行状态，例如消息作业和秒级作业",
      "effect": "light",
      "popper-class": "allocation-popper"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle"
  })])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 22
    }
  }, [(Object.entries(_vm.runningAllocationInfo.potentialRunningJobItems).length === 0) ? _c('div', [_vm._v("无")]) : _c('div', _vm._l((Object.entries(_vm.runningAllocationInfo.potentialRunningJobItems)), function(item) {
    return _c('el-tag', {
      key: item[0],
      staticClass: "form-tags",
      attrs: {
        "type": "warning"
      }
    }, [_vm._v(_vm._s(item[0]) + " : " + _vm._s(item[1]))])
  }))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.closeDialog()
      }
    }
  }, [_vm._v("取消")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1414 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._t("default", null, null, this), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [10, 25, 50, 100, 200, '所有'],
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.totalRecords
    },
    on: {
      "current-change": _vm.onCurrentChange,
      "size-change": _vm.onPageSize
    }
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 1415 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "title": _vm.oauthClientTitle,
      "width": "45%",
      "visible": _vm.isVisible,
      "before-close": _vm.closeDialog,
      "element-loading-text": "请稍等···"
    },
    on: {
      "update:visible": function($event) {
        _vm.isVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "oauthClientInfo",
    attrs: {
      "model": _vm.oauthClientInfo,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [(_vm.oauthClientOperate === 'add') ? _c('el-form-item', {
    attrs: {
      "label": "应用Id",
      "prop": "appId"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入应用Id",
      "disabled": !_vm.isEditable
    },
    model: {
      value: (_vm.oauthClientInfo.appId),
      callback: function($$v) {
        _vm.$set(_vm.oauthClientInfo, "appId", $$v)
      },
      expression: "oauthClientInfo.appId"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.oauthClientOperate === 'edit') ? _c('el-form-item', {
    attrs: {
      "label": "应用Id",
      "prop": "appId"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": !_vm.isEditable
    },
    model: {
      value: (_vm.oauthClientInfo.appId),
      callback: function($$v) {
        _vm.$set(_vm.oauthClientInfo, "appId", $$v)
      },
      expression: "oauthClientInfo.appId"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.oauthClientOperate === 'add') ? _c('el-form-item', {
    attrs: {
      "label": "应用Key",
      "prop": "appKey"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入应用Key",
      "disabled": !_vm.isEditable
    },
    model: {
      value: (_vm.oauthClientInfo.appKey),
      callback: function($$v) {
        _vm.$set(_vm.oauthClientInfo, "appKey", $$v)
      },
      expression: "oauthClientInfo.appKey"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.oauthClientOperate === 'edit') ? _c('el-form-item', {
    attrs: {
      "label": "应用Key",
      "prop": "appKey"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入应用Key"
    },
    model: {
      value: (_vm.oauthClientInfo.appKey),
      callback: function($$v) {
        _vm.$set(_vm.oauthClientInfo, "appKey", $$v)
      },
      expression: "oauthClientInfo.appKey"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.oauthClientOperate === 'add') ? _c('el-form-item', {
    attrs: {
      "label": "用户名",
      "prop": "adminName"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入管理员用户名",
      "disabled": !_vm.isEditable
    },
    model: {
      value: (_vm.oauthClientInfo.adminName),
      callback: function($$v) {
        _vm.$set(_vm.oauthClientInfo, "adminName", $$v)
      },
      expression: "oauthClientInfo.adminName"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.oauthClientOperate === 'edit') ? _c('el-form-item', {
    attrs: {
      "label": "用户名",
      "prop": "adminName"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入管理员用户名"
    },
    model: {
      value: (_vm.oauthClientInfo.adminName),
      callback: function($$v) {
        _vm.$set(_vm.oauthClientInfo, "adminName", $$v)
      },
      expression: "oauthClientInfo.adminName"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.oauthClientOperate === 'add') ? _c('el-form-item', {
    attrs: {
      "label": "密码",
      "prop": "adminPassword"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入管理员密码",
      "disabled": !_vm.isEditable
    },
    model: {
      value: (_vm.oauthClientInfo.adminPassword),
      callback: function($$v) {
        _vm.$set(_vm.oauthClientInfo, "adminPassword", $$v)
      },
      expression: "oauthClientInfo.adminPassword"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.oauthClientOperate === 'edit') ? _c('el-form-item', {
    attrs: {
      "label": "密码",
      "prop": "adminPassword"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入管理员密码"
    },
    model: {
      value: (_vm.oauthClientInfo.adminPassword),
      callback: function($$v) {
        _vm.$set(_vm.oauthClientInfo, "adminPassword", $$v)
      },
      expression: "oauthClientInfo.adminPassword"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.oauthClientOperate === 'add') ? _c('el-form-item', {
    attrs: {
      "label": "扩展参数",
      "prop": "extJson"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入扩展参数"
    },
    model: {
      value: (_vm.oauthClientInfo.extJson),
      callback: function($$v) {
        _vm.$set(_vm.oauthClientInfo, "extJson", $$v)
      },
      expression: "oauthClientInfo.extJson"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.oauthClientOperate === 'edit') ? _c('el-form-item', {
    attrs: {
      "label": "扩展参数",
      "prop": "extJson"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入扩展参数"
    },
    model: {
      value: (_vm.oauthClientInfo.extJson),
      callback: function($$v) {
        _vm.$set(_vm.oauthClientInfo, "extJson", $$v)
      },
      expression: "oauthClientInfo.extJson"
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.closeDialog()
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.handleSubmit()
      }
    }
  }, [_vm._v("确定")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1416 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "title": _vm.userInfoTitle,
      "width": "45%",
      "visible": _vm.isVisible,
      "before-close": _vm.closeDialog,
      "element-loading-text": "请稍等···"
    },
    on: {
      "update:visible": function($event) {
        _vm.isVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "userPasswordInfo",
    attrs: {
      "model": _vm.userPasswordInfo,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "当前密码",
      "prop": "password"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入当前的密码",
      "type": "password",
      "show-password": ""
    },
    model: {
      value: (_vm.userPasswordInfo.password),
      callback: function($$v) {
        _vm.$set(_vm.userPasswordInfo, "password", $$v)
      },
      expression: "userPasswordInfo.password"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "新密码",
      "prop": "newPassword"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "show-password": "",
      "placeholder": "请输入新的密码"
    },
    model: {
      value: (_vm.userPasswordInfo.newPassword),
      callback: function($$v) {
        _vm.$set(_vm.userPasswordInfo, "newPassword", $$v)
      },
      expression: "userPasswordInfo.newPassword"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "确认新密码",
      "prop": "newPassword2"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "show-password": "",
      "placeholder": "请再次输入新的密码"
    },
    model: {
      value: (_vm.userPasswordInfo.newPassword2),
      callback: function($$v) {
        _vm.$set(_vm.userPasswordInfo, "newPassword2", $$v)
      },
      expression: "userPasswordInfo.newPassword2"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.closeDialog()
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.handleSubmit()
      }
    }
  }, [_vm._v("确定")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1417 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": _vm.importTitle,
      "width": "40%",
      "visible": _vm.isVisible,
      "before-close": _vm.closeDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.isVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "下载模板文件"
    }
  }, [_c('a', {
    on: {
      "click": _vm.exportModel
    }
  }, [_vm._v("点击下载")]), _vm._v(" (请勿更改表头数据)\n        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "导入文件 "
    }
  }, [_c('div', [_c('el-upload', {
    ref: "upload",
    attrs: {
      "action": _vm.importUrl,
      "data": _vm.importData,
      "auto-upload": false,
      "multiple": false,
      "on-error": _vm.handleError,
      "on-success": _vm.handleSuccess
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "trigger",
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.handleUpload
    },
    slot: "trigger"
  }, [_vm._v("选取文件")]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v(_vm._s(_vm.importTip))])], 1)], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.closeDialog()
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.handleSubmit()
      }
    }
  }, [_vm._v("确定")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1418 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": "请稍等···"
    }
  }, [_c('div', {
    staticClass: "margin-20"
  }, [_c('FilterPageList', {
    ref: "pageListRef",
    attrs: {
      "data": _vm.userList,
      "total": _vm.total,
      "order-by": _vm.orderBy,
      "filters": _vm.filters
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-form', {
          staticClass: "table-filter",
          attrs: {
            "inline": true
          }
        }, [_c('input', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (false),
            expression: "false"
          }],
          attrs: {
            "type": "text"
          }
        }), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": ""
          }
        }, [_c('el-input', {
          attrs: {
            "placeholder": "请输入用户名"
          },
          nativeOn: {
            "keyup": function($event) {
              if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
              _vm.getUsersReq($event)
            }
          },
          model: {
            value: (_vm.backFilter.userName),
            callback: function($$v) {
              _vm.$set(_vm.backFilter, "userName", $$v)
            },
            expression: "backFilter.userName"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "icon": "el-icon-search"
          },
          on: {
            "click": _vm.getUsersReq
          }
        }, [_vm._v("查询")])], 1)], 1), _vm._v(" "), _c('div', {
          staticClass: "page-table"
        }, [_c('div', {
          staticClass: "page-table-header"
        }, [_c('div', {
          staticClass: "page-table-header-title"
        }, [_c('i', {
          staticClass: "fa fa-list"
        }), _vm._v("用户列表\n                            "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": _vm.getUsersReq
          }
        }, [_c('i', {
          staticClass: "fa fa-refresh"
        })])], 1), _vm._v(" "), _c('div', {
          staticClass: "pull-right"
        })]), _vm._v(" "), _c('el-table', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "stripe": "",
            "border": "",
            "data": scope.pageData
          },
          on: {
            "sort-change": scope.onSortChange
          }
        }, [_c('el-table-column', {
          attrs: {
            "prop": "userName",
            "label": "用户名"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "authenticationKey",
            "label": "动态秘钥"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "createdBy",
            "label": "创建者"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "createTime",
            "label": "创建时间"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n                                " + _vm._s(_vm._f("formatDate")(scope.row.createTime)) + "\n                            ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "lastUpdateTime",
            "label": "更新时间"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n                                " + _vm._s(_vm._f("formatDate")(scope.row.lastUpdateTime)) + "\n                            ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "操作",
            "width": "100px",
            "align": "center"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('el-tooltip', {
                attrs: {
                  "content": "重置动态秘钥",
                  "placement": "top"
                }
              }, [_c('el-button', {
                attrs: {
                  "type": "text",
                  "icon": "el-icon-edit"
                },
                on: {
                  "click": function($event) {
                    _vm.handleResetAuthenticationKey(scope.row)
                  }
                }
              })], 1), _vm._v(" "), _c('el-tooltip', {
                attrs: {
                  "content": "重置密码",
                  "placement": "top"
                }
              }, [_c('el-button', {
                attrs: {
                  "type": "text",
                  "icon": "el-icon-refresh"
                },
                on: {
                  "click": function($event) {
                    _vm.handleReset(scope.row)
                  }
                }
              })], 1), _vm._v(" "), _c('el-tooltip', {
                attrs: {
                  "content": "删除",
                  "placement": "top"
                }
              }, [_c('el-button', {
                attrs: {
                  "type": "text",
                  "icon": "el-icon-delete text-danger"
                },
                on: {
                  "click": function($event) {
                    _vm.handleDelete(scope.row)
                  }
                }
              })], 1)]
            }
          }])
        })], 1)], 1)]
      }
    }])
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1419 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-container', {
    staticClass: "my-container"
  }, [_c('el-header', {
    attrs: {
      "height": "50px"
    }
  }, [_c('VHeader')], 1), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 1420 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": _vm.title,
      "visible": _vm.isVisible,
      "before-close": _vm.closeDialog,
      "custom-class": "view-content"
    },
    on: {
      "update:visible": function($event) {
        _vm.isVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "view-content-body"
  }, [_c('pre', [_vm._v(_vm._s(_vm.content))])])])
},staticRenderFns: []}

/***/ }),
/* 1421 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": _vm.migrateStatusTitle,
      "width": "45%",
      "visible": _vm.isVisible,
      "before-close": _vm.closeDialog,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.isVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "migrateStatusInfo",
    attrs: {
      "model": _vm.migrateStatusInfo,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "迁移量"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-tag', {
    staticClass: "form-tags",
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("总共 : " + _vm._s(_vm.migrateStatusInfo.totalCount))]), _vm._v(" "), _c('el-tag', {
    staticClass: "form-tags",
    attrs: {
      "type": "success"
    }
  }, [_vm._v("成功 : " + _vm._s(_vm.migrateStatusInfo.successCount))]), _vm._v(" "), _c('el-tag', {
    staticClass: "form-tags",
    attrs: {
      "type": "danger"
    }
  }, [_vm._v("失败 : " + _vm._s(_vm.migrateStatusInfo.failCount))]), _vm._v(" "), _c('el-tag', {
    staticClass: "form-tags",
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("忽略 : " + _vm._s(_vm.migrateStatusInfo.ignoreCount))]), _vm._v(" "), _c('el-tag', {
    staticClass: "form-tags",
    attrs: {
      "type": ""
    }
  }, [_vm._v("未做 : " + _vm._s(_vm.migrateStatusInfo.unDoCount))])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "正在迁移"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "readonly": ""
    },
    model: {
      value: (_vm.migrateStatusInfo.moving),
      callback: function($$v) {
        _vm.$set(_vm.migrateStatusInfo, "moving", $$v)
      },
      expression: "migrateStatusInfo.moving"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('div', [_vm._v("注：忽略的域，指该域已经处于目标集群")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.migrateStatusInfo.finished
    },
    on: {
      "click": function($event) {
        _vm.closeDialog()
      }
    }
  }, [_vm._v("完成")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1422 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.initialized || _vm.initComponent === 'Login') ? [_c(_vm.initComponent, {
    tag: "component",
    on: {
      "login-success": _vm.loginSuccess
    }
  })] : [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "fullscreen": true
      }
    }],
    attrs: {
      "element-loading-text": "正在初始化应用，请稍等···"
    }
  })]], 2)
},staticRenderFns: []}

/***/ }),
/* 1423 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": "请稍等···"
    }
  }, [_c('div', {
    staticClass: "page-container"
  }, [_c('UnableFailoverJobs', {
    attrs: {
      "unable-failover-jobs-list": _vm.namespaceUnableFailoverJobsList
    },
    on: {
      "refresh-list": _vm.getUnableFailoverJobs
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1424 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('VAside', {
    attrs: {
      "sidebar-menus": _vm.sidebarMenus,
      "headerHeight": "50"
    }
  }, [_c('router-view', {
    staticStyle: {
      "margin": "20px"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1425 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": "请稍等···"
    }
  }, [_c('div', {
    staticClass: "page-container"
  }, [_c('AbnormalJobs', {
    attrs: {
      "abnormal-jobs-list": _vm.abnormalJobsList
    },
    on: {
      "refresh-list": _vm.getAbnormalJobs,
      "no-alarm": _vm.noAlarm
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1426 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": "请稍等···"
    }
  }, [_c('div', {
    staticClass: "page-container"
  }, [_c('UnableFailoverJobs', {
    attrs: {
      "unable-failover-jobs-list": _vm.unableFailoverJobsList
    },
    on: {
      "refresh-list": _vm.getUnableFailoverJobs
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1427 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "margin-20"
  }, [(_vm.abnormalJob === '' && _vm.timeoutJob === '' && _vm.unableFailoverJob === '') ? _c('div', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "job-alarm-empty"
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-info-circle"
  }), _vm._v("当前没有告警信息")])])])], 1) : _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": "请稍等···"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [(_vm.abnormalJob !== '') ? _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Panel', {
    staticClass: "job-alarm-panel",
    attrs: {
      "type": "warning"
    }
  }, [_c('div', {
    staticClass: "job-alarm-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("异常告警")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "job-alarm-content"
  }, [_c('div', {
    staticClass: "panel-row"
  }, [_vm._v(_vm._s(_vm.abnormalJob.nextFireTimeWithTimeZoneFormat))]), _vm._v(" "), _c('div', {
    staticClass: "panel-row"
  }, [_vm._v(_vm._s(_vm.$map.causeMap[_vm.abnormalJob.cause]))]), _vm._v(" "), (_vm.$common.hasPerm('alarmCenter:setAbnormalJobRead', _vm.domainName)) ? _c('div', {
    staticClass: "panel-btn"
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.abnormalJob.read,
      "size": "small",
      "type": "warning"
    },
    on: {
      "click": function($event) {
        _vm.handleAbnormalJob()
      }
    }
  }, [_vm._v("不再告警")])], 1) : _vm._e()])])])], 1) : _vm._e(), _vm._v(" "), (_vm.timeoutJob !== '') ? _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Panel', {
    staticClass: "job-alarm-panel",
    attrs: {
      "type": "warning"
    }
  }, [_c('div', {
    staticClass: "job-alarm-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("超时告警")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "job-alarm-content"
  }, [_c('div', {
    staticClass: "panel-row"
  }, [_vm._v("超时秒数: " + _vm._s(_vm.timeoutJob.timeout4AlarmSeconds) + "s")]), _vm._v(" "), _c('div', {
    staticClass: "panel-row"
  }, [_vm._v("超时分片: " + _vm._s(_vm.timeoutJob.timeoutItems))]), _vm._v(" "), (_vm.$common.hasPerm('alarmCenter:setTimeout4AlarmJobRead', _vm.domainName)) ? _c('div', {
    staticClass: "panel-btn"
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.timeoutJob.read,
      "size": "small",
      "type": "warning"
    },
    on: {
      "click": function($event) {
        _vm.handleTimeoutJob()
      }
    }
  }, [_vm._v("不再告警")])], 1) : _vm._e()])])])], 1) : _vm._e(), _vm._v(" "), (_vm.unableFailoverJob !== '') ? _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Panel', {
    staticClass: "job-alarm-panel",
    attrs: {
      "type": "warning"
    }
  }, [_c('div', {
    staticClass: "job-alarm-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("无法高可用告警")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "job-alarm-content"
  }, [_c('div', {
    staticClass: "panel-row"
  }, [_vm._v("域等级: " + _vm._s(_vm.$map.degreeMap[_vm.unableFailoverJob.degree]))]), _vm._v(" "), _c('div', {
    staticClass: "panel-row"
  }, [_vm._v("作业等级: " + _vm._s(_vm.$map.degreeMap[_vm.unableFailoverJob.jobDegree]))])])])])], 1) : _vm._e()], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1428 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('FilterPageList', {
    attrs: {
      "data": _vm.abnormalContainersList,
      "total": _vm.total,
      "order-by": _vm.orderBy,
      "filters": _vm.filters
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-form', {
          staticClass: "table-filter",
          attrs: {
            "inline": true
          }
        }, [_c('input', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (false),
            expression: "false"
          }],
          attrs: {
            "type": "text"
          }
        }), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": ""
          }
        }, [_c('el-input', {
          attrs: {
            "placeholder": "请输入容器名"
          },
          nativeOn: {
            "keyup": function($event) {
              if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
              scope.search($event)
            }
          },
          model: {
            value: (_vm.filters.taskId.value),
            callback: function($$v) {
              _vm.$set(_vm.filters.taskId, "value", $$v)
            },
            expression: "filters.taskId.value"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "icon": "el-icon-search"
          },
          on: {
            "click": scope.search
          }
        }, [_vm._v("查询")])], 1)], 1), _vm._v(" "), _c('div', {
          staticClass: "page-table"
        }, [_c('div', {
          staticClass: "page-table-header"
        }, [_c('div', {
          staticClass: "page-table-header-title"
        }, [_c('i', {
          staticClass: "fa fa-list"
        }), _vm._v("异常容器\n                    "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": _vm.refreshList
          }
        }, [_c('i', {
          staticClass: "fa fa-refresh"
        })])], 1)]), _vm._v(" "), _c('el-table', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "stripe": "",
            "border": "",
            "data": scope.pageData
          },
          on: {
            "sort-change": scope.onSortChange
          }
        }, [_c('el-table-column', {
          attrs: {
            "prop": "taskId",
            "label": "容器名"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "domainName",
            "label": "所属域",
            "sortable": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('router-link', {
                attrs: {
                  "tag": "a",
                  "to": {
                    name: 'job_overview',
                    params: {
                      domain: scope.row.domainName
                    }
                  }
                }
              }, [_c('el-button', {
                attrs: {
                  "type": "text"
                }
              }, [_vm._v("\n                                " + _vm._s(scope.row.domainName) + "\n                            ")])], 1)]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "degree",
            "label": "域等级",
            "sortable": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n                        " + _vm._s(_vm.$map.degreeMap[scope.row.degree]) + "\n                    ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "cause",
            "label": "异常原因"
          }
        })], 1)], 1)]
      }
    }])
  })
},staticRenderFns: []}

/***/ }),
/* 1429 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "title": "批量选择优先Executors",
      "element-loading-text": "请稍等···",
      "visible": _vm.isVisible,
      "before-close": _vm.closeDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.isVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "140px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "作业名称",
      "prop": "type"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 18
    }
  }, _vm._l((_vm.jobNamesArray), function(item) {
    return _c('el-tag', {
      key: item,
      staticClass: "form-tags",
      attrs: {
        "type": "success"
      }
    }, [_vm._v(_vm._s(item))])
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "优先Executors",
      "prop": "jobName"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "size": "small",
      "filterable": "",
      "multiple": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.selectedExecutors),
      callback: function($$v) {
        _vm.selectedExecutors = $$v
      },
      expression: "selectedExecutors"
    }
  }, _vm._l((_vm.onlineExecutors), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.value,
        "value": item.value
      }
    }, [_c('span', {
      staticStyle: {
        "float": "left"
      }
    }, [_vm._v(_vm._s(item.value))]), _vm._v(" "), (item.container) ? _c('span', {
      staticStyle: {
        "float": "left"
      }
    }, [_vm._v(" (容器组)")]) : _vm._e()])
  }))], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.closeDialog()
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.handleSubmit()
      }
    }
  }, [_vm._v("确定")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1430 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": "请稍等···"
    }
  }, [_c('div', {
    staticClass: "margin-20"
  }, [_c('FilterPageList', {
    attrs: {
      "data": _vm.namespaceList,
      "total": _vm.total,
      "order-by": _vm.orderBy,
      "filters": _vm.filters
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-form', {
          staticClass: "table-filter",
          attrs: {
            "inline": true
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": ""
          }
        }, [_c('el-select', {
          on: {
            "change": scope.search
          },
          model: {
            value: (_vm.filters.zkAlias.value),
            callback: function($$v) {
              _vm.$set(_vm.filters.zkAlias, "value", $$v)
            },
            expression: "filters.zkAlias.value"
          }
        }, [_c('el-option', {
          attrs: {
            "label": "全部ZK集群",
            "value": ""
          }
        }), _vm._v(" "), _vm._l((_vm.zkClusterKeys), function(item) {
          return _c('el-option', {
            key: item.zkAlias,
            attrs: {
              "label": item.zkAlias,
              "value": item.zkAlias
            }
          })
        })], 2)], 1), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": ""
          }
        }, [_c('el-input', {
          attrs: {
            "placeholder": "请输入域名"
          },
          nativeOn: {
            "keyup": function($event) {
              if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
              scope.search($event)
            }
          },
          model: {
            value: (_vm.filters.namespace.value),
            callback: function($$v) {
              _vm.$set(_vm.filters.namespace, "value", $$v)
            },
            expression: "filters.namespace.value"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "icon": "el-icon-search"
          },
          on: {
            "click": scope.search
          }
        }, [_vm._v("查询")])], 1)], 1), _vm._v(" "), _c('div', {
          staticClass: "page-table"
        }, [_c('div', {
          staticClass: "page-table-header"
        }, [_c('div', {
          staticClass: "page-table-header-title"
        }, [_c('i', {
          staticClass: "fa fa-list"
        }), _vm._v("域信息\n                            "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": _vm.getAllNamespace
          }
        }, [_c('i', {
          staticClass: "fa fa-refresh"
        })])], 1), _vm._v(" "), _c('div', {
          staticClass: "page-table-header-separator"
        }), _vm._v(" "), _c('div', [(_vm.$common.hasPerm('registryCenter:batchMoveNamespaces')) ? _c('el-button', {
          on: {
            "click": function($event) {
              _vm.batchMigrate()
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-play-circle text-btn"
        }), _vm._v("批量迁移")]) : _vm._e(), _vm._v(" "), (_vm.$common.hasPerm('registryCenter:exportNamespaces')) ? _c('el-button', {
          on: {
            "click": function($event) {
              _vm.handleExport()
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-arrow-circle-o-up text-btn"
        }), _vm._v("导出")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
          staticClass: "pull-right"
        }, [(_vm.$common.hasPerm('registryCenter:addNamespace')) ? _c('el-button', {
          on: {
            "click": function($event) {
              _vm.handleAdd()
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-plus-circle text-btn"
        }), _vm._v("添加域")]) : _vm._e(), _vm._v(" "), (_vm.$common.hasPerm('registryCenter:addNamespace')) ? _c('el-button', {
          on: {
            "click": function($event) {
              _vm.handleRefreshCenter()
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-refresh text-btn"
        }), _vm._v("刷新注册中心")]) : _vm._e()], 1)]), _vm._v(" "), _c('el-table', {
          ref: "multipleTable",
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "stripe": "",
            "border": "",
            "data": scope.pageData
          },
          on: {
            "selection-change": _vm.handleSelectionChange,
            "sort-change": scope.onSortChange
          }
        }, [_c('el-table-column', {
          attrs: {
            "type": "selection",
            "width": "55"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "namespace",
            "label": "域名",
            "min-width": "110px",
            "sortable": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('router-link', {
                attrs: {
                  "tag": "a",
                  "to": {
                    name: 'job_overview',
                    params: {
                      domain: scope.row.namespace
                    }
                  }
                }
              }, [_c('el-button', {
                attrs: {
                  "type": "text"
                }
              }, [_vm._v("\n                                        " + _vm._s(scope.row.namespace) + "\n                                    ")])], 1)]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "name",
            "label": "描述"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "degree",
            "label": "重要等级",
            "sortable": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n                                " + _vm._s(_vm.$map.degreeMap[scope.row.degree]) + "\n                            ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "version",
            "label": "Executor版本",
            "sortable": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "zkAlias",
            "label": "ZK集群名称",
            "sortable": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('el-tooltip', {
                attrs: {
                  "placement": "top"
                }
              }, [_c('div', {
                attrs: {
                  "slot": "content"
                },
                slot: "content"
              }, [_vm._v(_vm._s(scope.row.zkAddressList))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.zkAlias))])])]
            }
          }])
        })], 1)], 1)]
      }
    }])
  }), _vm._v(" "), (_vm.isNamespaceVisible) ? _c('div', [_c('namespace-info-dialog', {
    attrs: {
      "namespace-info": _vm.namespaceInfo,
      "zk-cluster-keys": _vm.zkClusterKeys
    },
    on: {
      "close-dialog": _vm.closeInfoDialog,
      "namespace-info-success": _vm.namespaceInfoSuccess
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isBatchMigrateVisible) ? _c('div', [_c('batch-migrate-dialog', {
    attrs: {
      "batch-migrate-info": _vm.batchMigrateInfo,
      "zk-cluster-keys": _vm.zkClusterKeys
    },
    on: {
      "batch-migrate-complete": _vm.batchMigrateComplete,
      "close-dialog": _vm.closeMigrateDialog
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isMigrateStatusVisible) ? _c('div', [_c('migrate-status-dialog', {
    attrs: {
      "migrate-status-title": _vm.migrateStatusTitle
    },
    on: {
      "close-dialog": _vm.closeMigrateStatusDialog
    }
  })], 1) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 1431 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "margin-20"
  }, [_c('div', {
    staticClass: "page-container"
  }, [_c('FilterPageList', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.tableLoading),
      expression: "tableLoading"
    }],
    ref: "pageListRef",
    attrs: {
      "get-data": _vm.getJobHistory,
      "total": _vm.total,
      "order-by": _vm.orderBy,
      "filters": _vm.filters,
      "element-loading-text": "请稍等···"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-form', {
          staticClass: "table-filter",
          attrs: {
            "inline": true
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": ""
          }
        }, [_c('el-select', {
          staticStyle: {
            "width": "140px"
          },
          on: {
            "change": scope.search
          },
          model: {
            value: (_vm.filters.jobResult.value),
            callback: function($$v) {
              _vm.$set(_vm.filters.jobResult, "value", $$v)
            },
            expression: "filters.jobResult.value"
          }
        }, [_c('el-option', {
          attrs: {
            "label": "全部状态",
            "value": ""
          }
        }), _vm._v(" "), _vm._l((_vm.jobResults), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        })], 2)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "icon": "fa fa-repeat"
          },
          on: {
            "click": function($event) {
              _vm.selectColumnChange();
              scope.search()
            }
          }
        }, [_vm._v("重置")])], 1)], 1), _vm._v(" "), _c('div', {
          directives: [{
            name: "loading",
            rawName: "v-loading",
            value: (_vm.loading),
            expression: "loading"
          }],
          staticClass: "page-table",
          attrs: {
            "element-loading-text": "请稍等···"
          }
        }, [_c('div', {
          staticClass: "page-table-header"
        }, [_c('div', {
          staticClass: "page-table-header-title"
        }, [_c('i', {
          staticClass: "fa fa-list"
        }), _vm._v("作业执行日志列表\n                            "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": scope.search
          }
        }, [_c('i', {
          staticClass: "fa fa-refresh"
        })])], 1), _vm._v(" "), _c('div', {
          staticClass: "page-table-header-separator"
        }), _vm._v(" "), _c('div', [(_vm.$common.hasPerm('job:batchRemove', _vm.domainName)) ? _c('el-button', {
          on: {
            "click": function($event) {
              _vm.batchDelete()
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash text-danger"
        }), _vm._v("删除")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
          staticClass: "pull-right"
        })]), _vm._v(" "), _c('el-table', {
          ref: "multipleTable",
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "stripe": "",
            "border": "",
            "data": _vm.JobHistoryList
          },
          on: {
            "selection-change": _vm.handleSelectionChange,
            "sort-change": scope.onSortChange
          }
        }, [_c('el-table-column', {
          attrs: {
            "type": "selection"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "topic",
            "label": "自定义参数",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n                                " + _vm._s(scope.row.jobParameter) + "\n                            ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "execTime",
            "label": "执行耗时 秒",
            "width": "100px"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n                                " + _vm._s(scope.row.execTime) + "\n                            ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "状态",
            "prop": "jobResult",
            "width": "90px"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('el-tag', {
                attrs: {
                  "type": scope.row.jobResult === true ? 'success' : 'warning',
                  "close-transition": ""
                }
              }, [_vm._v(_vm._s(_vm.translateJobResult[scope.row.jobResult]))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "作业执行时间",
            "prop": "createTime",
            "width": "160px"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n                                " + _vm._s(_vm._f("formatDate")(scope.row.createTime)) + "\n                            ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "jobResultReason",
            "show-overflow-tooltip": "",
            "label": "失败原因"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v(" \n                                " + _vm._s(scope.row.jobResultReason) + "\n                            ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "操作",
            "width": "120px",
            "align": "center"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('el-tooltip', {
                attrs: {
                  "content": "删除",
                  "placement": "top"
                }
              }, [_c('el-button', {
                attrs: {
                  "type": "text",
                  "icon": "el-icon-delete text-danger"
                },
                on: {
                  "click": function($event) {
                    _vm.handleDelete(scope.row)
                  }
                }
              })], 1)]
            }
          }])
        })], 1)], 1)]
      }
    }])
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1432 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "title": "添加新域",
      "width": "35%",
      "visible": _vm.isVisible,
      "before-close": _vm.closeDialog,
      "element-loading-text": "请稍等···"
    },
    on: {
      "update:visible": function($event) {
        _vm.isVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "namespaceInfo",
    attrs: {
      "model": _vm.namespaceInfo,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "zk集群",
      "prop": "zkClusterKey"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.namespaceInfo.zkClusterKey),
      callback: function($$v) {
        _vm.$set(_vm.namespaceInfo, "zkClusterKey", $$v)
      },
      expression: "namespaceInfo.zkClusterKey"
    }
  }, _vm._l((_vm.onLineClusters), function(item) {
    return _c('el-option', {
      key: item.zkClusterKey,
      attrs: {
        "label": item.zkAlias,
        "value": item.zkClusterKey
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "域名",
      "prop": "namespace"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.namespaceInfo.namespace),
      callback: function($$v) {
        _vm.$set(_vm.namespaceInfo, "namespace", $$v)
      },
      expression: "namespaceInfo.namespace"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.closeDialog()
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.handleSubmit()
      }
    }
  }, [_vm._v("确定")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1433 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": "请稍等···"
    }
  }, [_c('div', {
    staticClass: "margin-20"
  }, [_c('FilterPageList', {
    attrs: {
      "data": _vm.zkClusterList,
      "total": _vm.total,
      "order-by": _vm.orderBy,
      "filters": _vm.filters
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-form', {
          staticClass: "table-filter",
          attrs: {
            "inline": true
          }
        }, [_c('input', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (false),
            expression: "false"
          }],
          attrs: {
            "type": "text"
          }
        }), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": ""
          }
        }, [_c('el-input', {
          attrs: {
            "placeholder": "请输入集群ID"
          },
          nativeOn: {
            "keyup": function($event) {
              if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
              scope.search($event)
            }
          },
          model: {
            value: (_vm.filters.zkClusterKey.value),
            callback: function($$v) {
              _vm.$set(_vm.filters.zkClusterKey, "value", $$v)
            },
            expression: "filters.zkClusterKey.value"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "icon": "el-icon-search"
          },
          on: {
            "click": scope.search
          }
        }, [_vm._v("查询")])], 1)], 1), _vm._v(" "), _c('div', {
          staticClass: "page-table"
        }, [_c('div', {
          staticClass: "page-table-header"
        }, [_c('div', {
          staticClass: "page-table-header-title"
        }, [_c('i', {
          staticClass: "fa fa-list"
        }), _vm._v("ZK集群信息\n                            "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": _vm.getAllClusters
          }
        }, [_c('i', {
          staticClass: "fa fa-refresh"
        })])], 1), _vm._v(" "), _c('div', {
          staticClass: "pull-right"
        }, [(_vm.$common.hasPerm('registryCenter:addZkCluster')) ? _c('el-button', {
          on: {
            "click": function($event) {
              _vm.handleAdd()
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-plus-circle text-btn"
        }), _vm._v("添加集群")]) : _vm._e()], 1)]), _vm._v(" "), _c('el-table', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "stripe": "",
            "border": "",
            "data": scope.pageData
          },
          on: {
            "sort-change": scope.onSortChange
          }
        }, [_c('el-table-column', {
          attrs: {
            "prop": "zkClusterKey",
            "label": "ID",
            "width": "150px",
            "sortable": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "zkAlias",
            "label": "名称",
            "width": "150px"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "offline",
            "label": "状态",
            "width": "100px"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('el-tag', {
                attrs: {
                  "type": scope.row.offline ? '' : 'success',
                  "close-transition": ""
                }
              }, [_vm._v(_vm._s(_vm.statusMap[scope.row.offline]))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "description",
            "label": "描述",
            "show-overflow-tooltip": true
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "zkAddr",
            "label": "连接串",
            "show-overflow-tooltip": true
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "操作",
            "width": "80px",
            "align": "center"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(_vm.$common.hasPerm('registryCenter:addZkCluster')) ? _c('el-tooltip', {
                attrs: {
                  "content": "编辑",
                  "placement": "top"
                }
              }, [_c('el-button', {
                attrs: {
                  "type": "text",
                  "icon": "el-icon-edit"
                },
                on: {
                  "click": function($event) {
                    _vm.handleEdit(scope.row)
                  }
                }
              })], 1) : _vm._e()]
            }
          }])
        })], 1)], 1)]
      }
    }])
  }), _vm._v(" "), (_vm.isClusterVisible) ? _c('div', [_c('cluster-info-dialog', {
    attrs: {
      "cluster-info": _vm.clusterInfo,
      "cluster-info-title": _vm.clusterInfoTitle,
      "cluster-info-operate": _vm.clusterInfoOperate
    },
    on: {
      "cluster-info-success": _vm.clusterInfoSuccess,
      "close-dialog": _vm.closeInfoDialog
    }
  })], 1) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 1434 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('div', {
    staticClass: "tm-info"
  }, [_c('div', {
    staticClass: "tm-item"
  }, [_vm._t("title")], 2), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('time', {
    staticClass: "tm-datetime"
  }, [_vm._t("date")], 2)]), _vm._v(" "), _c('div', {
    staticClass: "tm-box"
  }, [_vm._t("content")], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tm-icon"
  }, [_c('i', {
    staticClass: "el-icon-time"
  })])
}]}

/***/ }),
/* 1435 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard-content"
  }, [_c('el-card', [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticStyle: {
      "font-size": "23px"
    }
  }, [_c('i', {
    staticClass: "fa fa-pie-chart"
  }), _vm._v("Dashboard")]), _vm._v(" "), _c('el-select', {
    staticClass: "pull-right",
    attrs: {
      "size": "small"
    },
    on: {
      "change": _vm.clusterChange
    },
    model: {
      value: (_vm.clusterKey),
      callback: function($$v) {
        _vm.clusterKey = $$v
      },
      expression: "clusterKey"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部集群",
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.onlineClusterkeys), function(item) {
    return _c('el-option', {
      key: item.zkClusterKey,
      attrs: {
        "label": item.zkAlias,
        "value": item.zkClusterKey
      }
    })
  })], 2)], 1), _vm._v(" "), _c('div', [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('CardPanel', {
    attrs: {
      "type": "green",
      "icon": "fa fa-life-ring",
      "title": "总域数",
      "num": _vm.domainCount,
      "to-url": "domain_statistic",
      "url-query": _vm.clusterKey
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('CardPanel', {
    attrs: {
      "type": "yellow",
      "icon": "fa fa-server",
      "title": "Executor数: 物理机+容器",
      "num": _vm.executorCount,
      "to-url": "executor_statistic",
      "url-query": _vm.clusterKey
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('CardPanel', {
    attrs: {
      "type": "primary",
      "icon": "fa fa-list-alt",
      "title": "总作业数",
      "num": _vm.jobCount,
      "to-url": "job_statistic",
      "url-query": _vm.clusterKey
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24,
      "lg": 24,
      "xl": 12
    }
  }, [_c('Chart-container', {
    attrs: {
      "title": "历史总域数",
      "type": "line"
    }
  }, [_c('div', {
    attrs: {
      "slot": "chart"
    },
    slot: "chart"
  }, [_c('MyLine', {
    attrs: {
      "id": "domainCountHistory",
      "option-info": _vm.domainCountOptionInfo
    }
  })], 1)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24,
      "lg": 24,
      "xl": 12
    }
  }, [_c('Chart-container', {
    attrs: {
      "title": "历史Executor数",
      "type": "line"
    }
  }, [_c('div', {
    attrs: {
      "slot": "chart"
    },
    slot: "chart"
  }, [_c('MyLine', {
    attrs: {
      "id": "executorCountHistory",
      "option-info": _vm.executorCountOptionInfo
    }
  })], 1)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24,
      "lg": 24,
      "xl": 12
    }
  }, [_c('Chart-container', {
    attrs: {
      "title": "历史作业数",
      "type": "line"
    }
  }, [_c('div', {
    attrs: {
      "slot": "chart"
    },
    slot: "chart"
  }, [_c('MyLine', {
    attrs: {
      "id": "jobCountHistory",
      "option-info": _vm.jobCountOptionInfo
    }
  })], 1)])], 1)], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1436 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "300px"
    },
    attrs: {
      "id": _vm.id
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 1437 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "预测",
      "width": "500px",
      "visible": _vm.isVisible,
      "before-close": _vm.closeDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.isVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "180px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "检验结果"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-tag', {
    staticClass: "form-tags",
    attrs: {
      "type": _vm.result === '成功' ? 'success' : 'danger'
    }
  }, [_vm._v(_vm._s(_vm.result))])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "作业时区"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_vm._v("\n                " + _vm._s(_vm.cronPredictInfo.timeZone) + "\n            ")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "预测执行时间点"
    }
  }, _vm._l((_vm.cronPredictInfo.nextFireTimes), function(item) {
    return _c('el-tag', {
      key: item,
      staticClass: "form-tags",
      attrs: {
        "type": ""
      }
    }, [_vm._v(_vm._s(item))])
  }))], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1438 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": "请稍等···"
    }
  }, [_c('div', {
    staticClass: "page-container"
  }, [_c('AbnormalJobs', {
    attrs: {
      "abnormal-jobs-list": _vm.namespaceAbnormalJobsList
    },
    on: {
      "refresh-list": _vm.getAbnormalJobs,
      "no-alarm": _vm.noAlarm
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1439 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "page-content",
    attrs: {
      "element-loading-text": "请稍等···"
    }
  }, [_c('el-form', {
    ref: "jobSettingInfo",
    attrs: {
      "model": _vm.jobSettingInfo,
      "rules": _vm.rules,
      "label-width": "140px"
    }
  }, [(_vm.$common.hasPerm('job:update', _vm.domainName)) ? _c('el-button', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "type": "primary",
      "disabled": _vm.jobSettingInfo.enabled
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.updateInfo($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-database"
  }), _vm._v("更新")]) : _vm._e(), _vm._v(" "), _c('el-collapse', {
    model: {
      value: (_vm.activeNames),
      callback: function($$v) {
        _vm.activeNames = $$v
      },
      expression: "activeNames"
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "name": "1"
    }
  }, [_c('template', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("\n                    基本配置\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "job-setting-content"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "jobType",
      "label": "作业类型"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.jobSettingInfo.jobType),
      callback: function($$v) {
        _vm.$set(_vm.jobSettingInfo, "jobType", $$v)
      },
      expression: "jobSettingInfo.jobType"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.$option.isJava(_vm.jobSettingInfo.jobType)) ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "jobClass",
      "label": "作业实现类"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.jobSettingInfo.jobClass),
      callback: function($$v) {
        _vm.$set(_vm.jobSettingInfo, "jobClass", $$v)
      },
      expression: "jobSettingInfo.jobClass"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$option.isCron(_vm.jobSettingInfo.jobType)) ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "cron",
      "label": "Cron"
    }
  }, [_c('el-tooltip', {
    attrs: {
      "popper-class": "form-tooltip",
      "content": "作业启动时间的cron表达式。如每10秒运行:*/10****?,每5分钟运行:0*/5***?",
      "placement": "bottom"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.jobSettingInfo.cron),
      callback: function($$v) {
        _vm.$set(_vm.jobSettingInfo, "cron", $$v)
      },
      expression: "jobSettingInfo.cron"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append"
    },
    on: {
      "click": _vm.checkAndForecastCron
    },
    slot: "append"
  }, [_vm._v("预测")])], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-annotation"
  }, [_c('span', [_vm._v("1. 每10秒运行一次的表达式：*/10 * * * * ?")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("2. 每分钟运行一次的表达式：0 * * * * ?")])])], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [(!_vm.jobSettingInfo.localMode) ? _c('el-form-item', {
    attrs: {
      "prop": "shardingTotalCount",
      "label": "作业分片数"
    }
  }, [(_vm.jobSettingInfo.downStream) ? _c('el-tooltip', {
    attrs: {
      "popper-class": "form-tooltip",
      "placement": "bottom"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('span', [_vm._v(_vm._s(_vm.jobSettingInfo.downStream.length > 0 ? '该作业有下游作业，作业分片数必须为1' : '作业分片数'))])]), _vm._v(" "), _c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.jobSettingInfo.downStream.length > 0,
      "controls-position": "right",
      "min": 1
    },
    model: {
      value: (_vm.jobSettingInfo.shardingTotalCount),
      callback: function($$v) {
        _vm.$set(_vm.jobSettingInfo, "shardingTotalCount", $$v)
      },
      expression: "jobSettingInfo.shardingTotalCount"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.jobSettingInfo.localMode) ? _c('el-form-item', {
    attrs: {
      "prop": "shardingTotalCount",
      "label": "作业分片数"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "value": "N/A",
      "disabled": ""
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "localMode",
      "label": "本地模式"
    }
  }, [(_vm.jobSettingInfo.downStream) ? _c('el-tooltip', {
    attrs: {
      "popper-class": "form-tooltip",
      "placement": "bottom"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('span', [_vm._v(_vm._s(_vm.jobSettingInfo.downStream.length > 0 ? '该作业有下游作业，不可选为本地模式' : '本地模式'))])]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "disabled": _vm.jobSettingInfo.downStream.length > 0
    },
    model: {
      value: (_vm.jobSettingInfo.localMode),
      callback: function($$v) {
        _vm.$set(_vm.jobSettingInfo, "localMode", $$v)
      },
      expression: "jobSettingInfo.localMode"
    }
  })], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), (_vm.$option.isMsg(_vm.jobSettingInfo.jobType)) ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "queueName",
      "label": "Queue名"
    }
  }, [_c('el-tooltip', {
    attrs: {
      "popper-class": "form-tooltip",
      "placement": "bottom"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                                        消息类型job的queue名\n                                    ")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.jobSettingInfo.queueName),
      callback: function($$v) {
        _vm.$set(_vm.jobSettingInfo, "queueName", $$v)
      },
      expression: "jobSettingInfo.queueName"
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "shardingItemParameters",
      "label": "分片参数"
    }
  }, [_c('el-tooltip', {
    attrs: {
      "popper-class": "form-tooltip",
      "placement": "bottom"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                                        分片序列号和参数用等号分隔，多个键值对用逗号分隔 。分片序列号从0开始，不可大于或等于作业分片总数。如：0=a,1=b,2=c;"), _c('br'), _vm._v("\n                                        英文双引号请使用!!代替，英文等号请使用@@代替，英文逗号请使用##代替。"), _c('br'), _vm._v("\n                                        如果作业所有分片无须参数，则只要保持值为0。例如有2个分片无须参数，则为“0=0,1=0”。"), _c('br'), _vm._v("\n                                        对于本地模式的作业，格式为*=value\n                                    ")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.jobSettingInfo.shardingItemParameters),
      callback: function($$v) {
        _vm.$set(_vm.jobSettingInfo, "shardingItemParameters", $$v)
      },
      expression: "jobSettingInfo.shardingItemParameters"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "jobParameter",
      "label": "自定义参数"
    }
  }, [_c('el-tooltip', {
    attrs: {
      "popper-class": "form-tooltip",
      "content": "配置格式: 多个配置使用逗号分隔(key1=value1, key2=value2)。在分片序列号/参数对照表中可作为alias形式引用，格式为{key1}",
      "placement": "bottom"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.jobSettingInfo.jobParameter),
      callback: function($$v) {
        _vm.$set(_vm.jobSettingInfo, "jobParameter", $$v)
      },
      expression: "jobSettingInfo.jobParameter"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "preferList",
      "label": "优先executor"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "multiple": ""
    },
    model: {
      value: (_vm.jobSettingInfo.preferList),
      callback: function($$v) {
        _vm.$set(_vm.jobSettingInfo, "preferList", $$v)
      },
      expression: "jobSettingInfo.preferList"
    }
  }, _vm._l((_vm.preferListProvidedArray), function(item) {
    return _c('el-option', {
      key: item.executorDes,
      attrs: {
        "label": item.executorDes,
        "value": item.executorName
      }
    })
  }))], 1)], 1)], 1), _vm._v(" "), _c('el-row', [(!_vm.jobSettingInfo.localMode) ? _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "onlyUsePreferList",
      "label": "只使用优先executor"
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.jobSettingInfo.onlyUsePreferList),
      callback: function($$v) {
        _vm.$set(_vm.jobSettingInfo, "onlyUsePreferList", $$v)
      },
      expression: "jobSettingInfo.onlyUsePreferList"
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "description",
      "label": "作业描述信息"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.jobSettingInfo.description),
      callback: function($$v) {
        _vm.$set(_vm.jobSettingInfo, "description", $$v)
      },
      expression: "jobSettingInfo.description"
    }
  })], 1)], 1)], 1)], 1)], 2), _vm._v(" "), _c('el-collapse-item', {
    attrs: {
      "name": "2"
    }
  }, [_c('template', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("\n                    高级配置\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "job-setting-content"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "timeout4AlarmSeconds",
      "label": "超时告警(秒)"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.jobSettingInfo.timeout4AlarmSeconds),
      callback: function($$v) {
        _vm.$set(_vm.jobSettingInfo, "timeout4AlarmSeconds", $$v)
      },
      expression: "jobSettingInfo.timeout4AlarmSeconds"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "timeoutSeconds",
      "label": "超时强杀(秒)"
    }
  }, [_c('el-tooltip', {
    attrs: {
      "popper-class": "form-tooltip",
      "placement": "top",
      "effect": "light"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('span', {
    staticClass: "text-warning"
  }, [_vm._v("警告：对于Java作业，立即终止操作（即强杀）会stop业务线程，如果作业代码没有实现onTimeout方法来释放资源，有可能导致资源的不释放，例如数据库连接的不释放。")])]), _vm._v(" "), _c('el-input', {
    model: {
      value: (_vm.jobSettingInfo.timeoutSeconds),
      callback: function($$v) {
        _vm.$set(_vm.jobSettingInfo, "timeoutSeconds", $$v)
      },
      expression: "jobSettingInfo.timeoutSeconds"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "groups",
      "label": "所属分组"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.jobSettingInfo.groups),
      callback: function($$v) {
        _vm.$set(_vm.jobSettingInfo, "groups", $$v)
      },
      expression: "jobSettingInfo.groups"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "loadLevel",
      "label": "作业负荷"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.jobSettingInfo.loadLevel),
      callback: function($$v) {
        _vm.$set(_vm.jobSettingInfo, "loadLevel", $$v)
      },
      expression: "jobSettingInfo.loadLevel"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "processCountIntervalSeconds",
      "label": "统计处理间隔(秒)"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.jobSettingInfo.processCountIntervalSeconds),
      callback: function($$v) {
        _vm.$set(_vm.jobSettingInfo, "processCountIntervalSeconds", $$v)
      },
      expression: "jobSettingInfo.processCountIntervalSeconds"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "timeZone",
      "label": "时区"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": ""
    },
    model: {
      value: (_vm.jobSettingInfo.timeZone),
      callback: function($$v) {
        _vm.$set(_vm.jobSettingInfo, "timeZone", $$v)
      },
      expression: "jobSettingInfo.timeZone"
    }
  }, _vm._l((_vm.jobSettingInfo.timeZonesProvided), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }))], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": _vm.$option.isMsg(_vm.jobSettingInfo.jobType) ? 7 : 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "showNormalLog",
      "label": "控制台输出日志"
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.jobSettingInfo.showNormalLog),
      callback: function($$v) {
        _vm.$set(_vm.jobSettingInfo, "showNormalLog", $$v)
      },
      expression: "jobSettingInfo.showNormalLog"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": _vm.$option.isMsg(_vm.jobSettingInfo.jobType) ? 7 : 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "enabledReport",
      "label": "上报运行状态"
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.jobSettingInfo.enabledReport),
      callback: function($$v) {
        _vm.$set(_vm.jobSettingInfo, "enabledReport", $$v)
      },
      expression: "jobSettingInfo.enabledReport"
    }
  })], 1)], 1), _vm._v(" "), (_vm.$option.isMsg(_vm.jobSettingInfo.jobType)) ? _c('el-col', {
    attrs: {
      "span": _vm.$option.isMsg(_vm.jobSettingInfo.jobType) ? 7 : 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "useSerial",
      "label": "串行消费"
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.jobSettingInfo.useSerial),
      callback: function($$v) {
        _vm.$set(_vm.jobSettingInfo, "useSerial", $$v)
      },
      expression: "jobSettingInfo.useSerial"
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.$option.isCron(_vm.jobSettingInfo.jobType) || _vm.$option.isPassive(_vm.jobSettingInfo.jobType)) ? _c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": _vm.$option.isCron(_vm.jobSettingInfo.jobType) ? 11 : 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "failover",
      "label": "故障转移"
    }
  }, [_c('el-switch', {
    attrs: {
      "title": "本地模式或非上报运行状态不可编辑",
      "disabled": _vm.jobSettingInfo.localMode || !_vm.jobSettingInfo.enabledReport
    },
    model: {
      value: (_vm.jobSettingInfo.failover),
      callback: function($$v) {
        _vm.$set(_vm.jobSettingInfo, "failover", $$v)
      },
      expression: "jobSettingInfo.failover"
    }
  })], 1)], 1), _vm._v(" "), (_vm.$option.isCron(_vm.jobSettingInfo.jobType)) ? _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "rerun"
    }
  }, [_c('div', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('span', [_vm._v("过时未跑重试")]), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "placement": "top",
      "content": "不建议高频作业启动超时重跑",
      "effect": "light",
      "popper-class": "allocation-popper"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle"
  })])], 1), _vm._v(" "), _c('el-switch', {
    attrs: {
      "title": "非上报运行状态不可编辑",
      "disabled": !_vm.jobSettingInfo.enabledReport
    },
    model: {
      value: (_vm.jobSettingInfo.rerun),
      callback: function($$v) {
        _vm.$set(_vm.jobSettingInfo, "rerun", $$v)
      },
      expression: "jobSettingInfo.rerun"
    }
  })], 1)], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.$option.isPassive(_vm.jobSettingInfo.jobType)) ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "upStream",
      "label": "上游作业"
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "bottom"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                                        满足上游作业的条件"), _c('br'), _vm._v("1.只能是定时作业或被动作业"), _c('br'), _vm._v("2.分片只能为1"), _c('br'), _vm._v("3.不能是本地模式作业"), _c('br'), _vm._v("4.不能是本作业的直接或者间接下游\n                                    ")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "multiple": ""
    },
    model: {
      value: (_vm.jobSettingInfo.upStream),
      callback: function($$v) {
        _vm.$set(_vm.jobSettingInfo, "upStream", $$v)
      },
      expression: "jobSettingInfo.upStream"
    }
  }, _vm._l((_vm.jobSettingInfo.upStreamProvided), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }))], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$option.isCron(_vm.jobSettingInfo.jobType) || _vm.$option.isPassive(_vm.jobSettingInfo.jobType)) ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "downStream",
      "label": "下游作业"
    }
  }, [_c('div', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("\n                                    下游作业\n                                    "), _c('el-tooltip', {
    attrs: {
      "content": "查看作业依赖图",
      "placement": "top"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.handleArrangeLayout()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search-plus"
  })])], 1)], 1), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "placement": "bottom"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                                        配置下游作业的条件"), _c('br'), _vm._v("1.只能是定时作业或被动作业"), _c('br'), _vm._v("2.分片只能为1"), _c('br'), _vm._v("3.不能是本地模式作业"), _c('br'), _c('br'), _vm._v("\n                                        满足下游作业的条件"), _c('br'), _vm._v("1.只能是被动作业"), _c('br'), _vm._v("2.不能是本作业的直接或者间接上游\n                                    ")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "multiple": "",
      "disabled": _vm.jobSettingInfo.localMode || _vm.jobSettingInfo.shardingTotalCount !== 1
    },
    model: {
      value: (_vm.jobSettingInfo.downStream),
      callback: function($$v) {
        _vm.$set(_vm.jobSettingInfo, "downStream", $$v)
      },
      expression: "jobSettingInfo.downStream"
    }
  }, _vm._l((_vm.jobSettingInfo.downStreamProvided), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }))], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "channelName",
      "label": "执行结果发送的Channel名"
    }
  }, [_c('el-tooltip', {
    attrs: {
      "popper-class": "form-tooltip",
      "content": "执行消息作业结果发送的channel名，注意不能跟queue绑定的channel一致，以免造成死循环",
      "placement": "bottom"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.jobSettingInfo.channelName),
      callback: function($$v) {
        _vm.$set(_vm.jobSettingInfo, "channelName", $$v)
      },
      expression: "jobSettingInfo.channelName"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.$option.isCron(_vm.jobSettingInfo.jobType)) ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "pausePeriodDate",
      "label": "暂停日期段"
    }
  }, [_c('el-tooltip', {
    attrs: {
      "popper-class": "form-tooltip",
      "content": "日期时间段，支持多个日期段。例如03/12-03/15。当日期为空，时间段不为空，表示每天那些时间段都暂停",
      "placement": "bottom"
    }
  }, [_c('InputTags', {
    attrs: {
      "dynamic-tags": _vm.jobSettingInfo.pausePeriodDate,
      "title": "日期段"
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$option.isCron(_vm.jobSettingInfo.jobType)) ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "pausePeriodTime",
      "label": "暂停时间段"
    }
  }, [_c('el-tooltip', {
    attrs: {
      "popper-class": "form-tooltip",
      "content": "日期时间段，支持多个时间段。例如12:23-13:23。当日期为不空，时间段为空，表示那些日期段24小时都暂停。针对跨日的时间段，\n                                编辑时需要分成2个段，以23:00-03:00为例，需写成23:00-23:59和00:00-03:00",
      "placement": "bottom"
    }
  }, [_c('InputTags', {
    attrs: {
      "dynamic-tags": _vm.jobSettingInfo.pausePeriodTime,
      "title": "时间段"
    }
  })], 1)], 1)], 1)], 1) : _vm._e()], 1)], 2)], 1), _vm._v(" "), (_vm.$common.hasPerm('job:update', _vm.domainName)) ? _c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary",
      "disabled": _vm.jobSettingInfo.enabled
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.updateInfo($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-database"
  }), _vm._v("更新")]) : _vm._e()], 1), _vm._v(" "), (_vm.isCronPredictVisible) ? _c('div', [_c('CronPredictDialog', {
    attrs: {
      "cron-predict-params": _vm.cronPredictParams
    },
    on: {
      "close-dialog": _vm.closeCronDialog
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isArrangeLayoutVisible) ? _c('div', [_c('arrange-layout-dialog', {
    attrs: {
      "arrange-layout-info": _vm.arrangeLayoutInfo
    },
    on: {
      "job-redirect": _vm.jobRedirect,
      "close-dialog": _vm.closeArrangeLayoutDialog
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1440 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": "请稍等···"
    }
  }, [_c('Top-bar', {
    attrs: {
      "domain": _vm.domainName,
      "domain-info": _vm.domainInfo
    }
  }), _vm._v(" "), _c('VAside', {
    attrs: {
      "sidebar-menus": _vm.sidebarMenus,
      "headerHeight": "90"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1441 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('el-main', [_c('div', {
    staticClass: "page-home"
  }, [_c('div', {
    staticClass: "page-home-container"
  }, [_c('div', {
    staticClass: "page-title"
  }, [_c('img', {
    attrs: {
      "width": "200px",
      "height": "200px",
      "src": __webpack_require__(1297)
    }
  })]), _vm._v(" "), _c('div', [_c('el-autocomplete', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "fetch-suggestions": _vm.querySearchAsync,
      "placeholder": "请输入域名"
    },
    on: {
      "select": _vm.handleSelect
    },
    model: {
      value: (_vm.domainName),
      callback: function($$v) {
        _vm.domainName = $$v
      },
      expression: "domainName"
    }
  }, [_c('i', {
    staticClass: "el-icon-search el-input__icon",
    attrs: {
      "slot": "suffix"
    },
    slot: "suffix"
  })])], 1)]), _vm._v(" "), (_vm.recentVisitDomains) ? _c('form', {
    staticClass: "recent-visit-form"
  }, [_c('fieldset', {
    staticClass: "quick-access"
  }, [_c('legend', {
    staticClass: "quick-access-title"
  }, [_vm._v("--- 快捷访问 ---")]), _vm._v(" "), _c('div', {
    staticClass: "tag-content"
  }, _vm._l((_vm.recentVisitDomains), function(item, key) {
    return _c('span', {
      key: key,
      staticClass: "status-tag",
      on: {
        "click": function($event) {
          _vm.toJobListPage(item.params.domain)
        }
      }
    }, [_vm._v("\n                            " + _vm._s(item.params.domain) + "\n                        ")])
  }))])]) : _vm._e()])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1442 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-container"
  }, [_c('div', {
    staticClass: "panel-header"
  }, [_c('span', {
    staticClass: "pull-left"
  }, [_c('i', {
    class: _vm.chartIcon,
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n            " + _vm._s(_vm.title) + "\n        ")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right",
    on: {
      "click": _vm.togglePanel
    }
  }, [(_vm.isExpand) ? _c('i', {
    staticClass: "fa fa-minus"
  }) : _vm._e(), _vm._v(" "), (!_vm.isExpand) ? _c('i', {
    staticClass: "fa fa-plus"
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isExpand),
      expression: "isExpand"
    }],
    staticClass: "panel-body"
  }, [_vm._t("chart")], 2)])
},staticRenderFns: []}

/***/ }),
/* 1443 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "300px"
    },
    attrs: {
      "id": _vm.id
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 1444 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Top-bar', {
    attrs: {
      "domain": _vm.domainName,
      "domain-info": _vm.domainInfo
    }
  }), _vm._v(" "), _c('VAside', {
    attrs: {
      "sidebar-menus": _vm.sidebarMenus,
      "headerHeight": "90"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": "请稍等···"
    }
  }, [_c('div', {
    staticClass: "job-detail-header"
  }, [_c('div', {
    staticClass: "pull-left job-detail-title"
  }, [_c('span', {
    staticClass: "job-span"
  }, [(_vm.jobInfo.jobType === 'JAVA_JOB') ? _c('i', {
    staticClass: "iconfont icon-java"
  }) : _vm._e(), _vm._v(" "), (_vm.jobInfo.jobType === 'SHELL_JOB') ? _c('i', {
    staticClass: "iconfont icon-msnui-logo-linux"
  }) : _vm._e(), _vm._v(" "), (_vm.jobInfo.jobType === 'MSG_JOB') ? _c('i', {
    staticClass: "fa fa-envelope-o"
  }) : _vm._e(), _vm._v("\n                    作业 : " + _vm._s(_vm.jobName) + "\n                ")]), _vm._v(" "), _c('el-tag', {
    staticClass: "status-tag",
    attrs: {
      "type": _vm.statusTag[_vm.jobInfo.status]
    }
  }, [_vm._v("运行状态: " + _vm._s(_vm.translateStatus[_vm.jobInfo.status]))])], 1), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [(_vm.$common.hasPerm('job:enable', _vm.domainName) && (_vm.jobInfo.status === 'STOPPING' || _vm.jobInfo.status === 'STOPPED')) ? _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.handleActive(true)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-play-circle text-btn"
  }), _vm._v("启用")]) : _vm._e(), _vm._v(" "), (_vm.$common.hasPerm('job:disable', _vm.domainName) && (_vm.jobInfo.status === 'READY' || _vm.jobInfo.status === 'RUNNING')) ? _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.handleActive(false)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-stop-circle text-warning"
  }), _vm._v("禁用")]) : _vm._e(), _vm._v(" "), (_vm.$common.hasPerm('job:runAtOnce', _vm.domainName) && (_vm.jobInfo.status === 'READY' && _vm.jobStatusJudge() && !_vm.$option.isMsg(_vm.jobInfo.jobType))) ? _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.handleOperate('runAtOnce')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-play-circle-o text-btn"
  }), _vm._v("立即执行")]) : _vm._e(), _vm._v(" "), (_vm.$common.hasPerm('job:stopAtOnce', _vm.domainName) && _vm.jobInfo.status === 'STOPPING') ? _c('el-button', {
    attrs: {
      "size": "small",
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.handleOperate('stopAtOnce')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-stop-circle-o"
  }), _vm._v("立即终止")]) : _vm._e(), _vm._v(" "), (_vm.$common.hasPerm('job:remove', _vm.domainName) && (_vm.jobInfo.status === 'STOPPED' || !_vm.jobInfo.enabled)) ? _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.handleDelete
    }
  }, [_c('i', {
    staticClass: "fa fa-trash text-danger"
  }), _vm._v("删除")]) : _vm._e()], 1)]), _vm._v(" "), _c('router-view')], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1445 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "margin-20"
  }, [_c('div', [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Panel', {
    attrs: {
      "type": "success"
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("启用作业数 / 总作业数")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v(_vm._s(_vm.jobTotalInfo.enabledNumber) + " / " + _vm._s(_vm.jobTotalInfo.totalNumber))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('a', {
    on: {
      "click": _vm.toAbnormalJobPage
    }
  }, [_c('Panel', {
    attrs: {
      "type": "danger"
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("异常作业数")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v(_vm._s(_vm.jobTotalInfo.abnormalNumber))])])], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "page-container"
  }, [_c('FilterPageList', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.tableLoading),
      expression: "tableLoading"
    }],
    ref: "pageListRef",
    attrs: {
      "get-data": _vm.getJobList,
      "total": _vm.total,
      "order-by": _vm.orderBy,
      "filters": _vm.filters,
      "element-loading-text": "请稍等···"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-form', {
          staticClass: "table-filter",
          attrs: {
            "inline": true
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": ""
          }
        }, [_c('el-select', {
          staticStyle: {
            "width": "140px"
          },
          on: {
            "change": scope.search
          },
          model: {
            value: (_vm.filters.groups.value),
            callback: function($$v) {
              _vm.$set(_vm.filters.groups, "value", $$v)
            },
            expression: "filters.groups.value"
          }
        }, [_c('el-option', {
          attrs: {
            "label": "全部分组",
            "value": ""
          }
        }), _vm._v(" "), _vm._l((_vm.groupList), function(item) {
          return _c('el-option', {
            key: item,
            attrs: {
              "label": item,
              "value": item
            }
          })
        })], 2)], 1), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": ""
          }
        }, [_c('el-select', {
          staticStyle: {
            "width": "140px"
          },
          on: {
            "change": scope.search
          },
          model: {
            value: (_vm.filters.status.value),
            callback: function($$v) {
              _vm.$set(_vm.filters.status, "value", $$v)
            },
            expression: "filters.status.value"
          }
        }, [_c('el-option', {
          attrs: {
            "label": "全部状态",
            "value": ""
          }
        }), _vm._v(" "), _vm._l((_vm.$option.jobStatusTypes), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        })], 2)], 1), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": ""
          }
        }, [_c('el-input', {
          attrs: {
            "placeholder": _vm.filterColumnPlaceholder
          },
          nativeOn: {
            "keyup": function($event) {
              if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
              scope.search($event)
            }
          },
          model: {
            value: (_vm.filters[_vm.selectColumn].value),
            callback: function($$v) {
              _vm.$set(_vm.filters[_vm.selectColumn], "value", (typeof $$v === 'string' ? $$v.trim() : $$v))
            },
            expression: "filters[selectColumn].value"
          }
        }, [_c('el-select', {
          staticStyle: {
            "width": "120px"
          },
          attrs: {
            "slot": "prepend"
          },
          on: {
            "change": _vm.selectColumnChange
          },
          slot: "prepend",
          model: {
            value: (_vm.selectColumn),
            callback: function($$v) {
              _vm.selectColumn = $$v
            },
            expression: "selectColumn"
          }
        }, [_c('el-option', {
          attrs: {
            "label": "作业名",
            "value": "jobName"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": "作业描述",
            "value": "description"
          }
        })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "icon": "el-icon-search"
          },
          on: {
            "click": scope.search
          }
        }, [_vm._v("查询")])], 1)], 1), _vm._v(" "), _c('div', {
          directives: [{
            name: "loading",
            rawName: "v-loading",
            value: (_vm.loading),
            expression: "loading"
          }],
          staticClass: "page-table",
          attrs: {
            "element-loading-text": "请稍等···"
          }
        }, [_c('div', {
          staticClass: "page-table-header"
        }, [_c('div', {
          staticClass: "page-table-header-title"
        }, [_c('i', {
          staticClass: "fa fa-list"
        }), _vm._v("作业列表\n                            "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": scope.search
          }
        }, [_c('i', {
          staticClass: "fa fa-refresh"
        })])], 1), _vm._v(" "), _c('div', {
          staticClass: "page-table-header-separator"
        }), _vm._v(" "), _c('div', [(_vm.$common.hasPerm('job:batchEnable', _vm.domainName)) ? _c('el-button', {
          on: {
            "click": function($event) {
              _vm.batchEnabled()
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-play-circle text-btn"
        }), _vm._v("启用")]) : _vm._e(), _vm._v(" "), (_vm.$common.hasPerm('job:batchDisable', _vm.domainName)) ? _c('el-button', {
          on: {
            "click": function($event) {
              _vm.batchDisabled()
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-stop-circle text-warning"
        }), _vm._v("禁用")]) : _vm._e(), _vm._v(" "), (_vm.$common.hasPerm('job:batchRemove', _vm.domainName)) ? _c('el-button', {
          on: {
            "click": function($event) {
              _vm.batchDelete()
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash text-danger"
        }), _vm._v("删除")]) : _vm._e(), _vm._v(" "), (_vm.$common.hasPerm('job:batchSetPreferExecutors', _vm.domainName)) ? _c('el-button', {
          on: {
            "click": function($event) {
              _vm.batchPriority()
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-level-up text-btn"
        }), _vm._v("优先")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
          staticClass: "pull-right"
        }, [(_vm.$common.hasPerm('job:add', _vm.domainName)) ? _c('el-button', {
          on: {
            "click": function($event) {
              _vm.handleAdd()
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-plus-circle text-btn"
        }), _vm._v("添加")]) : _vm._e(), _vm._v(" "), (_vm.$common.hasPerm('job:import', _vm.domainName)) ? _c('el-button', {
          on: {
            "click": function($event) {
              _vm.handleImport()
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-arrow-circle-o-down text-btn"
        }), _vm._v("导入")]) : _vm._e(), _vm._v(" "), _c('el-button', {
          on: {
            "click": function($event) {
              _vm.handleExport()
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-arrow-circle-o-up text-btn"
        }), _vm._v("导出")]), _vm._v(" "), _c('el-button', {
          on: {
            "click": function($event) {
              _vm.handleArrangeLayout()
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-line-chart text-btn"
        }), _vm._v("作业依赖图")])], 1)]), _vm._v(" "), _c('el-table', {
          ref: "multipleTable",
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "stripe": "",
            "border": "",
            "data": _vm.jobList
          },
          on: {
            "selection-change": _vm.handleSelectionChange,
            "sort-change": scope.onSortChange
          }
        }, [_c('el-table-column', {
          attrs: {
            "type": "selection",
            "width": "55"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "jobName",
            "label": "作业名",
            "sortable": "custom"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('router-link', {
                attrs: {
                  "tag": "a",
                  "to": {
                    name: 'job_setting',
                    params: {
                      domain: _vm.domainName,
                      jobName: scope.row.jobName
                    }
                  }
                }
              }, [(scope.row.jobType === 'JAVA_JOB' || scope.row.jobType === 'PASSIVE_JAVA_JOB') ? _c('i', {
                staticClass: "iconfont icon-java"
              }) : _vm._e(), _vm._v(" "), (scope.row.jobType === 'SHELL_JOB' || scope.row.jobType === 'PASSIVE_SHELL_JOB') ? _c('i', {
                staticClass: "iconfont icon-msnui-logo-linux"
              }) : _vm._e(), _vm._v(" "), (scope.row.jobType === 'MSG_JOB') ? _c('i', {
                staticClass: "fa fa-envelope-o"
              }) : _vm._e(), _vm._v("\n                                    " + _vm._s(scope.row.jobName) + "\n                                ")])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "jobType",
            "label": "作业类型",
            "width": "100px"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v(" \n                                " + _vm._s(_vm.$map.jobTypeMap[scope.row.jobType]) + "\n                            ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "状态",
            "prop": "status",
            "width": "90px"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('el-tag', {
                attrs: {
                  "type": _vm.statusTag[scope.row.status],
                  "close-transition": ""
                }
              }, [_vm._v(_vm._s(_vm.$map.jobStatusMap[scope.row.status]))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "description",
            "show-overflow-tooltip": "",
            "label": "描述"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v(" \n                                " + _vm._s(scope.row.description) + "\n                            ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "groups",
            "label": "分组",
            "width": "120px"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "shardingTotalCount",
            "label": "分片数",
            "width": "70px"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "shardingList",
            "label": "是否已分配分片",
            "width": "130px"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.shardingList === '') ? _c('span', [_vm._v("-")]) : _c('el-tag', {
                attrs: {
                  "type": scope.row.shardingList === '已分配' ? 'primary' : ''
                }
              }, [_vm._v(_vm._s(scope.row.shardingList))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "操作",
            "width": "120px",
            "align": "center"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(_vm.$common.hasPerm('job:enable', _vm.domainName) && (scope.row.status === 'STOPPING' || scope.row.status === 'STOPPED')) ? _c('el-tooltip', {
                attrs: {
                  "content": "启用",
                  "placement": "top"
                }
              }, [_c('el-button', {
                attrs: {
                  "type": "text"
                },
                on: {
                  "click": function($event) {
                    _vm.handleActive(scope.row, true)
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-play-circle"
              })])], 1) : _vm._e(), _vm._v(" "), (_vm.$common.hasPerm('job:disable', _vm.domainName) && (scope.row.status === 'READY' || scope.row.status === 'RUNNING')) ? _c('el-tooltip', {
                attrs: {
                  "content": "禁用",
                  "placement": "top"
                }
              }, [_c('el-button', {
                attrs: {
                  "type": "text"
                },
                on: {
                  "click": function($event) {
                    _vm.handleActive(scope.row, false)
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-stop-circle text-warning"
              })])], 1) : _vm._e(), _vm._v(" "), (_vm.$common.hasPerm('job:copy', _vm.domainName)) ? _c('el-tooltip', {
                attrs: {
                  "content": "复制",
                  "placement": "top"
                }
              }, [_c('el-button', {
                attrs: {
                  "type": "text"
                },
                on: {
                  "click": function($event) {
                    _vm.handleCopy(scope.row)
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-clone"
              })])], 1) : _vm._e(), _vm._v(" "), (_vm.$common.hasPerm('job:remove', _vm.domainName) && scope.row.status === 'STOPPED') ? _c('el-tooltip', {
                attrs: {
                  "content": "删除",
                  "placement": "top"
                }
              }, [_c('el-button', {
                attrs: {
                  "type": "text",
                  "icon": "el-icon-delete text-danger"
                },
                on: {
                  "click": function($event) {
                    _vm.handleDelete(scope.row)
                  }
                }
              })], 1) : _vm._e()]
            }
          }])
        })], 1)], 1)]
      }
    }])
  }), _vm._v(" "), (_vm.isJobInfoVisible) ? _c('div', [_c('job-info-dialog', {
    attrs: {
      "domain-name": _vm.domainName,
      "job-info": _vm.jobInfo,
      "job-info-title": _vm.jobInfoTitle,
      "job-info-operation": _vm.jobInfoOperation
    },
    on: {
      "job-info-success": _vm.jobInfoSuccess,
      "close-dialog": _vm.closeDialog
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isBatchPriorityVisible) ? _c('div', [_c('batch-priority-dialog', {
    attrs: {
      "job-names-array": _vm.jobNamesArray,
      "domain-name": _vm.domainName
    },
    on: {
      "close-dialog": _vm.closePriorityDialog,
      "batch-priority-success": _vm.batchPrioritySuccess
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isImportVisible) ? _c('div', [_c('ImportFileDialog', {
    attrs: {
      "import-data": _vm.importData,
      "import-template-url": "/console/static/jobTemplate/download",
      "import-url": _vm.importUrl,
      "import-title": "导入作业"
    },
    on: {
      "close-dialog": _vm.closeImportDialog,
      "import-success": _vm.importSuccess
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isImportResultVisible) ? _c('div', [_c('import-result-dialog', {
    attrs: {
      "import-result": _vm.importResult
    },
    on: {
      "close-dialog": _vm.closeImportResultDialog
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isArrangeLayoutVisible) ? _c('div', [_c('arrange-layout-dialog', {
    attrs: {
      "arrange-layout-info": _vm.arrangeLayoutInfo
    },
    on: {
      "job-redirect": _vm.jobRedirect,
      "close-dialog": _vm.closeArrangeLayoutDialog
    }
  })], 1) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 1446 */,
/* 1447 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(965);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("689584df", content, true);

/***/ }),
/* 1448 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(966);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("147a0a47", content, true);

/***/ }),
/* 1449 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(967);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("3dedc0c4", content, true);

/***/ }),
/* 1450 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(968);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("1ee09283", content, true);

/***/ }),
/* 1451 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(969);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("768510aa", content, true);

/***/ }),
/* 1452 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(970);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("1d98baa1", content, true);

/***/ }),
/* 1453 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(971);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("0ab5cb8d", content, true);

/***/ }),
/* 1454 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(972);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("05ab99a0", content, true);

/***/ }),
/* 1455 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(973);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("5c3cccc4", content, true);

/***/ }),
/* 1456 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(974);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("0cc7a084", content, true);

/***/ }),
/* 1457 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(975);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("6cf40937", content, true);

/***/ }),
/* 1458 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(976);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("5bbf149c", content, true);

/***/ }),
/* 1459 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(977);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("28533cd8", content, true);

/***/ }),
/* 1460 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(978);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("410e0464", content, true);

/***/ }),
/* 1461 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(979);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("74d85a48", content, true);

/***/ }),
/* 1462 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(980);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("69cb6454", content, true);

/***/ }),
/* 1463 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(981);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("3f0056f0", content, true);

/***/ }),
/* 1464 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(982);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("9775e03a", content, true);

/***/ }),
/* 1465 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(983);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("5772a596", content, true);

/***/ }),
/* 1466 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(984);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("519688ea", content, true);

/***/ }),
/* 1467 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(985);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("3489aa92", content, true);

/***/ }),
/* 1468 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(986);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("2924e81b", content, true);

/***/ }),
/* 1469 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(987);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("5e93d523", content, true);

/***/ }),
/* 1470 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(988);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("f16e3058", content, true);

/***/ }),
/* 1471 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(989);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("0962eedc", content, true);

/***/ }),
/* 1472 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(990);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("3bb7ac52", content, true);

/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(991);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("0be993ee", content, true);

/***/ }),
/* 1474 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(992);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("0537408e", content, true);

/***/ }),
/* 1475 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(993);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("43db877e", content, true);

/***/ }),
/* 1476 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(994);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("76cadcbf", content, true);

/***/ }),
/* 1477 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(995);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("a6443518", content, true);

/***/ }),
/* 1478 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(996);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("1a4b2575", content, true);

/***/ }),
/* 1479 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(997);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("449a2ad4", content, true);

/***/ }),
/* 1480 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(998);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("581d540a", content, true);

/***/ }),
/* 1481 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(999);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("57a1014e", content, true);

/***/ }),
/* 1482 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1000);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("22a3d88b", content, true);

/***/ }),
/* 1483 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1001);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("0dd9c9f2", content, true);

/***/ }),
/* 1484 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1002);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("7e921747", content, true);

/***/ }),
/* 1485 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1003);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("7261086f", content, true);

/***/ }),
/* 1486 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1004);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("31eb40b0", content, true);

/***/ }),
/* 1487 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1005);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("5f5f0e98", content, true);

/***/ }),
/* 1488 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1006);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("4d250860", content, true);

/***/ }),
/* 1489 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1007);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("6a15b62f", content, true);

/***/ }),
/* 1490 */,
/* 1491 */,
/* 1492 */,
/* 1493 */,
/* 1494 */,
/* 1495 */,
/* 1496 */,
/* 1497 */,
/* 1498 */,
/* 1499 */,
/* 1500 */,
/* 1501 */,
/* 1502 */,
/* 1503 */,
/* 1504 */,
/* 1505 */,
/* 1506 */,
/* 1507 */,
/* 1508 */,
/* 1509 */,
/* 1510 */,
/* 1511 */,
/* 1512 */,
/* 1513 */,
/* 1514 */,
/* 1515 */,
/* 1516 */,
/* 1517 */,
/* 1518 */,
/* 1519 */,
/* 1520 */,
/* 1521 */,
/* 1522 */,
/* 1523 */,
/* 1524 */,
/* 1525 */,
/* 1526 */,
/* 1527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(562);

__webpack_require__(567);

var _vue = __webpack_require__(32);

var _vue2 = _interopRequireDefault(_vue);

var _elementUi = __webpack_require__(281);

var _elementUi2 = _interopRequireDefault(_elementUi);

__webpack_require__(564);

__webpack_require__(563);

__webpack_require__(559);

__webpack_require__(558);

var _App = __webpack_require__(568);

var _App2 = _interopRequireDefault(_App);

var _store = __webpack_require__(190);

var _store2 = _interopRequireDefault(_store);

var _routers = __webpack_require__(560);

var _routers2 = _interopRequireDefault(_routers);

var _utils = __webpack_require__(561);

var _utils2 = _interopRequireDefault(_utils);

__webpack_require__(565);

__webpack_require__(566);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_elementUi2.default);
_vue2.default.use(_utils2.default);

window.vm = new _vue2.default({
  el: '#app',
  store: _store2.default,
  router: _routers2.default,
  render: function render(h) {
    return h(_App2.default);
  }
});
vm.clearZk = function clear(url) {
  var _this = this;

  this.$message.confirmMessage('确定清除zk吗?', function () {
    _this.$http.post(url, '').then(function () {
      _this.$message.successNotify('清除zk操作成功，请稍后刷新页面获取最新数据。');
    }).catch(function () {
      _this.$http.buildErrorHandler('清除zk请求失败！');
    });
  });
};

/***/ })
]),[1527]);


// WEBPACK FOOTER //
// js/app.dc879dda16fa02178a41.js